
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref490"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref490"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("5apVM", function(module, exports) {

$parcel$export(module.exports, "$", function () { return $; });
$parcel$export(module.exports, "addClass", function () { return addClass; });
$parcel$export(module.exports, "removeClass", function () { return removeClass; });
$parcel$export(module.exports, "toggleClass", function () { return toggleClass; });
$parcel$export(module.exports, "hasClass", function () { return hasClass; });
$parcel$export(module.exports, "attr", function () { return attr; });
$parcel$export(module.exports, "removeAttr", function () { return removeAttr; });
$parcel$export(module.exports, "transform", function () { return transform; });
$parcel$export(module.exports, "transition", function () { return transition; });
$parcel$export(module.exports, "on", function () { return on; });
$parcel$export(module.exports, "off", function () { return off; });
$parcel$export(module.exports, "trigger", function () { return trigger; });
$parcel$export(module.exports, "transitionEnd", function () { return transitionEnd; });
$parcel$export(module.exports, "outerWidth", function () { return outerWidth; });
$parcel$export(module.exports, "outerHeight", function () { return outerHeight; });
$parcel$export(module.exports, "offset", function () { return offset; });
$parcel$export(module.exports, "styles", function () { return styles; });
$parcel$export(module.exports, "css", function () { return css; });
$parcel$export(module.exports, "each", function () { return each; });
$parcel$export(module.exports, "filter", function () { return filter; });
$parcel$export(module.exports, "html", function () { return html; });
$parcel$export(module.exports, "text", function () { return text; });
$parcel$export(module.exports, "is", function () { return is; });
$parcel$export(module.exports, "index", function () { return index; });
$parcel$export(module.exports, "eq", function () { return eq; });
$parcel$export(module.exports, "append", function () { return append; });
$parcel$export(module.exports, "prepend", function () { return prepend; });
$parcel$export(module.exports, "next", function () { return next; });
$parcel$export(module.exports, "nextAll", function () { return nextAll; });
$parcel$export(module.exports, "prev", function () { return prev; });
$parcel$export(module.exports, "prevAll", function () { return prevAll; });
$parcel$export(module.exports, "parent", function () { return parent; });
$parcel$export(module.exports, "parents", function () { return parents; });
$parcel$export(module.exports, "closest", function () { return closest; });
$parcel$export(module.exports, "find", function () { return find; });
$parcel$export(module.exports, "children", function () { return children; });
$parcel$export(module.exports, "remove", function () { return remove; });
/**
 * Dom7 4.0.6
 * Minimalistic JavaScript library for DOM manipulation, with a jQuery-compatible API
 * https://framework7.io/docs/dom7.html
 *
 * Copyright 2023, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: February 2, 2023
 */ 
var $4acFp = parcelRequire("4acFp");
/* eslint-disable no-proto */ function makeReactive(obj) {
    const proto = obj.__proto__;
    Object.defineProperty(obj, '__proto__', {
        get () {
            return proto;
        },
        set (value) {
            proto.__proto__ = value;
        }
    });
}
class Dom7 extends Array {
    constructor(items){
        if (typeof items === 'number') super(items);
        else {
            super(...items || []);
            makeReactive(this);
        }
    }
}
function arrayFlat(arr = []) {
    const res = [];
    arr.forEach((el)=>{
        if (Array.isArray(el)) res.push(...arrayFlat(el));
        else res.push(el);
    });
    return res;
}
function arrayFilter(arr, callback) {
    return Array.prototype.filter.call(arr, callback);
}
function arrayUnique(arr) {
    const uniqueArray = [];
    for(let i = 0; i < arr.length; i += 1)if (uniqueArray.indexOf(arr[i]) === -1) uniqueArray.push(arr[i]);
    return uniqueArray;
}
function toCamelCase(string) {
    return string.toLowerCase().replace(/-(.)/g, (match, group)=>group.toUpperCase());
}
// eslint-disable-next-line
function qsa(selector, context) {
    if (typeof selector !== 'string') return [
        selector
    ];
    const a = [];
    const res = context.querySelectorAll(selector);
    for(let i = 0; i < res.length; i += 1)a.push(res[i]);
    return a;
}
function $(selector, context) {
    const window = (0, $4acFp.getWindow)();
    const document = (0, $4acFp.getDocument)();
    let arr = [];
    if (!context && selector instanceof Dom7) return selector;
    if (!selector) return new Dom7(arr);
    if (typeof selector === 'string') {
        const html = selector.trim();
        if (html.indexOf('<') >= 0 && html.indexOf('>') >= 0) {
            let toCreate = 'div';
            if (html.indexOf('<li') === 0) toCreate = 'ul';
            if (html.indexOf('<tr') === 0) toCreate = 'tbody';
            if (html.indexOf('<td') === 0 || html.indexOf('<th') === 0) toCreate = 'tr';
            if (html.indexOf('<tbody') === 0) toCreate = 'table';
            if (html.indexOf('<option') === 0) toCreate = 'select';
            const tempParent = document.createElement(toCreate);
            tempParent.innerHTML = html;
            for(let i = 0; i < tempParent.childNodes.length; i += 1)arr.push(tempParent.childNodes[i]);
        } else arr = qsa(selector.trim(), context || document);
         // arr = qsa(selector, document);
    } else if (selector.nodeType || selector === window || selector === document) arr.push(selector);
    else if (Array.isArray(selector)) {
        if (selector instanceof Dom7) return selector;
        arr = selector;
    }
    return new Dom7(arrayUnique(arr));
}
$.fn = Dom7.prototype;
// eslint-disable-next-line
function addClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.add(...classNames);
    });
    return this;
}
function removeClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        el.classList.remove(...classNames);
    });
    return this;
}
function toggleClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    this.forEach((el)=>{
        classNames.forEach((className)=>{
            el.classList.toggle(className);
        });
    });
}
function hasClass(...classes) {
    const classNames = arrayFlat(classes.map((c)=>c.split(' ')));
    return arrayFilter(this, (el)=>{
        return classNames.filter((className)=>el.classList.contains(className)).length > 0;
    }).length > 0;
}
function attr(attrs, value) {
    if (arguments.length === 1 && typeof attrs === 'string') {
        // Get attr
        if (this[0]) return this[0].getAttribute(attrs);
        return undefined;
    } // Set attrs
    for(let i = 0; i < this.length; i += 1){
        if (arguments.length === 2) // String
        this[i].setAttribute(attrs, value);
        else // Object
        for(const attrName in attrs){
            this[i][attrName] = attrs[attrName];
            this[i].setAttribute(attrName, attrs[attrName]);
        }
    }
    return this;
}
function removeAttr(attr) {
    for(let i = 0; i < this.length; i += 1)this[i].removeAttribute(attr);
    return this;
}
function prop(props, value) {
    if (arguments.length === 1 && typeof props === 'string') {
        // Get prop
        if (this[0]) return this[0][props];
    } else {
        // Set props
        for(let i = 0; i < this.length; i += 1){
            if (arguments.length === 2) // String
            this[i][props] = value;
            else // Object
            for(const propName in props)this[i][propName] = props[propName];
        }
        return this;
    }
    return this;
}
function data(key, value) {
    let el;
    if (typeof value === 'undefined') {
        el = this[0];
        if (!el) return undefined; // Get value
        if (el.dom7ElementDataStorage && key in el.dom7ElementDataStorage) return el.dom7ElementDataStorage[key];
        const dataKey = el.getAttribute(`data-${key}`);
        if (dataKey) return dataKey;
        return undefined;
    } // Set value
    for(let i = 0; i < this.length; i += 1){
        el = this[i];
        if (!el.dom7ElementDataStorage) el.dom7ElementDataStorage = {};
        el.dom7ElementDataStorage[key] = value;
    }
    return this;
}
function removeData(key) {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.dom7ElementDataStorage && el.dom7ElementDataStorage[key]) {
            el.dom7ElementDataStorage[key] = null;
            delete el.dom7ElementDataStorage[key];
        }
    }
}
function dataset() {
    const el = this[0];
    if (!el) return undefined;
    const dataset = {}; // eslint-disable-line
    if (el.dataset) for(const dataKey in el.dataset)dataset[dataKey] = el.dataset[dataKey];
    else for(let i = 0; i < el.attributes.length; i += 1){
        const attr = el.attributes[i];
        if (attr.name.indexOf('data-') >= 0) dataset[toCamelCase(attr.name.split('data-')[1])] = attr.value;
    }
    for(const key in dataset){
        if (dataset[key] === 'false') dataset[key] = false;
        else if (dataset[key] === 'true') dataset[key] = true;
        else if (parseFloat(dataset[key]) === dataset[key] * 1) dataset[key] *= 1;
    }
    return dataset;
}
function val(value) {
    if (typeof value === 'undefined') {
        // get value
        const el = this[0];
        if (!el) return undefined;
        if (el.multiple && el.nodeName.toLowerCase() === 'select') {
            const values = [];
            for(let i = 0; i < el.selectedOptions.length; i += 1)values.push(el.selectedOptions[i].value);
            return values;
        }
        return el.value;
    } // set value
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (Array.isArray(value) && el.multiple && el.nodeName.toLowerCase() === 'select') for(let j = 0; j < el.options.length; j += 1)el.options[j].selected = value.indexOf(el.options[j].value) >= 0;
        else el.value = value;
    }
    return this;
}
function value(value) {
    return this.val(value);
}
function transform(transform) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transform = transform;
    return this;
}
function transition(duration) {
    for(let i = 0; i < this.length; i += 1)this[i].style.transitionDuration = typeof duration !== 'string' ? `${duration}ms` : duration;
    return this;
}
function on(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    function handleLiveEvent(e) {
        const target = e.target;
        if (!target) return;
        const eventData = e.target.dom7EventData || [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        if ($(target).is(targetSelector)) listener.apply(target, eventData);
        else {
            const parents = $(target).parents(); // eslint-disable-line
            for(let k = 0; k < parents.length; k += 1)if ($(parents[k]).is(targetSelector)) listener.apply(parents[k], eventData);
        }
    }
    function handleEvent(e) {
        const eventData = e && e.target ? e.target.dom7EventData || [] : [];
        if (eventData.indexOf(e) < 0) eventData.unshift(e);
        listener.apply(this, eventData);
    }
    const events = eventType.split(' ');
    let j;
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (!targetSelector) for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7Listeners) el.dom7Listeners = {};
            if (!el.dom7Listeners[event]) el.dom7Listeners[event] = [];
            el.dom7Listeners[event].push({
                listener: listener,
                proxyListener: handleEvent
            });
            el.addEventListener(event, handleEvent, capture);
        }
        else // Live events
        for(j = 0; j < events.length; j += 1){
            const event = events[j];
            if (!el.dom7LiveListeners) el.dom7LiveListeners = {};
            if (!el.dom7LiveListeners[event]) el.dom7LiveListeners[event] = [];
            el.dom7LiveListeners[event].push({
                listener: listener,
                proxyListener: handleLiveEvent
            });
            el.addEventListener(event, handleLiveEvent, capture);
        }
    }
    return this;
}
function off(...args) {
    let [eventType, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventType, listener, capture] = args;
        targetSelector = undefined;
    }
    if (!capture) capture = false;
    const events = eventType.split(' ');
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            let handlers;
            if (!targetSelector && el.dom7Listeners) handlers = el.dom7Listeners[event];
            else if (targetSelector && el.dom7LiveListeners) handlers = el.dom7LiveListeners[event];
            if (handlers && handlers.length) for(let k = handlers.length - 1; k >= 0; k -= 1){
                const handler = handlers[k];
                if (listener && handler.listener === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (listener && handler.listener && handler.listener.dom7proxy && handler.listener.dom7proxy === listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                } else if (!listener) {
                    el.removeEventListener(event, handler.proxyListener, capture);
                    handlers.splice(k, 1);
                }
            }
        }
    }
    return this;
}
function once(...args) {
    const dom = this;
    let [eventName, targetSelector, listener, capture] = args;
    if (typeof args[1] === 'function') {
        [eventName, listener, capture] = args;
        targetSelector = undefined;
    }
    function onceHandler(...eventArgs) {
        listener.apply(this, eventArgs);
        dom.off(eventName, targetSelector, onceHandler, capture);
        if (onceHandler.dom7proxy) delete onceHandler.dom7proxy;
    }
    onceHandler.dom7proxy = listener;
    return dom.on(eventName, targetSelector, onceHandler, capture);
}
function trigger(...args) {
    const window = (0, $4acFp.getWindow)();
    const events = args[0].split(' ');
    const eventData = args[1];
    for(let i = 0; i < events.length; i += 1){
        const event = events[i];
        for(let j = 0; j < this.length; j += 1){
            const el = this[j];
            if (window.CustomEvent) {
                const evt = new window.CustomEvent(event, {
                    detail: eventData,
                    bubbles: true,
                    cancelable: true
                });
                el.dom7EventData = args.filter((data, dataIndex)=>dataIndex > 0);
                el.dispatchEvent(evt);
                el.dom7EventData = [];
                delete el.dom7EventData;
            }
        }
    }
    return this;
}
function transitionStart(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionstart', fireCallBack);
    }
    if (callback) dom.on('transitionstart', fireCallBack);
    return this;
}
function transitionEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('transitionend', fireCallBack);
    }
    if (callback) dom.on('transitionend', fireCallBack);
    return this;
}
function animationEnd(callback) {
    const dom = this;
    function fireCallBack(e) {
        if (e.target !== this) return;
        callback.call(this, e);
        dom.off('animationend', fireCallBack);
    }
    if (callback) dom.on('animationend', fireCallBack);
    return this;
}
function width() {
    const window = (0, $4acFp.getWindow)();
    if (this[0] === window) return window.innerWidth;
    if (this.length > 0) return parseFloat(this.css('width'));
    return null;
}
function outerWidth(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetWidth + parseFloat(styles.getPropertyValue('margin-right')) + parseFloat(styles.getPropertyValue('margin-left'));
        }
        return this[0].offsetWidth;
    }
    return null;
}
function height() {
    const window = (0, $4acFp.getWindow)();
    if (this[0] === window) return window.innerHeight;
    if (this.length > 0) return parseFloat(this.css('height'));
    return null;
}
function outerHeight(includeMargins) {
    if (this.length > 0) {
        if (includeMargins) {
            const styles = this.styles();
            return this[0].offsetHeight + parseFloat(styles.getPropertyValue('margin-top')) + parseFloat(styles.getPropertyValue('margin-bottom'));
        }
        return this[0].offsetHeight;
    }
    return null;
}
function offset() {
    if (this.length > 0) {
        const window = (0, $4acFp.getWindow)();
        const document = (0, $4acFp.getDocument)();
        const el = this[0];
        const box = el.getBoundingClientRect();
        const body = document.body;
        const clientTop = el.clientTop || body.clientTop || 0;
        const clientLeft = el.clientLeft || body.clientLeft || 0;
        const scrollTop = el === window ? window.scrollY : el.scrollTop;
        const scrollLeft = el === window ? window.scrollX : el.scrollLeft;
        return {
            top: box.top + scrollTop - clientTop,
            left: box.left + scrollLeft - clientLeft
        };
    }
    return null;
}
function hide() {
    for(let i = 0; i < this.length; i += 1)this[i].style.display = 'none';
    return this;
}
function show() {
    const window = (0, $4acFp.getWindow)();
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.style.display === 'none') el.style.display = '';
        if (window.getComputedStyle(el, null).getPropertyValue('display') === 'none') // Still not visible
        el.style.display = 'block';
    }
    return this;
}
function styles() {
    const window = (0, $4acFp.getWindow)();
    if (this[0]) return window.getComputedStyle(this[0], null);
    return {};
}
function css(props, value) {
    const window = (0, $4acFp.getWindow)();
    let i;
    if (arguments.length === 1) {
        if (typeof props === 'string') {
            // .css('width')
            if (this[0]) return window.getComputedStyle(this[0], null).getPropertyValue(props);
        } else {
            // .css({ width: '100px' })
            for(i = 0; i < this.length; i += 1)for(const prop in props)this[i].style[prop] = props[prop];
            return this;
        }
    }
    if (arguments.length === 2 && typeof props === 'string') {
        // .css('width', '100px')
        for(i = 0; i < this.length; i += 1)this[i].style[props] = value;
        return this;
    }
    return this;
}
function each(callback) {
    if (!callback) return this;
    this.forEach((el, index)=>{
        callback.apply(el, [
            el,
            index
        ]);
    });
    return this;
}
function filter(callback) {
    const result = arrayFilter(this, callback);
    return $(result);
}
function html(html) {
    if (typeof html === 'undefined') return this[0] ? this[0].innerHTML : null;
    for(let i = 0; i < this.length; i += 1)this[i].innerHTML = html;
    return this;
}
function text(text) {
    if (typeof text === 'undefined') return this[0] ? this[0].textContent.trim() : null;
    for(let i = 0; i < this.length; i += 1)this[i].textContent = text;
    return this;
}
function is(selector) {
    const window = (0, $4acFp.getWindow)();
    const document = (0, $4acFp.getDocument)();
    const el = this[0];
    let compareWith;
    let i;
    if (!el || typeof selector === 'undefined') return false;
    if (typeof selector === 'string') {
        if (el.matches) return el.matches(selector);
        if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
        if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        compareWith = $(selector);
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    if (selector === document) return el === document;
    if (selector === window) return el === window;
    if (selector.nodeType || selector instanceof Dom7) {
        compareWith = selector.nodeType ? [
            selector
        ] : selector;
        for(i = 0; i < compareWith.length; i += 1){
            if (compareWith[i] === el) return true;
        }
        return false;
    }
    return false;
}
function index() {
    let child = this[0];
    let i;
    if (child) {
        i = 0; // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function eq(index) {
    if (typeof index === 'undefined') return this;
    const length = this.length;
    if (index > length - 1) return $([]);
    if (index < 0) {
        const returnIndex = length + index;
        if (returnIndex < 0) return $([]);
        return $([
            this[returnIndex]
        ]);
    }
    return $([
        this[index]
    ]);
}
function append(...els) {
    let newChild;
    const document = (0, $4acFp.getDocument)();
    for(let k = 0; k < els.length; k += 1){
        newChild = els[k];
        for(let i = 0; i < this.length; i += 1){
            if (typeof newChild === 'string') {
                const tempDiv = document.createElement('div');
                tempDiv.innerHTML = newChild;
                while(tempDiv.firstChild)this[i].appendChild(tempDiv.firstChild);
            } else if (newChild instanceof Dom7) for(let j = 0; j < newChild.length; j += 1)this[i].appendChild(newChild[j]);
            else this[i].appendChild(newChild);
        }
    }
    return this;
}
function appendTo(parent) {
    $(parent).append(this);
    return this;
}
function prepend(newChild) {
    const document = (0, $4acFp.getDocument)();
    let i;
    let j;
    for(i = 0; i < this.length; i += 1){
        if (typeof newChild === 'string') {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = newChild;
            for(j = tempDiv.childNodes.length - 1; j >= 0; j -= 1)this[i].insertBefore(tempDiv.childNodes[j], this[i].childNodes[0]);
        } else if (newChild instanceof Dom7) for(j = 0; j < newChild.length; j += 1)this[i].insertBefore(newChild[j], this[i].childNodes[0]);
        else this[i].insertBefore(newChild, this[i].childNodes[0]);
    }
    return this;
}
function prependTo(parent) {
    $(parent).prepend(this);
    return this;
}
function insertBefore(selector) {
    const before = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (before.length === 1) before[0].parentNode.insertBefore(this[i], before[0]);
        else if (before.length > 1) for(let j = 0; j < before.length; j += 1)before[j].parentNode.insertBefore(this[i].cloneNode(true), before[j]);
    }
}
function insertAfter(selector) {
    const after = $(selector);
    for(let i = 0; i < this.length; i += 1){
        if (after.length === 1) after[0].parentNode.insertBefore(this[i], after[0].nextSibling);
        else if (after.length > 1) for(let j = 0; j < after.length; j += 1)after[j].parentNode.insertBefore(this[i].cloneNode(true), after[j].nextSibling);
    }
}
function next(selector) {
    if (this.length > 0) {
        if (selector) {
            if (this[0].nextElementSibling && $(this[0].nextElementSibling).is(selector)) return $([
                this[0].nextElementSibling
            ]);
            return $([]);
        }
        if (this[0].nextElementSibling) return $([
            this[0].nextElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function nextAll(selector) {
    const nextEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.nextElementSibling){
        const next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if ($(next).is(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return $(nextEls);
}
function prev(selector) {
    if (this.length > 0) {
        const el = this[0];
        if (selector) {
            if (el.previousElementSibling && $(el.previousElementSibling).is(selector)) return $([
                el.previousElementSibling
            ]);
            return $([]);
        }
        if (el.previousElementSibling) return $([
            el.previousElementSibling
        ]);
        return $([]);
    }
    return $([]);
}
function prevAll(selector) {
    const prevEls = [];
    let el = this[0];
    if (!el) return $([]);
    while(el.previousElementSibling){
        const prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if ($(prev).is(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return $(prevEls);
}
function siblings(selector) {
    return this.nextAll(selector).add(this.prevAll(selector));
}
function parent(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode !== null) {
        if (selector) {
            if ($(this[i].parentNode).is(selector)) parents.push(this[i].parentNode);
        } else parents.push(this[i].parentNode);
    }
    return $(parents);
}
function parents(selector) {
    const parents = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        let parent = this[i].parentNode; // eslint-disable-line
        while(parent){
            if (selector) {
                if ($(parent).is(selector)) parents.push(parent);
            } else parents.push(parent);
            parent = parent.parentNode;
        }
    }
    return $(parents);
}
function closest(selector) {
    let closest = this; // eslint-disable-line
    if (typeof selector === 'undefined') return $([]);
    if (!closest.is(selector)) closest = closest.parents(selector).eq(0);
    return closest;
}
function find(selector) {
    const foundElements = [];
    for(let i = 0; i < this.length; i += 1){
        const found = this[i].querySelectorAll(selector);
        for(let j = 0; j < found.length; j += 1)foundElements.push(found[j]);
    }
    return $(foundElements);
}
function children(selector) {
    const children = []; // eslint-disable-line
    for(let i = 0; i < this.length; i += 1){
        const childNodes = this[i].children;
        for(let j = 0; j < childNodes.length; j += 1)if (!selector || $(childNodes[j]).is(selector)) children.push(childNodes[j]);
    }
    return $(children);
}
function remove() {
    for(let i = 0; i < this.length; i += 1)if (this[i].parentNode) this[i].parentNode.removeChild(this[i]);
    return this;
}
function detach() {
    return this.remove();
}
function add(...els) {
    const dom = this;
    let i;
    let j;
    for(i = 0; i < els.length; i += 1){
        const toAdd = $(els[i]);
        for(j = 0; j < toAdd.length; j += 1)dom.push(toAdd[j]);
    }
    return dom;
}
function empty() {
    for(let i = 0; i < this.length; i += 1){
        const el = this[i];
        if (el.nodeType === 1) {
            for(let j = 0; j < el.childNodes.length; j += 1)if (el.childNodes[j].parentNode) el.childNodes[j].parentNode.removeChild(el.childNodes[j]);
            el.textContent = '';
        }
    }
    return this;
}
// eslint-disable-next-line
function scrollTo(...args) {
    const window = (0, $4acFp.getWindow)();
    let [left, top, duration, easing, callback] = args;
    if (args.length === 4 && typeof easing === 'function') {
        callback = easing;
        [left, top, duration, callback, easing] = args;
    }
    if (typeof easing === 'undefined') easing = 'swing';
    return this.each(function animate() {
        const el = this;
        let currentTop;
        let currentLeft;
        let maxTop;
        let maxLeft;
        let newTop;
        let newLeft;
        let scrollTop; // eslint-disable-line
        let scrollLeft; // eslint-disable-line
        let animateTop = top > 0 || top === 0;
        let animateLeft = left > 0 || left === 0;
        if (typeof easing === 'undefined') easing = 'swing';
        if (animateTop) {
            currentTop = el.scrollTop;
            if (!duration) el.scrollTop = top;
        }
        if (animateLeft) {
            currentLeft = el.scrollLeft;
            if (!duration) el.scrollLeft = left;
        }
        if (!duration) return;
        if (animateTop) {
            maxTop = el.scrollHeight - el.offsetHeight;
            newTop = Math.max(Math.min(top, maxTop), 0);
        }
        if (animateLeft) {
            maxLeft = el.scrollWidth - el.offsetWidth;
            newLeft = Math.max(Math.min(left, maxLeft), 0);
        }
        let startTime = null;
        if (animateTop && newTop === currentTop) animateTop = false;
        if (animateLeft && newLeft === currentLeft) animateLeft = false;
        function render(time = new Date().getTime()) {
            if (startTime === null) startTime = time;
            const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
            const easeProgress = easing === 'linear' ? progress : 0.5 - Math.cos(progress * Math.PI) / 2;
            let done;
            if (animateTop) scrollTop = currentTop + easeProgress * (newTop - currentTop);
            if (animateLeft) scrollLeft = currentLeft + easeProgress * (newLeft - currentLeft);
            if (animateTop && newTop > currentTop && scrollTop >= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateTop && newTop < currentTop && scrollTop <= newTop) {
                el.scrollTop = newTop;
                done = true;
            }
            if (animateLeft && newLeft > currentLeft && scrollLeft >= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (animateLeft && newLeft < currentLeft && scrollLeft <= newLeft) {
                el.scrollLeft = newLeft;
                done = true;
            }
            if (done) {
                if (callback) callback();
                return;
            }
            if (animateTop) el.scrollTop = scrollTop;
            if (animateLeft) el.scrollLeft = scrollLeft;
            window.requestAnimationFrame(render);
        }
        window.requestAnimationFrame(render);
    });
} // scrollTop(top, duration, easing, callback) {
function scrollTop(...args) {
    let [top, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [top, duration, callback, easing] = args;
    const dom = this;
    if (typeof top === 'undefined') {
        if (dom.length > 0) return dom[0].scrollTop;
        return null;
    }
    return dom.scrollTo(undefined, top, duration, easing, callback);
}
function scrollLeft(...args) {
    let [left, duration, easing, callback] = args;
    if (args.length === 3 && typeof easing === 'function') [left, duration, callback, easing] = args;
    const dom = this;
    if (typeof left === 'undefined') {
        if (dom.length > 0) return dom[0].scrollLeft;
        return null;
    }
    return dom.scrollTo(left, undefined, duration, easing, callback);
}
// eslint-disable-next-line
function animate(initialProps, initialParams) {
    const window = (0, $4acFp.getWindow)();
    const els = this;
    const a = {
        props: Object.assign({}, initialProps),
        params: Object.assign({
            duration: 300,
            easing: 'swing' // or 'linear'
        }, initialParams),
        elements: els,
        animating: false,
        que: [],
        easingProgress (easing, progress) {
            if (easing === 'swing') return 0.5 - Math.cos(progress * Math.PI) / 2;
            if (typeof easing === 'function') return easing(progress);
            return progress;
        },
        stop () {
            if (a.frameId) window.cancelAnimationFrame(a.frameId);
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            a.que = [];
        },
        done (complete) {
            a.animating = false;
            a.elements.each((el)=>{
                const element = el;
                delete element.dom7AnimateInstance;
            });
            if (complete) complete(els);
            if (a.que.length > 0) {
                const que = a.que.shift();
                a.animate(que[0], que[1]);
            }
        },
        animate (props, params) {
            if (a.animating) {
                a.que.push([
                    props,
                    params
                ]);
                return a;
            }
            const elements = []; // Define & Cache Initials & Units
            a.elements.each((el, index)=>{
                let initialFullValue;
                let initialValue;
                let unit;
                let finalValue;
                let finalFullValue;
                if (!el.dom7AnimateInstance) a.elements[index].dom7AnimateInstance = a;
                elements[index] = {
                    container: el
                };
                Object.keys(props).forEach((prop)=>{
                    initialFullValue = window.getComputedStyle(el, null).getPropertyValue(prop).replace(',', '.');
                    initialValue = parseFloat(initialFullValue);
                    unit = initialFullValue.replace(initialValue, '');
                    finalValue = parseFloat(props[prop]);
                    finalFullValue = props[prop] + unit;
                    elements[index][prop] = {
                        initialFullValue: initialFullValue,
                        initialValue: initialValue,
                        unit: unit,
                        finalValue: finalValue,
                        finalFullValue: finalFullValue,
                        currentValue: initialValue
                    };
                });
            });
            let startTime = null;
            let time;
            let elementsDone = 0;
            let propsDone = 0;
            let done;
            let began = false;
            a.animating = true;
            function render() {
                time = new Date().getTime();
                let progress;
                let easeProgress; // let el;
                if (!began) {
                    began = true;
                    if (params.begin) params.begin(els);
                }
                if (startTime === null) startTime = time;
                if (params.progress) // eslint-disable-next-line
                params.progress(els, Math.max(Math.min((time - startTime) / params.duration, 1), 0), startTime + params.duration - time < 0 ? 0 : startTime + params.duration - time, startTime);
                elements.forEach((element)=>{
                    const el = element;
                    if (done || el.done) return;
                    Object.keys(props).forEach((prop)=>{
                        if (done || el.done) return;
                        progress = Math.max(Math.min((time - startTime) / params.duration, 1), 0);
                        easeProgress = a.easingProgress(params.easing, progress);
                        const { initialValue, finalValue, unit } = el[prop];
                        el[prop].currentValue = initialValue + easeProgress * (finalValue - initialValue);
                        const currentValue = el[prop].currentValue;
                        if (finalValue > initialValue && currentValue >= finalValue || finalValue < initialValue && currentValue <= finalValue) {
                            el.container.style[prop] = finalValue + unit;
                            propsDone += 1;
                            if (propsDone === Object.keys(props).length) {
                                el.done = true;
                                elementsDone += 1;
                            }
                            if (elementsDone === elements.length) done = true;
                        }
                        if (done) {
                            a.done(params.complete);
                            return;
                        }
                        el.container.style[prop] = currentValue + unit;
                    });
                });
                if (done) return; // Then call
                a.frameId = window.requestAnimationFrame(render);
            }
            a.frameId = window.requestAnimationFrame(render);
            return a;
        }
    };
    if (a.elements.length === 0) return els;
    let animateInstance;
    for(let i = 0; i < a.elements.length; i += 1)if (a.elements[i].dom7AnimateInstance) animateInstance = a.elements[i].dom7AnimateInstance;
    else a.elements[i].dom7AnimateInstance = a;
    if (!animateInstance) animateInstance = a;
    if (initialProps === 'stop') animateInstance.stop();
    else animateInstance.animate(a.props, a.params);
    return els;
}
function stop() {
    const els = this;
    for(let i = 0; i < els.length; i += 1)if (els[i].dom7AnimateInstance) els[i].dom7AnimateInstance.stop();
}
const noTrigger = 'resize scroll'.split(' ');
function shortcut(name) {
    function eventHandler(...args) {
        if (typeof args[0] === 'undefined') {
            for(let i = 0; i < this.length; i += 1)if (noTrigger.indexOf(name) < 0) {
                if (name in this[i]) this[i][name]();
                else $(this[i]).trigger(name);
            }
            return this;
        }
        return this.on(name, ...args);
    }
    return eventHandler;
}
const click = shortcut('click');
const blur = shortcut('blur');
const focus = shortcut('focus');
const focusin = shortcut('focusin');
const focusout = shortcut('focusout');
const keyup = shortcut('keyup');
const keydown = shortcut('keydown');
const keypress = shortcut('keypress');
const submit = shortcut('submit');
const change = shortcut('change');
const mousedown = shortcut('mousedown');
const mousemove = shortcut('mousemove');
const mouseup = shortcut('mouseup');
const mouseenter = shortcut('mouseenter');
const mouseleave = shortcut('mouseleave');
const mouseout = shortcut('mouseout');
const mouseover = shortcut('mouseover');
const touchstart = shortcut('touchstart');
const touchend = shortcut('touchend');
const touchmove = shortcut('touchmove');
const resize = shortcut('resize');
const scroll = shortcut('scroll');
var $3c320048fa76b910$export$2e2bcd8739ae039 = $;

});
parcelRegister("4acFp", function(module, exports) {

$parcel$export(module.exports, "getDocument", function () { return $3081ebf44248f949$export$f65ca476c09acec0; });
$parcel$export(module.exports, "getWindow", function () { return $3081ebf44248f949$export$38b2d434cce3ea22; });
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $3081ebf44248f949$var$isObject(obj) {
    return obj !== null && typeof obj === 'object' && 'constructor' in obj && obj.constructor === Object;
}
function $3081ebf44248f949$export$8b58be045bf06082(target = {}, src = {}) {
    Object.keys(src).forEach((key)=>{
        if (typeof target[key] === 'undefined') target[key] = src[key];
        else if ($3081ebf44248f949$var$isObject(src[key]) && $3081ebf44248f949$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $3081ebf44248f949$export$8b58be045bf06082(target[key], src[key]);
    });
}
const $3081ebf44248f949$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ''
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    }
};
function $3081ebf44248f949$export$f65ca476c09acec0() {
    const doc = typeof document !== 'undefined' ? document : {};
    $3081ebf44248f949$export$8b58be045bf06082(doc, $3081ebf44248f949$export$3fdcb9b4d81368d8);
    return doc;
}
const $3081ebf44248f949$export$8582633f185c62bb = {
    document: $3081ebf44248f949$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ''
    },
    location: {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        protocol: '',
        search: ''
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return '';
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (callback) {
        if (typeof setTimeout === 'undefined') {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame (id) {
        if (typeof setTimeout === 'undefined') return;
        clearTimeout(id);
    }
};
function $3081ebf44248f949$export$38b2d434cce3ea22() {
    const win = typeof window !== 'undefined' ? window : {};
    $3081ebf44248f949$export$8b58be045bf06082(win, $3081ebf44248f949$export$8582633f185c62bb);
    return win;
}

});


// First we get the viewport height and we multiple it by 1% to get a value for a vh unit
const $28c15c8b5c5906e8$var$vhUtils = window.innerHeight * 0.01;
// Then we set the value in the --vh custom property to the root of the document
document.documentElement.style.setProperty('--vh', `${$28c15c8b5c5906e8$var$vhUtils}px`);
// We listen to the resize event
window.addEventListener('resize', ()=>{
    // We execute the same script as before
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
});


var $d0178846fa869d5e$exports = {};
/** @type {import('tailwindcss').Config} */ $d0178846fa869d5e$exports = {
    /**
     * FD content
     * **/ // content: ["./src/**/*.{html,js}"],
    /**
     * SD content
     * **/ content: [
        './app/modules/**/*.php',
        './app/layout/**/*.php',
        './app/modules/!panel/**',
        './app/public/js/*.js',
        '!./**/system/**',
        './src/js/**/*.js',
        './src/js/*.js'
    ],
    theme: {
        screens: {
            'xs': '360px',
            // => @media (min-width: 360px) { ... }
            'sm': '640px',
            // => @media (min-width: 640px) { ... }
            'md': '768px',
            // => @media (min-width: 768px) { ... }
            'lg': '1024px',
            // => @media (min-width: 1024px) { ... }
            'xl': '1280px',
            // => @media (min-width: 1280px) { ... }
            '2xl': '1536px',
            // => @media (min-width: 1536px) { ... }
            '3xl': '1800px'
        },
        extend: {
            colors: {
                transparent: "transparent",
                current: "currentColor"
            }
        }
    },
    plugins: []
};


function $5c2065aa5c493538$export$74b8f1741b4483c3(options = {}) {
    const defaultOptions = {
        animateOnce: true,
        speed: 600,
        threshold: 0.5,
        delay: 0,
        easing: 'ease',
        disableMutationObserver: false,
        breakpoints: {}
    };
    // Export breakpoints from tailwind
    if (Object.keys((0, (/*@__PURE__*/$parcel$interopDefault($d0178846fa869d5e$exports))).theme.screens).length) defaultOptions.breakpoints = (0, (/*@__PURE__*/$parcel$interopDefault($d0178846fa869d5e$exports))).theme.screens;
    /* --- Merge all options --- */ const { breakpoints: breakpoints } = defaultOptions;
    const mergedBreakpoints = Object.assign(breakpoints, options.breakpoints);
    const mainOptions = Object.assign(defaultOptions, options);
    mainOptions.breakpoints = mergedBreakpoints;
    /* --- Set global properties --- */ function setGlobalProperty(name, value, isTimeUnit) {
        if (isTimeUnit) value += 'ms';
        document.documentElement.style.setProperty(`--view-${name}`, `${value}`);
    }
    const { speed: speed, easing: easing } = mainOptions;
    setGlobalProperty('speed', speed, true);
    setGlobalProperty('easing', easing);
    // Setup of Intersection Observer
    const intesectionObserver = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            // Show element
            if (entry.isIntersecting) entry.target.classList.add('animated');
            else if (!entry.isIntersecting && !mainOptions.animateOnce) entry.target.classList.remove('animated');
        });
    }, {
        threshold: 0,
        rootMargin: '0% 0% -10% 0%'
    });
    // Change animation of element on breakpoints
    function changeEffectOnResize(element, breakpoint, effect) {
        const initialEffect = element.dataset.view;
        let fixedBreakpoint = typeof breakpoint === 'string' ? breakpoint.replace(/\D/g, '') : breakpoint;
        if (window.innerWidth >= fixedBreakpoint) element.dataset.view = effect;
        else element.dataset.view = initialEffect;
    }
    // Main function to observe element
    function intersectElement(element, isMutation = false) {
        element.classList.add('in-view');
        const dataset = element.dataset;
        // Set speed to current element
        if (dataset.viewSpeed) element.style.transitionDuration = `${dataset.viewSpeed}ms`;
        // Set easing to current element
        if (dataset.viewEasing) element.style.transitionTimingFunction = dataset.viewEasing;
        for(const key in dataset){
            const property = key.toLowerCase();
            let dataViewValue = property.match(/view(.*)/)[1].replace(/^-/, '');
            // Check if dataset value equal to breakpoint
            if (dataViewValue && dataViewValue in breakpoints) changeEffectOnResize(element, breakpoints[dataViewValue], dataset[key]);
        }
        if (!isMutation) window.addEventListener('load', ()=>{
            // Observe element with delay
            if (dataset.viewDelay) setTimeout(()=>intesectionObserver.observe(element), dataset.viewDelay);
            else intesectionObserver.observe(element);
        });
        else intesectionObserver.observe(element);
    }
    /* --- Intersect elements on init --- */ const targetElements = document.querySelectorAll('[data-view]');
    if (targetElements.length) targetElements.forEach((target)=>intersectElement(target));
    /* --- Intersect dynamically added elements in DOM --- */ if (!mainOptions.disableMutationObserver) {
        // Callback function to handle the mutations
        const handleMutations = function(mutationsList) {
            for (const mutation of mutationsList)if (mutation.addedNodes.length) {
                // Check if any added node has the desired class
                const addedNodes = mutation.addedNodes;
                addedNodes.forEach((target)=>{
                    if (target.dataset && 'view' in target.dataset) intersectElement(target, true);
                });
            }
        };
        // Create a MutationObserver instance
        const mutationObserver = new MutationObserver(handleMutations);
        const mutationObserverOptions = {
            childList: true,
            subtree: true,
            characterData: false
        };
        mutationObserver.observe(document.body, mutationObserverOptions);
    }
}
// Test call
$5c2065aa5c493538$export$74b8f1741b4483c3();
const $5c2065aa5c493538$var$startViewAnimationArr = document.querySelectorAll('.start-view-animation');
if ($5c2065aa5c493538$var$startViewAnimationArr.length) for(let i = 0; i < $5c2065aa5c493538$var$startViewAnimationArr.length; i++)setTimeout(function() {
    $5c2065aa5c493538$var$startViewAnimationArr[i].classList.add('animated');
}, 50);


function $97f4084bd576acac$var$setParallax(element, effectSpeed) {
    element.style.opacity = 1;
    function handleScroll() {
        const defaultSpeed = 0.1;
        const originalSpeed = parseFloat(element.getAttribute('data-parallax-view-speed')) || defaultSpeed;
        const speed = originalSpeed / 10;
        const scroll = window.scrollY + window.innerHeight;
        const elPos = element.getBoundingClientRect().top + window.scrollY;
        let newPos = 0;
        if (elPos + element.clientHeight >= window.scrollY) {
            if (window.innerHeight >= elPos) {
                newPos = window.scrollY * speed;
                if (element.hasAttribute('data-parallax-view-horizontal') === true) element.style.transform = `translateX(${-newPos}px)`;
                else element.style.transform = `translateY(${-newPos}px)`;
            } else if (scroll >= elPos) {
                newPos = (elPos - (window.scrollY + window.innerHeight)) * speed;
                if (element.hasAttribute('data-parallax-view-horizontal') === true) element.style.transform = `translateX(${newPos}px)`;
                else element.style.transform = `translateY(${newPos}px)`;
            }
        }
    }
    window.addEventListener('scroll', handleScroll);
    handleScroll();
}
const $97f4084bd576acac$var$parallaxElements = document.querySelectorAll('[data-parallax-view]');
$97f4084bd576acac$var$parallaxElements.forEach((element)=>{
    $97f4084bd576acac$var$setParallax(element);
});


function $4feb6e53421ae19f$var$isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
if ($4feb6e53421ae19f$var$isSafari()) {
    const mainElement = document.getElementsByClassName('main')[0];
    const footerElement = document.getElementsByClassName('footer')[0];
    if (mainElement) mainElement.classList.add('is-safari');
    if (footerElement) footerElement.classList.add('is-safari');
}


var $e911b83697f16430$var$Ee = Object.defineProperty;
var $e911b83697f16430$var$Se = (n, t, e)=>t in n ? $e911b83697f16430$var$Ee(n, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: e
    }) : n[t] = e;
var $e911b83697f16430$var$At = (n, t, e)=>($e911b83697f16430$var$Se(n, typeof t != "symbol" ? t + "" : t, e), e), $e911b83697f16430$var$wt = (n, t, e)=>{
    if (!t.has(n)) throw TypeError("Cannot " + e);
};
var $e911b83697f16430$var$l = (n, t, e)=>($e911b83697f16430$var$wt(n, t, "read from private field"), e ? e.call(n) : t.get(n)), $e911b83697f16430$var$r = (n, t, e)=>{
    if (t.has(n)) throw TypeError("Cannot add the same private member more than once");
    t instanceof WeakSet ? t.add(n) : t.set(n, e);
}, $e911b83697f16430$var$xt = (n, t, e, o)=>($e911b83697f16430$var$wt(n, t, "write to private field"), o ? o.call(n, e) : t.set(n, e), e);
var $e911b83697f16430$var$i = (n, t, e)=>($e911b83697f16430$var$wt(n, t, "access private method"), e);
const $e911b83697f16430$var$$e = {
    title: "Cookies compliance",
    message: "We use cookies",
    policy: "",
    btnAccept: "Accept all",
    btnReject: "Reject all",
    btnDismiss: "Cookies policy",
    btnInfo: "Details",
    btnSettings: "Settings",
    content_align: "left",
    info: ""
};
let $e911b83697f16430$var$Te = (n)=>crypto.getRandomValues(new Uint8Array(n)), $e911b83697f16430$var$Ae = (n, t, e)=>{
    let o = (2 << Math.log(n.length - 1) / Math.LN2) - 1, s = -~(1.6 * o * t / n.length);
    return (c = t)=>{
        let a = "";
        for(;;){
            let d = e(s), u = s;
            for(; u--;)if (a += n[d[u] & o] || "", a.length === c) return a;
        }
    };
}, $e911b83697f16430$var$je = (n, t = 21)=>$e911b83697f16430$var$Ae(n, t, $e911b83697f16430$var$Te);
const $e911b83697f16430$var$Le = $e911b83697f16430$var$je("1234567890abcdef", 10);
var $e911b83697f16430$var$Re = typeof $parcel$global == "object" && $parcel$global && $parcel$global.Object === Object && $parcel$global, $e911b83697f16430$var$Oe = typeof self == "object" && self && self.Object === Object && self, $e911b83697f16430$var$He = $e911b83697f16430$var$Re || $e911b83697f16430$var$Oe || Function("return this")(), $e911b83697f16430$var$B = $e911b83697f16430$var$He.Symbol, $e911b83697f16430$var$Wt = Object.prototype, $e911b83697f16430$var$Be = $e911b83697f16430$var$Wt.hasOwnProperty, $e911b83697f16430$var$Ie = $e911b83697f16430$var$Wt.toString, $e911b83697f16430$var$I = $e911b83697f16430$var$B ? $e911b83697f16430$var$B.toStringTag : void 0;
function $e911b83697f16430$var$Me(n) {
    var t = $e911b83697f16430$var$Be.call(n, $e911b83697f16430$var$I), e = n[$e911b83697f16430$var$I];
    try {
        n[$e911b83697f16430$var$I] = void 0;
        var o = !0;
    } catch  {}
    var s = $e911b83697f16430$var$Ie.call(n);
    return o && (t ? n[$e911b83697f16430$var$I] = e : delete n[$e911b83697f16430$var$I]), s;
}
var $e911b83697f16430$var$_e = Object.prototype, $e911b83697f16430$var$De = $e911b83697f16430$var$_e.toString;
function $e911b83697f16430$var$Ne(n) {
    return $e911b83697f16430$var$De.call(n);
}
var $e911b83697f16430$var$Ue = "[object Null]", $e911b83697f16430$var$Fe = "[object Undefined]", $e911b83697f16430$var$jt = $e911b83697f16430$var$B ? $e911b83697f16430$var$B.toStringTag : void 0;
function $e911b83697f16430$var$Ge(n) {
    return n == null ? n === void 0 ? $e911b83697f16430$var$Fe : $e911b83697f16430$var$Ue : $e911b83697f16430$var$jt && $e911b83697f16430$var$jt in Object(n) ? $e911b83697f16430$var$Me(n) : $e911b83697f16430$var$Ne(n);
}
function $e911b83697f16430$var$We(n) {
    return n != null && typeof n == "object";
}
var $e911b83697f16430$var$Pe = "[object Symbol]";
function $e911b83697f16430$var$ze(n) {
    return typeof n == "symbol" || $e911b83697f16430$var$We(n) && $e911b83697f16430$var$Ge(n) == $e911b83697f16430$var$Pe;
}
function $e911b83697f16430$var$Ze(n, t) {
    for(var e = -1, o = n == null ? 0 : n.length, s = Array(o); ++e < o;)s[e] = t(n[e], e, n);
    return s;
}
var $e911b83697f16430$var$Je = Array.isArray, $e911b83697f16430$var$qe = 1 / 0, $e911b83697f16430$var$Lt = $e911b83697f16430$var$B ? $e911b83697f16430$var$B.prototype : void 0, $e911b83697f16430$var$Rt = $e911b83697f16430$var$Lt ? $e911b83697f16430$var$Lt.toString : void 0;
function $e911b83697f16430$var$Pt(n) {
    if (typeof n == "string") return n;
    if ($e911b83697f16430$var$Je(n)) return $e911b83697f16430$var$Ze(n, $e911b83697f16430$var$Pt) + "";
    if ($e911b83697f16430$var$ze(n)) return $e911b83697f16430$var$Rt ? $e911b83697f16430$var$Rt.call(n) : "";
    var t = n + "";
    return t == "0" && 1 / n == -$e911b83697f16430$var$qe ? "-0" : t;
}
function $e911b83697f16430$var$zt(n) {
    return n == null ? "" : $e911b83697f16430$var$Pt(n);
}
function $e911b83697f16430$var$Ke(n, t, e, o) {
    var s = -1, c = n == null ? 0 : n.length;
    for(o && c && (e = n[++s]); ++s < c;)e = t(e, n[s], s, n);
    return e;
}
function $e911b83697f16430$var$Ve(n) {
    return function(t) {
        return n == null ? void 0 : n[t];
    };
}
var $e911b83697f16430$var$Ye = {
    // Latin-1 Supplement block.
    "\xc0": "A",
    "\xc1": "A",
    "\xc2": "A",
    "\xc3": "A",
    "\xc4": "A",
    "\xc5": "A",
    "\xe0": "a",
    "\xe1": "a",
    "\xe2": "a",
    "\xe3": "a",
    "\xe4": "a",
    "\xe5": "a",
    "\xc7": "C",
    "\xe7": "c",
    "\xd0": "D",
    "\xf0": "d",
    "\xc8": "E",
    "\xc9": "E",
    "\xca": "E",
    "\xcb": "E",
    "\xe8": "e",
    "\xe9": "e",
    "\xea": "e",
    "\xeb": "e",
    "\xcc": "I",
    "\xcd": "I",
    "\xce": "I",
    "\xcf": "I",
    "\xec": "i",
    "\xed": "i",
    "\xee": "i",
    "\xef": "i",
    "\xd1": "N",
    "\xf1": "n",
    "\xd2": "O",
    "\xd3": "O",
    "\xd4": "O",
    "\xd5": "O",
    "\xd6": "O",
    "\xd8": "O",
    "\xf2": "o",
    "\xf3": "o",
    "\xf4": "o",
    "\xf5": "o",
    "\xf6": "o",
    "\xf8": "o",
    "\xd9": "U",
    "\xda": "U",
    "\xdb": "U",
    "\xdc": "U",
    "\xf9": "u",
    "\xfa": "u",
    "\xfb": "u",
    "\xfc": "u",
    "\xdd": "Y",
    "\xfd": "y",
    "\xff": "y",
    "\xc6": "Ae",
    "\xe6": "ae",
    "\xde": "Th",
    "\xfe": "th",
    "\xdf": "ss",
    // Latin Extended-A block.
    \u0100: "A",
    \u0102: "A",
    \u0104: "A",
    \u0101: "a",
    \u0103: "a",
    \u0105: "a",
    \u0106: "C",
    \u0108: "C",
    \u010A: "C",
    \u010C: "C",
    \u0107: "c",
    \u0109: "c",
    \u010B: "c",
    \u010D: "c",
    \u010E: "D",
    \u0110: "D",
    \u010F: "d",
    \u0111: "d",
    \u0112: "E",
    \u0114: "E",
    \u0116: "E",
    \u0118: "E",
    \u011A: "E",
    \u0113: "e",
    \u0115: "e",
    \u0117: "e",
    \u0119: "e",
    \u011B: "e",
    \u011C: "G",
    \u011E: "G",
    \u0120: "G",
    \u0122: "G",
    \u011D: "g",
    \u011F: "g",
    \u0121: "g",
    \u0123: "g",
    \u0124: "H",
    \u0126: "H",
    \u0125: "h",
    \u0127: "h",
    \u0128: "I",
    \u012A: "I",
    \u012C: "I",
    \u012E: "I",
    \u0130: "I",
    \u0129: "i",
    \u012B: "i",
    \u012D: "i",
    \u012F: "i",
    \u0131: "i",
    \u0134: "J",
    \u0135: "j",
    \u0136: "K",
    \u0137: "k",
    \u0138: "k",
    \u0139: "L",
    \u013B: "L",
    \u013D: "L",
    \u013F: "L",
    \u0141: "L",
    \u013A: "l",
    \u013C: "l",
    \u013E: "l",
    \u0140: "l",
    \u0142: "l",
    \u0143: "N",
    \u0145: "N",
    \u0147: "N",
    \u014A: "N",
    \u0144: "n",
    \u0146: "n",
    \u0148: "n",
    \u014B: "n",
    \u014C: "O",
    \u014E: "O",
    \u0150: "O",
    \u014D: "o",
    \u014F: "o",
    \u0151: "o",
    \u0154: "R",
    \u0156: "R",
    \u0158: "R",
    \u0155: "r",
    \u0157: "r",
    \u0159: "r",
    \u015A: "S",
    \u015C: "S",
    \u015E: "S",
    \u0160: "S",
    \u015B: "s",
    \u015D: "s",
    \u015F: "s",
    \u0161: "s",
    \u0162: "T",
    \u0164: "T",
    \u0166: "T",
    \u0163: "t",
    \u0165: "t",
    \u0167: "t",
    \u0168: "U",
    \u016A: "U",
    \u016C: "U",
    \u016E: "U",
    \u0170: "U",
    \u0172: "U",
    \u0169: "u",
    \u016B: "u",
    \u016D: "u",
    \u016F: "u",
    \u0171: "u",
    \u0173: "u",
    \u0174: "W",
    \u0175: "w",
    \u0176: "Y",
    \u0177: "y",
    \u0178: "Y",
    \u0179: "Z",
    \u017B: "Z",
    \u017D: "Z",
    \u017A: "z",
    \u017C: "z",
    \u017E: "z",
    \u0132: "IJ",
    \u0133: "ij",
    \u0152: "Oe",
    \u0153: "oe",
    \u0149: "'n",
    \u017F: "s"
}, $e911b83697f16430$var$Qe = $e911b83697f16430$var$Ve($e911b83697f16430$var$Ye);
const $e911b83697f16430$var$Xe = $e911b83697f16430$var$Qe;
var $e911b83697f16430$var$tn = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g, $e911b83697f16430$var$en = "\\u0300-\\u036f", $e911b83697f16430$var$nn = "\\ufe20-\\ufe2f", $e911b83697f16430$var$on = "\\u20d0-\\u20ff", $e911b83697f16430$var$sn = $e911b83697f16430$var$en + $e911b83697f16430$var$nn + $e911b83697f16430$var$on, $e911b83697f16430$var$cn = "[" + $e911b83697f16430$var$sn + "]", $e911b83697f16430$var$an = RegExp($e911b83697f16430$var$cn, "g");
function $e911b83697f16430$var$rn(n) {
    return n = $e911b83697f16430$var$zt(n), n && n.replace($e911b83697f16430$var$tn, $e911b83697f16430$var$Xe).replace($e911b83697f16430$var$an, "");
}
var $e911b83697f16430$var$dn = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
function $e911b83697f16430$var$un(n) {
    return n.match($e911b83697f16430$var$dn) || [];
}
var $e911b83697f16430$var$ln = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
function $e911b83697f16430$var$mn(n) {
    return $e911b83697f16430$var$ln.test(n);
}
var $e911b83697f16430$var$Zt = "\\ud800-\\udfff", $e911b83697f16430$var$fn = "\\u0300-\\u036f", $e911b83697f16430$var$gn = "\\ufe20-\\ufe2f", $e911b83697f16430$var$pn = "\\u20d0-\\u20ff", $e911b83697f16430$var$hn = $e911b83697f16430$var$fn + $e911b83697f16430$var$gn + $e911b83697f16430$var$pn, $e911b83697f16430$var$Jt = "\\u2700-\\u27bf", $e911b83697f16430$var$qt = "a-z\\xdf-\\xf6\\xf8-\\xff", $e911b83697f16430$var$bn = "\\xac\\xb1\\xd7\\xf7", $e911b83697f16430$var$kn = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", $e911b83697f16430$var$wn = "\\u2000-\\u206f", $e911b83697f16430$var$xn = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", $e911b83697f16430$var$Kt = "A-Z\\xc0-\\xd6\\xd8-\\xde", $e911b83697f16430$var$Cn = "\\ufe0e\\ufe0f", $e911b83697f16430$var$Vt = $e911b83697f16430$var$bn + $e911b83697f16430$var$kn + $e911b83697f16430$var$wn + $e911b83697f16430$var$xn, $e911b83697f16430$var$Yt = "['\u2019]", $e911b83697f16430$var$Ot = "[" + $e911b83697f16430$var$Vt + "]", $e911b83697f16430$var$yn = "[" + $e911b83697f16430$var$hn + "]", $e911b83697f16430$var$Qt = "\\d+", $e911b83697f16430$var$vn = "[" + $e911b83697f16430$var$Jt + "]", $e911b83697f16430$var$Xt = "[" + $e911b83697f16430$var$qt + "]", $e911b83697f16430$var$te = "[^" + $e911b83697f16430$var$Zt + $e911b83697f16430$var$Vt + $e911b83697f16430$var$Qt + $e911b83697f16430$var$Jt + $e911b83697f16430$var$qt + $e911b83697f16430$var$Kt + "]", $e911b83697f16430$var$En = "\\ud83c[\\udffb-\\udfff]", $e911b83697f16430$var$Sn = "(?:" + $e911b83697f16430$var$yn + "|" + $e911b83697f16430$var$En + ")", $e911b83697f16430$var$$n = "[^" + $e911b83697f16430$var$Zt + "]", $e911b83697f16430$var$ee = "(?:\\ud83c[\\udde6-\\uddff]){2}", $e911b83697f16430$var$ne = "[\\ud800-\\udbff][\\udc00-\\udfff]", $e911b83697f16430$var$E = "[" + $e911b83697f16430$var$Kt + "]", $e911b83697f16430$var$Tn = "\\u200d", $e911b83697f16430$var$Ht = "(?:" + $e911b83697f16430$var$Xt + "|" + $e911b83697f16430$var$te + ")", $e911b83697f16430$var$An = "(?:" + $e911b83697f16430$var$E + "|" + $e911b83697f16430$var$te + ")", $e911b83697f16430$var$Bt = "(?:" + $e911b83697f16430$var$Yt + "(?:d|ll|m|re|s|t|ve))?", $e911b83697f16430$var$It = "(?:" + $e911b83697f16430$var$Yt + "(?:D|LL|M|RE|S|T|VE))?", $e911b83697f16430$var$oe = $e911b83697f16430$var$Sn + "?", $e911b83697f16430$var$se = "[" + $e911b83697f16430$var$Cn + "]?", $e911b83697f16430$var$jn = "(?:" + $e911b83697f16430$var$Tn + "(?:" + [
    $e911b83697f16430$var$$n,
    $e911b83697f16430$var$ee,
    $e911b83697f16430$var$ne
].join("|") + ")" + $e911b83697f16430$var$se + $e911b83697f16430$var$oe + ")*", $e911b83697f16430$var$Ln = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", $e911b83697f16430$var$Rn = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", $e911b83697f16430$var$On = $e911b83697f16430$var$se + $e911b83697f16430$var$oe + $e911b83697f16430$var$jn, $e911b83697f16430$var$Hn = "(?:" + [
    $e911b83697f16430$var$vn,
    $e911b83697f16430$var$ee,
    $e911b83697f16430$var$ne
].join("|") + ")" + $e911b83697f16430$var$On, $e911b83697f16430$var$Bn = RegExp([
    $e911b83697f16430$var$E + "?" + $e911b83697f16430$var$Xt + "+" + $e911b83697f16430$var$Bt + "(?=" + [
        $e911b83697f16430$var$Ot,
        $e911b83697f16430$var$E,
        "$"
    ].join("|") + ")",
    $e911b83697f16430$var$An + "+" + $e911b83697f16430$var$It + "(?=" + [
        $e911b83697f16430$var$Ot,
        $e911b83697f16430$var$E + $e911b83697f16430$var$Ht,
        "$"
    ].join("|") + ")",
    $e911b83697f16430$var$E + "?" + $e911b83697f16430$var$Ht + "+" + $e911b83697f16430$var$Bt,
    $e911b83697f16430$var$E + "+" + $e911b83697f16430$var$It,
    $e911b83697f16430$var$Rn,
    $e911b83697f16430$var$Ln,
    $e911b83697f16430$var$Qt,
    $e911b83697f16430$var$Hn
].join("|"), "g");
function $e911b83697f16430$var$In(n) {
    return n.match($e911b83697f16430$var$Bn) || [];
}
function $e911b83697f16430$var$Mn(n, t, e) {
    return n = $e911b83697f16430$var$zt(n), t = e ? void 0 : t, t === void 0 ? $e911b83697f16430$var$mn(n) ? $e911b83697f16430$var$In(n) : $e911b83697f16430$var$un(n) : n.match(t) || [];
}
var $e911b83697f16430$var$_n = "['\u2019]", $e911b83697f16430$var$Dn = RegExp($e911b83697f16430$var$_n, "g");
function $e911b83697f16430$var$Nn(n) {
    return function(t) {
        return $e911b83697f16430$var$Ke($e911b83697f16430$var$Mn($e911b83697f16430$var$rn(t).replace($e911b83697f16430$var$Dn, "")), n, "");
    };
}
var $e911b83697f16430$var$Mt = $e911b83697f16430$var$Nn(function(n, t, e) {
    return n + (e ? "-" : "") + t.toLowerCase();
});
function $e911b83697f16430$var$Un(n) {
    let t = "";
    function e(o, s = "") {
        Object.entries(o).forEach(([c, a])=>{
            if (typeof a == "object") e(a, `${s}${c}`);
            else {
                const d = `--cc${s ? `-${$e911b83697f16430$var$Mt(s)}` : ""}-${$e911b83697f16430$var$Mt(c)}`;
                t += `${d}: ${a};
`;
            }
        });
    }
    return e(n), t;
}
var $e911b83697f16430$var$x, $e911b83697f16430$var$m, $e911b83697f16430$var$U, $e911b83697f16430$var$$, $e911b83697f16430$var$tt, $e911b83697f16430$var$ce, $e911b83697f16430$var$et, $e911b83697f16430$var$ie, $e911b83697f16430$var$nt, $e911b83697f16430$var$ae, $e911b83697f16430$var$ot, $e911b83697f16430$var$re, $e911b83697f16430$var$st, $e911b83697f16430$var$de, $e911b83697f16430$var$F, $e911b83697f16430$var$yt, $e911b83697f16430$var$T, $e911b83697f16430$var$J, $e911b83697f16430$var$A, $e911b83697f16430$var$q, $e911b83697f16430$var$ct, $e911b83697f16430$var$ue, $e911b83697f16430$var$j, $e911b83697f16430$var$K, $e911b83697f16430$var$it, $e911b83697f16430$var$le, $e911b83697f16430$var$L, $e911b83697f16430$var$V, $e911b83697f16430$var$y, $e911b83697f16430$var$D, $e911b83697f16430$var$G, $e911b83697f16430$var$vt, $e911b83697f16430$var$at, $e911b83697f16430$var$me, $e911b83697f16430$var$v, $e911b83697f16430$var$N, $e911b83697f16430$var$R, $e911b83697f16430$var$Y, $e911b83697f16430$var$rt, $e911b83697f16430$var$fe, $e911b83697f16430$var$dt, $e911b83697f16430$var$ge, $e911b83697f16430$var$ut, $e911b83697f16430$var$pe, $e911b83697f16430$var$lt, $e911b83697f16430$var$he, $e911b83697f16430$var$mt, $e911b83697f16430$var$be, $e911b83697f16430$var$ft, $e911b83697f16430$var$ke, $e911b83697f16430$var$gt, $e911b83697f16430$var$we, $e911b83697f16430$var$W, $e911b83697f16430$var$Et, $e911b83697f16430$var$pt, $e911b83697f16430$var$xe, $e911b83697f16430$var$P, $e911b83697f16430$var$St, $e911b83697f16430$var$ht, $e911b83697f16430$var$Ce, $e911b83697f16430$var$z, $e911b83697f16430$var$$t, $e911b83697f16430$var$bt, $e911b83697f16430$var$ye, $e911b83697f16430$var$kt, $e911b83697f16430$var$ve, $e911b83697f16430$var$O, $e911b83697f16430$var$Q, $e911b83697f16430$var$H, $e911b83697f16430$var$X, $e911b83697f16430$var$C, $e911b83697f16430$var$S;
class $e911b83697f16430$export$abba94fbeefd623b {
    constructor(t){
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$tt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$et);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$nt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$ot);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$st);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$F);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$T);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$A);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$ct);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$j);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$it);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$L);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$y);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$G);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$at);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$v);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$R);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$rt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$dt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$ut);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$lt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$mt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$ft);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$gt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$W);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$pt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$P);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$ht);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$z);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$bt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$kt);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$O);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$H);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$C);
        $e911b83697f16430$var$At(this, "params");
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$x, !1);
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$m, {});
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$U, "consentcookies_status");
        $e911b83697f16430$var$r(this, $e911b83697f16430$var$$, []);
        this.params = t ?? {}, $e911b83697f16430$var$i(this, $e911b83697f16430$var$ct, $e911b83697f16430$var$ue).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$tt, $e911b83697f16430$var$ce).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$et, $e911b83697f16430$var$ie).call(this) && ($e911b83697f16430$var$i(this, $e911b83697f16430$var$nt, $e911b83697f16430$var$ae).call(this) ? ($e911b83697f16430$var$i(this, $e911b83697f16430$var$st, $e911b83697f16430$var$de).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$y, $e911b83697f16430$var$D).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$C, $e911b83697f16430$var$S).call(this, "load")) : ($e911b83697f16430$var$i(this, $e911b83697f16430$var$j, $e911b83697f16430$var$K).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$C, $e911b83697f16430$var$S).call(this, "first-load")));
    }
    // #region public methods
    getStatus() {
        return $e911b83697f16430$var$l(this, $e911b83697f16430$var$x);
    }
    getConfig() {
        return this.params;
    }
    showMessage() {
        try {
            $e911b83697f16430$var$i(this, $e911b83697f16430$var$j, $e911b83697f16430$var$K).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$G, $e911b83697f16430$var$vt).call(this);
        } catch  {
            console.error("ERROR: Can not show message");
        }
    }
    removeCookies() {
        document.cookie.split(";").forEach((e)=>{
            const [o] = e.trim().split("=");
            document.cookie = `${o}=""; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${this.params.path}`;
        });
    }
    toggleSettings() {
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$R, $e911b83697f16430$var$Y).call(this);
    }
}
$e911b83697f16430$var$x = new WeakMap(), $e911b83697f16430$var$m = new WeakMap(), $e911b83697f16430$var$U = new WeakMap(), $e911b83697f16430$var$$ = new WeakMap(), $e911b83697f16430$var$tt = new WeakSet(), $e911b83697f16430$var$ce = function() {
    if (this.params.theme) {
        const t = $e911b83697f16430$var$Un(this.params.theme), e = document.createElement("style");
        e.innerHTML = `:root { ${t} }`, document.head.appendChild(e);
    }
}, $e911b83697f16430$var$et = new WeakSet(), $e911b83697f16430$var$ie = function() {
    var e;
    const t = window.location.pathname;
    return !((e = this.params.ignorePages) != null && e.some((o)=>t !== "" && t.includes(o)));
}, $e911b83697f16430$var$nt = new WeakSet(), $e911b83697f16430$var$ae = function() {
    return $e911b83697f16430$var$xt(this, $e911b83697f16430$var$x, (document.cookie.split(";").some((t)=>t.trim().startsWith($e911b83697f16430$var$l(this, $e911b83697f16430$var$U))) || "") !== ""), $e911b83697f16430$var$l(this, $e911b83697f16430$var$x);
}, $e911b83697f16430$var$ot = new WeakSet(), $e911b83697f16430$var$re = function(t) {
    return !!$e911b83697f16430$var$l(this, $e911b83697f16430$var$m)[t];
}, $e911b83697f16430$var$st = new WeakSet(), $e911b83697f16430$var$de = function() {
    document.cookie.split(" ").forEach((t)=>{
        const [e] = t.split("=");
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$ot, $e911b83697f16430$var$re).call(this, e) && ($e911b83697f16430$var$l(this, $e911b83697f16430$var$m)[e].status = !0);
    });
}, $e911b83697f16430$var$F = new WeakSet(), $e911b83697f16430$var$yt = function(t) {
    return !!(t != null && t.cookies);
}, $e911b83697f16430$var$T = new WeakSet(), $e911b83697f16430$var$J = function(t) {
    var e;
    return (e = this.params.cookies) == null ? void 0 : e.find((o)=>o.name === t);
}, $e911b83697f16430$var$A = new WeakSet(), $e911b83697f16430$var$q = function(t) {
    if (t) return $e911b83697f16430$var$l(this, $e911b83697f16430$var$m)[t];
}, $e911b83697f16430$var$ct = new WeakSet(), $e911b83697f16430$var$ue = function() {
    var t, e, o, s, c, a, d, u;
    this.params = this.params || {}, this.params.cookies = this.params.cookies || [];
    for(const p in this.params.cookies){
        const f = this.params.cookies[p];
        f && (f.manageFunction && $e911b83697f16430$var$l(this, $e911b83697f16430$var$$).push(f), $e911b83697f16430$var$i(this, $e911b83697f16430$var$F, $e911b83697f16430$var$yt).call(this, f) ? (t = f.cookies) == null || t.forEach((b)=>{
            var Tt;
            b.manageFunction && $e911b83697f16430$var$l(this, $e911b83697f16430$var$$).push(b), $e911b83697f16430$var$l(this, $e911b83697f16430$var$m)[b.name] = {
                status: !1,
                parent: (Tt = this.params.cookies) == null ? void 0 : Tt[p],
                ...b
            };
        }) : $e911b83697f16430$var$l(this, $e911b83697f16430$var$m)[f == null ? void 0 : f.name] = {
            status: !1,
            ...f
        });
    }
    (e = this.params).mainWindowSettings ?? (e.mainWindowSettings = !1), (o = this.params).position ?? (o.position = "bottom-left"), (s = this.params).btnDismissPosition ?? (s.btnDismissPosition = "bottom-left"), (c = this.params).expirationDays ?? (c.expirationDays = 0), (a = this.params).animation ?? (a.animation = !0), (d = this.params).path ?? (d.path = "path=/"), (u = this.params).hideDescription ?? (u.hideDescription = !0), this.params.content = {
        ...$e911b83697f16430$var$$e,
        ...this.params.content
    };
}, $e911b83697f16430$var$j = new WeakSet(), $e911b83697f16430$var$K = function() {
    var t, e, o, s, c;
    if (this.params.mainWindowSettings) $e911b83697f16430$var$i(this, $e911b83697f16430$var$R, $e911b83697f16430$var$Y).call(this);
    else if (!document.getElementById("cc-window")) {
        const a = `cc-pos-${this.params.position}`, d = `cc-content-${(t = this.params.content) == null ? void 0 : t.align}`, u = [
            "bottom",
            "bottom-right",
            "bottom-left",
            "bottom-center"
        ].includes(this.params.position ?? "") ? "beforeend" : "afterbegin", p = $e911b83697f16430$var$i(this, $e911b83697f16430$var$it, $e911b83697f16430$var$le).call(this), f = ((e = this.params.content) == null ? void 0 : e.policy) !== "" && ((o = this.params.content) == null ? void 0 : o.policyLink) !== "" ? `<a href="${this.params.content.policyLink}" target="_blank">${this.params.content.policy}</a>` : "", b = `
        <div id="cc-window" class="cc-window ${a} ${d} ${this.params.animation ? "cc-animation-in" : ""}">
            <div class="cc-window-content">
              <div class="cc-window-title">${(s = this.params.content) == null ? void 0 : s.title}</div>
              <div class="cc-window-message">${(c = this.params.content) == null ? void 0 : c.message} <span class="cc-window-policy">${f}</span></div>
              <div class="cc-window-buttons">${p}</div>
          </div>
        </div>
      `;
        document.body.insertAdjacentHTML(u, b), $e911b83697f16430$var$i(this, $e911b83697f16430$var$z, $e911b83697f16430$var$$t).call(this);
    }
}, $e911b83697f16430$var$it = new WeakSet(), $e911b83697f16430$var$le = function() {
    var t, e;
    if ((t = this.params) != null && t.buttons && Array.isArray(this.params.buttons)) {
        let o = "";
        return this.params.buttons.forEach((s)=>{
            var c, a, d, u;
            s === "accept" ? o += `<button type="button" id="cc-btn-accept" class="cc-btn-accept">${(c = this.params.content) == null ? void 0 : c.btnAccept}</button>` : s === "reject" ? o += `<button type="button" id="cc-btn-reject" class="cc-btn-reject">${(a = this.params.content) == null ? void 0 : a.btnReject}</button>` : s === "info" ? o += `<button type="button" id="cc-btn-info" class="cc-btn-info">${(d = this.params.content) == null ? void 0 : d.btnInfo}</button>` : s === "settings" && (o += `<button type="button" id="cc-btn-settings" class="cc-btn-settings">${(u = this.params.content) == null ? void 0 : u.btnSettings}</button>`);
        }), o;
    }
    return `<button type="button" id="cc-btn-accept" class="cc-btn-accept">${(e = this.params.content) == null ? void 0 : e.btnAccept}</button>`;
}, $e911b83697f16430$var$L = new WeakSet(), $e911b83697f16430$var$V = function() {
    if (!this.params.mainWindowSettings) {
        const t = document.getElementById("cc-window");
        this.params.animation && t ? ([
            "accept",
            "reject",
            "info",
            "settings"
        ].forEach((e)=>{
            const o = document.getElementById(`cc-btn-${e}`);
            o && (o.id = `cc-btn-${e}-out`);
        }), t.id = "cc-window-out", t.classList.remove("cc-animation-in"), t.classList.add("cc-animation-out"), setTimeout(()=>t == null ? void 0 : t.remove(), 2e3)) : t == null || t.remove();
    }
}, $e911b83697f16430$var$y = new WeakSet(), $e911b83697f16430$var$D = function() {
    var e, o, s;
    if (!document.getElementById("cc-btn-dismiss") && (o = (e = this.params) == null ? void 0 : e.buttons) != null && o.includes("dismiss")) {
        const c = `cc-pos-${this.params.btnDismissPosition}`, a = [
            "top-right",
            "top-left"
        ].includes(this.params.position ?? "") ? "afterbegin" : "beforeend";
        document.body.insertAdjacentHTML(a, `
        <div id="cc-btn-dismiss" class="${c}">
          ${((s = this.params.content) == null ? void 0 : s.btnDismiss) ?? ""}
        </div>
      `), $e911b83697f16430$var$i(this, $e911b83697f16430$var$z, $e911b83697f16430$var$$t).call(this);
    }
}, $e911b83697f16430$var$G = new WeakSet(), $e911b83697f16430$var$vt = function() {
    var t;
    (t = document.getElementById("cc-btn-dismiss")) == null || t.remove();
}, $e911b83697f16430$var$at = new WeakSet(), $e911b83697f16430$var$me = function() {
    var t;
    if ((t = this.params.content) != null && t.info) {
        const e = document.createElement("div");
        e.innerHTML = this.params.content.info ?? "", $e911b83697f16430$var$i(this, $e911b83697f16430$var$P, $e911b83697f16430$var$St).call(this, "cc-window-info", e);
    }
}, $e911b83697f16430$var$v = new WeakSet(), $e911b83697f16430$var$N = function(t, e, o) {
    const s = document.createElement(t);
    return s.className = e, s.innerHTML = o ?? "", s;
}, $e911b83697f16430$var$R = new WeakSet(), $e911b83697f16430$var$Y = function() {
    var e;
    const t = $e911b83697f16430$var$i(this, $e911b83697f16430$var$v, $e911b83697f16430$var$N).call(this, "div", "cc-window-settings-cookies");
    $e911b83697f16430$var$i(this, $e911b83697f16430$var$rt, $e911b83697f16430$var$fe).call(this, t), (e = this.params.cookies) == null || e.forEach((o)=>{
        const s = $e911b83697f16430$var$i(this, $e911b83697f16430$var$dt, $e911b83697f16430$var$ge).call(this, o.name);
        s && t.appendChild(s);
    }), $e911b83697f16430$var$i(this, $e911b83697f16430$var$ft, $e911b83697f16430$var$ke).call(this, t), $e911b83697f16430$var$i(this, $e911b83697f16430$var$gt, $e911b83697f16430$var$we).call(this, t), $e911b83697f16430$var$i(this, $e911b83697f16430$var$P, $e911b83697f16430$var$St).call(this, "cc-window-settings", t), $e911b83697f16430$var$i(this, $e911b83697f16430$var$bt, $e911b83697f16430$var$ye).call(this);
}, $e911b83697f16430$var$rt = new WeakSet(), $e911b83697f16430$var$fe = function(t) {
    var e;
    if ((e = this.params.content) != null && e.settingsHeader) {
        const o = $e911b83697f16430$var$i(this, $e911b83697f16430$var$v, $e911b83697f16430$var$N).call(this, "div", "cc-window-settings-header", this.params.content.settingsHeader);
        t.appendChild(o);
    }
}, $e911b83697f16430$var$dt = new WeakSet(), $e911b83697f16430$var$ge = function(t) {
    const e = $e911b83697f16430$var$Le(), o = document.createElement("div");
    o.setAttribute("id", t), o.className = "cc-window-settings-cookie";
    const s = $e911b83697f16430$var$i(this, $e911b83697f16430$var$v, $e911b83697f16430$var$N).call(this, "div", "cc-window-settings-cookie-content"), c = $e911b83697f16430$var$i(this, $e911b83697f16430$var$ut, $e911b83697f16430$var$pe).call(this, t, e), a = $e911b83697f16430$var$i(this, $e911b83697f16430$var$lt, $e911b83697f16430$var$he).call(this, t, e), d = $e911b83697f16430$var$i(this, $e911b83697f16430$var$mt, $e911b83697f16430$var$be).call(this, t);
    return c && s.appendChild(c), a && s.appendChild(a), o.insertAdjacentElement("afterbegin", s), d && o.insertAdjacentElement("beforeend", d), o;
}, $e911b83697f16430$var$ut = new WeakSet(), $e911b83697f16430$var$pe = function(t, e) {
    const o = $e911b83697f16430$var$i(this, $e911b83697f16430$var$T, $e911b83697f16430$var$J).call(this, t);
    if (o) {
        const s = $e911b83697f16430$var$i(this, $e911b83697f16430$var$v, $e911b83697f16430$var$N).call(this, "div", "cc-window-settings-cookie-title", o.title);
        return o.description && this.params.hideDescription && (s.innerHTML += ` <div id="cc-window-icon-dropdown-id-${e}">&#10095;</div>`, s.classList.add("cc-window-settings-cookie-title-dropdown"), s.addEventListener("click", ()=>{
            $e911b83697f16430$var$i(this, $e911b83697f16430$var$pt, $e911b83697f16430$var$xe).call(this, String(e));
        })), s;
    }
}, $e911b83697f16430$var$lt = new WeakSet(), $e911b83697f16430$var$he = function(t, e) {
    const o = $e911b83697f16430$var$i(this, $e911b83697f16430$var$T, $e911b83697f16430$var$J).call(this, t);
    if (o != null && o.description) {
        const s = document.createElement("div");
        return s.id = `cc-window-desc-id-${e}`, s.className = "cc-window-settings-cookie-desc", o != null && o.title && this.params.hideDescription && (s.style.display = "none"), s.innerHTML = o.description ?? "", s;
    }
}, $e911b83697f16430$var$mt = new WeakSet(), $e911b83697f16430$var$be = function(t) {
    var p, f, b;
    const e = $e911b83697f16430$var$i(this, $e911b83697f16430$var$T, $e911b83697f16430$var$J).call(this, t), o = $e911b83697f16430$var$i(this, $e911b83697f16430$var$F, $e911b83697f16430$var$yt).call(this, e);
    if (!e) return;
    const s = (o ? (f = $e911b83697f16430$var$i(this, $e911b83697f16430$var$A, $e911b83697f16430$var$q).call(this, (p = e.cookies) == null ? void 0 : p[0].name)) == null ? void 0 : f.status : (b = $e911b83697f16430$var$i(this, $e911b83697f16430$var$A, $e911b83697f16430$var$q).call(this, t)) == null ? void 0 : b.status) ?? !1;
    let c = "";
    $e911b83697f16430$var$l(this, $e911b83697f16430$var$x) ? c = s ? " checked" : "" : c = e.checked ? " checked" : "";
    const a = e.disabled && c !== "" ? "disabled" : "", d = e.name ?? "", u = document.createElement("div");
    return u.className = "cc-window-settings-cookie-value", u.innerHTML = `<label class="switch" for="cc-cookie-${d}"><input type="checkbox" class="cc-cookie-checkbox" id="cc-cookie-${d}" data-name="${d}" name="cc-cookie-${d}" ${c} ${a}><span class="slider round"></span></label>`, u;
}, $e911b83697f16430$var$ft = new WeakSet(), $e911b83697f16430$var$ke = function(t) {
    var s, c;
    const e = ((s = this.params.content) == null ? void 0 : s.btnSettingsSelectAll) ?? "Select all", o = ((c = this.params.content) == null ? void 0 : c.btnSettingsAccept) ?? "Accept selection";
    if (t.innerHTML !== "") {
        const a = document.createElement("div");
        a.className = "cc-window-settings-buttons", a.innerHTML = `
        ${$e911b83697f16430$var$i(this, $e911b83697f16430$var$W, $e911b83697f16430$var$Et).call(this, "cc-btn-settings-select", "cc-btn-settings-select", e)}
        ${$e911b83697f16430$var$i(this, $e911b83697f16430$var$W, $e911b83697f16430$var$Et).call(this, "cc-btn-settings-accept", "cc-btn-settings-accept", o)}
      `, t.appendChild(a);
    }
}, $e911b83697f16430$var$gt = new WeakSet(), $e911b83697f16430$var$we = function(t) {
    var e;
    if ((e = this.params.content) != null && e.settingsFooter) {
        const o = document.createElement("div");
        o.className = "cc-window-settings-footer", o.innerHTML = this.params.content.settingsFooter ?? "", t.appendChild(o);
    }
}, $e911b83697f16430$var$W = new WeakSet(), $e911b83697f16430$var$Et = function(t, e, o) {
    return `<button type="button" id="${t}" class="${e}">${o}</button>`;
}, $e911b83697f16430$var$pt = new WeakSet(), $e911b83697f16430$var$xe = function(t) {
    const e = document.getElementById(`cc-window-desc-id-${t}`), o = document.getElementById(`cc-window-icon-dropdown-id-${t}`);
    (e == null ? void 0 : e.style.display) === "block" && o ? (o.style.transform = "rotate(0deg)", e.style.display = "none") : e && o && (o.style.transform = "rotate(90deg)", e.style.display = "block");
}, $e911b83697f16430$var$P = new WeakSet(), $e911b83697f16430$var$St = function(t, e) {
    const o = document.createElement("div");
    o.id = t, o.className = "cc-modal";
    const s = document.createElement("div");
    s.className = "cc-modal-window";
    const c = document.createElement("div");
    if (c.className = "cc-modal-content", c.appendChild(e), !this.params.mainWindowSettings) {
        const d = document.createElement("div");
        d.id = "cc-modal-close", d.className = "cc-modal-close", d.innerHTML = "&times;", s.appendChild(d);
    }
    s.appendChild(c), o.appendChild(s), document.body.insertAdjacentElement("beforeend", o), o.style.display = "block";
    const a = document.getElementById("cc-modal-close");
    a == null || a.addEventListener("click", ()=>o.remove());
}, $e911b83697f16430$var$ht = new WeakSet(), $e911b83697f16430$var$Ce = function() {
    const t = document.getElementsByClassName("cc-modal");
    for(let e = 0; e < t.length; e++)t[e].remove();
}, $e911b83697f16430$var$z = new WeakSet(), $e911b83697f16430$var$$t = function() {
    const t = document.getElementById("cc-btn-accept"), e = document.getElementById("cc-btn-reject"), o = document.getElementById("cc-btn-info"), s = document.getElementById("cc-btn-settings"), c = document.getElementById("cc-btn-dismiss");
    t == null || t.addEventListener("click", ()=>{
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$L, $e911b83697f16430$var$V).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$y, $e911b83697f16430$var$D).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$H, $e911b83697f16430$var$X).call(this, "accept_all"), $e911b83697f16430$var$i(this, $e911b83697f16430$var$O, $e911b83697f16430$var$Q).call(this, "accept"), $e911b83697f16430$var$i(this, $e911b83697f16430$var$C, $e911b83697f16430$var$S).call(this, "accept");
    }), e == null || e.addEventListener("click", ()=>{
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$L, $e911b83697f16430$var$V).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$y, $e911b83697f16430$var$D).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$H, $e911b83697f16430$var$X).call(this, "reject_all"), $e911b83697f16430$var$i(this, $e911b83697f16430$var$O, $e911b83697f16430$var$Q).call(this, "reject"), $e911b83697f16430$var$i(this, $e911b83697f16430$var$C, $e911b83697f16430$var$S).call(this, "reject");
    }), o == null || o.addEventListener("click", ()=>{
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$at, $e911b83697f16430$var$me).call(this);
    }), c == null || c.addEventListener("click", ()=>{
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$j, $e911b83697f16430$var$K).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$G, $e911b83697f16430$var$vt).call(this);
    }), s == null || s.addEventListener("click", ()=>{
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$R, $e911b83697f16430$var$Y).call(this);
    });
}, $e911b83697f16430$var$bt = new WeakSet(), $e911b83697f16430$var$ye = function() {
    const t = document.getElementById("cc-btn-settings-select"), e = document.getElementById("cc-btn-settings-accept");
    t && t.addEventListener("click", ()=>{
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$kt, $e911b83697f16430$var$ve).call(this);
    }), e && e.addEventListener("click", ()=>{
        $e911b83697f16430$var$i(this, $e911b83697f16430$var$L, $e911b83697f16430$var$V).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$y, $e911b83697f16430$var$D).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$H, $e911b83697f16430$var$X).call(this, "selection"), $e911b83697f16430$var$i(this, $e911b83697f16430$var$O, $e911b83697f16430$var$Q).call(this, "selection"), $e911b83697f16430$var$i(this, $e911b83697f16430$var$ht, $e911b83697f16430$var$Ce).call(this), $e911b83697f16430$var$i(this, $e911b83697f16430$var$C, $e911b83697f16430$var$S).call(this, "accept");
    });
}, $e911b83697f16430$var$kt = new WeakSet(), $e911b83697f16430$var$ve = function() {
    const t = document.getElementById("cc-btn-settings-select"), e = t == null ? void 0 : t.dataset.action;
    if (t && (e === "select" || e === "unselect")) {
        const o = e === "select";
        t.innerHTML = o ? this.params.content.btnSettingsUnselectAll ?? "" : this.params.content.btnSettingsSelectAll ?? "", t.dataset.action = o ? "unselect" : "select", document.querySelectorAll(".cc-window-settings-cookie-value .cc-cookie-checkbox").forEach((c)=>{
            c.disabled || (c.checked = o);
        });
    }
}, $e911b83697f16430$var$O = new WeakSet(), $e911b83697f16430$var$Q = function(t) {
    const e = this.params.expirationDays > 0 ? `expires=${new Date(Date.now() + this.params.expirationDays * 86400000).toUTCString()}` : "", o = btoa(`${t}:${Date.now()}`), s = {
        none: "SameSite=None;Secure",
        strict: "SameSite=Strict",
        lax: "SameSite=Lax"
    }, c = this.params.sameSite && s[this.params.sameSite] || s.lax, a = (u, p)=>{
        document.cookie = `${u}=${p};${e};${this.params.path};${c};`;
    }, d = (u)=>{
        document.cookie = `${u}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; ${this.params.path}; ${c};`;
    };
    a($e911b83697f16430$var$l(this, $e911b83697f16430$var$U), o), Object.entries($e911b83697f16430$var$l(this, $e911b83697f16430$var$m)).forEach(([u, p])=>{
        p.status ? a(u, btoa(`${u}:${Date.now()}`)) : d(u);
    }), $e911b83697f16430$var$xt(this, $e911b83697f16430$var$x, !0);
}, $e911b83697f16430$var$H = new WeakSet(), $e911b83697f16430$var$X = function(t) {
    if ($e911b83697f16430$var$l(this, $e911b83697f16430$var$m)) {
        if (t === "accept_all") for(const e in $e911b83697f16430$var$l(this, $e911b83697f16430$var$m))$e911b83697f16430$var$l(this, $e911b83697f16430$var$m)[e].status = !0;
        else if (t === "reject_all") for(const e in $e911b83697f16430$var$l(this, $e911b83697f16430$var$m))$e911b83697f16430$var$l(this, $e911b83697f16430$var$m)[e].status = !1;
        else t === "selection" && document.querySelectorAll(".cc-window-settings-cookie-value .cc-cookie-checkbox").forEach((o)=>{
            const s = o.dataset.name;
            Object.entries($e911b83697f16430$var$l(this, $e911b83697f16430$var$m)).forEach(([, c])=>{
                var a;
                s && (c == null ? void 0 : c.name) === s && (c.status = o.checked), s && ((a = c.parent) == null ? void 0 : a.name) === s && (c.status = o.checked);
            });
        });
    }
}, $e911b83697f16430$var$C = new WeakSet(), $e911b83697f16430$var$S = function(t) {
    const e = (o)=>{
        var c;
        const s = (c = this.params.callback) == null ? void 0 : c[o];
        if (s && typeof s == "function") try {
            s($e911b83697f16430$var$l(this, $e911b83697f16430$var$m));
        } catch  {
            console.error(`ERROR: Function ${o} not found`);
        }
    };
    switch($e911b83697f16430$var$l(this, $e911b83697f16430$var$$).forEach((o)=>{
        const s = $e911b83697f16430$var$i(this, $e911b83697f16430$var$A, $e911b83697f16430$var$q).call(this, o.name);
        if (s && s.manageFunction) try {
            s.manageFunction({
                lifecycle: t,
                cookie: s,
                status: s.status,
                path: this.params.path
            });
        } catch  {
            console.error(`ERROR: Function manageFunction not found in cookie ${s.name}`);
        }
    }), t){
        case "first-load":
            e("first_load");
            break;
        case "load":
            e("load");
            break;
        case "accept":
            e("accept");
            break;
        case "reject":
            e("reject");
            break;
    }
};
function $e911b83697f16430$export$4e53bdbbebc21430({ lifecycle: n, cookie: t, status: e = !1, path: o = "" }) {
    const s = t.code ?? "", c = t.onLoad ?? !1;
    if (s !== "") switch(n){
        case "first-load":
            c ? ($e911b83697f16430$var$_t(s), $e911b83697f16430$var$M(s, !0)) : ($e911b83697f16430$var$M(s, !1), $e911b83697f16430$var$Ct(o));
            break;
        case "load":
        case "accept":
            e ? ($e911b83697f16430$var$_t(s), $e911b83697f16430$var$M(s, !0)) : ($e911b83697f16430$var$M(s, !1), $e911b83697f16430$var$Nt(), $e911b83697f16430$var$Ct(o));
            break;
        case "reject":
            $e911b83697f16430$var$M(s, !1), $e911b83697f16430$var$Nt(), $e911b83697f16430$var$Ct(o);
            break;
    }
    else console.error("ERROR: Google Analytics code not specified");
}
function $e911b83697f16430$var$_t(n) {
    if (n === "") return;
    const t = document.getElementById("cc-ga-script-1"), e = document.getElementById("cc-ga-script-2");
    if (t || $e911b83697f16430$var$Dt(`https://www.googletagmanager.com/gtag/js?id=${n}`, "cc-ga-script-1"), !e) {
        const o = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', '${n}', { 'anonymize_ip': true });
      gtag('config', '${n}');
      gtag('consent', 'default', { 'analytics_storage': 'denied' });
      window['ga-disable-' + '${n}'] = true;
    `;
        $e911b83697f16430$var$Dt(o, "cc-ga-script-2");
    }
}
function $e911b83697f16430$var$Dt(n, t) {
    const e = document.createElement("script");
    e.id = t, e[n.startsWith("http") ? "src" : "innerHTML"] = n, e.async = !0, document.head.appendChild(e);
}
function $e911b83697f16430$var$Nt() {
    var n, t;
    (n = document.getElementById("cc-ga-script-1")) == null || n.remove(), (t = document.getElementById("cc-ga-script-2")) == null || t.remove();
}
function $e911b83697f16430$var$M(n, t) {
    const e = document.getElementById("cc-ga-script-2");
    n !== "" && e && (gtag("set", "allow_google_signals", t), gtag("set", "allow_ad_personalization_signals", t), gtag("consent", "update", {
        analytics_storage: t ? "granted" : "denied"
    }), window[`ga-disable-${n}`] = !t);
}
function $e911b83697f16430$var$Ct(n) {
    const t = [
        "_ga",
        "_gid",
        "__utm"
    ], o = document.cookie.split(";"), s = window.location.hostname.split(".");
    for(let c = 0; c < o.length; c++){
        const a = o[c].split("=");
        for(let d = 0; d < t.length; d++)if (a.toString().trim().startsWith(t[d]) && (document.cookie = `${a[0]}="";domain=${window.location.hostname};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`, s[0] === "www")) {
            const u = `.${s[1]}.${s[2]}`;
            document.cookie = `${a[0]}="";domain=${u};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`;
        }
    }
}
function $e911b83697f16430$export$820186ca1f2a4eae({ lifecycle: n, cookie: t, status: e = !1, path: o = "" }) {
    const s = t.code ?? "";
    if (s !== "") switch(n){
        case "first-load":
        case "reject":
            $e911b83697f16430$var$Ut(), $e911b83697f16430$var$Ft(o);
            break;
        case "load":
        case "accept":
            e ? $e911b83697f16430$var$Fn(s) : ($e911b83697f16430$var$Ut(), $e911b83697f16430$var$Ft(o));
            break;
    }
    else console.error("ERROR: Google Tag Manager code not specified");
}
function $e911b83697f16430$var$Fn(n) {
    if (n === "") return;
    const t = document.getElementById("cc-gtm-script-1"), e = document.getElementById("cc-gtm-script-2");
    if (!t) {
        const o = $e911b83697f16430$var$Gn("cc-gtm-script-1", `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${n}');
    `);
        document.head.insertAdjacentElement("afterbegin", o);
    }
    if (!e) {
        const o = document.createElement("noscript");
        o.id = "cc-gtm-script-2", o.innerHTML = `
                <iframe src="https://www.googletagmanager.com/ns.html?id=${n}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`, document.body.insertAdjacentElement("afterbegin", o);
    }
}
function $e911b83697f16430$var$Ut() {
    $e911b83697f16430$var$Z("cc-gtm-script-1"), $e911b83697f16430$var$Z("cc-gtm-script-2"), $e911b83697f16430$var$Z('script[src^="https://www.googletagmanager.com/gtm.js"]'), $e911b83697f16430$var$Z('script[src^="https://www.google-analytics.com/analytics.js"]');
}
function $e911b83697f16430$var$Ft(n) {
    const t = [
        "_ga",
        "_gid",
        "__utm"
    ], o = document.cookie.split(";"), s = window.location.hostname.split(".");
    for(let c = 0; c < o.length; c++){
        const a = o[c].split("=");
        for(let d = 0; d < t.length; d++)if (a.toString().trim().startsWith(t[d]) && (document.cookie = `${a[0]}="";domain=${window.location.hostname};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`, s[0] === "www")) {
            const u = `.${s[1]}.${s[2]}`;
            document.cookie = `${a[0]}="";domain=${u};expires=Thu, 01 Jan 1970 00:00:00 UTC;${n}`;
        }
    }
}
function $e911b83697f16430$var$Gn(n, t) {
    const e = document.createElement("script");
    return e.id = n, e.innerHTML = t, e;
}
function $e911b83697f16430$var$Z(n) {
    const t = document.querySelector(`#${n}`) || document.querySelector(n);
    t && t.remove();
}
const $e911b83697f16430$var$Gt = "#2f3337", $e911b83697f16430$var$_ = "#ffffff", $e911b83697f16430$export$3e936a8db52a10a0 = {
    window: {
        background: $e911b83697f16430$var$Gt
    },
    popup: {
        background: $e911b83697f16430$var$Gt,
        textColor: $e911b83697f16430$var$_
    },
    title: {
        textColor: $e911b83697f16430$var$_
    },
    message: {
        textColor: $e911b83697f16430$var$_,
        linkColor: $e911b83697f16430$var$_,
        linkFontWeight: "600"
    },
    settings: {
        separatorColor: "#ddd"
    },
    btnClose: {
        color: $e911b83697f16430$var$_,
        colorHover: "#ddd"
    },
    btnAccept: {
        background: "#388E3C",
        backgroundHover: "#1B5E20",
        textColor: "#ffffff",
        border: "0"
    },
    btnReject: {
        background: "#D32F2F",
        backgroundHover: "#B71C1C",
        textColor: "#ffffff",
        border: "0"
    },
    btnInfo: {
        background: "#EEE",
        backgroundHover: "#CCC",
        textColor: "#333",
        border: "0"
    },
    btnSettings: {
        background: "#EEE",
        backgroundHover: "#CCC",
        textColor: "#333",
        border: "0"
    },
    btnSettingsSelect: {
        background: "#EEE",
        backgroundHover: "#CCC",
        textColor: "#333",
        border: "0"
    },
    btnSettingsAccept: {
        background: "#388E3C",
        backgroundHover: "#1B5E20",
        textColor: "#ffffff",
        border: "0"
    }
}, $e911b83697f16430$var$g = "#ffffff", $e911b83697f16430$var$k = "#000000", $e911b83697f16430$export$53eb5d44de7e7386 = {
    window: {
        background: $e911b83697f16430$var$g
    },
    popup: {
        background: $e911b83697f16430$var$g,
        textColor: $e911b83697f16430$var$k
    },
    title: {
        textColor: $e911b83697f16430$var$k
    },
    message: {
        textColor: $e911b83697f16430$var$k,
        linkColor: $e911b83697f16430$var$k,
        linkFontWeight: "600"
    },
    settings: {
        separatorColor: "#000"
    },
    btnClose: {
        color: $e911b83697f16430$var$k,
        colorHover: "#666"
    },
    btnAccept: {
        background: $e911b83697f16430$var$g,
        backgroundHover: $e911b83697f16430$var$g,
        textColor: "#1B5E20",
        border: "0"
    },
    btnReject: {
        background: $e911b83697f16430$var$g,
        backgroundHover: $e911b83697f16430$var$g,
        textColor: "#B71C1C",
        border: "0"
    },
    btnInfo: {
        background: $e911b83697f16430$var$g,
        backgroundHover: $e911b83697f16430$var$g,
        textColor: $e911b83697f16430$var$k,
        border: "0"
    },
    btnSettings: {
        background: $e911b83697f16430$var$g,
        backgroundHover: $e911b83697f16430$var$g,
        textColor: $e911b83697f16430$var$k,
        border: "0"
    },
    btnSettingsSelect: {
        background: $e911b83697f16430$var$g,
        backgroundHover: $e911b83697f16430$var$g,
        textColor: $e911b83697f16430$var$k,
        border: "0"
    },
    btnSettingsAccept: {
        background: $e911b83697f16430$var$g,
        backgroundHover: $e911b83697f16430$var$g,
        textColor: $e911b83697f16430$var$k,
        border: "0"
    }
}, $e911b83697f16430$var$h = "#c2e7ff", $e911b83697f16430$var$w = "#001d35", $e911b83697f16430$export$9c24b80fa0a8bbc = {
    window: {
        background: $e911b83697f16430$var$h
    },
    popup: {
        background: $e911b83697f16430$var$h,
        textColor: $e911b83697f16430$var$w
    },
    title: {
        textColor: $e911b83697f16430$var$w
    },
    message: {
        textColor: $e911b83697f16430$var$w,
        linkColor: $e911b83697f16430$var$w,
        linkFontWeight: "600"
    },
    settings: {
        separatorColor: "#001d35"
    },
    btnClose: {
        color: $e911b83697f16430$var$w,
        colorHover: "#666"
    },
    btnAccept: {
        background: "#388E3C",
        backgroundHover: "#1B5E20",
        textColor: "#ffffff",
        border: "0"
    },
    btnReject: {
        background: "#D32F2F",
        backgroundHover: "#B71C1C",
        textColor: "#ffffff",
        border: "0"
    },
    btnInfo: {
        background: $e911b83697f16430$var$h,
        backgroundHover: $e911b83697f16430$var$h,
        textColor: $e911b83697f16430$var$w,
        border: "0"
    },
    btnSettings: {
        background: $e911b83697f16430$var$h,
        backgroundHover: $e911b83697f16430$var$h,
        textColor: $e911b83697f16430$var$w,
        border: "0"
    },
    btnSettingsSelect: {
        background: $e911b83697f16430$var$h,
        backgroundHover: $e911b83697f16430$var$h,
        textColor: $e911b83697f16430$var$w,
        border: "0"
    },
    btnSettingsAccept: {
        background: $e911b83697f16430$var$h,
        backgroundHover: $e911b83697f16430$var$h,
        textColor: $e911b83697f16430$var$w,
        border: "0"
    }
};


// const siteUrl = window.location.origin;
const $02c28f63d8e70de0$var$cookieNoticeUrl = site_url + 'cookie-policy';
const $02c28f63d8e70de0$var$cookiesConsent = new (0, $e911b83697f16430$export$abba94fbeefd623b)({
    expirationDays: 182,
    buttons: [
        'accept',
        'settings',
        'reject'
    ],
    content: {
        btnAccept: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438 \u0432\u0441\u0435",
        btnReject: "\u0412\u0456\u0434\u043C\u043E\u0432\u0438\u0442\u0438\u0441\u044F \u0432\u0456\u0434 \u0443\u0441\u044C\u043E\u0433\u043E",
        btnSettings: "\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u0442\u0438 \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438",
        btnSettingsSelectAll: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438 \u0432\u0441\u0435",
        btnSettingsAccept: "\u041F\u0440\u0438\u0439\u043D\u044F\u0442\u0438 \u0432\u0438\u0431\u0440\u0430\u043D\u0435",
        title: "\u0426\u0435\u0439 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454 Cookies!",
        message: `
        
      <p>
        \u{426}\u{435}\u{439} \u{432}\u{435}\u{431}-\u{441}\u{430}\u{439}\u{442} \u{432}\u{438}\u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{43E}\u{432}\u{443}\u{454} \u{444}\u{430}\u{439}\u{43B}\u{438} cookie \u{434}\u{43B}\u{44F} \u{430}\u{43D}\u{430}\u{43B}\u{456}\u{437}\u{443} \u{442}\u{440}\u{430}\u{444}\u{456}\u{43A}\u{443} \u{442}\u{430} \u{43F}\u{43E}\u{43A}\u{440}\u{430}\u{449}\u{435}\u{43D}\u{43D}\u{44F} \u{432}\u{430}\u{448}\u{43E}\u{433}\u{43E} \u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{443}\u{432}\u{430}\u{446}\u{44C}\u{43A}\u{43E}\u{433}\u{43E} \u{434}\u{43E}\u{441}\u{432}\u{456}\u{434}\u{443}. \u{41D}\u{430}\u{442}\u{438}\u{441}\u{43A}\u{430}\u{44E}\u{447}\u{438} '\u{41F}\u{440}\u{438}\u{439}\u{43D}\u{44F}\u{442}\u{438} \u{432}\u{441}\u{435}', \u{432}\u{438} \u{43F}\u{43E}\u{433}\u{43E}\u{434}\u{436}\u{443}\u{454}\u{442}\u{435}\u{441}\u{44F} \u{43D}\u{430} \u{432}\u{438}\u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F} \u{432}\u{441}\u{456}\u{445} \u{444}\u{430}\u{439}\u{43B}\u{456}\u{432} cookie. \u{412}\u{438} \u{43C}\u{43E}\u{436}\u{435}\u{442}\u{435} \u{43D}\u{430}\u{43B}\u{430}\u{448}\u{442}\u{443}\u{432}\u{430}\u{442}\u{438} \u{441}\u{432}\u{43E}\u{457} \u{432}\u{43F}\u{43E}\u{434}\u{43E}\u{431}\u{430}\u{43D}\u{43D}\u{44F} \u{430}\u{431}\u{43E} \u{432}\u{456}\u{434}\u{43C}\u{43E}\u{432}\u{438}\u{442}\u{438}\u{441}\u{44F} \u{432}\u{456}\u{434} \u{443}\u{441}\u{456}\u{445} \u{444}\u{430}\u{439}\u{43B}\u{456}\u{432} cookie, \u{43D}\u{430}\u{442}\u{438}\u{441}\u{43D}\u{443}\u{432}\u{448}\u{438} '\u{41D}\u{430}\u{43B}\u{430}\u{448}\u{442}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{456}\u{432} cookie' \u{430}\u{431}\u{43E} '\u{412}\u{456}\u{434}\u{445}\u{438}\u{43B}\u{438}\u{442}\u{438} \u{432}\u{441}\u{435}' \u{432}\u{456}\u{434}\u{43F}\u{43E}\u{432}\u{456}\u{434}\u{43D}\u{43E}. \u{414}\u{43B}\u{44F} \u{43E}\u{442}\u{440}\u{438}\u{43C}\u{430}\u{43D}\u{43D}\u{44F} \u{434}\u{435}\u{442}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{457} \u{456}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{457} \u{43E}\u{437}\u{43D}\u{430}\u{439}\u{43E}\u{43C}\u{442}\u{435}\u{441}\u{44F} \u{437} \u{43D}\u{430}\u{448}\u{43E}\u{44E} <a href=${$02c28f63d8e70de0$var$cookieNoticeUrl}>\u{41F}\u{43E}\u{43B}\u{456}\u{442}\u{438}\u{43A}\u{43E}\u{44E} \u{432}\u{438}\u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{456}\u{432} cookie</a>.
      </p>
      `,
        // policy: 'Privacy Policy',
        // policyLink: 'https://gdpr-info.eu/',
        settingsFooter: `
    <p>
      \u{41E}\u{434}\u{43D}\u{430}\u{43A}, \u{44F}\u{43A}\u{449}\u{43E} \u{432}\u{438} \u{43D}\u{430}\u{43B}\u{430}\u{448}\u{442}\u{443}\u{454}\u{442}\u{435} \u{432}\u{430}\u{448} \u{431}\u{440}\u{430}\u{443}\u{437}\u{435}\u{440} \u{43D}\u{430} \u{431}\u{43B}\u{43E}\u{43A}\u{443}\u{432}\u{430}\u{43D}\u{43D}\u{44F} \u{432}\u{441}\u{456}\u{445} \u{444}\u{430}\u{439}\u{43B}\u{456}\u{432} cookie, \u{432}\u{43A}\u{43B}\u{44E}\u{447}\u{430}\u{44E}\u{447}\u{438} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{456}\u{434}\u{43D}\u{456}, \u{432}\u{438} \u{43C}\u{43E}\u{436}\u{435}\u{442}\u{435} \u{43D}\u{435} \u{43C}\u{430}\u{442}\u{438} \u{434}\u{43E}\u{441}\u{442}\u{443}\u{43F}\u{443} \u{434}\u{43E} \u{432}\u{441}\u{456}\u{445} \u{430}\u{431}\u{43E} \u{434}\u{435}\u{44F}\u{43A}\u{438}\u{445} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{456}\u{439} \u{43D}\u{430}\u{448}\u{43E}\u{433}\u{43E} \u{432}\u{435}\u{431}-\u{441}\u{430}\u{439}\u{442}\u{443}. \u{417}\u{432}\u{435}\u{440}\u{43D}\u{456}\u{442}\u{44C} \u{443}\u{432}\u{430}\u{433}\u{443}, \u{449}\u{43E} \u{432}\u{441}\u{456} \u{444}\u{430}\u{439}\u{43B}\u{438} cookie, \u{437}\u{430} \u{432}\u{438}\u{43D}\u{44F}\u{442}\u{43A}\u{43E}\u{43C} \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{456}\u{434}\u{43D}\u{438}\u{445}, \u{432}\u{442}\u{440}\u{430}\u{447}\u{430}\u{44E}\u{442}\u{44C} \u{441}\u{432}\u{43E}\u{44E} \u{434}\u{456}\u{44E} \u{43F}\u{456}\u{441}\u{43B}\u{44F} \u{437}\u{430}\u{43A}\u{456}\u{43D}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{442}\u{435}\u{440}\u{43C}\u{456}\u{43D}\u{443}, \u{432}\u{43A}\u{430}\u{437}\u{430}\u{43D}\u{43E}\u{433}\u{43E} \u{432} \u{43D}\u{430}\u{448}\u{456}\u{439} <a href=${$02c28f63d8e70de0$var$cookieNoticeUrl}>\u{41F}\u{43E}\u{43B}\u{456}\u{442}\u{438}\u{446}\u{456} \u{432}\u{438}\u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{430}\u{43D}\u{43D}\u{44F} \u{444}\u{430}\u{439}\u{43B}\u{456}\u{432} cookie</a>.
    </p>
  `
    },
    cookies: [
        {
            name: 'title_cookie',
            title: "\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F",
            checked: true
        },
        {
            checked: true,
            name: 'essential_cookie',
            title: "\u041E\u0441\u043D\u043E\u0432\u043D\u0456 \u0432\u0438\u0434\u0438 Cookies",
            description: `
      <p>
        \u{426}\u{456} \u{444}\u{430}\u{439}\u{43B}\u{438} cookie \u{43D}\u{435}\u{43E}\u{431}\u{445}\u{456}\u{434}\u{43D}\u{456} \u{434}\u{43B}\u{44F} \u{437}\u{430}\u{431}\u{435}\u{437}\u{43F}\u{435}\u{447}\u{435}\u{43D}\u{43D}\u{44F} \u{43E}\u{441}\u{43D}\u{43E}\u{432}\u{43D}\u{43E}\u{457} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{456}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{43E}\u{441}\u{442}\u{456} \u{421}\u{430}\u{439}\u{442}\u{443}. \u{411}\u{435}\u{437} \u{446}\u{438}\u{445} \u{444}\u{430}\u{439}\u{43B}\u{456}\u{432} cookie \u{437}\u{430}\u{43F}\u{438}\u{442}\u{443}\u{432}\u{430}\u{43D}\u{456} \u{432}\u{430}\u{43C}\u{438} \u{43F}\u{43E}\u{441}\u{43B}\u{443}\u{433}\u{438} \u{43D}\u{435} \u{43C}\u{43E}\u{436}\u{443}\u{442}\u{44C} \u{431}\u{443}\u{442}\u{438} \u{43D}\u{430}\u{434}\u{430}\u{43D}\u{456}. \u{42F}\u{43A}\u{449}\u{43E} \u{432}\u{438} \u{432}\u{438}\u{43C}\u{43A}\u{43D}\u{435}\u{442}\u{435} \u{446}\u{456} \u{444}\u{430}\u{439}\u{43B}\u{438} cookie, \u{43F}\u{435}\u{432}\u{43D}\u{456} \u{447}\u{430}\u{441}\u{442}\u{438}\u{43D}\u{438} \u{421}\u{430}\u{439}\u{442}\u{443} \u{43D}\u{435} \u{43F}\u{440}\u{430}\u{446}\u{44E}\u{432}\u{430}\u{442}\u{438}\u{43C}\u{443}\u{442}\u{44C} \u{434}\u{43B}\u{44F} \u{432}\u{430}\u{441}.
      </p>
      `
        },
        {
            name: 'analytics_cookie',
            title: "\u0410\u043D\u0430\u043B\u0456\u0442\u0438\u0447\u043D\u0456 \u0444\u0430\u0439\u043B\u0438 Cookies",
            description: `
      <p>
        \u{426}\u{456} \u{444}\u{430}\u{439}\u{43B}\u{438} cookie \u{432}\u{438}\u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{43E}\u{432}\u{443}\u{44E}\u{442}\u{44C}\u{441}\u{44F} \u{434}\u{43B}\u{44F} \u{437}\u{431}\u{43E}\u{440}\u{443} \u{456}\u{43D}\u{444}\u{43E}\u{440}\u{43C}\u{430}\u{446}\u{456}\u{457} \u{43F}\u{440}\u{43E} \u{442}\u{435}, \u{44F}\u{43A} \u{432}\u{456}\u{434}\u{432}\u{456}\u{434}\u{443}\u{432}\u{430}\u{447}\u{456} \u{432}\u{437}\u{430}\u{454}\u{43C}\u{43E}\u{434}\u{456}\u{44E}\u{442}\u{44C} \u{456}\u{437} \u{43D}\u{430}\u{448}\u{438}\u{43C} \u{421}\u{430}\u{439}\u{442}\u{43E}\u{43C}. \u{412}\u{43E}\u{43D}\u{438} \u{434}\u{43E}\u{43F}\u{43E}\u{43C}\u{430}\u{433}\u{430}\u{44E}\u{442}\u{44C} \u{43D}\u{430}\u{43C} \u{437}\u{440}\u{43E}\u{437}\u{443}\u{43C}\u{456}\u{442}\u{438}, \u{44F}\u{43A}\u{456} \u{441}\u{442}\u{43E}\u{440}\u{456}\u{43D}\u{43A}\u{438} \u{454} \u{43D}\u{430}\u{439}\u{431}\u{456}\u{43B}\u{44C}\u{448} \u{43F}\u{43E}\u{43F}\u{443}\u{43B}\u{44F}\u{440}\u{43D}\u{438}\u{43C}\u{438}, \u{441}\u{43A}\u{456}\u{43B}\u{44C}\u{43A}\u{438} \u{447}\u{430}\u{441}\u{443} \u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{443}\u{432}\u{430}\u{447}\u{456} \u{43F}\u{440}\u{43E}\u{432}\u{43E}\u{434}\u{44F}\u{442}\u{44C} \u{43D}\u{430} \u{421}\u{430}\u{439}\u{442}\u{456}, \u{430} \u{442}\u{430}\u{43A}\u{43E}\u{436} \u{432}\u{438}\u{44F}\u{432}\u{438}\u{442}\u{438} \u{43C}\u{43E}\u{436}\u{43B}\u{438}\u{432}\u{456} \u{43F}\u{440}\u{43E}\u{431}\u{43B}\u{435}\u{43C}\u{438} \u{432} \u{440}\u{43E}\u{431}\u{43E}\u{442}\u{456} \u{440}\u{435}\u{441}\u{443}\u{440}\u{441}\u{443}. \u{426}\u{435} \u{434}\u{43E}\u{437}\u{432}\u{43E}\u{43B}\u{44F}\u{454} \u{43D}\u{430}\u{43C} \u{43F}\u{43E}\u{43A}\u{440}\u{430}\u{449}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43A}\u{43E}\u{43D}\u{442}\u{435}\u{43D}\u{442} \u{456} \u{444}\u{443}\u{43D}\u{43A}\u{446}\u{456}\u{43E}\u{43D}\u{430}\u{43B}\u{44C}\u{43D}\u{456}\u{441}\u{442}\u{44C} \u{421}\u{430}\u{439}\u{442}\u{443}, \u{437}\u{430}\u{431}\u{435}\u{437}\u{43F}\u{435}\u{447}\u{443}\u{44E}\u{447}\u{438} \u{43A}\u{440}\u{430}\u{449}\u{438}\u{439} \u{43A}\u{43E}\u{440}\u{438}\u{441}\u{442}\u{443}\u{432}\u{430}\u{446}\u{44C}\u{43A}\u{438}\u{439} \u{434}\u{43E}\u{441}\u{432}\u{456}\u{434}. \u{41D}\u{430}\u{43F}\u{440}\u{438}\u{43A}\u{43B}\u{430}\u{434}, \u{43C}\u{438} \u{43C}\u{43E}\u{436}\u{435}\u{43C}\u{43E} \u{430}\u{43D}\u{430}\u{43B}\u{456}\u{437}\u{443}\u{432}\u{430}\u{442}\u{438} \u{43A}\u{456}\u{43B}\u{44C}\u{43A}\u{456}\u{441}\u{442}\u{44C} \u{432}\u{456}\u{434}\u{432}\u{456}\u{434}\u{443}\u{432}\u{430}\u{43D}\u{44C} \u{43F}\u{435}\u{432}\u{43D}\u{438}\u{445} \u{441}\u{442}\u{43E}\u{440}\u{456}\u{43D}\u{43E}\u{43A} \u{430}\u{431}\u{43E} \u{43E}\u{446}\u{456}\u{43D}\u{44E}\u{432}\u{430}\u{442}\u{438} \u{435}\u{444}\u{435}\u{43A}\u{442}\u{438}\u{432}\u{43D}\u{456}\u{441}\u{442}\u{44C} \u{43D}\u{430}\u{448}\u{438}\u{445} \u{43C}\u{430}\u{440}\u{43A}\u{435}\u{442}\u{438}\u{43D}\u{433}\u{43E}\u{432}\u{438}\u{445} \u{43A}\u{430}\u{43C}\u{43F}\u{430}\u{43D}\u{456}\u{439}.
      </p>
      `,
            cookies: [
                {
                    name: 'cc_ga',
                    code: 'G-5VB9Y83CYB',
                    manageFunction: (0, $e911b83697f16430$export$4e53bdbbebc21430)
                },
                {
                    name: 'cc_gtm',
                    code: 'GTM-PVJH7S4',
                    manageFunction: (0, $e911b83697f16430$export$820186ca1f2a4eae)
                }
            ]
        }
    ]
});
const $02c28f63d8e70de0$var$cookiesConsentSetting = function(option) {
    const elem = option === 'sets' && '.js-cookie-setting' || option === 'msn' && '.js-cookie-msn';
    const settingTriggers = document.querySelectorAll(elem);
    settingTriggers.forEach((trigger)=>{
        trigger.addEventListener('click', ()=>{
            option === 'sets' && $02c28f63d8e70de0$var$cookiesConsent.toggleSettings();
            option === 'msn' && $02c28f63d8e70de0$var$cookiesConsent.showMessage();
        });
    });
};
window.cookiesConsent = $02c28f63d8e70de0$var$cookiesConsent;
window.cookiesConsentSetting = $02c28f63d8e70de0$var$cookiesConsentSetting('sets');
window.cookiesConsentShow = $02c28f63d8e70de0$var$cookiesConsentSetting('msn');


const $6ad400af65f406ec$var$headerComponent = document.getElementsByClassName('header')[0];
const $6ad400af65f406ec$var$topHeaderComponent = document.getElementsByClassName('top-header')[0];
// Header scroll
if ($6ad400af65f406ec$var$headerComponent) {
    const scrollContainer = ()=>document.documentElement || document.body;
    document.addEventListener('scroll', ()=>{
        if (scrollContainer().scrollTop > 50) {
            $6ad400af65f406ec$var$headerComponent.classList.add('scrolled');
            $6ad400af65f406ec$var$topHeaderComponent.classList.add('scrolled');
        } else if (scrollContainer().scrollTop == 0) {
            $6ad400af65f406ec$var$headerComponent.classList.remove('scrolled');
            $6ad400af65f406ec$var$topHeaderComponent.classList.remove('scrolled');
        }
    });
    // menu handlers
    // check mobile menu show/hide condition
    const mobileMenuStartPoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--mobile-menu-start-point'));
    let isMobileMenuEnable = window.outerWidth <= mobileMenuStartPoint || document.querySelector('.header-mobile');
    /*const dropdownToggle = document.querySelectorAll('.menu-dropdown');

  dropdownToggle.forEach((dropdown) => {
    const toggle = dropdown.querySelector('.menu-dropdown__arrow');
    toggle.addEventListener('click', function (e) {
      if (isMobileMenuEnable) {
        const menuItem = this.closest('.menu__item.menu-dropdown');
        const menuList = menuItem.querySelector('.menu-dropdown__list');
        const dropdownMenu = this.nextElementSibling;

        // close all opened sub menu
        const activeDropdowns = document.querySelectorAll(
          '.menu-item.dropdown.active .dropdown-menu'
        );
        activeDropdowns.forEach((menu) => {
          menu.style.display = 'none';
          menu.closest('.dropdown').classList.remove('active');
        });
        document.querySelectorAll('.menu-dropdown__list').forEach((list) => {
          list.classList.remove('active');
        });

        // open current submenu
        menuItem.classList.toggle('active');
        menuList.classList.toggle('active');
        if (menuItem.classList.contains('active')) {
          e.preventDefault();
          dropdownMenu.style.display = 'block';
        }
      }
    });
  });*/ if (document.getElementsByClassName('menu-dropdown')[0]) {
        const dropdownToggleArr = document.querySelectorAll('.menu-dropdown');
        const dropdownArrowArr = document.querySelectorAll('.menu-dropdown__arrow');
        const dropdownListArr = document.querySelectorAll('.menu-dropdown__list');
        dropdownToggleArr.forEach((btn, i)=>{
            const arrow = btn.querySelector('.menu-dropdown__arrow');
            const link = btn.querySelector('.menu__link');
            link.addEventListener('click', (e)=>{
                if (!link.classList.contains('is-opened')) e.preventDefault();
                link.classList.add('is-opened');
                openLogic();
            });
            arrow.addEventListener('click', ()=>{
                if (!arrow.classList.contains('active')) openLogic();
                else for(let j = 0; j < dropdownToggleArr.length; j++){
                    dropdownArrowArr[j].classList.remove('active');
                    dropdownListArr[j].classList.remove('active');
                }
            });
            function openLogic() {
                for(let j = 0; j < dropdownToggleArr.length; j++){
                    dropdownArrowArr[j].classList.remove('active');
                    dropdownListArr[j].classList.remove('active');
                }
                arrow.classList.toggle('active');
                dropdownListArr[i].classList.toggle('active');
            }
        });
    }
    // toggle menu handler
    function menuToggleFunc() {
        const menuToggle = document.querySelector('.menu-toggle');
        const navbarNav = document.querySelector('.navbar-nav');
        const headerCloseWrapper = document.querySelector('.header-close-wrapper');
        menuToggle.classList.toggle('active');
        navbarNav.classList.toggle('active');
        $6ad400af65f406ec$var$headerComponent.classList.toggle('open-menu');
        $6ad400af65f406ec$var$topHeaderComponent.classList.toggle('open-menu');
        headerCloseWrapper.classList.toggle('active');
        updatePositionMobileNav();
        // LockScroll when burger open and enable when closed and enable scroll on menu
        if (document.getElementsByClassName('cart-container')[0]) {
            if (!document.getElementsByClassName('cart-container')[0].classList.contains('is-open')) {
                if (scrollLock.getScrollState()) {
                    scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
                    scrollLock.addScrollableSelector('.simplebar-content-wrapper');
                } else scrollLock.enablePageScroll();
            }
        } else if (scrollLock.getScrollState()) {
            scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
            scrollLock.addScrollableSelector('.simplebar-content-wrapper');
        } else scrollLock.enablePageScroll();
    }
    // menu update function
    function updateMenu() {
        isMobileMenuEnable = window.outerWidth <= mobileMenuStartPoint || document.querySelector('.mobile-header');
        if (!isMobileMenuEnable) {
            const dropdownMenus = document.querySelectorAll('.dropdown-menu');
            dropdownMenus.forEach((menu)=>{
                menu.style.display = '';
            });
            const headerCloseWrapper = document.querySelector('.header-close-wrapper');
            headerCloseWrapper.classList.remove('active');
            const activeMenuItems = document.querySelectorAll('.menu-item.active');
            activeMenuItems.forEach((item)=>{
                item.classList.remove('active');
            });
            const navbarNav = document.querySelector('.navbar-nav');
            navbarNav.classList.remove('active');
            $6ad400af65f406ec$var$headerComponent.classList.remove('open-menu');
            $6ad400af65f406ec$var$topHeaderComponent.classList.remove('open-menu');
            const menuToggle = document.querySelector('.menu-toggle');
            menuToggle.classList.remove('active');
            // LockScroll when burger open and enable when closed
            scrollLock.enablePageScroll();
        }
        updatePositionMobileNav();
    }
    function updatePositionMobileNav() {
        const topNavValue = `${$6ad400af65f406ec$var$headerComponent.clientHeight}px`;
        document.documentElement.style.setProperty('--top-nav', topNavValue);
    }
    updatePositionMobileNav();
    window.addEventListener('resize', updateMenu);
    window.addEventListener('orientationchange', updateMenu);
    // end of toggle menu handler
    const menuToggle = document.querySelector('.menu-toggle');
    const headerCloseWrapper = document.querySelector('.header-close-wrapper');
    const toggleCloseMenu = document.querySelector('.toggle-close-menu');
    menuToggle.addEventListener('click', menuToggleFunc);
    headerCloseWrapper.addEventListener('click', menuToggleFunc);
    toggleCloseMenu.addEventListener('click', menuToggleFunc);
    // Hide and show Header when scroll up
    /*function headerSticky() {
    let prevScrollPos = window.pageYOffset;

    window.addEventListener('scroll', () => {
      const currentScrollPos = window.pageYOffset;
      const headerHeight = headerComponent.scrollHeight;
      const topHeaderHeight = topHeaderComponent.scrollHeight;

      if (window.scrollY > 0) {
        if (prevScrollPos > currentScrollPos) {
          /!*headerComponent.style.top = 0;*!/
          headerComponent.classList.add('scrolled');
          topHeaderComponent.style.top = 0;
          topHeaderComponent.classList.add('scrolled');
          if (headerComponent.classList.contains('scrolled')) {
            headerComponent.style.top = `${topHeaderHeight}px`;
          }
        } else {
          /!*headerComponent.style.top = `-${headerHeight + 3}px`;*!/
          topHeaderComponent.style.top = `-${topHeaderHeight + 3}px`;
          headerComponent.style.top = 0;
        }
      }

      if (window.scrollY === 0) {
        headerComponent.classList.remove('scrolled');
        topHeaderComponent.classList.remove('scrolled');
        headerComponent.style.top = 0;
      }

      prevScrollPos = currentScrollPos;
    });

    if (window.scrollY !== 0) {
      headerComponent.classList.add('scrolled');
      topHeaderComponent.classList.add('scrolled');
    }
  }

  headerSticky();*/ function headerSticky() {
        let prevScrollPos = window.pageYOffset;
        window.addEventListener('scroll', ()=>{
            const currentScrollPos = window.pageYOffset;
            const headerHeight = $6ad400af65f406ec$var$headerComponent.scrollHeight;
            if (window.scrollY > 0) {
                if (prevScrollPos > currentScrollPos) {
                    $6ad400af65f406ec$var$headerComponent.style.top = 0;
                    $6ad400af65f406ec$var$headerComponent.classList.add('scrolled');
                } else /*headerComponent.style.top = `-${headerHeight + 3}px`;*/ $6ad400af65f406ec$var$headerComponent.style.top = 0;
            }
            if (window.scrollY === 0) {
                $6ad400af65f406ec$var$headerComponent.classList.remove('scrolled');
                $6ad400af65f406ec$var$headerComponent.style.top = 0;
            }
            prevScrollPos = currentScrollPos;
        });
        if (window.scrollY !== 0) $6ad400af65f406ec$var$headerComponent.classList.add('scrolled');
    }
    headerSticky();
    const languageDropdown = document.getElementsByClassName('top-header__language')[0];
    if (languageDropdown) {
        languageDropdown.addEventListener('click', ()=>{
            if (window.innerWidth <= 1024) languageDropdown.classList.toggle('active');
        });
        document.addEventListener('click', (event)=>{
            if (window.innerWidth <= 1024) {
                const targetElement = event.target;
                const isClickInsideLanguageDropdown = languageDropdown.contains(targetElement);
                if (!isClickInsideLanguageDropdown) languageDropdown.classList.remove('active');
            }
        });
    }
}


window.uploadFile = function uploadFile1() {
    if (document.querySelector('[data-upload-file-animation]')) {
        const uploadFileBlocksArr = document.querySelectorAll('[data-upload-file-animation]');
        uploadFileBlocksArr.forEach((fileUpload)=>{
            fileUpload.addEventListener('dragover', function() {
                this.classList.add('drag');
                this.classList.remove('drop', 'done');
            });
            fileUpload.addEventListener('dragleave', function() {
                this.classList.remove('drag');
            });
            fileUpload.addEventListener('drop', start, false);
            fileUpload.addEventListener('change', start, false);
            function start() {
                this.classList.remove('drag');
                this.classList.add('drop');
                setTimeout(()=>this.classList.add('done'), 500);
            }
        });
    }
};
uploadFile();


window.autosizeTextarea = function autosizeTextarea1() {
    if (document.querySelector('textarea[data-autosize]')) {
        const autosizeTextareaElements = document.querySelectorAll('textarea[data-autosize]');
        autosizeTextareaElements.forEach((textarea)=>{
            const startHeight = textarea.offsetHeight;
            textarea.addEventListener('input', autosize);
            function autosize() {
                const el = this;
                const newHeight = el.scrollHeight;
                if (newHeight > startHeight) el.style.minHeight = `${el.scrollHeight}px`;
                else el.style.minHeight = startHeight;
            }
        });
    }
};
autosizeTextarea();
window.initFocusInputLogic = function initFocusInputLogic1() {
    if (document.getElementsByClassName('meta-input')[0]) {
        const inputsFieldsArr = document.querySelectorAll('.meta-input');
        inputsFieldsArr.forEach((inputField, index)=>{
            if (!inputField.classList.contains('is-init')) {
                const input = inputField.querySelector('input');
                const textarea = inputField.querySelector('textarea');
                /*console.log(input.value.trim());*/ if (input) {
                    if (input.getAttribute('value')) inputField.classList.add('focused');
                    input.addEventListener('focus', function() {
                        inputField.classList.add('focused');
                    });
                    input.addEventListener('blur', function() {
                        if (!input.value) inputField.classList.remove('focused');
                    });
                    inputField.classList.add('is-init');
                } else {
                    if (textarea.getAttribute('value')) inputField.classList.add('focused');
                    textarea.addEventListener('focus', function() {
                        inputField.classList.add('focused');
                    });
                    $('textarea').on('blur', function() {
                        var value = $(this).val();
                        var cleanedValue = value.replace(/\s+/g, '').replace(/[\u00A0]+/g, '');
                        if (cleanedValue === '') inputField.classList.remove('focused');
                    });
                    inputField.classList.add('is-init');
                }
            }
        });
    }
};
initFocusInputLogic();
window.passwordInputs = function passwordInputs1() {
    if (document.querySelector('.password-input')) {
        const passwordInputsArr = document.querySelectorAll('.password-input');
        passwordInputsArr.forEach((password)=>{
            const btn = password.querySelector('.password-input__btn');
            const input = password.querySelector('input');
            btn.addEventListener('click', ()=>{
                inputIconFunc();
            });
            function inputIconFunc() {
                if (!btn.classList.contains('is-password-hidden')) {
                    btn.classList.add('is-password-hidden');
                    input.type = 'password';
                } else {
                    btn.classList.remove('is-password-hidden');
                    input.type = 'text';
                }
            }
            inputIconFunc();
        });
    }
};
passwordInputs();
const $b4527f46cc7e9b87$var$phoneNumberInput = document.getElementsByClassName('phone-input')[0];
if ($b4527f46cc7e9b87$var$phoneNumberInput) {
    const phoneNumberInputArr = document.querySelectorAll('.phone-input');
    const maskOptions = {
        mask: '+{38} (000) 000-00-00'
    };
    const validatePhoneNumberLength = (value)=>{
        return value.replace(/\D/g, '').length === 12;
    };
    const formatPhoneNumberInput = (input)=>{
        const currentValue = input.value;
        const infoInput = input.parentElement.querySelector('.input-info');
        if (validatePhoneNumberLength(currentValue)) {
            if (Number(input.value[5]) !== 0) {
                infoInput.classList.add('active');
                infoInput.classList.remove('active-valid');
                infoInput.classList.add('active-not-valid');
                infoInput.textContent = "\u041A\u043E\u0434 \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u0443 \u043C\u0430\u0454 \u043F\u043E\u0447\u0438\u043D\u0430\u0442\u0438\u0441\u044F \u0437 0, \u043D\u0430\u043F\u0440\u0438\u043A\u043B\u0430\u0434 099";
            } else {
                infoInput.classList.add('active');
                infoInput.classList.remove('active-not-valid');
                infoInput.classList.add('active-valid');
                infoInput.textContent = "\u041D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443 \u0432\u0432\u0435\u0434\u0435\u043D\u043E \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0438\u0439";
                setTimeout(function() {
                    infoInput.classList.remove('active');
                }, 2000);
            }
        } else {
            infoInput.classList.add('active');
            infoInput.classList.remove('active-valid');
            infoInput.classList.add('active-not-valid');
            infoInput.textContent = "\u0412\u0432\u0435\u0434\u0456\u0442\u044C \u043A\u043E\u0440\u0435\u043A\u0442\u043D\u0438\u0439 \u043D\u043E\u043C\u0435\u0440 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u0443, \u043C\u0430\u0454 \u0431\u0443\u0442\u0438 12 \u0441\u0438\u043C\u0432\u043E\u043B\u0456\u0432";
        }
    };
    phoneNumberInputArr.forEach((input, index)=>{
        const mask = IMask(input, maskOptions);
        input.addEventListener('click', (event)=>{
            if (input.value === '+38 (000) 000-00-00') input.value = '';
        });
        input.addEventListener('blur', ()=>{
            input.value;
        });
        input.addEventListener('input', (event)=>{
            formatPhoneNumberInput(event.target);
        });
    });
}
window.counterInputsFunc = function counterInputsFunc1() {
    const checkoutInputsArr = document.querySelectorAll('.checkout-input');
    checkoutInputsArr.forEach((input)=>{
        input.addEventListener('input', function(event) {
            let value = this.value.trim();
            value = value.replace(/\D/g, '');
            if (parseInt(value) >= 999) value = '999';
            this.value = value;
        });
    });
};
counterInputsFunc();
window.decreaseInputNumber = function decreaseInputNumber(inputId) {
    const input = document.getElementById(inputId);
    input.stepDown();
    const parentBlock = input.closest('.counter-parent-toggle');
    if (Number(input.value) === 0 && parentBlock.classList.contains('active')) {
        const parentCard = parentBlock.parentElement.parentElement.parentElement;
        parentBlock.classList.remove('active');
        parentCard.classList.remove('is-open-counter');
    }
    const event = new Event('change');
    input.dispatchEvent(event);
};
window.increaseInputNumber = function increaseInputNumber(inputId) {
    const input = document.getElementById(inputId);
    let value = input.value.trim();
    value = value.replace(/\D/g, '');
    if (parseInt(value) >= 999) value = '999';
    else input.stepUp();
    const event = new Event('change');
    input.dispatchEvent(event);
};


/**
 * simplebar - v6.3.0
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ /**
 * simplebar-core - v1.3.0
 * Scrollbars, simpler.
 * https://grsmto.github.io/simplebar/
 *
 * Made by Adrien Denat from a fork by Jonathan Nicol
 * Under MIT License
 */ var $f41b4c82c646b949$exports = {};
var $3742f66b0b4e3bb6$exports = {};
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $3742f66b0b4e3bb6$var$isObject(value) {
    var type = typeof value;
    return value != null && (type == 'object' || type == 'function');
}
$3742f66b0b4e3bb6$exports = $3742f66b0b4e3bb6$var$isObject;


var $795cbad2cff1da57$exports = {};
var $58fc58406980b205$exports = {};
var $174ef45175b53c43$exports = {};
/** Detect free variable `global` from Node.js. */ var $174ef45175b53c43$var$freeGlobal = typeof $parcel$global == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
$174ef45175b53c43$exports = $174ef45175b53c43$var$freeGlobal;


/** Detect free variable `self`. */ var $58fc58406980b205$var$freeSelf = typeof self == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $58fc58406980b205$var$root = $174ef45175b53c43$exports || $58fc58406980b205$var$freeSelf || Function('return this')();
$58fc58406980b205$exports = $58fc58406980b205$var$root;


/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $795cbad2cff1da57$var$now = function() {
    return $58fc58406980b205$exports.Date.now();
};
$795cbad2cff1da57$exports = $795cbad2cff1da57$var$now;


var $cdfb709f87ca2d35$exports = {};
var $5ee3f8854a575d46$exports = {};
var $3668e3fff8260dba$exports = {};
/** Used to match a single whitespace character. */ var $3668e3fff8260dba$var$reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */ function $3668e3fff8260dba$var$trimmedEndIndex(string) {
    var index = string.length;
    while(index-- && $3668e3fff8260dba$var$reWhitespace.test(string.charAt(index)));
    return index;
}
$3668e3fff8260dba$exports = $3668e3fff8260dba$var$trimmedEndIndex;


/** Used to match leading whitespace. */ var $5ee3f8854a575d46$var$reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */ function $5ee3f8854a575d46$var$baseTrim(string) {
    return string ? string.slice(0, $3668e3fff8260dba$exports(string) + 1).replace($5ee3f8854a575d46$var$reTrimStart, '') : string;
}
$5ee3f8854a575d46$exports = $5ee3f8854a575d46$var$baseTrim;



var $1b364d4b3d648939$exports = {};
var $20002ccb6f4ea696$exports = {};
var $a6e86a9b8d978d2b$exports = {};

/** Built-in value references. */ var $a6e86a9b8d978d2b$var$Symbol = $58fc58406980b205$exports.Symbol;
$a6e86a9b8d978d2b$exports = $a6e86a9b8d978d2b$var$Symbol;


var $03f4fc2a8d2a41ef$exports = {};

/** Used for built-in method references. */ var $03f4fc2a8d2a41ef$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $03f4fc2a8d2a41ef$var$hasOwnProperty = $03f4fc2a8d2a41ef$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $03f4fc2a8d2a41ef$var$nativeObjectToString = $03f4fc2a8d2a41ef$var$objectProto.toString;
/** Built-in value references. */ var $03f4fc2a8d2a41ef$var$symToStringTag = $a6e86a9b8d978d2b$exports ? $a6e86a9b8d978d2b$exports.toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $03f4fc2a8d2a41ef$var$getRawTag(value) {
    var isOwn = $03f4fc2a8d2a41ef$var$hasOwnProperty.call(value, $03f4fc2a8d2a41ef$var$symToStringTag), tag = value[$03f4fc2a8d2a41ef$var$symToStringTag];
    try {
        value[$03f4fc2a8d2a41ef$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $03f4fc2a8d2a41ef$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$03f4fc2a8d2a41ef$var$symToStringTag] = tag;
        else delete value[$03f4fc2a8d2a41ef$var$symToStringTag];
    }
    return result;
}
$03f4fc2a8d2a41ef$exports = $03f4fc2a8d2a41ef$var$getRawTag;


var $525269069c2f70cb$exports = {};
/** Used for built-in method references. */ var $525269069c2f70cb$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $525269069c2f70cb$var$nativeObjectToString = $525269069c2f70cb$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $525269069c2f70cb$var$objectToString(value) {
    return $525269069c2f70cb$var$nativeObjectToString.call(value);
}
$525269069c2f70cb$exports = $525269069c2f70cb$var$objectToString;


/** `Object#toString` result references. */ var $20002ccb6f4ea696$var$nullTag = '[object Null]', $20002ccb6f4ea696$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $20002ccb6f4ea696$var$symToStringTag = $a6e86a9b8d978d2b$exports ? $a6e86a9b8d978d2b$exports.toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $20002ccb6f4ea696$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $20002ccb6f4ea696$var$undefinedTag : $20002ccb6f4ea696$var$nullTag;
    return $20002ccb6f4ea696$var$symToStringTag && $20002ccb6f4ea696$var$symToStringTag in Object(value) ? $03f4fc2a8d2a41ef$exports(value) : $525269069c2f70cb$exports(value);
}
$20002ccb6f4ea696$exports = $20002ccb6f4ea696$var$baseGetTag;


var $1bb463dde9fe8351$exports = {};
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $1bb463dde9fe8351$var$isObjectLike(value) {
    return value != null && typeof value == 'object';
}
$1bb463dde9fe8351$exports = $1bb463dde9fe8351$var$isObjectLike;


/** `Object#toString` result references. */ var $1b364d4b3d648939$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $1b364d4b3d648939$var$isSymbol(value) {
    return typeof value == 'symbol' || $1bb463dde9fe8351$exports(value) && $20002ccb6f4ea696$exports(value) == $1b364d4b3d648939$var$symbolTag;
}
$1b364d4b3d648939$exports = $1b364d4b3d648939$var$isSymbol;


/** Used as references for various `Number` constants. */ var $cdfb709f87ca2d35$var$NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */ var $cdfb709f87ca2d35$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $cdfb709f87ca2d35$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $cdfb709f87ca2d35$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $cdfb709f87ca2d35$var$freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $cdfb709f87ca2d35$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($1b364d4b3d648939$exports(value)) return $cdfb709f87ca2d35$var$NAN;
    if ($3742f66b0b4e3bb6$exports(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $3742f66b0b4e3bb6$exports(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = $5ee3f8854a575d46$exports(value);
    var isBinary = $cdfb709f87ca2d35$var$reIsBinary.test(value);
    return isBinary || $cdfb709f87ca2d35$var$reIsOctal.test(value) ? $cdfb709f87ca2d35$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $cdfb709f87ca2d35$var$reIsBadHex.test(value) ? $cdfb709f87ca2d35$var$NAN : +value;
}
$cdfb709f87ca2d35$exports = $cdfb709f87ca2d35$var$toNumber;


/** Error message constants. */ var $f41b4c82c646b949$var$FUNC_ERROR_TEXT = 'Expected a function';
/* Built-in method references for those with the same name as other `lodash` methods. */ var $f41b4c82c646b949$var$nativeMax = Math.max, $f41b4c82c646b949$var$nativeMin = Math.min;
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $f41b4c82c646b949$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($f41b4c82c646b949$var$FUNC_ERROR_TEXT);
    wait = $cdfb709f87ca2d35$exports(wait) || 0;
    if ($3742f66b0b4e3bb6$exports(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $f41b4c82c646b949$var$nativeMax($cdfb709f87ca2d35$exports(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
        return maxing ? $f41b4c82c646b949$var$nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $795cbad2cff1da57$exports();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($795cbad2cff1da57$exports());
    }
    function debounced() {
        var time = $795cbad2cff1da57$exports(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                clearTimeout(timerId);
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
$f41b4c82c646b949$exports = $f41b4c82c646b949$var$debounce;


var $f8b60767c910e8cf$exports = {};


/** Error message constants. */ var $f8b60767c910e8cf$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */ function $f8b60767c910e8cf$var$throttle(func, wait, options) {
    var leading = true, trailing = true;
    if (typeof func != 'function') throw new TypeError($f8b60767c910e8cf$var$FUNC_ERROR_TEXT);
    if ($3742f66b0b4e3bb6$exports(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    return $f41b4c82c646b949$exports(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
    });
}
$f8b60767c910e8cf$exports = $f8b60767c910e8cf$var$throttle;


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ var $7a4e61fecf313c47$var$__assign = function() {
    $7a4e61fecf313c47$var$__assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $7a4e61fecf313c47$var$__assign.apply(this, arguments);
};
function $7a4e61fecf313c47$var$getElementWindow$1(element) {
    if (!element || !element.ownerDocument || !element.ownerDocument.defaultView) return window;
    return element.ownerDocument.defaultView;
}
function $7a4e61fecf313c47$var$getElementDocument$1(element) {
    if (!element || !element.ownerDocument) return document;
    return element.ownerDocument;
}
// Helper function to retrieve options from element attributes
var $7a4e61fecf313c47$var$getOptions$1 = function(obj) {
    var initialObj = {};
    var options = Array.prototype.reduce.call(obj, function(acc, attribute) {
        var option = attribute.name.match(/data-simplebar-(.+)/);
        if (option) {
            var key = option[1].replace(/\W+(.)/g, function(_, chr) {
                return chr.toUpperCase();
            });
            switch(attribute.value){
                case 'true':
                    acc[key] = true;
                    break;
                case 'false':
                    acc[key] = false;
                    break;
                case undefined:
                    acc[key] = true;
                    break;
                default:
                    acc[key] = attribute.value;
            }
        }
        return acc;
    }, initialObj);
    return options;
};
function $7a4e61fecf313c47$var$addClasses$1(el, classes) {
    var _a;
    if (!el) return;
    (_a = el.classList).add.apply(_a, classes.split(' '));
}
function $7a4e61fecf313c47$var$removeClasses$1(el, classes) {
    if (!el) return;
    classes.split(' ').forEach(function(className) {
        el.classList.remove(className);
    });
}
function $7a4e61fecf313c47$var$classNamesToQuery$1(classNames) {
    return ".".concat(classNames.split(' ').join('.'));
}
var $7a4e61fecf313c47$var$canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
var $7a4e61fecf313c47$var$helpers = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    addClasses: $7a4e61fecf313c47$var$addClasses$1,
    canUseDOM: $7a4e61fecf313c47$var$canUseDOM,
    classNamesToQuery: $7a4e61fecf313c47$var$classNamesToQuery$1,
    getElementDocument: $7a4e61fecf313c47$var$getElementDocument$1,
    getElementWindow: $7a4e61fecf313c47$var$getElementWindow$1,
    getOptions: $7a4e61fecf313c47$var$getOptions$1,
    removeClasses: $7a4e61fecf313c47$var$removeClasses$1
});
var $7a4e61fecf313c47$var$cachedScrollbarWidth = null;
var $7a4e61fecf313c47$var$cachedDevicePixelRatio = null;
if ($7a4e61fecf313c47$var$canUseDOM) window.addEventListener('resize', function() {
    if ($7a4e61fecf313c47$var$cachedDevicePixelRatio !== window.devicePixelRatio) {
        $7a4e61fecf313c47$var$cachedDevicePixelRatio = window.devicePixelRatio;
        $7a4e61fecf313c47$var$cachedScrollbarWidth = null;
    }
});
function $7a4e61fecf313c47$var$scrollbarWidth() {
    if ($7a4e61fecf313c47$var$cachedScrollbarWidth === null) {
        if (typeof document === 'undefined') {
            $7a4e61fecf313c47$var$cachedScrollbarWidth = 0;
            return $7a4e61fecf313c47$var$cachedScrollbarWidth;
        }
        var body = document.body;
        var box = document.createElement('div');
        box.classList.add('simplebar-hide-scrollbar');
        body.appendChild(box);
        var width = box.getBoundingClientRect().right;
        body.removeChild(box);
        $7a4e61fecf313c47$var$cachedScrollbarWidth = width;
    }
    return $7a4e61fecf313c47$var$cachedScrollbarWidth;
}
var $7a4e61fecf313c47$var$getElementWindow = $7a4e61fecf313c47$var$getElementWindow$1, $7a4e61fecf313c47$var$getElementDocument = $7a4e61fecf313c47$var$getElementDocument$1, $7a4e61fecf313c47$var$getOptions = $7a4e61fecf313c47$var$getOptions$1, $7a4e61fecf313c47$var$addClasses = $7a4e61fecf313c47$var$addClasses$1, $7a4e61fecf313c47$var$removeClasses = $7a4e61fecf313c47$var$removeClasses$1, $7a4e61fecf313c47$var$classNamesToQuery = $7a4e61fecf313c47$var$classNamesToQuery$1;
var $7a4e61fecf313c47$export$2e2bcd8739ae039 = /** @class */ function() {
    function SimpleBarCore(element, options) {
        if (options === void 0) options = {};
        var _this = this;
        this.removePreventClickId = null;
        this.minScrollbarWidth = 20;
        this.stopScrollDelay = 175;
        this.isScrolling = false;
        this.isMouseEntering = false;
        this.isDragging = false;
        this.scrollXTicking = false;
        this.scrollYTicking = false;
        this.wrapperEl = null;
        this.contentWrapperEl = null;
        this.contentEl = null;
        this.offsetEl = null;
        this.maskEl = null;
        this.placeholderEl = null;
        this.heightAutoObserverWrapperEl = null;
        this.heightAutoObserverEl = null;
        this.rtlHelpers = null;
        this.scrollbarWidth = 0;
        this.resizeObserver = null;
        this.mutationObserver = null;
        this.elStyles = null;
        this.isRtl = null;
        this.mouseX = 0;
        this.mouseY = 0;
        this.onMouseMove = function() {};
        this.onWindowResize = function() {};
        this.onStopScrolling = function() {};
        this.onMouseEntered = function() {};
        /**
         * On scroll event handling
         */ this.onScroll = function() {
            var elWindow = $7a4e61fecf313c47$var$getElementWindow(_this.el);
            if (!_this.scrollXTicking) {
                elWindow.requestAnimationFrame(_this.scrollX);
                _this.scrollXTicking = true;
            }
            if (!_this.scrollYTicking) {
                elWindow.requestAnimationFrame(_this.scrollY);
                _this.scrollYTicking = true;
            }
            if (!_this.isScrolling) {
                _this.isScrolling = true;
                $7a4e61fecf313c47$var$addClasses(_this.el, _this.classNames.scrolling);
            }
            _this.showScrollbar('x');
            _this.showScrollbar('y');
            _this.onStopScrolling();
        };
        this.scrollX = function() {
            if (_this.axis.x.isOverflowing) _this.positionScrollbar('x');
            _this.scrollXTicking = false;
        };
        this.scrollY = function() {
            if (_this.axis.y.isOverflowing) _this.positionScrollbar('y');
            _this.scrollYTicking = false;
        };
        this._onStopScrolling = function() {
            $7a4e61fecf313c47$var$removeClasses(_this.el, _this.classNames.scrolling);
            if (_this.options.autoHide) {
                _this.hideScrollbar('x');
                _this.hideScrollbar('y');
            }
            _this.isScrolling = false;
        };
        this.onMouseEnter = function() {
            if (!_this.isMouseEntering) {
                $7a4e61fecf313c47$var$addClasses(_this.el, _this.classNames.mouseEntered);
                _this.showScrollbar('x');
                _this.showScrollbar('y');
                _this.isMouseEntering = true;
            }
            _this.onMouseEntered();
        };
        this._onMouseEntered = function() {
            $7a4e61fecf313c47$var$removeClasses(_this.el, _this.classNames.mouseEntered);
            if (_this.options.autoHide) {
                _this.hideScrollbar('x');
                _this.hideScrollbar('y');
            }
            _this.isMouseEntering = false;
        };
        this._onMouseMove = function(e) {
            _this.mouseX = e.clientX;
            _this.mouseY = e.clientY;
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseMoveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseMoveForAxis('y');
        };
        this.onMouseLeave = function() {
            _this.onMouseMove.cancel();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) _this.onMouseLeaveForAxis('x');
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) _this.onMouseLeaveForAxis('y');
            _this.mouseX = -1;
            _this.mouseY = -1;
        };
        this._onWindowResize = function() {
            // Recalculate scrollbarWidth in case it's a zoom
            _this.scrollbarWidth = _this.getScrollbarWidth();
            _this.hideNativeScrollbar();
        };
        this.onPointerEvent = function(e) {
            if (!_this.axis.x.track.el || !_this.axis.y.track.el || !_this.axis.x.scrollbar.el || !_this.axis.y.scrollbar.el) return;
            var isWithinTrackXBounds, isWithinTrackYBounds;
            _this.axis.x.track.rect = _this.axis.x.track.el.getBoundingClientRect();
            _this.axis.y.track.rect = _this.axis.y.track.el.getBoundingClientRect();
            if (_this.axis.x.isOverflowing || _this.axis.x.forceVisible) isWithinTrackXBounds = _this.isWithinBounds(_this.axis.x.track.rect);
            if (_this.axis.y.isOverflowing || _this.axis.y.forceVisible) isWithinTrackYBounds = _this.isWithinBounds(_this.axis.y.track.rect);
            // If any pointer event is called on the scrollbar
            if (isWithinTrackXBounds || isWithinTrackYBounds) {
                // Prevent event leaking
                e.stopPropagation();
                if (e.type === 'pointerdown' && e.pointerType !== 'touch') {
                    if (isWithinTrackXBounds) {
                        _this.axis.x.scrollbar.rect = _this.axis.x.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.x.scrollbar.rect)) _this.onDragStart(e, 'x');
                        else _this.onTrackClick(e, 'x');
                    }
                    if (isWithinTrackYBounds) {
                        _this.axis.y.scrollbar.rect = _this.axis.y.scrollbar.el.getBoundingClientRect();
                        if (_this.isWithinBounds(_this.axis.y.scrollbar.rect)) _this.onDragStart(e, 'y');
                        else _this.onTrackClick(e, 'y');
                    }
                }
            }
        };
        /**
         * Drag scrollbar handle
         */ this.drag = function(e) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            if (!_this.draggedAxis || !_this.contentWrapperEl) return;
            var eventOffset;
            var track = _this.axis[_this.draggedAxis].track;
            var trackSize = (_b = (_a = track.rect) === null || _a === void 0 ? void 0 : _a[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _b !== void 0 ? _b : 0;
            var scrollbar = _this.axis[_this.draggedAxis].scrollbar;
            var contentSize = (_d = (_c = _this.contentWrapperEl) === null || _c === void 0 ? void 0 : _c[_this.axis[_this.draggedAxis].scrollSizeAttr]) !== null && _d !== void 0 ? _d : 0;
            var hostSize = parseInt((_f = (_e = _this.elStyles) === null || _e === void 0 ? void 0 : _e[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _f !== void 0 ? _f : '0px', 10);
            e.preventDefault();
            e.stopPropagation();
            if (_this.draggedAxis === 'y') eventOffset = e.pageY;
            else eventOffset = e.pageX;
            // Calculate how far the user's mouse is from the top/left of the scrollbar (minus the dragOffset).
            var dragPos = eventOffset - ((_h = (_g = track.rect) === null || _g === void 0 ? void 0 : _g[_this.axis[_this.draggedAxis].offsetAttr]) !== null && _h !== void 0 ? _h : 0) - _this.axis[_this.draggedAxis].dragOffset;
            dragPos = _this.draggedAxis === 'x' && _this.isRtl ? ((_k = (_j = track.rect) === null || _j === void 0 ? void 0 : _j[_this.axis[_this.draggedAxis].sizeAttr]) !== null && _k !== void 0 ? _k : 0) - scrollbar.size - dragPos : dragPos;
            // Convert the mouse position into a percentage of the scrollbar height/width.
            var dragPerc = dragPos / (trackSize - scrollbar.size);
            // Scroll the content by the same percentage.
            var scrollPos = dragPerc * (contentSize - hostSize);
            // Fix browsers inconsistency on RTL
            if (_this.draggedAxis === 'x' && _this.isRtl) scrollPos = ((_l = SimpleBarCore.getRtlHelpers()) === null || _l === void 0 ? void 0 : _l.isScrollingToNegative) ? -scrollPos : scrollPos;
            _this.contentWrapperEl[_this.axis[_this.draggedAxis].scrollOffsetAttr] = scrollPos;
        };
        /**
         * End scroll handle drag
         */ this.onEndDrag = function(e) {
            _this.isDragging = false;
            var elDocument = $7a4e61fecf313c47$var$getElementDocument(_this.el);
            var elWindow = $7a4e61fecf313c47$var$getElementWindow(_this.el);
            e.preventDefault();
            e.stopPropagation();
            $7a4e61fecf313c47$var$removeClasses(_this.el, _this.classNames.dragging);
            _this.onStopScrolling();
            elDocument.removeEventListener('mousemove', _this.drag, true);
            elDocument.removeEventListener('mouseup', _this.onEndDrag, true);
            _this.removePreventClickId = elWindow.setTimeout(function() {
                // Remove these asynchronously so we still suppress click events
                // generated simultaneously with mouseup.
                elDocument.removeEventListener('click', _this.preventClick, true);
                elDocument.removeEventListener('dblclick', _this.preventClick, true);
                _this.removePreventClickId = null;
            });
        };
        /**
         * Handler to ignore click events during drag
         */ this.preventClick = function(e) {
            e.preventDefault();
            e.stopPropagation();
        };
        this.el = element;
        this.options = $7a4e61fecf313c47$var$__assign($7a4e61fecf313c47$var$__assign({}, SimpleBarCore.defaultOptions), options);
        this.classNames = $7a4e61fecf313c47$var$__assign($7a4e61fecf313c47$var$__assign({}, SimpleBarCore.defaultOptions.classNames), options.classNames);
        this.axis = {
            x: {
                scrollOffsetAttr: 'scrollLeft',
                sizeAttr: 'width',
                scrollSizeAttr: 'scrollWidth',
                offsetSizeAttr: 'offsetWidth',
                offsetAttr: 'left',
                overflowAttr: 'overflowX',
                dragOffset: 0,
                isOverflowing: true,
                forceVisible: false,
                track: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                },
                scrollbar: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                }
            },
            y: {
                scrollOffsetAttr: 'scrollTop',
                sizeAttr: 'height',
                scrollSizeAttr: 'scrollHeight',
                offsetSizeAttr: 'offsetHeight',
                offsetAttr: 'top',
                overflowAttr: 'overflowY',
                dragOffset: 0,
                isOverflowing: true,
                forceVisible: false,
                track: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                },
                scrollbar: {
                    size: null,
                    el: null,
                    rect: null,
                    isVisible: false
                }
            }
        };
        if (typeof this.el !== 'object' || !this.el.nodeName) throw new Error("Argument passed to SimpleBar must be an HTML element instead of ".concat(this.el));
        this.onMouseMove = (0, (/*@__PURE__*/$parcel$interopDefault($f8b60767c910e8cf$exports)))(this._onMouseMove, 64);
        this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($f41b4c82c646b949$exports)))(this._onWindowResize, 64, {
            leading: true
        });
        this.onStopScrolling = (0, (/*@__PURE__*/$parcel$interopDefault($f41b4c82c646b949$exports)))(this._onStopScrolling, this.stopScrollDelay);
        this.onMouseEntered = (0, (/*@__PURE__*/$parcel$interopDefault($f41b4c82c646b949$exports)))(this._onMouseEntered, this.stopScrollDelay);
        this.init();
    }
    /**
     * Helper to fix browsers inconsistency on RTL:
     *  - Firefox inverts the scrollbar initial position
     *  - IE11 inverts both scrollbar position and scrolling offset
     * Directly inspired by @KingSora's OverlayScrollbars https://github.com/KingSora/OverlayScrollbars/blob/master/js/OverlayScrollbars.js#L1634
     */ SimpleBarCore.getRtlHelpers = function() {
        if (SimpleBarCore.rtlHelpers) return SimpleBarCore.rtlHelpers;
        var dummyDiv = document.createElement('div');
        dummyDiv.innerHTML = '<div class="simplebar-dummy-scrollbar-size"><div></div></div>';
        var scrollbarDummyEl = dummyDiv.firstElementChild;
        var dummyChild = scrollbarDummyEl === null || scrollbarDummyEl === void 0 ? void 0 : scrollbarDummyEl.firstElementChild;
        if (!dummyChild) return null;
        document.body.appendChild(scrollbarDummyEl);
        scrollbarDummyEl.scrollLeft = 0;
        var dummyContainerOffset = SimpleBarCore.getOffset(scrollbarDummyEl);
        var dummyChildOffset = SimpleBarCore.getOffset(dummyChild);
        scrollbarDummyEl.scrollLeft = -999;
        var dummyChildOffsetAfterScroll = SimpleBarCore.getOffset(dummyChild);
        document.body.removeChild(scrollbarDummyEl);
        SimpleBarCore.rtlHelpers = {
            // determines if the scrolling is responding with negative values
            isScrollOriginAtZero: dummyContainerOffset.left !== dummyChildOffset.left,
            // determines if the origin scrollbar position is inverted or not (positioned on left or right)
            isScrollingToNegative: dummyChildOffset.left !== dummyChildOffsetAfterScroll.left
        };
        return SimpleBarCore.rtlHelpers;
    };
    SimpleBarCore.prototype.getScrollbarWidth = function() {
        // Try/catch for FF 56 throwing on undefined computedStyles
        try {
            // Detect browsers supporting CSS scrollbar styling and do not calculate
            if (this.contentWrapperEl && getComputedStyle(this.contentWrapperEl, '::-webkit-scrollbar').display === 'none' || 'scrollbarWidth' in document.documentElement.style || '-ms-overflow-style' in document.documentElement.style) return 0;
            else return $7a4e61fecf313c47$var$scrollbarWidth();
        } catch (e) {
            return $7a4e61fecf313c47$var$scrollbarWidth();
        }
    };
    SimpleBarCore.getOffset = function(el) {
        var rect = el.getBoundingClientRect();
        var elDocument = $7a4e61fecf313c47$var$getElementDocument(el);
        var elWindow = $7a4e61fecf313c47$var$getElementWindow(el);
        return {
            top: rect.top + (elWindow.pageYOffset || elDocument.documentElement.scrollTop),
            left: rect.left + (elWindow.pageXOffset || elDocument.documentElement.scrollLeft)
        };
    };
    SimpleBarCore.prototype.init = function() {
        // We stop here on server-side
        if ($7a4e61fecf313c47$var$canUseDOM) {
            this.initDOM();
            this.rtlHelpers = SimpleBarCore.getRtlHelpers();
            this.scrollbarWidth = this.getScrollbarWidth();
            this.recalculate();
            this.initListeners();
        }
    };
    SimpleBarCore.prototype.initDOM = function() {
        var _a, _b;
        // assume that element has his DOM already initiated
        this.wrapperEl = this.el.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.wrapper));
        this.contentWrapperEl = this.options.scrollableNode || this.el.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.contentWrapper));
        this.contentEl = this.options.contentNode || this.el.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.contentEl));
        this.offsetEl = this.el.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.offset));
        this.maskEl = this.el.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.mask));
        this.placeholderEl = this.findChild(this.wrapperEl, $7a4e61fecf313c47$var$classNamesToQuery(this.classNames.placeholder));
        this.heightAutoObserverWrapperEl = this.el.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.heightAutoObserverWrapperEl));
        this.heightAutoObserverEl = this.el.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.heightAutoObserverEl));
        this.axis.x.track.el = this.findChild(this.el, "".concat($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.track)).concat($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.horizontal)));
        this.axis.y.track.el = this.findChild(this.el, "".concat($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.track)).concat($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.vertical)));
        this.axis.x.scrollbar.el = ((_a = this.axis.x.track.el) === null || _a === void 0 ? void 0 : _a.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.scrollbar))) || null;
        this.axis.y.scrollbar.el = ((_b = this.axis.y.track.el) === null || _b === void 0 ? void 0 : _b.querySelector($7a4e61fecf313c47$var$classNamesToQuery(this.classNames.scrollbar))) || null;
        if (!this.options.autoHide) {
            $7a4e61fecf313c47$var$addClasses(this.axis.x.scrollbar.el, this.classNames.visible);
            $7a4e61fecf313c47$var$addClasses(this.axis.y.scrollbar.el, this.classNames.visible);
        }
    };
    SimpleBarCore.prototype.initListeners = function() {
        var _this = this;
        var _a;
        var elWindow = $7a4e61fecf313c47$var$getElementWindow(this.el);
        // Event listeners
        this.el.addEventListener('mouseenter', this.onMouseEnter);
        this.el.addEventListener('pointerdown', this.onPointerEvent, true);
        this.el.addEventListener('mousemove', this.onMouseMove);
        this.el.addEventListener('mouseleave', this.onMouseLeave);
        (_a = this.contentWrapperEl) === null || _a === void 0 || _a.addEventListener('scroll', this.onScroll);
        // Browser zoom triggers a window resize
        elWindow.addEventListener('resize', this.onWindowResize);
        if (!this.contentEl) return;
        if (window.ResizeObserver) {
            // Hack for https://github.com/WICG/ResizeObserver/issues/38
            var resizeObserverStarted_1 = false;
            var resizeObserver = elWindow.ResizeObserver || ResizeObserver;
            this.resizeObserver = new resizeObserver(function() {
                if (!resizeObserverStarted_1) return;
                elWindow.requestAnimationFrame(function() {
                    _this.recalculate();
                });
            });
            this.resizeObserver.observe(this.el);
            this.resizeObserver.observe(this.contentEl);
            elWindow.requestAnimationFrame(function() {
                resizeObserverStarted_1 = true;
            });
        }
        // This is required to detect horizontal scroll. Vertical scroll only needs the resizeObserver.
        this.mutationObserver = new elWindow.MutationObserver(function() {
            elWindow.requestAnimationFrame(function() {
                _this.recalculate();
            });
        });
        this.mutationObserver.observe(this.contentEl, {
            childList: true,
            subtree: true,
            characterData: true
        });
    };
    SimpleBarCore.prototype.recalculate = function() {
        if (!this.heightAutoObserverEl || !this.contentEl || !this.contentWrapperEl || !this.wrapperEl || !this.placeholderEl) return;
        var elWindow = $7a4e61fecf313c47$var$getElementWindow(this.el);
        this.elStyles = elWindow.getComputedStyle(this.el);
        this.isRtl = this.elStyles.direction === 'rtl';
        var contentElOffsetWidth = this.contentEl.offsetWidth;
        var isHeightAuto = this.heightAutoObserverEl.offsetHeight <= 1;
        var isWidthAuto = this.heightAutoObserverEl.offsetWidth <= 1 || contentElOffsetWidth > 0;
        var contentWrapperElOffsetWidth = this.contentWrapperEl.offsetWidth;
        var elOverflowX = this.elStyles.overflowX;
        var elOverflowY = this.elStyles.overflowY;
        this.contentEl.style.padding = "".concat(this.elStyles.paddingTop, " ").concat(this.elStyles.paddingRight, " ").concat(this.elStyles.paddingBottom, " ").concat(this.elStyles.paddingLeft);
        this.wrapperEl.style.margin = "-".concat(this.elStyles.paddingTop, " -").concat(this.elStyles.paddingRight, " -").concat(this.elStyles.paddingBottom, " -").concat(this.elStyles.paddingLeft);
        var contentElScrollHeight = this.contentEl.scrollHeight;
        var contentElScrollWidth = this.contentEl.scrollWidth;
        this.contentWrapperEl.style.height = isHeightAuto ? 'auto' : '100%';
        // Determine placeholder size
        this.placeholderEl.style.width = isWidthAuto ? "".concat(contentElOffsetWidth || contentElScrollWidth, "px") : 'auto';
        this.placeholderEl.style.height = "".concat(contentElScrollHeight, "px");
        var contentWrapperElOffsetHeight = this.contentWrapperEl.offsetHeight;
        this.axis.x.isOverflowing = contentElOffsetWidth !== 0 && contentElScrollWidth > contentElOffsetWidth;
        this.axis.y.isOverflowing = contentElScrollHeight > contentWrapperElOffsetHeight;
        // Set isOverflowing to false if user explicitely set hidden overflow
        this.axis.x.isOverflowing = elOverflowX === 'hidden' ? false : this.axis.x.isOverflowing;
        this.axis.y.isOverflowing = elOverflowY === 'hidden' ? false : this.axis.y.isOverflowing;
        this.axis.x.forceVisible = this.options.forceVisible === 'x' || this.options.forceVisible === true;
        this.axis.y.forceVisible = this.options.forceVisible === 'y' || this.options.forceVisible === true;
        this.hideNativeScrollbar();
        // Set isOverflowing to false if scrollbar is not necessary (content is shorter than offset)
        var offsetForXScrollbar = this.axis.x.isOverflowing ? this.scrollbarWidth : 0;
        var offsetForYScrollbar = this.axis.y.isOverflowing ? this.scrollbarWidth : 0;
        this.axis.x.isOverflowing = this.axis.x.isOverflowing && contentElScrollWidth > contentWrapperElOffsetWidth - offsetForYScrollbar;
        this.axis.y.isOverflowing = this.axis.y.isOverflowing && contentElScrollHeight > contentWrapperElOffsetHeight - offsetForXScrollbar;
        this.axis.x.scrollbar.size = this.getScrollbarSize('x');
        this.axis.y.scrollbar.size = this.getScrollbarSize('y');
        if (this.axis.x.scrollbar.el) this.axis.x.scrollbar.el.style.width = "".concat(this.axis.x.scrollbar.size, "px");
        if (this.axis.y.scrollbar.el) this.axis.y.scrollbar.el.style.height = "".concat(this.axis.y.scrollbar.size, "px");
        this.positionScrollbar('x');
        this.positionScrollbar('y');
        this.toggleTrackVisibility('x');
        this.toggleTrackVisibility('y');
    };
    /**
     * Calculate scrollbar size
     */ SimpleBarCore.prototype.getScrollbarSize = function(axis) {
        var _a, _b;
        if (axis === void 0) axis = 'y';
        if (!this.axis[axis].isOverflowing || !this.contentEl) return 0;
        var contentSize = this.contentEl[this.axis[axis].scrollSizeAttr];
        var trackSize = (_b = (_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) !== null && _b !== void 0 ? _b : 0;
        var scrollbarRatio = trackSize / contentSize;
        var scrollbarSize;
        // Calculate new height/position of drag handle.
        scrollbarSize = Math.max(~~(scrollbarRatio * trackSize), this.options.scrollbarMinSize);
        if (this.options.scrollbarMaxSize) scrollbarSize = Math.min(scrollbarSize, this.options.scrollbarMaxSize);
        return scrollbarSize;
    };
    SimpleBarCore.prototype.positionScrollbar = function(axis) {
        var _a, _b, _c;
        if (axis === void 0) axis = 'y';
        var scrollbar = this.axis[axis].scrollbar;
        if (!this.axis[axis].isOverflowing || !this.contentWrapperEl || !scrollbar.el || !this.elStyles) return;
        var contentSize = this.contentWrapperEl[this.axis[axis].scrollSizeAttr];
        var trackSize = ((_a = this.axis[axis].track.el) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetSizeAttr]) || 0;
        var hostSize = parseInt(this.elStyles[this.axis[axis].sizeAttr], 10);
        var scrollOffset = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        scrollOffset = axis === 'x' && this.isRtl && ((_b = SimpleBarCore.getRtlHelpers()) === null || _b === void 0 ? void 0 : _b.isScrollOriginAtZero) ? -scrollOffset : scrollOffset;
        if (axis === 'x' && this.isRtl) scrollOffset = ((_c = SimpleBarCore.getRtlHelpers()) === null || _c === void 0 ? void 0 : _c.isScrollingToNegative) ? scrollOffset : -scrollOffset;
        var scrollPourcent = scrollOffset / (contentSize - hostSize);
        var handleOffset = ~~((trackSize - scrollbar.size) * scrollPourcent);
        handleOffset = axis === 'x' && this.isRtl ? -handleOffset + (trackSize - scrollbar.size) : handleOffset;
        scrollbar.el.style.transform = axis === 'x' ? "translate3d(".concat(handleOffset, "px, 0, 0)") : "translate3d(0, ".concat(handleOffset, "px, 0)");
    };
    SimpleBarCore.prototype.toggleTrackVisibility = function(axis) {
        if (axis === void 0) axis = 'y';
        var track = this.axis[axis].track.el;
        var scrollbar = this.axis[axis].scrollbar.el;
        if (!track || !scrollbar || !this.contentWrapperEl) return;
        if (this.axis[axis].isOverflowing || this.axis[axis].forceVisible) {
            track.style.visibility = 'visible';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'scroll';
            this.el.classList.add("".concat(this.classNames.scrollable, "-").concat(axis));
        } else {
            track.style.visibility = 'hidden';
            this.contentWrapperEl.style[this.axis[axis].overflowAttr] = 'hidden';
            this.el.classList.remove("".concat(this.classNames.scrollable, "-").concat(axis));
        }
        // Even if forceVisible is enabled, scrollbar itself should be hidden
        if (this.axis[axis].isOverflowing) scrollbar.style.display = 'block';
        else scrollbar.style.display = 'none';
    };
    SimpleBarCore.prototype.showScrollbar = function(axis) {
        if (axis === void 0) axis = 'y';
        if (this.axis[axis].isOverflowing && !this.axis[axis].scrollbar.isVisible) {
            $7a4e61fecf313c47$var$addClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
            this.axis[axis].scrollbar.isVisible = true;
        }
    };
    SimpleBarCore.prototype.hideScrollbar = function(axis) {
        if (axis === void 0) axis = 'y';
        if (this.isDragging) return;
        if (this.axis[axis].isOverflowing && this.axis[axis].scrollbar.isVisible) {
            $7a4e61fecf313c47$var$removeClasses(this.axis[axis].scrollbar.el, this.classNames.visible);
            this.axis[axis].scrollbar.isVisible = false;
        }
    };
    SimpleBarCore.prototype.hideNativeScrollbar = function() {
        if (!this.offsetEl) return;
        this.offsetEl.style[this.isRtl ? 'left' : 'right'] = this.axis.y.isOverflowing || this.axis.y.forceVisible ? "-".concat(this.scrollbarWidth, "px") : '0px';
        this.offsetEl.style.bottom = this.axis.x.isOverflowing || this.axis.x.forceVisible ? "-".concat(this.scrollbarWidth, "px") : '0px';
    };
    SimpleBarCore.prototype.onMouseMoveForAxis = function(axis) {
        if (axis === void 0) axis = 'y';
        var currentAxis = this.axis[axis];
        if (!currentAxis.track.el || !currentAxis.scrollbar.el) return;
        currentAxis.track.rect = currentAxis.track.el.getBoundingClientRect();
        currentAxis.scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
        if (this.isWithinBounds(currentAxis.track.rect)) {
            this.showScrollbar(axis);
            $7a4e61fecf313c47$var$addClasses(currentAxis.track.el, this.classNames.hover);
            if (this.isWithinBounds(currentAxis.scrollbar.rect)) $7a4e61fecf313c47$var$addClasses(currentAxis.scrollbar.el, this.classNames.hover);
            else $7a4e61fecf313c47$var$removeClasses(currentAxis.scrollbar.el, this.classNames.hover);
        } else {
            $7a4e61fecf313c47$var$removeClasses(currentAxis.track.el, this.classNames.hover);
            if (this.options.autoHide) this.hideScrollbar(axis);
        }
    };
    SimpleBarCore.prototype.onMouseLeaveForAxis = function(axis) {
        if (axis === void 0) axis = 'y';
        $7a4e61fecf313c47$var$removeClasses(this.axis[axis].track.el, this.classNames.hover);
        $7a4e61fecf313c47$var$removeClasses(this.axis[axis].scrollbar.el, this.classNames.hover);
        if (this.options.autoHide) this.hideScrollbar(axis);
    };
    /**
     * on scrollbar handle drag movement starts
     */ SimpleBarCore.prototype.onDragStart = function(e, axis) {
        var _a;
        if (axis === void 0) axis = 'y';
        this.isDragging = true;
        var elDocument = $7a4e61fecf313c47$var$getElementDocument(this.el);
        var elWindow = $7a4e61fecf313c47$var$getElementWindow(this.el);
        var scrollbar = this.axis[axis].scrollbar;
        // Measure how far the user's mouse is from the top of the scrollbar drag handle.
        var eventOffset = axis === 'y' ? e.pageY : e.pageX;
        this.axis[axis].dragOffset = eventOffset - (((_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) || 0);
        this.draggedAxis = axis;
        $7a4e61fecf313c47$var$addClasses(this.el, this.classNames.dragging);
        elDocument.addEventListener('mousemove', this.drag, true);
        elDocument.addEventListener('mouseup', this.onEndDrag, true);
        if (this.removePreventClickId === null) {
            elDocument.addEventListener('click', this.preventClick, true);
            elDocument.addEventListener('dblclick', this.preventClick, true);
        } else {
            elWindow.clearTimeout(this.removePreventClickId);
            this.removePreventClickId = null;
        }
    };
    SimpleBarCore.prototype.onTrackClick = function(e, axis) {
        var _this = this;
        var _a, _b, _c, _d;
        if (axis === void 0) axis = 'y';
        var currentAxis = this.axis[axis];
        if (!this.options.clickOnTrack || !currentAxis.scrollbar.el || !this.contentWrapperEl) return;
        // Preventing the event's default to trigger click underneath
        e.preventDefault();
        var elWindow = $7a4e61fecf313c47$var$getElementWindow(this.el);
        this.axis[axis].scrollbar.rect = currentAxis.scrollbar.el.getBoundingClientRect();
        var scrollbar = this.axis[axis].scrollbar;
        var scrollbarOffset = (_b = (_a = scrollbar.rect) === null || _a === void 0 ? void 0 : _a[this.axis[axis].offsetAttr]) !== null && _b !== void 0 ? _b : 0;
        var hostSize = parseInt((_d = (_c = this.elStyles) === null || _c === void 0 ? void 0 : _c[this.axis[axis].sizeAttr]) !== null && _d !== void 0 ? _d : '0px', 10);
        var scrolled = this.contentWrapperEl[this.axis[axis].scrollOffsetAttr];
        var t = axis === 'y' ? this.mouseY - scrollbarOffset : this.mouseX - scrollbarOffset;
        var dir = t < 0 ? -1 : 1;
        var scrollSize = dir === -1 ? scrolled - hostSize : scrolled + hostSize;
        var speed = 40;
        var scrollTo = function() {
            if (!_this.contentWrapperEl) return;
            if (dir === -1) {
                if (scrolled > scrollSize) {
                    scrolled -= speed;
                    _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                    elWindow.requestAnimationFrame(scrollTo);
                }
            } else if (scrolled < scrollSize) {
                scrolled += speed;
                _this.contentWrapperEl[_this.axis[axis].scrollOffsetAttr] = scrolled;
                elWindow.requestAnimationFrame(scrollTo);
            }
        };
        scrollTo();
    };
    /**
     * Getter for content element
     */ SimpleBarCore.prototype.getContentElement = function() {
        return this.contentEl;
    };
    /**
     * Getter for original scrolling element
     */ SimpleBarCore.prototype.getScrollElement = function() {
        return this.contentWrapperEl;
    };
    SimpleBarCore.prototype.removeListeners = function() {
        var elWindow = $7a4e61fecf313c47$var$getElementWindow(this.el);
        // Event listeners
        this.el.removeEventListener('mouseenter', this.onMouseEnter);
        this.el.removeEventListener('pointerdown', this.onPointerEvent, true);
        this.el.removeEventListener('mousemove', this.onMouseMove);
        this.el.removeEventListener('mouseleave', this.onMouseLeave);
        if (this.contentWrapperEl) this.contentWrapperEl.removeEventListener('scroll', this.onScroll);
        elWindow.removeEventListener('resize', this.onWindowResize);
        if (this.mutationObserver) this.mutationObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
        // Cancel all debounced functions
        this.onMouseMove.cancel();
        this.onWindowResize.cancel();
        this.onStopScrolling.cancel();
        this.onMouseEntered.cancel();
    };
    /**
     * Remove all listeners from DOM nodes
     */ SimpleBarCore.prototype.unMount = function() {
        this.removeListeners();
    };
    /**
     * Check if mouse is within bounds
     */ SimpleBarCore.prototype.isWithinBounds = function(bbox) {
        return this.mouseX >= bbox.left && this.mouseX <= bbox.left + bbox.width && this.mouseY >= bbox.top && this.mouseY <= bbox.top + bbox.height;
    };
    /**
     * Find element children matches query
     */ SimpleBarCore.prototype.findChild = function(el, query) {
        var matches = el.matches || el.webkitMatchesSelector || el.mozMatchesSelector || el.msMatchesSelector;
        return Array.prototype.filter.call(el.children, function(child) {
            return matches.call(child, query);
        })[0];
    };
    SimpleBarCore.rtlHelpers = null;
    SimpleBarCore.defaultOptions = {
        forceVisible: false,
        clickOnTrack: true,
        scrollbarMinSize: 25,
        scrollbarMaxSize: 0,
        ariaLabel: 'scrollable content',
        tabIndex: 0,
        classNames: {
            contentEl: 'simplebar-content',
            contentWrapper: 'simplebar-content-wrapper',
            offset: 'simplebar-offset',
            mask: 'simplebar-mask',
            wrapper: 'simplebar-wrapper',
            placeholder: 'simplebar-placeholder',
            scrollbar: 'simplebar-scrollbar',
            track: 'simplebar-track',
            heightAutoObserverWrapperEl: 'simplebar-height-auto-observer-wrapper',
            heightAutoObserverEl: 'simplebar-height-auto-observer',
            visible: 'simplebar-visible',
            horizontal: 'simplebar-horizontal',
            vertical: 'simplebar-vertical',
            hover: 'simplebar-hover',
            dragging: 'simplebar-dragging',
            scrolling: 'simplebar-scrolling',
            scrollable: 'simplebar-scrollable',
            mouseEntered: 'simplebar-mouse-entered'
        },
        scrollableNode: null,
        contentNode: null,
        autoHide: true
    };
    /**
     * Static functions
     */ SimpleBarCore.getOptions = $7a4e61fecf313c47$var$getOptions;
    SimpleBarCore.helpers = $7a4e61fecf313c47$var$helpers;
    return SimpleBarCore;
}();


/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $3267907de6a0efa4$var$extendStatics = function(d, b) {
    $3267907de6a0efa4$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $3267907de6a0efa4$var$extendStatics(d, b);
};
function $3267907de6a0efa4$var$__extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $3267907de6a0efa4$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $3267907de6a0efa4$var$_a = (0, $7a4e61fecf313c47$export$2e2bcd8739ae039).helpers, $3267907de6a0efa4$var$getOptions = $3267907de6a0efa4$var$_a.getOptions, $3267907de6a0efa4$var$addClasses = $3267907de6a0efa4$var$_a.addClasses, $3267907de6a0efa4$var$canUseDOM = $3267907de6a0efa4$var$_a.canUseDOM;
var $3267907de6a0efa4$export$2e2bcd8739ae039 = /** @class */ function(_super) {
    $3267907de6a0efa4$var$__extends(SimpleBar, _super);
    function SimpleBar() {
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        var _this = _super.apply(this, args) || this;
        // // Save a reference to the instance, so we know this DOM node has already been instancied
        SimpleBar.instances.set(args[0], _this);
        return _this;
    }
    SimpleBar.initDOMLoadedElements = function() {
        document.removeEventListener('DOMContentLoaded', this.initDOMLoadedElements);
        window.removeEventListener('load', this.initDOMLoadedElements);
        Array.prototype.forEach.call(document.querySelectorAll('[data-simplebar]'), function(el) {
            if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el)) new SimpleBar(el, $3267907de6a0efa4$var$getOptions(el.attributes));
        });
    };
    SimpleBar.removeObserver = function() {
        var _a;
        (_a = SimpleBar.globalObserver) === null || _a === void 0 || _a.disconnect();
    };
    SimpleBar.prototype.initDOM = function() {
        var _this = this;
        var _a, _b, _c;
        // make sure this element doesn't have the elements yet
        if (!Array.prototype.filter.call(this.el.children, function(child) {
            return child.classList.contains(_this.classNames.wrapper);
        }).length) {
            // Prepare DOM
            this.wrapperEl = document.createElement('div');
            this.contentWrapperEl = document.createElement('div');
            this.offsetEl = document.createElement('div');
            this.maskEl = document.createElement('div');
            this.contentEl = document.createElement('div');
            this.placeholderEl = document.createElement('div');
            this.heightAutoObserverWrapperEl = document.createElement('div');
            this.heightAutoObserverEl = document.createElement('div');
            $3267907de6a0efa4$var$addClasses(this.wrapperEl, this.classNames.wrapper);
            $3267907de6a0efa4$var$addClasses(this.contentWrapperEl, this.classNames.contentWrapper);
            $3267907de6a0efa4$var$addClasses(this.offsetEl, this.classNames.offset);
            $3267907de6a0efa4$var$addClasses(this.maskEl, this.classNames.mask);
            $3267907de6a0efa4$var$addClasses(this.contentEl, this.classNames.contentEl);
            $3267907de6a0efa4$var$addClasses(this.placeholderEl, this.classNames.placeholder);
            $3267907de6a0efa4$var$addClasses(this.heightAutoObserverWrapperEl, this.classNames.heightAutoObserverWrapperEl);
            $3267907de6a0efa4$var$addClasses(this.heightAutoObserverEl, this.classNames.heightAutoObserverEl);
            while(this.el.firstChild)this.contentEl.appendChild(this.el.firstChild);
            this.contentWrapperEl.appendChild(this.contentEl);
            this.offsetEl.appendChild(this.contentWrapperEl);
            this.maskEl.appendChild(this.offsetEl);
            this.heightAutoObserverWrapperEl.appendChild(this.heightAutoObserverEl);
            this.wrapperEl.appendChild(this.heightAutoObserverWrapperEl);
            this.wrapperEl.appendChild(this.maskEl);
            this.wrapperEl.appendChild(this.placeholderEl);
            this.el.appendChild(this.wrapperEl);
            (_a = this.contentWrapperEl) === null || _a === void 0 || _a.setAttribute('tabindex', this.options.tabIndex.toString());
            (_b = this.contentWrapperEl) === null || _b === void 0 || _b.setAttribute('role', 'region');
            (_c = this.contentWrapperEl) === null || _c === void 0 || _c.setAttribute('aria-label', this.options.ariaLabel);
        }
        if (!this.axis.x.track.el || !this.axis.y.track.el) {
            var track = document.createElement('div');
            var scrollbar = document.createElement('div');
            $3267907de6a0efa4$var$addClasses(track, this.classNames.track);
            $3267907de6a0efa4$var$addClasses(scrollbar, this.classNames.scrollbar);
            track.appendChild(scrollbar);
            this.axis.x.track.el = track.cloneNode(true);
            $3267907de6a0efa4$var$addClasses(this.axis.x.track.el, this.classNames.horizontal);
            this.axis.y.track.el = track.cloneNode(true);
            $3267907de6a0efa4$var$addClasses(this.axis.y.track.el, this.classNames.vertical);
            this.el.appendChild(this.axis.x.track.el);
            this.el.appendChild(this.axis.y.track.el);
        }
        (0, $7a4e61fecf313c47$export$2e2bcd8739ae039).prototype.initDOM.call(this);
        this.el.setAttribute('data-simplebar', 'init');
    };
    SimpleBar.prototype.unMount = function() {
        (0, $7a4e61fecf313c47$export$2e2bcd8739ae039).prototype.unMount.call(this);
        SimpleBar.instances["delete"](this.el);
    };
    SimpleBar.initHtmlApi = function() {
        this.initDOMLoadedElements = this.initDOMLoadedElements.bind(this);
        // MutationObserver is IE11+
        if (typeof MutationObserver !== 'undefined') {
            // Mutation observer to observe dynamically added elements
            this.globalObserver = new MutationObserver(SimpleBar.handleMutations);
            this.globalObserver.observe(document, {
                childList: true,
                subtree: true
            });
        }
        // Taken from jQuery `ready` function
        // Instantiate elements already present on the page
        if (document.readyState === 'complete' || // @ts-ignore: IE specific
        document.readyState !== 'loading' && !document.documentElement.doScroll) // Handle it asynchronously to allow scripts the opportunity to delay init
        window.setTimeout(this.initDOMLoadedElements);
        else {
            document.addEventListener('DOMContentLoaded', this.initDOMLoadedElements);
            window.addEventListener('load', this.initDOMLoadedElements);
        }
    };
    SimpleBar.handleMutations = function(mutations) {
        mutations.forEach(function(mutation) {
            mutation.addedNodes.forEach(function(addedNode) {
                if (addedNode.nodeType === 1) {
                    if (addedNode.hasAttribute('data-simplebar')) !SimpleBar.instances.has(addedNode) && document.documentElement.contains(addedNode) && new SimpleBar(addedNode, $3267907de6a0efa4$var$getOptions(addedNode.attributes));
                    else addedNode.querySelectorAll('[data-simplebar]').forEach(function(el) {
                        if (el.getAttribute('data-simplebar') !== 'init' && !SimpleBar.instances.has(el) && document.documentElement.contains(el)) new SimpleBar(el, $3267907de6a0efa4$var$getOptions(el.attributes));
                    });
                }
            });
            mutation.removedNodes.forEach(function(removedNode) {
                var _a;
                if (removedNode.nodeType === 1) {
                    if (removedNode.getAttribute('data-simplebar') === 'init') !document.documentElement.contains(removedNode) && ((_a = SimpleBar.instances.get(removedNode)) === null || _a === void 0 || _a.unMount());
                    else Array.prototype.forEach.call(removedNode.querySelectorAll('[data-simplebar="init"]'), function(el) {
                        var _a;
                        !document.documentElement.contains(el) && ((_a = SimpleBar.instances.get(el)) === null || _a === void 0 || _a.unMount());
                    });
                }
            });
        });
    };
    SimpleBar.instances = new WeakMap();
    return SimpleBar;
}((0, $7a4e61fecf313c47$export$2e2bcd8739ae039));
/**
 * HTML API
 * Called only in a browser env.
 */ if ($3267907de6a0efa4$var$canUseDOM) $3267907de6a0efa4$export$2e2bcd8739ae039.initHtmlApi();


/**
 * Updates the SimpleBar instance for a given list element.
 *
 * @param {HTMLElement} list - The list element to update.
 */ function $0b9c7896f2cdbf1c$var$updateSimpleBar(list) {
    if (list.SimpleBar) list.SimpleBar.unMount();
    list.SimpleBar = new (0, $3267907de6a0efa4$export$2e2bcd8739ae039)(list);
    const simplebarYInstancesArr = list.querySelectorAll('.simplebar-track.simplebar-vertical');
    const simplebarXInstancesArr = list.querySelectorAll('.simplebar-track.simplebar-horizontal');
    if (simplebarYInstancesArr.length) simplebarYInstancesArr.forEach((element, idx)=>{
        if (idx > 0) element.remove();
    });
    if (simplebarXInstancesArr.length) simplebarXInstancesArr.forEach((element, idx)=>{
        if (idx > 0) element.remove();
    });
}
/**
 * Initializes project meta select elements and sets up the list dropdown functionality.
 *
 * @param {string} elementsArr - The CSS selector to find the select elements.
 */ window.initProjectMetaSelect = function initProjectMetaSelect1(elementsArr) {
    const metaSelectArr = document.querySelectorAll(elementsArr);
    metaSelectArr.forEach((selectElement, idx)=>{
        const parentContainer = selectElement.closest('.project-meta-select');
        parentContainer.style.zIndex = metaSelectArr.length - idx;
        if (!parentContainer) return;
        if (!selectElement.classList.contains('is-init')) {
            selectElement.classList.add('is-init');
            const label = parentContainer.querySelector('label');
            const wrapper = document.createElement('div');
            wrapper.className = 'project-meta-select-inner';
            const placeholder = document.createElement('div');
            placeholder.className = 'project-meta-select-placeholder';
            const list = document.createElement('div');
            list.className = 'project-meta-select-list';
            const notInlinePosition = selectElement.hasAttribute('data-meta-select-not-inline');
            /**
       * Positions the dropdown list relative to the select element.
       */ function positionList() {
                if (!notInlinePosition) return;
                document.body.appendChild(list);
                list.style.position = 'absolute';
                list.style.minWidth = `${wrapper.clientWidth}px`;
                list.style.maxWidth = `${wrapper.clientWidth}px`;
                const selectRect = wrapper.getBoundingClientRect();
                const scrollTop = window.scrollY || document.documentElement.scrollTop;
                let top = selectRect.top + scrollTop + wrapper.clientHeight + 3;
                let left = selectRect.left;
                list.style.top = `${top}px`;
                list.style.left = `${left}px`;
            }
            /**
       * Updates the dropdown list with the current options from the select element.
       */ function updateList() {
                list.innerHTML = '';
                placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C...";
                Array.from(selectElement.options).forEach((option)=>{
                    const item = document.createElement('div');
                    item.className = 'project-meta-select-list__item';
                    item.textContent = option.text;
                    item.dataset.value = option.value;
                    if (option.selected) item.classList.add('is-selected');
                    if (option.disabled) item.classList.add('is-disabled');
                    if (option.classList.contains('is-placeholder')) item.classList.add('is-placeholder');
                    item.addEventListener('click', ()=>{
                        if (!item.classList.contains('is-disabled')) {
                            setProjectMetaSelectValue(selectElement.id, option.value);
                            closeList();
                        }
                    });
                    list.appendChild(item);
                });
                setTimeout(function() {
                    positionList();
                }, 50);
                $0b9c7896f2cdbf1c$var$updateSimpleBar(list);
            }
            /**
       * Opens the dropdown list and positions it correctly.
       */ function openList() {
                list.classList.add('is-open');
                wrapper.classList.add('is-open');
                positionList();
                window.addEventListener('resize', positionList);
                $0b9c7896f2cdbf1c$var$updateSimpleBar(list);
            }
            /**
       * Closes the dropdown list and removes event listeners.
       */ function closeList() {
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
                window.removeEventListener('resize', positionList);
                if (notInlinePosition) wrapper.appendChild(list);
            }
            /**
       * Toggles the visibility of the dropdown list.
       */ const toggleList = ()=>{
                if (list.classList.contains('is-open')) closeList();
                else openList();
            };
            wrapper.addEventListener('click', (ev)=>{
                if (ev.target !== list && ev.target !== label) toggleList();
            });
            label?.addEventListener('click', (ev)=>{
                ev.preventDefault();
                ev.stopPropagation();
                toggleList();
            });
            document.addEventListener('click', (e)=>{
                if (!wrapper.contains(e.target) && !list.contains(e.target) && (!label || !label.contains(e.target))) closeList();
            });
            selectElement.addEventListener('change', updateList);
            wrapper.appendChild(placeholder);
            wrapper.appendChild(list);
            parentContainer.appendChild(wrapper);
            selectElement.style.display = 'none';
            updateList();
        }
    });
};
/**
 * Sets the value of a select element and triggers a change event.
 *
 * @param {string} selectId - The ID of the select element.
 * @param {string} value - The value to set for the select element.
 */ window.setProjectMetaSelectValue = function setProjectMetaSelectValue1(selectId, value) {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) return;
    const optionExists = Array.from(selectElement.options).some((option)=>option.value === value);
    if (!optionExists) return;
    selectElement.value = value;
    selectElement.dispatchEvent(new Event('change', {
        bubbles: true
    }));
};
/**
 * Updates the dropdown list of a specific select element.
 *
 * @param {string} selectId - The ID of the select element to update.
 */ window.updateProjectMetaSelect = function updateProjectMetaSelect(selectId) {
    const selectElement = document.getElementById(selectId);
    if (!selectElement) return;
    const parentContainer = selectElement.closest('.project-meta-select');
    if (!parentContainer) return;
    const wrapper = parentContainer.querySelector('.project-meta-select-inner');
    const placeholder = wrapper.querySelector('.project-meta-select-placeholder');
    const list = wrapper.querySelector('.project-meta-select-list');
    if (!list) return;
    list.innerHTML = '';
    Array.from(selectElement.options).forEach((option)=>{
        const item = document.createElement('div');
        item.className = 'project-meta-select-list__item';
        item.textContent = option.text;
        item.dataset.value = option.value;
        if (option.selected) item.classList.add('is-selected');
        if (option.disabled) item.classList.add('is-disabled');
        if (option.classList.contains('is-placeholder')) item.classList.add('is-placeholder');
        item.addEventListener('click', ()=>{
            if (!item.classList.contains('is-disabled')) {
                setProjectMetaSelectValue(selectId, option.value);
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
            }
        });
        list.appendChild(item);
    });
    placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C...";
    $0b9c7896f2cdbf1c$var$updateSimpleBar(list);
};
/**
 * Updates the dropdown list of all select elements on the page.
 */ window.updateAllProjectMetaSelects = function updateAllProjectMetaSelects() {
    document.querySelectorAll('[data-meta-select]').forEach((selectElement)=>{
        const parentContainer = selectElement.closest('.project-meta-select');
        if (!parentContainer) return;
        const wrapper = parentContainer.querySelector('.project-meta-select-inner');
        const placeholder = wrapper.querySelector('.project-meta-select-placeholder');
        const list = wrapper.querySelector('.project-meta-select-list');
        if (!list) return;
        list.innerHTML = '';
        Array.from(selectElement.options).forEach((option)=>{
            const item = document.createElement('div');
            item.className = 'project-meta-select-list__item';
            item.textContent = option.text;
            item.dataset.value = option.value;
            if (option.selected) item.classList.add('is-selected');
            item.addEventListener('click', ()=>{
                setProjectMetaSelectValue(selectElement.id, option.value);
                list.classList.remove('is-open');
                wrapper.classList.remove('is-open');
            });
            list.appendChild(item);
        });
        placeholder.textContent = selectElement.options[selectElement.selectedIndex]?.text || "\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C...";
        $0b9c7896f2cdbf1c$var$updateSimpleBar(list);
    });
};
initProjectMetaSelect('[data-meta-select]');


window.timePickerInit = function timePickerInit1() {
    const metaTimePickersArr = document.querySelectorAll('.meta-time-picker');
    metaTimePickersArr.forEach((metaTimePicker, i)=>{
        if (!metaTimePicker.classList.contains('is-time-picker-init')) {
            const zIndexValue = metaTimePicker.length - i;
            metaTimePicker.style.zIndex = zIndexValue + 10;
            metaTimePicker.classList.add('is-time-picker-init');
            const input = metaTimePicker.querySelector('input');
            const pickerElement = metaTimePicker.querySelector('.js-inline-picker');
            const max = +pickerElement.dataset.max;
            const min = +pickerElement.dataset.min;
            const step = +pickerElement.dataset.step;
            const metaTimePickerList = metaTimePicker.querySelector('.meta-time-picker__list');
            const timePicker = new Picker(pickerElement, {
                controls: true,
                inline: true,
                rows: 1,
                format: 'HH:mm',
                text: {
                    title: "\u041E\u0431\u0435\u0440\u0456\u0442\u044C \u0447\u0430\u0441"
                }
            });
            const decreaseButton = metaTimePicker.querySelector('.picker-minutes .picker-cell__control--prev');
            // Function to round minutes up to the nearest interval
            function roundUpToNearestInterval(date, interval) {
                let minutes = date.getMinutes();
                let roundedMinutes = Math.ceil(minutes / interval) * interval;
                if (roundedMinutes >= 60) {
                    roundedMinutes = 0;
                    date.setHours(date.getHours() + 1);
                }
                date.setMinutes(roundedMinutes);
                date.setSeconds(0);
                return date;
            }
            // Function to round minutes down to the nearest interval
            function roundDownToNearestInterval(date, interval) {
                let minutes = date.getMinutes();
                let roundedMinutes = Math.floor(minutes / interval) * interval;
                if (roundedMinutes < 0) {
                    roundedMinutes = 45;
                    date.setHours(date.getHours() - 1);
                }
                date.setMinutes(roundedMinutes);
                date.setSeconds(0);
                return date;
            }
            // Function to update the time picker and round minutes
            function updateTimePicker() {
                let date = timePicker.getDate(true);
                if (date) {
                    // If `date` is a string, convert it to a Date object
                    if (typeof date === 'string') {
                        const [hours, minutes] = date.split(':').map(Number);
                        date = new Date();
                        date.setHours(hours);
                        date.setMinutes(minutes);
                        date.setSeconds(0);
                    }
                    const currentHours = date.getHours();
                    const currentMinutes = date.getMinutes();
                    // Round minutes up
                    date = roundUpToNearestInterval(date, step);
                    // Set hours and minutes in the time picker
                    date.setHours(currentHours); // Restore original hours
                    date.setMinutes(date.getMinutes());
                    timePicker.setDate(date);
                    input.value = date.toISOString().substr(11, 5);
                    checkInputValue(input);
                }
            }
            // Function to decrease time by 15 minutes
            function decreaseTime() {
                let date = timePicker.getDate(true);
                if (date) {
                    if (typeof date === 'string') {
                        const [hours, minutes] = date.split(':').map(Number);
                        date = new Date();
                        date.setHours(hours);
                        date.setMinutes(minutes);
                        date.setSeconds(0);
                    }
                    const currentHours = date.getHours();
                    const currentMinutes = date.getMinutes();
                    // Decrease minutes and round down
                    date.setMinutes(currentMinutes - step);
                    date = roundDownToNearestInterval(date, step);
                    // Restore original hours
                    date.setHours(currentHours);
                    timePicker.setDate(date);
                    input.value = date.toISOString().substr(11, 5);
                    checkInputValue(input);
                }
            }
            // Event handler for clicking the decrease button
            if (decreaseButton) decreaseButton.addEventListener('click', decreaseTime);
            function handlePickerChange(mutationsList) {
                for (const mutation of mutationsList)if (mutation.type === 'attributes' && mutation.attributeName === 'data-value') {
                    updateTimePicker();
                    input.value = timePicker.getDate(true);
                    checkInputValue(input);
                }
            }
            const observer = new MutationObserver(handlePickerChange);
            const observerConfig = {
                attributes: true,
                subtree: true,
                attributeFilter: [
                    'data-value'
                ]
            };
            observer.observe(pickerElement, observerConfig);
            function checkInputValue(input) {
                const timeValue = input.value;
                const [hours, minutes] = timeValue.split(':').map(Number);
                // Check if the time is within the range 10:00 - 11:00
                if (hours === min && minutes >= 0 || hours === min && minutes === 59) {
                    metaTimePicker.classList.add('time-too-early');
                    metaTimePicker.classList.remove('time-too-late');
                } else if (hours === max && minutes >= 0 || hours === max && minutes === 59) {
                    metaTimePicker.classList.add('time-too-late');
                    metaTimePicker.classList.remove('time-too-early');
                    setTimeout(function() {
                        metaTimePicker.querySelector('.picker-item.picker-picked[data-name="minute"]').textContent = '00';
                        input.value = `${max}:00`;
                    }, 50);
                } else metaTimePicker.classList.remove('time-too-early', 'time-too-late');
            }
            metaTimePicker.addEventListener('click', (e)=>{
                if (!metaTimePicker.classList.contains('active')) metaTimePicker.classList.add('active');
                else if (!metaTimePickerList.contains(e.target)) metaTimePicker.classList.remove('active');
            });
            document.addEventListener('click', (event)=>{
                if (!metaTimePickerList.contains(event.target) && !metaTimePicker.contains(event.target)) metaTimePicker.classList.remove('active');
            });
        }
    });
};
if (document.querySelector('.meta-time-picker')) timePickerInit();


var $7c91cf96f56c9b55$exports = {};
!function(e, t) {
    $7c91cf96f56c9b55$exports = t();
}($7c91cf96f56c9b55$exports, function() {
    return function() {
        "use strict";
        var e = {
            d: function(t, i) {
                for(var s in i)e.o(i, s) && !e.o(t, s) && Object.defineProperty(t, s, {
                    enumerable: !0,
                    get: i[s]
                });
            },
            o: function(e, t) {
                return Object.prototype.hasOwnProperty.call(e, t);
            }
        }, t = {};
        e.d(t, {
            default: function() {
                return R;
            }
        });
        var i = {
            days: "days",
            months: "months",
            years: "years",
            day: "day",
            month: "month",
            year: "year",
            eventChangeViewDate: "changeViewDate",
            eventChangeCurrentView: "changeCurrentView",
            eventChangeFocusDate: "changeFocusDate",
            eventChangeSelectedDate: "changeSelectedDate",
            eventChangeTime: "changeTime",
            eventChangeLastSelectedDate: "changeLastSelectedDate",
            actionSelectDate: "selectDate",
            actionUnselectDate: "unselectDate",
            cssClassWeekend: "-weekend-"
        }, s = {
            classes: "",
            inline: !1,
            locale: {
                days: [
                    "\u0412\u043E\u0441\u043A\u0440\u0435\u0441\u0435\u043D\u044C\u0435",
                    "\u041F\u043E\u043D\u0435\u0434\u0435\u043B\u044C\u043D\u0438\u043A",
                    "\u0412\u0442\u043E\u0440\u043D\u0438\u043A",
                    "\u0421\u0440\u0435\u0434\u0430",
                    "\u0427\u0435\u0442\u0432\u0435\u0440\u0433",
                    "\u041F\u044F\u0442\u043D\u0438\u0446\u0430",
                    "\u0421\u0443\u0431\u0431\u043E\u0442\u0430"
                ],
                daysShort: [
                    "\u0412\u043E\u0441",
                    "\u041F\u043E\u043D",
                    "\u0412\u0442\u043E",
                    "\u0421\u0440\u0435",
                    "\u0427\u0435\u0442",
                    "\u041F\u044F\u0442",
                    "\u0421\u0443\u0431"
                ],
                daysMin: [
                    "\u0412\u0441",
                    "\u041F\u043D",
                    "\u0412\u0442",
                    "\u0421\u0440",
                    "\u0427\u0442",
                    "\u041F\u0442",
                    "\u0421\u0431"
                ],
                months: [
                    "\u042F\u043D\u0432\u0430\u0440\u044C",
                    "\u0424\u0435\u0432\u0440\u0430\u043B\u044C",
                    "\u041C\u0430\u0440\u0442",
                    "\u0410\u043F\u0440\u0435\u043B\u044C",
                    "\u041C\u0430\u0439",
                    "\u0418\u044E\u043D\u044C",
                    "\u0418\u044E\u043B\u044C",
                    "\u0410\u0432\u0433\u0443\u0441\u0442",
                    "\u0421\u0435\u043D\u0442\u044F\u0431\u0440\u044C",
                    "\u041E\u043A\u0442\u044F\u0431\u0440\u044C",
                    "\u041D\u043E\u044F\u0431\u0440\u044C",
                    "\u0414\u0435\u043A\u0430\u0431\u0440\u044C"
                ],
                monthsShort: [
                    "\u042F\u043D\u0432",
                    "\u0424\u0435\u0432",
                    "\u041C\u0430\u0440",
                    "\u0410\u043F\u0440",
                    "\u041C\u0430\u0439",
                    "\u0418\u044E\u043D",
                    "\u0418\u044E\u043B",
                    "\u0410\u0432\u0433",
                    "\u0421\u0435\u043D",
                    "\u041E\u043A\u0442",
                    "\u041D\u043E\u044F",
                    "\u0414\u0435\u043A"
                ],
                today: "\u0421\u0435\u0433\u043E\u0434\u043D\u044F",
                clear: "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C",
                dateFormat: "dd.MM.yyyy",
                timeFormat: "HH:mm",
                firstDay: 1
            },
            startDate: new Date,
            firstDay: "",
            weekends: [
                6,
                0
            ],
            dateFormat: "",
            altField: "",
            altFieldDateFormat: "T",
            toggleSelected: !0,
            keyboardNav: !0,
            selectedDates: !1,
            container: "",
            isMobile: !1,
            visible: !1,
            position: "bottom left",
            offset: 12,
            view: i.days,
            minView: i.days,
            showOtherMonths: !0,
            selectOtherMonths: !0,
            moveToOtherMonthsOnSelect: !0,
            showOtherYears: !0,
            selectOtherYears: !0,
            moveToOtherYearsOnSelect: !0,
            minDate: "",
            maxDate: "",
            disableNavWhenOutOfRange: !0,
            multipleDates: !1,
            multipleDatesSeparator: ", ",
            range: !1,
            dynamicRange: !0,
            buttons: !1,
            monthsField: "monthsShort",
            showEvent: "focus",
            autoClose: !1,
            fixedHeight: !1,
            prevHtml: '<svg><path d="M 17,12 l -5,5 l 5,5"></path></svg>',
            nextHtml: '<svg><path d="M 14,12 l 5,5 l -5,5"></path></svg>',
            navTitles: {
                days: "MMMM, <i>yyyy</i>",
                months: "yyyy",
                years: "yyyy1 - yyyy2"
            },
            timepicker: !1,
            onlyTimepicker: !1,
            dateTimeSeparator: " ",
            timeFormat: "",
            minHours: 0,
            maxHours: 24,
            minMinutes: 0,
            maxMinutes: 59,
            hoursStep: 1,
            minutesStep: 1,
            onSelect: !1,
            onChangeViewDate: !1,
            onChangeView: !1,
            onRenderCell: !1,
            onShow: !1,
            onHide: !1,
            onClickDayName: !1
        };
        function a(e) {
            let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : document;
            return "string" == typeof e ? t.querySelector(e) : e;
        }
        function n() {
            let { tagName: e = "div", className: t = "", innerHtml: i = "", id: s = "", attrs: a = {} } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, n = document.createElement(e);
            return t && n.classList.add(...t.split(" ")), s && (n.id = s), i && (n.innerHTML = i), a && r(n, a), n;
        }
        function r(e, t) {
            for (let [i, s] of Object.entries(t))void 0 !== s && e.setAttribute(i, s);
            return e;
        }
        function o(e) {
            return new Date(e.getFullYear(), e.getMonth() + 1, 0).getDate();
        }
        function h(e) {
            let t = e.getHours(), { hours: i, dayPeriod: s } = l(t);
            return {
                year: e.getFullYear(),
                month: e.getMonth(),
                fullMonth: e.getMonth() + 1 < 10 ? "0" + (e.getMonth() + 1) : e.getMonth() + 1,
                date: e.getDate(),
                fullDate: e.getDate() < 10 ? "0" + e.getDate() : e.getDate(),
                day: e.getDay(),
                hours: t,
                fullHours: d(t),
                hours12: i,
                dayPeriod: s,
                fullHours12: d(i),
                minutes: e.getMinutes(),
                fullMinutes: e.getMinutes() < 10 ? "0" + e.getMinutes() : e.getMinutes()
            };
        }
        function l(e) {
            return {
                dayPeriod: e > 11 ? "pm" : "am",
                hours: e % 12 == 0 ? 12 : e % 12
            };
        }
        function d(e) {
            return e < 10 ? "0" + e : e;
        }
        function c(e) {
            let t = 10 * Math.floor(e.getFullYear() / 10);
            return [
                t,
                t + 9
            ];
        }
        function u() {
            let e = [];
            for(var t = arguments.length, i = new Array(t), s = 0; s < t; s++)i[s] = arguments[s];
            return i.forEach((t)=>{
                if ("object" == typeof t) for(let i in t)t[i] && e.push(i);
                else t && e.push(t);
            }), e.join(" ");
        }
        function p(e, t) {
            let s = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : i.days;
            if (!e || !t) return !1;
            let a = h(e), n = h(t);
            return ({
                [i.days]: a.date === n.date && a.month === n.month && a.year === n.year,
                [i.months]: a.month === n.month && a.year === n.year,
                [i.years]: a.year === n.year
            })[s];
        }
        function m(e, t, i) {
            let s = g(e, !1).getTime(), a = g(t, !1).getTime();
            return i ? s >= a : s > a;
        }
        function v(e, t) {
            return !m(e, t, !0);
        }
        function g(e) {
            let t = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1], i = new Date(e.getTime());
            return "boolean" != typeof t || t || function(e) {
                e.setHours(0, 0, 0, 0);
            }(i), i;
        }
        function D(e, t, i) {
            e.length ? e.forEach((e)=>{
                e.addEventListener(t, i);
            }) : e.addEventListener(t, i);
        }
        function y(e, t) {
            return !(!e || e === document || e instanceof DocumentFragment) && (e.matches(t) ? e : y(e.parentNode, t));
        }
        function f(e, t, i) {
            return e > i ? i : e < t ? t : e;
        }
        function w(e) {
            for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
            return i.filter((e)=>e).forEach((t)=>{
                for (let [i, s] of Object.entries(t))if (void 0 !== s && "[object Object]" === s.toString()) {
                    let t = void 0 !== e[i] ? e[i].toString() : void 0, a = s.toString(), n = Array.isArray(s) ? [] : {};
                    e[i] = e[i] ? t !== a ? n : e[i] : n, w(e[i], s);
                } else e[i] = s;
            }), e;
        }
        function b(e) {
            let t = e;
            return e instanceof Date || ("string" == typeof e && /^\d{4}-\d{2}-\d{2}$/.test(e) && (e += "T00:00:00"), t = new Date(e)), isNaN(t.getTime()) && (console.log(`Unable to convert value "${e}" to Date object`), t = !1), t;
        }
        function k(e) {
            let t = "\\s|\\.|-|/|\\\\|,|\\$|\\!|\\?|:|;";
            return new RegExp("(^|>|" + t + ")(" + e + ")($|<|" + t + ")", "g");
        }
        function $(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class C {
            constructor(){
                let { type: e, date: t, dp: i, opts: s, body: a } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                $(this, "focus", ()=>{
                    this.$cell.classList.add("-focus-"), this.focused = !0;
                }), $(this, "removeFocus", ()=>{
                    this.$cell.classList.remove("-focus-"), this.focused = !1;
                }), $(this, "select", ()=>{
                    this.$cell.classList.add("-selected-"), this.selected = !0;
                }), $(this, "removeSelect", ()=>{
                    this.$cell.classList.remove("-selected-", "-range-from-", "-range-to-"), this.selected = !1;
                }), $(this, "onChangeSelectedDate", ()=>{
                    this.isDisabled || (this._handleSelectedStatus(), this.opts.range && this._handleRangeStatus());
                }), $(this, "onChangeFocusDate", (e)=>{
                    if (!e) return void (this.focused && this.removeFocus());
                    let t = p(e, this.date, this.type);
                    t ? this.focus() : !t && this.focused && this.removeFocus(), this.opts.range && this._handleRangeStatus();
                }), $(this, "render", ()=>(this.$cell.innerHTML = this._getHtml(), this._handleClasses(), this.$cell)), this.type = e, this.singleType = this.type.slice(0, -1), this.date = t, this.dp = i, this.opts = s, this.body = a, this.customData = !1, this.init();
            }
            init() {
                var e;
                let { onRenderCell: t } = this.opts;
                t && (this.customData = t({
                    date: this.date,
                    cellType: this.singleType,
                    datepicker: this.dp
                })), this._createElement(), this._bindDatepickerEvents(), null !== (e = this.customData) && void 0 !== e && e.disabled && this.dp.disableDate(this.date);
            }
            _bindDatepickerEvents() {
                this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeFocusDate, this.onChangeFocusDate);
            }
            unbindDatepickerEvents() {
                this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeFocusDate, this.onChangeFocusDate);
            }
            _createElement() {
                var e;
                let { year: t, month: i, date: s } = h(this.date), a = (null === (e = this.customData) || void 0 === e ? void 0 : e.attrs) || {};
                this.$cell = n({
                    attrs: {
                        "data-year": t,
                        "data-month": i,
                        "data-date": s,
                        ...a
                    }
                }), this.$cell.adpCell = this;
            }
            _getClassName() {
                var e;
                let t = new Date, { selectOtherMonths: s, selectOtherYears: a } = this.opts, { minDate: n, maxDate: r, isDateDisabled: o } = this.dp, { day: l } = h(this.date), d = this._isOutOfMinMaxRange(), c = o(this.date), m = u("air-datepicker-cell", `-${this.singleType}-`, {
                    "-current-": p(t, this.date, this.type),
                    "-min-date-": n && p(n, this.date, this.type),
                    "-max-date-": r && p(r, this.date, this.type)
                }), v = "";
                switch(this.type){
                    case i.days:
                        v = u({
                            "-weekend-": this.dp.isWeekend(l),
                            "-other-month-": this.isOtherMonth,
                            "-disabled-": this.isOtherMonth && !s || d || c
                        });
                        break;
                    case i.months:
                        v = u({
                            "-disabled-": d
                        });
                        break;
                    case i.years:
                        v = u({
                            "-other-decade-": this.isOtherDecade,
                            "-disabled-": d || this.isOtherDecade && !a
                        });
                }
                return u(m, v, null === (e = this.customData) || void 0 === e ? void 0 : e.classes).split(" ");
            }
            _getHtml() {
                var e;
                let { year: t, month: s, date: a } = h(this.date), { showOtherMonths: n, showOtherYears: r } = this.opts;
                if (null !== (e = this.customData) && void 0 !== e && e.html) return this.customData.html;
                switch(this.type){
                    case i.days:
                        return !n && this.isOtherMonth ? "" : a;
                    case i.months:
                        return this.dp.locale[this.opts.monthsField][s];
                    case i.years:
                        return !r && this.isOtherDecade ? "" : t;
                }
            }
            _isOutOfMinMaxRange() {
                let { minDate: e, maxDate: t } = this.dp, { type: s, date: a } = this, { month: n, year: r, date: o } = h(a), l = s === i.days, d = s === i.years, c = !!e && new Date(r, d ? e.getMonth() : n, l ? o : e.getDate()), u = !!t && new Date(r, d ? t.getMonth() : n, l ? o : t.getDate());
                return e && t ? v(c, e) || m(u, t) : e ? v(c, e) : t ? m(u, t) : void 0;
            }
            destroy() {
                this.unbindDatepickerEvents();
            }
            _handleRangeStatus() {
                const { selectedDates: e, focusDate: t, rangeDateTo: i, rangeDateFrom: s } = this.dp, a = e.length;
                if (!a) return;
                let n = s, r = i;
                if (1 === a && t) {
                    const i = m(t, e[0]);
                    n = i ? e[0] : t, r = i ? t : e[0];
                }
                let o = u({
                    "-in-range-": n && r && (h = this.date, l = n, d = r, m(h, l) && v(h, d)),
                    "-range-from-": n && p(this.date, n, this.type),
                    "-range-to-": r && p(this.date, r, this.type)
                });
                var h, l, d;
                this.$cell.classList.remove("-range-from-", "-range-to-", "-in-range-"), o && this.$cell.classList.add(...o.split(" "));
            }
            _handleSelectedStatus() {
                let e = this.dp._checkIfDateIsSelected(this.date, this.type);
                e ? this.select() : !e && this.selected && this.removeSelect();
            }
            _handleInitialFocusStatus() {
                p(this.dp.focusDate, this.date, this.type) && this.focus();
            }
            _handleClasses() {
                this.$cell.setAttribute("class", ""), this._handleInitialFocusStatus(), this.dp.hasSelectedDates && (this._handleSelectedStatus(), this.dp.opts.range && this._handleRangeStatus()), this.$cell.classList.add(...this._getClassName());
            }
            get isDisabled() {
                return this.$cell.matches(".-disabled-");
            }
            get isOtherMonth() {
                return this.dp.isOtherMonth(this.date);
            }
            get isOtherDecade() {
                return this.dp.isOtherDecade(this.date);
            }
        }
        function _(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        let M = {
            [i.days]: `<div class="air-datepicker-body--day-names"></div><div class="air-datepicker-body--cells -${i.days}-"></div>`,
            [i.months]: `<div class="air-datepicker-body--cells -${i.months}-"></div>`,
            [i.years]: `<div class="air-datepicker-body--cells -${i.years}-"></div>`
        };
        const S = ".air-datepicker-cell";
        class T {
            constructor(e){
                let { dp: t, type: s, opts: a } = e;
                _(this, "handleClick", (e)=>{
                    let t = e.target.closest(S).adpCell;
                    if (t.isDisabled) return;
                    if (!this.dp.isMinViewReached) return void this.dp.down();
                    let i = this.dp._checkIfDateIsSelected(t.date, t.type);
                    i ? this.dp._handleAlreadySelectedDates(i, t.date) : this.dp.selectDate(t.date);
                }), _(this, "handleDayNameClick", (e)=>{
                    let t = e.target.getAttribute("data-day-index");
                    this.opts.onClickDayName({
                        dayIndex: Number(t),
                        datepicker: this.dp
                    });
                }), _(this, "onChangeCurrentView", (e)=>{
                    e !== this.type ? this.hide() : (this.show(), this.render());
                }), _(this, "onMouseOverCell", (e)=>{
                    let t = y(e.target, S);
                    this.dp.setFocusDate(!!t && t.adpCell.date);
                }), _(this, "onMouseOutCell", ()=>{
                    this.dp.setFocusDate(!1);
                }), _(this, "onClickBody", (e)=>{
                    let { onClickDayName: t } = this.opts, i = e.target;
                    i.closest(S) && this.handleClick(e), t && i.closest(".air-datepicker-body--day-name") && this.handleDayNameClick(e);
                }), _(this, "onMouseDown", (e)=>{
                    this.pressed = !0;
                    let t = y(e.target, S), i = t && t.adpCell;
                    p(i.date, this.dp.rangeDateFrom) && (this.rangeFromFocused = !0), p(i.date, this.dp.rangeDateTo) && (this.rangeToFocused = !0);
                }), _(this, "onMouseMove", (e)=>{
                    if (!this.pressed || !this.dp.isMinViewReached) return;
                    e.preventDefault();
                    let t = y(e.target, S), i = t && t.adpCell, { selectedDates: s, rangeDateTo: a, rangeDateFrom: n } = this.dp;
                    if (!i || i.isDisabled) return;
                    let { date: r } = i;
                    if (2 === s.length) {
                        if (this.rangeFromFocused && !m(r, a)) {
                            let { hours: e, minutes: t } = h(n);
                            r.setHours(e), r.setMinutes(t), this.dp.rangeDateFrom = r, this.dp.replaceDate(n, r);
                        }
                        if (this.rangeToFocused && !v(r, n)) {
                            let { hours: e, minutes: t } = h(a);
                            r.setHours(e), r.setMinutes(t), this.dp.rangeDateTo = r, this.dp.replaceDate(a, r);
                        }
                    }
                }), _(this, "onMouseUp", ()=>{
                    this.pressed = !1, this.rangeFromFocused = !1, this.rangeToFocused = !1;
                }), _(this, "onChangeViewDate", (e, t)=>{
                    if (!this.isVisible) return;
                    let s = c(e), a = c(t);
                    switch(this.dp.currentView){
                        case i.days:
                            if (p(e, t, i.months)) return;
                            break;
                        case i.months:
                            if (p(e, t, i.years)) return;
                            break;
                        case i.years:
                            if (s[0] === a[0] && s[1] === a[1]) return;
                    }
                    this.render();
                }), _(this, "render", ()=>{
                    this.destroyCells(), this._generateCells(), this.cells.forEach((e)=>{
                        this.$cells.appendChild(e.render());
                    });
                }), this.dp = t, this.type = s, this.opts = a, this.cells = [], this.$el = "", this.pressed = !1, this.isVisible = !0, this.init();
            }
            init() {
                this._buildBaseHtml(), this.type === i.days && this.renderDayNames(), this.render(), this._bindEvents(), this._bindDatepickerEvents();
            }
            _bindEvents() {
                let { range: e, dynamicRange: t } = this.opts;
                D(this.$el, "mouseover", this.onMouseOverCell), D(this.$el, "mouseout", this.onMouseOutCell), D(this.$el, "click", this.onClickBody), e && t && (D(this.$el, "mousedown", this.onMouseDown), D(this.$el, "mousemove", this.onMouseMove), D(window.document, "mouseup", this.onMouseUp));
            }
            _bindDatepickerEvents() {
                this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView);
            }
            _buildBaseHtml() {
                this.$el = n({
                    className: `air-datepicker-body -${this.type}-`,
                    innerHtml: M[this.type]
                }), this.$names = a(".air-datepicker-body--day-names", this.$el), this.$cells = a(".air-datepicker-body--cells", this.$el);
            }
            _getDayNamesHtml() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.dp.locale.firstDay, t = "", s = this.dp.isWeekend, { onClickDayName: a } = this.opts, n = e, r = 0;
                for(; r < 7;){
                    let e = n % 7;
                    t += `<div class="${u("air-datepicker-body--day-name", {
                        [i.cssClassWeekend]: s(e),
                        "-clickable-": !!a
                    })}" data-day-index='${e}'>${this.dp.locale.daysMin[e]}</div>`, r++, n++;
                }
                return t;
            }
            renderDayNames() {
                this.$names.innerHTML = this._getDayNamesHtml();
            }
            _generateCell(e) {
                let { type: t, dp: i, opts: s } = this;
                return new C({
                    type: t,
                    dp: i,
                    opts: s,
                    date: e,
                    body: this
                });
            }
            _generateCells() {
                T.getDatesFunction(this.type)(this.dp, (e)=>{
                    this.cells.push(this._generateCell(e));
                });
            }
            show() {
                this.isVisible = !0, this.$el.classList.remove("-hidden-");
            }
            hide() {
                this.isVisible = !1, this.$el.classList.add("-hidden-");
            }
            destroyCells() {
                this.cells.forEach((e)=>e.destroy()), this.cells = [], this.$cells.innerHTML = "";
            }
            destroy() {
                this.destroyCells(), this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView);
            }
            static getDaysDates(e, t) {
                let { viewDate: i, opts: { fixedHeight: s }, locale: { firstDay: a } } = e, n = o(i), { year: r, month: l } = h(i), d = new Date(r, l, 1), c = new Date(r, l, n), u = d.getDay() - a, p = 6 - c.getDay() + a;
                u = u < 0 ? u + 7 : u, p = p > 6 ? p - 7 : p;
                let m = function(e, t) {
                    let { year: i, month: s, date: a } = h(e);
                    return new Date(i, s, a - t);
                }(d, u), v = n + u + p, g = m.getDate(), { year: D, month: y } = h(m), f = 0;
                s && (v = 42);
                const w = [];
                for(; f < v;){
                    let e = new Date(D, y, g + f);
                    t && t(e), w.push(e), f++;
                }
                return w;
            }
            static getMonthsDates(e, t) {
                let { year: i } = e.parsedViewDate, s = 0, a = [];
                for(; s < 12;){
                    const e = new Date(i, s);
                    a.push(e), t && t(e), s++;
                }
                return a;
            }
            static getYearsDates(e, t) {
                let i = c(e.viewDate), s = i[0] - 1, a = i[1] + 1, n = s, r = [];
                for(; n <= a;){
                    const e = new Date(n, 0);
                    r.push(e), t && t(e), n++;
                }
                return r;
            }
            static getDatesFunction() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
                return ({
                    [i.days]: T.getDaysDates,
                    [i.months]: T.getMonthsDates,
                    [i.years]: T.getYearsDates
                })[e];
            }
        }
        function F(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class V {
            constructor(e){
                let { dp: t, opts: i } = e;
                F(this, "onClickNav", (e)=>{
                    let t = y(e.target, ".air-datepicker-nav--action");
                    if (!t) return;
                    let i = t.dataset.action;
                    this.dp[i]();
                }), F(this, "onChangeViewDate", ()=>{
                    this.render(), this._resetNavStatus(), this.handleNavStatus();
                }), F(this, "onChangeCurrentView", ()=>{
                    this.render(), this._resetNavStatus(), this.handleNavStatus();
                }), F(this, "onClickNavTitle", ()=>{
                    this.dp.isFinalView || this.dp.up();
                }), F(this, "update", ()=>{
                    let { prevHtml: e, nextHtml: t } = this.opts;
                    this.$prev.innerHTML = e, this.$next.innerHTML = t, this._resetNavStatus(), this.render(), this.handleNavStatus();
                }), F(this, "renderDelay", ()=>{
                    setTimeout(this.render);
                }), F(this, "render", ()=>{
                    this.$title.innerHTML = this._getTitle(), function(e, t) {
                        for(let i in t)t[i] ? e.classList.add(i) : e.classList.remove(i);
                    }(this.$title, {
                        "-disabled-": this.dp.isFinalView
                    });
                }), this.dp = t, this.opts = i, this.init();
            }
            init() {
                this._createElement(), this._buildBaseHtml(), this._defineDOM(), this.render(), this.handleNavStatus(), this._bindEvents(), this._bindDatepickerEvents();
            }
            _defineDOM() {
                this.$title = a(".air-datepicker-nav--title", this.$el), this.$prev = a('[data-action="prev"]', this.$el), this.$next = a('[data-action="next"]', this.$el);
            }
            _bindEvents() {
                this.$el.addEventListener("click", this.onClickNav), this.$title.addEventListener("click", this.onClickNavTitle);
            }
            _bindDatepickerEvents() {
                this.dp.on(i.eventChangeViewDate, this.onChangeViewDate), this.dp.on(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.on(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.on(i.eventChangeTime, this.render));
            }
            destroy() {
                this.dp.off(i.eventChangeViewDate, this.onChangeViewDate), this.dp.off(i.eventChangeCurrentView, this.onChangeCurrentView), this.isNavIsFunction && (this.dp.off(i.eventChangeSelectedDate, this.renderDelay), this.dp.opts.timepicker && this.dp.off(i.eventChangeTime, this.render));
            }
            _createElement() {
                this.$el = n({
                    tagName: "nav",
                    className: "air-datepicker-nav"
                });
            }
            _getTitle() {
                let { dp: e, opts: t } = this, i = t.navTitles[e.currentView];
                return "function" == typeof i ? i(e) : e.formatDate(e.viewDate, i);
            }
            handleNavStatus() {
                let { disableNavWhenOutOfRange: e } = this.opts, { minDate: t, maxDate: s } = this.dp;
                if (!t && !s || !e) return;
                let { year: a, month: n } = this.dp.parsedViewDate, r = !!t && h(t), o = !!s && h(s);
                switch(this.dp.currentView){
                    case i.days:
                        t && r.month >= n && r.year >= a && this._disableNav("prev"), s && o.month <= n && o.year <= a && this._disableNav("next");
                        break;
                    case i.months:
                        t && r.year >= a && this._disableNav("prev"), s && o.year <= a && this._disableNav("next");
                        break;
                    case i.years:
                        {
                            let e = c(this.dp.viewDate);
                            t && r.year >= e[0] && this._disableNav("prev"), s && o.year <= e[1] && this._disableNav("next");
                            break;
                        }
                }
            }
            _disableNav(e) {
                a('[data-action="' + e + '"]', this.$el).classList.add("-disabled-");
            }
            _resetNavStatus() {
                !function(e) {
                    for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
                    e.length ? e.forEach((e)=>{
                        e.classList.remove(...i);
                    }) : e.classList.remove(...i);
                }(this.$el.querySelectorAll(".air-datepicker-nav--action"), "-disabled-");
            }
            _buildBaseHtml() {
                let { prevHtml: e, nextHtml: t } = this.opts;
                this.$el.innerHTML = `<div class="air-datepicker-nav--action" data-action="prev">${e}</div><div class="air-datepicker-nav--title"></div><div class="air-datepicker-nav--action" data-action="next">${t}</div>`;
            }
            get isNavIsFunction() {
                let { navTitles: e } = this.opts;
                return Object.keys(e).find((t)=>"function" == typeof e[t]);
            }
        }
        var x = {
            today: {
                content: (e)=>e.locale.today,
                onClick: (e)=>e.setViewDate(new Date)
            },
            clear: {
                content: (e)=>e.locale.clear,
                onClick: (e)=>e.clear()
            }
        };
        class H {
            constructor(e){
                let { dp: t, opts: i } = e;
                this.dp = t, this.opts = i, this.init();
            }
            init() {
                this.createElement(), this.render();
            }
            createElement() {
                this.$el = n({
                    className: "air-datepicker-buttons"
                });
            }
            destroy() {
                this.$el.parentNode.removeChild(this.$el);
            }
            clearHtml() {
                return this.$el.innerHTML = "", this;
            }
            generateButtons() {
                let { buttons: e } = this.opts;
                Array.isArray(e) || (e = [
                    e
                ]), e.forEach((e)=>{
                    let t = e;
                    "string" == typeof e && x[e] && (t = x[e]);
                    let i = this.createButton(t);
                    t.onClick && this.attachEventToButton(i, t.onClick), this.$el.appendChild(i);
                });
            }
            attachEventToButton(e, t) {
                e.addEventListener("click", ()=>{
                    t(this.dp);
                });
            }
            createButton(e) {
                let { content: t, className: i, tagName: s = "button", attrs: a = {} } = e;
                return n({
                    tagName: s,
                    innerHtml: `<span tabindex='-1'>${"function" == typeof t ? t(this.dp) : t}</span>`,
                    className: u("air-datepicker-button", i),
                    attrs: a
                });
            }
            render() {
                this.generateButtons();
            }
        }
        function E(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class L {
            constructor(){
                let { opts: e, dp: t } = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                E(this, "toggleTimepickerIsActive", (e)=>{
                    this.dp.timepickerIsActive = e;
                }), E(this, "onChangeSelectedDate", (e)=>{
                    let { date: t, updateTime: i = !1 } = e;
                    t && (this.setMinMaxTime(t), this.setCurrentTime(!!i && t), this.addTimeToDate(t));
                }), E(this, "onChangeLastSelectedDate", (e)=>{
                    e && (this.setTime(e), this.render());
                }), E(this, "onChangeInputRange", (e)=>{
                    let t = e.target;
                    this[t.getAttribute("name")] = t.value, this.updateText(), this.dp.trigger(i.eventChangeTime, {
                        hours: this.hours,
                        minutes: this.minutes
                    });
                }), E(this, "onMouseEnterLeave", (e)=>{
                    let t = e.target.getAttribute("name"), i = this.$minutesText;
                    "hours" === t && (i = this.$hoursText), i.classList.toggle("-focus-");
                }), E(this, "onFocus", ()=>{
                    this.toggleTimepickerIsActive(!0);
                }), E(this, "onBlur", ()=>{
                    this.toggleTimepickerIsActive(!1);
                }), this.opts = e, this.dp = t;
                let { timeFormat: s } = this.dp.locale;
                s && (s.match(k("h")) || s.match(k("hh"))) && (this.ampm = !0), this.init();
            }
            init() {
                this.setTime(this.dp.lastSelectedDate || this.dp.viewDate), this.createElement(), this.buildHtml(), this.defineDOM(), this.render(), this.bindDatepickerEvents(), this.bindDOMEvents();
            }
            bindDatepickerEvents() {
                this.dp.on(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.on(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate);
            }
            bindDOMEvents() {
                let e = "input";
                navigator.userAgent.match(/trident/gi) && (e = "change"), D(this.$ranges, e, this.onChangeInputRange), D(this.$ranges, "mouseenter", this.onMouseEnterLeave), D(this.$ranges, "mouseleave", this.onMouseEnterLeave), D(this.$ranges, "focus", this.onFocus), D(this.$ranges, "mousedown", this.onFocus), D(this.$ranges, "blur", this.onBlur);
            }
            createElement() {
                this.$el = n({
                    className: u("air-datepicker-time", {
                        "-am-pm-": this.dp.ampm
                    })
                });
            }
            destroy() {
                this.dp.off(i.eventChangeSelectedDate, this.onChangeSelectedDate), this.dp.off(i.eventChangeLastSelectedDate, this.onChangeLastSelectedDate), this.$el.parentNode.removeChild(this.$el);
            }
            buildHtml() {
                let { ampm: e, hours: t, displayHours: i, minutes: s, minHours: a, minMinutes: n, maxHours: r, maxMinutes: o, dayPeriod: h, opts: { hoursStep: l, minutesStep: c } } = this;
                this.$el.innerHTML = `<div class="air-datepicker-time--current">   <span class="air-datepicker-time--current-hours">${d(i)}</span>   <span class="air-datepicker-time--current-colon">:</span>   <span class="air-datepicker-time--current-minutes">${d(s)}</span>   ` + (e ? `<span class='air-datepicker-time--current-ampm'>${h}</span>` : "") + '</div><div class="air-datepicker-time--sliders">   <div class="air-datepicker-time--row">' + `      <input type="range" name="hours" value="${t}" min="${a}" max="${r}" step="${l}"/>   </div>   <div class="air-datepicker-time--row">` + `      <input type="range" name="minutes" value="${s}" min="${n}" max="${o}" step="${c}"/>   </div></div>`;
            }
            defineDOM() {
                let e = (e)=>a(e, this.$el);
                this.$ranges = this.$el.querySelectorAll('[type="range"]'), this.$hours = e('[name="hours"]'), this.$minutes = e('[name="minutes"]'), this.$hoursText = e(".air-datepicker-time--current-hours"), this.$minutesText = e(".air-datepicker-time--current-minutes"), this.$ampm = e(".air-datepicker-time--current-ampm");
            }
            setTime(e) {
                this.setMinMaxTime(e), this.setCurrentTime(e);
            }
            addTimeToDate(e) {
                e && (e.setHours(this.hours), e.setMinutes(this.minutes));
            }
            setMinMaxTime(e) {
                if (this.setMinMaxTimeFromOptions(), e) {
                    let { minDate: t, maxDate: i } = this.dp;
                    t && p(e, t) && this.setMinTimeFromMinDate(t), i && p(e, i) && this.setMaxTimeFromMaxDate(i);
                }
            }
            setCurrentTime(e) {
                let { hours: t, minutes: i } = e ? h(e) : this;
                this.hours = f(t, this.minHours, this.maxHours), this.minutes = f(i, this.minMinutes, this.maxMinutes);
            }
            setMinMaxTimeFromOptions() {
                let { minHours: e, minMinutes: t, maxHours: i, maxMinutes: s } = this.opts;
                this.minHours = f(e, 0, 23), this.minMinutes = f(t, 0, 59), this.maxHours = f(i, 0, 23), this.maxMinutes = f(s, 0, 59);
            }
            setMinTimeFromMinDate(e) {
                let { lastSelectedDate: t } = this.dp;
                this.minHours = e.getHours(), t && t.getHours() > e.getHours() ? this.minMinutes = this.opts.minMinutes : this.minMinutes = e.getMinutes();
            }
            setMaxTimeFromMaxDate(e) {
                let { lastSelectedDate: t } = this.dp;
                this.maxHours = e.getHours(), t && t.getHours() < e.getHours() ? this.maxMinutes = this.opts.maxMinutes : this.maxMinutes = e.getMinutes();
            }
            updateSliders() {
                r(this.$hours, {
                    min: this.minHours,
                    max: this.maxHours
                }).value = this.hours, r(this.$minutes, {
                    min: this.minMinutes,
                    max: this.maxMinutes
                }).value = this.minutes;
            }
            updateText() {
                this.$hoursText.innerHTML = d(this.displayHours), this.$minutesText.innerHTML = d(this.minutes), this.ampm && (this.$ampm.innerHTML = this.dayPeriod);
            }
            set hours(e) {
                this._hours = e;
                let { hours: t, dayPeriod: i } = l(e);
                this.displayHours = this.ampm ? t : e, this.dayPeriod = i;
            }
            get hours() {
                return this._hours;
            }
            render() {
                this.updateSliders(), this.updateText();
            }
        }
        function O(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        class A {
            constructor(e){
                let { dp: t, opts: i } = e;
                O(this, "pressedKeys", new Set), O(this, "hotKeys", new Map([
                    [
                        [
                            [
                                "Control",
                                "ArrowRight"
                            ],
                            [
                                "Control",
                                "ArrowUp"
                            ]
                        ],
                        (e)=>e.month++
                    ],
                    [
                        [
                            [
                                "Control",
                                "ArrowLeft"
                            ],
                            [
                                "Control",
                                "ArrowDown"
                            ]
                        ],
                        (e)=>e.month--
                    ],
                    [
                        [
                            [
                                "Shift",
                                "ArrowRight"
                            ],
                            [
                                "Shift",
                                "ArrowUp"
                            ]
                        ],
                        (e)=>e.year++
                    ],
                    [
                        [
                            [
                                "Shift",
                                "ArrowLeft"
                            ],
                            [
                                "Shift",
                                "ArrowDown"
                            ]
                        ],
                        (e)=>e.year--
                    ],
                    [
                        [
                            [
                                "Alt",
                                "ArrowRight"
                            ],
                            [
                                "Alt",
                                "ArrowUp"
                            ]
                        ],
                        (e)=>e.year += 10
                    ],
                    [
                        [
                            [
                                "Alt",
                                "ArrowLeft"
                            ],
                            [
                                "Alt",
                                "ArrowDown"
                            ]
                        ],
                        (e)=>e.year -= 10
                    ],
                    [
                        [
                            "Control",
                            "Shift",
                            "ArrowUp"
                        ],
                        (e, t)=>t.up()
                    ]
                ])), O(this, "handleHotKey", (e)=>{
                    let t = this.hotKeys.get(e), i = h(this.getInitialFocusDate());
                    t(i, this.dp);
                    let { year: s, month: a, date: n } = i, r = o(new Date(s, a));
                    r < n && (n = r);
                    let l = this.dp.getClampedDate(new Date(s, a, n));
                    this.dp.setFocusDate(l, {
                        viewDateTransition: !0
                    });
                }), O(this, "isHotKeyPressed", ()=>{
                    let e = !1, t = this.pressedKeys.size, i = (e)=>this.pressedKeys.has(e);
                    for (let [s] of this.hotKeys){
                        if (e) break;
                        if (Array.isArray(s[0])) s.forEach((a)=>{
                            e || t !== a.length || (e = a.every(i) && s);
                        });
                        else {
                            if (t !== s.length) continue;
                            e = s.every(i) && s;
                        }
                    }
                    return e;
                }), O(this, "isArrow", (e)=>e >= 37 && e <= 40), O(this, "onKeyDown", (e)=>{
                    let { key: t, which: i } = e, { dp: s, dp: { focusDate: a }, opts: n } = this;
                    this.registerKey(t);
                    let r = this.isHotKeyPressed();
                    if (r) return e.preventDefault(), void this.handleHotKey(r);
                    if (this.isArrow(i)) return e.preventDefault(), void this.focusNextCell(t);
                    if ("Enter" === t) {
                        if (s.currentView !== n.minView) return void s.down();
                        if (a) {
                            let e = s._checkIfDateIsSelected(a);
                            return void (e ? s._handleAlreadySelectedDates(e, a) : s.selectDate(a));
                        }
                    }
                    "Escape" === t && this.dp.hide();
                }), O(this, "onKeyUp", (e)=>{
                    this.removeKey(e.key);
                }), this.dp = t, this.opts = i, this.init();
            }
            init() {
                this.bindKeyboardEvents();
            }
            bindKeyboardEvents() {
                let { $el: e } = this.dp;
                e.addEventListener("keydown", this.onKeyDown), e.addEventListener("keyup", this.onKeyUp);
            }
            destroy() {
                let { $el: e } = this.dp;
                e.removeEventListener("keydown", this.onKeyDown), e.removeEventListener("keyup", this.onKeyUp), this.hotKeys = null, this.pressedKeys = null;
            }
            getInitialFocusDate() {
                let { focusDate: e, currentView: t, selectedDates: s, parsedViewDate: { year: a, month: n } } = this.dp, r = e || s[s.length - 1];
                if (!r) switch(t){
                    case i.days:
                        r = new Date(a, n, (new Date).getDate());
                        break;
                    case i.months:
                        r = new Date(a, n, 1);
                        break;
                    case i.years:
                        r = new Date(a, 0, 1);
                }
                return r;
            }
            focusNextCell(e) {
                let t = this.getInitialFocusDate(), { currentView: s } = this.dp, { days: a, months: n, years: r } = i, o = h(t), l = o.year, d = o.month, c = o.date;
                switch(e){
                    case "ArrowLeft":
                        s === a && (c -= 1), s === n && (d -= 1), s === r && (l -= 1);
                        break;
                    case "ArrowUp":
                        s === a && (c -= 7), s === n && (d -= 3), s === r && (l -= 4);
                        break;
                    case "ArrowRight":
                        s === a && (c += 1), s === n && (d += 1), s === r && (l += 1);
                        break;
                    case "ArrowDown":
                        s === a && (c += 7), s === n && (d += 3), s === r && (l += 4);
                }
                let u = this.dp.getClampedDate(new Date(l, d, c));
                this.dp.setFocusDate(u, {
                    viewDateTransition: !0
                });
            }
            registerKey(e) {
                this.pressedKeys.add(e);
            }
            removeKey(e) {
                this.pressedKeys.delete(e);
            }
        }
        let N = {
            on (e, t) {
                this.__events || (this.__events = {}), this.__events[e] ? this.__events[e].push(t) : this.__events[e] = [
                    t
                ];
            },
            off (e, t) {
                this.__events && this.__events[e] && (this.__events[e] = this.__events[e].filter((e)=>e !== t));
            },
            removeAllEvents () {
                this.__events = {};
            },
            trigger (e) {
                for(var t = arguments.length, i = new Array(t > 1 ? t - 1 : 0), s = 1; s < t; s++)i[s - 1] = arguments[s];
                this.__events && this.__events[e] && this.__events[e].forEach((e)=>{
                    e(...i);
                });
            }
        };
        function I(e, t, i) {
            return (t = function(e) {
                var t = function(e, t) {
                    if ("object" != typeof e || null === e) return e;
                    var i = e[Symbol.toPrimitive];
                    if (void 0 !== i) {
                        var s = i.call(e, "string");
                        if ("object" != typeof s) return s;
                        throw new TypeError("@@toPrimitive must return a primitive value.");
                    }
                    return String(e);
                }(e);
                return "symbol" == typeof t ? t : String(t);
            }(t)) in e ? Object.defineProperty(e, t, {
                value: i,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = i, e;
        }
        let P = "", j = "", B = !1;
        class R {
            static buildGlobalContainer(e) {
                B = !0, P = n({
                    className: e,
                    id: e
                }), a("body").appendChild(P);
            }
            constructor(e, t){
                var r = this;
                if (I(this, "viewIndexes", [
                    i.days,
                    i.months,
                    i.years
                ]), I(this, "next", ()=>{
                    let { year: e, month: t } = this.parsedViewDate;
                    switch(this.currentView){
                        case i.days:
                            this.setViewDate(new Date(e, t + 1, 1));
                            break;
                        case i.months:
                            this.setViewDate(new Date(e + 1, t, 1));
                            break;
                        case i.years:
                            this.setViewDate(new Date(e + 10, 0, 1));
                    }
                }), I(this, "prev", ()=>{
                    let { year: e, month: t } = this.parsedViewDate;
                    switch(this.currentView){
                        case i.days:
                            this.setViewDate(new Date(e, t - 1, 1));
                            break;
                        case i.months:
                            this.setViewDate(new Date(e - 1, t, 1));
                            break;
                        case i.years:
                            this.setViewDate(new Date(e - 10, 0, 1));
                    }
                }), I(this, "_finishHide", ()=>{
                    this.hideAnimation = !1, this._destroyComponents(), this.$container.removeChild(this.$datepicker);
                }), I(this, "setPosition", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                    if ("function" == typeof (e = e || r.opts.position)) return void (r.customHide = e({
                        $datepicker: r.$datepicker,
                        $target: r.$el,
                        $pointer: r.$pointer,
                        isViewChange: t,
                        done: r._finishHide
                    }));
                    let i, s, { isMobile: a } = r.opts, n = r.$el.getBoundingClientRect(), o = r.$el.getBoundingClientRect(), h = r.$datepicker.offsetParent, l = r.$el.offsetParent, d = r.$datepicker.getBoundingClientRect(), c = e.split(" "), u = window.scrollY, p = window.scrollX, m = r.opts.offset, v = c[0], g = c[1];
                    if (a) r.$datepicker.style.cssText = "left: 50%; top: 50%";
                    else {
                        if (h === l && h !== document.body && (o = {
                            top: r.$el.offsetTop,
                            left: r.$el.offsetLeft,
                            width: n.width,
                            height: r.$el.offsetHeight
                        }, u = 0, p = 0), h !== l && h !== document.body) {
                            let e = h.getBoundingClientRect();
                            o = {
                                top: n.top - e.top,
                                left: n.left - e.left,
                                width: n.width,
                                height: n.height
                            }, u = 0, p = 0;
                        }
                        switch(v){
                            case "top":
                                i = o.top - d.height - m;
                                break;
                            case "right":
                                s = o.left + o.width + m;
                                break;
                            case "bottom":
                                i = o.top + o.height + m;
                                break;
                            case "left":
                                s = o.left - d.width - m;
                        }
                        switch(g){
                            case "top":
                                i = o.top;
                                break;
                            case "right":
                                s = o.left + o.width - d.width;
                                break;
                            case "bottom":
                                i = o.top + o.height - d.height;
                                break;
                            case "left":
                                s = o.left;
                                break;
                            case "center":
                                /left|right/.test(v) ? i = o.top + o.height / 2 - d.height / 2 : s = o.left + o.width / 2 - d.width / 2;
                        }
                        r.$datepicker.style.cssText = `left: ${s + p}px; top: ${i + u}px`;
                    }
                }), I(this, "_setInputValue", ()=>{
                    let { opts: e, $altField: t, locale: { dateFormat: i } } = this, { altFieldDateFormat: s, altField: a } = e;
                    a && t && (t.value = this._getInputValue(s)), this.$el.value = this._getInputValue(i);
                }), I(this, "_getInputValue", (e)=>{
                    let { selectedDates: t, opts: i } = this, { multipleDates: s, multipleDatesSeparator: a } = i;
                    if (!t.length) return "";
                    let n = "function" == typeof e, r = n ? e(s ? t : t[0]) : t.map((t)=>this.formatDate(t, e));
                    return r = n ? r : r.join(a), r;
                }), I(this, "_checkIfDateIsSelected", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.days, s = !1;
                    return r.selectedDates.some((i)=>{
                        let a = p(e, i, t);
                        return s = a && i, a;
                    }), s;
                }), I(this, "_scheduleCallAfterTransition", (e)=>{
                    this._cancelScheduledCall(), e && e(!1), this._onTransitionEnd = ()=>{
                        e && e(!0);
                    }, this.$datepicker.addEventListener("transitionend", this._onTransitionEnd, {
                        once: !0
                    });
                }), I(this, "_cancelScheduledCall", ()=>{
                    this.$datepicker.removeEventListener("transitionend", this._onTransitionEnd);
                }), I(this, "setViewDate", (e)=>{
                    if (!((e = b(e)) instanceof Date)) return;
                    if (p(e, this.viewDate)) return;
                    let t = this.viewDate;
                    this.viewDate = e;
                    let { onChangeViewDate: s } = this.opts;
                    if (s) {
                        let { month: e, year: t } = this.parsedViewDate;
                        s({
                            month: e,
                            year: t,
                            decade: this.curDecade
                        });
                    }
                    this.trigger(i.eventChangeViewDate, e, t);
                }), I(this, "setFocusDate", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    (!e || (e = b(e)) instanceof Date) && (r.focusDate = e, r.trigger(i.eventChangeFocusDate, e, t));
                }), I(this, "setCurrentView", function(e) {
                    let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (r.viewIndexes.includes(e)) {
                        if (r.currentView = e, r.elIsInput && r.visible && r.setPosition(void 0, !0), r.trigger(i.eventChangeCurrentView, e), !r.views[e]) {
                            let t = r.views[e] = new T({
                                dp: r,
                                opts: r.opts,
                                type: e
                            });
                            r.shouldUpdateDOM && r.$content.appendChild(t.$el);
                        }
                        r.opts.onChangeView && !t.silent && r.opts.onChangeView(e);
                    }
                }), I(this, "_updateLastSelectedDate", (e)=>{
                    this.lastSelectedDate = e, this.trigger(i.eventChangeLastSelectedDate, e);
                }), I(this, "destroy", ()=>{
                    if (this.isDestroyed) return;
                    let { showEvent: e, isMobile: t } = this.opts, i = this.$datepicker.parentNode;
                    i && i.removeChild(this.$datepicker), this.$el.removeEventListener(e, this._onFocus), this.$el.removeEventListener("blur", this._onBlur), window.removeEventListener("resize", this._onResize), t && this._removeMobileAttributes(), this.keyboardNav && this.keyboardNav.destroy(), this.views = null, this.nav = null, this.$datepicker = null, this.opts = {}, this.$customContainer = null, this.viewDate = null, this.focusDate = null, this.selectedDates = [], this.rangeDateFrom = null, this.rangeDateTo = null, this.isDestroyed = !0;
                }), I(this, "update", function() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, s = w({}, r.opts), { silent: a } = t;
                    w(r.opts, e);
                    let { timepicker: n, buttons: o, range: h, selectedDates: l, isMobile: d } = r.opts, c = r.visible || r.treatAsInline;
                    r._createMinMaxDates(), r._limitViewDateByMaxMinDates(), r._handleLocale(), l && (r.selectedDates = [], r.selectDate(l, {
                        silent: a
                    })), e.view && r.setCurrentView(e.view, {
                        silent: a
                    }), r._setInputValue(), s.range && !h ? (r.rangeDateTo = !1, r.rangeDateFrom = !1) : !s.range && h && r.selectedDates.length && (r.rangeDateFrom = r.selectedDates[0], r.rangeDateTo = r.selectedDates[1]), s.timepicker && !n ? (c && r.timepicker.destroy(), r.timepicker = !1, r.$timepicker.parentNode.removeChild(r.$timepicker)) : !s.timepicker && n && r._addTimepicker(), !s.buttons && o ? r._addButtons() : s.buttons && !o ? (r.buttons.destroy(), r.$buttons.parentNode.removeChild(r.$buttons)) : c && s.buttons && o && r.buttons.clearHtml().render(), !s.isMobile && d ? (r.treatAsInline || j || r._createMobileOverlay(), r._addMobileAttributes(), r.visible && r._showMobileOverlay()) : s.isMobile && !d && (r._removeMobileAttributes(), r.visible && (j.classList.remove("-active-"), "function" != typeof r.opts.position && r.setPosition())), c && (r.nav.update(), r.views[r.currentView].render(), r.currentView === i.days && r.views[r.currentView].renderDayNames());
                }), I(this, "disableDate", (e, t)=>{
                    (Array.isArray(e) ? e : [
                        e
                    ]).forEach((e)=>{
                        let i = b(e);
                        if (!i) return;
                        let s = t ? "delete" : "add";
                        this.disabledDates[s](this.formatDate(i, "yyyy-MM-dd"));
                        let a = this.getCell(i, this.currentViewSingular);
                        a && a.adpCell.render();
                    }, []);
                }), I(this, "enableDate", (e)=>{
                    this.disableDate(e, !0);
                }), I(this, "isDateDisabled", (e)=>{
                    let t = b(e);
                    return this.disabledDates.has(this.formatDate(t, "yyyy-MM-dd"));
                }), I(this, "isOtherMonth", (e)=>{
                    let { month: t } = h(e);
                    return t !== this.parsedViewDate.month;
                }), I(this, "isOtherYear", (e)=>{
                    let { year: t } = h(e);
                    return t !== this.parsedViewDate.year;
                }), I(this, "isOtherDecade", (e)=>{
                    let { year: t } = h(e), [i, s] = c(this.viewDate);
                    return t < i || t > s;
                }), I(this, "_onChangeSelectedDate", (e)=>{
                    let { silent: t } = e;
                    setTimeout(()=>{
                        this._setInputValue(), this.opts.onSelect && !t && this._triggerOnSelect();
                    });
                }), I(this, "_onChangeFocusedDate", function(e) {
                    let { viewDateTransition: t } = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    if (!e) return;
                    let i = !1;
                    t && (i = r.isOtherMonth(e) || r.isOtherYear(e) || r.isOtherDecade(e)), i && r.setViewDate(e), r.opts.onFocus && r.opts.onFocus({
                        datepicker: r,
                        date: e
                    });
                }), I(this, "_onChangeTime", (e)=>{
                    let { hours: t, minutes: i } = e, s = new Date, { lastSelectedDate: a, opts: { onSelect: n } } = this, r = a;
                    a || (r = s);
                    let o = this.getCell(r, this.currentViewSingular), h = o && o.adpCell;
                    h && h.isDisabled || (r.setHours(t), r.setMinutes(i), a ? (this._setInputValue(), n && this._triggerOnSelect()) : this.selectDate(r));
                }), I(this, "_onFocus", (e)=>{
                    this.visible || this.show();
                }), I(this, "_onBlur", (e)=>{
                    this.inFocus || !this.visible || this.opts.isMobile || this.hide();
                }), I(this, "_onMouseDown", (e)=>{
                    this.inFocus = !0;
                }), I(this, "_onMouseUp", (e)=>{
                    this.inFocus = !1, this.$el.focus();
                }), I(this, "_onResize", ()=>{
                    this.visible && "function" != typeof this.opts.position && this.setPosition();
                }), I(this, "_onClickOverlay", ()=>{
                    this.visible && this.hide();
                }), I(this, "getViewDates", function() {
                    let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : i.days;
                    return T.getDatesFunction(e)(r);
                }), I(this, "isWeekend", (e)=>this.opts.weekends.includes(e)), I(this, "getClampedDate", (e)=>{
                    let { minDate: t, maxDate: i } = this, s = e;
                    return i && m(e, i) ? s = i : t && v(e, t) && (s = t), s;
                }), this.$el = a(e), !this.$el) return;
                this.$datepicker = n({
                    className: "air-datepicker"
                }), this.opts = w({}, s, t), this.$customContainer = !!this.opts.container && a(this.opts.container), this.$altField = a(this.opts.altField || !1);
                let { view: o, startDate: l } = this.opts;
                l || (this.opts.startDate = new Date), "INPUT" === this.$el.nodeName && (this.elIsInput = !0), this.inited = !1, this.visible = !1, this.viewDate = b(this.opts.startDate), this.focusDate = !1, this.initialReadonly = this.$el.getAttribute("readonly"), this.customHide = !1, this.currentView = o, this.selectedDates = [], this.disabledDates = new Set, this.isDestroyed = !1, this.views = {}, this.keys = [], this.rangeDateFrom = "", this.rangeDateTo = "", this.timepickerIsActive = !1, this.treatAsInline = this.opts.inline || !this.elIsInput, this.init();
            }
            init() {
                let { opts: e, treatAsInline: t, opts: { inline: i, isMobile: s, selectedDates: n, keyboardNav: r, onlyTimepicker: o } } = this, h = a("body");
                (!B || B && P && !h.contains(P)) && !i && this.elIsInput && !this.$customContainer && R.buildGlobalContainer(R.defaultGlobalContainerId), !s || j || t || this._createMobileOverlay(), this._handleLocale(), this._bindSubEvents(), this._createMinMaxDates(), this._limitViewDateByMaxMinDates(), this.elIsInput && (i || this._bindEvents(), r && !o && (this.keyboardNav = new A({
                    dp: this,
                    opts: e
                }))), n && this.selectDate(n, {
                    silent: !0
                }), this.opts.visible && !t && this.show(), s && !t && this.$el.setAttribute("readonly", !0), t && this._createComponents();
            }
            _createMobileOverlay() {
                j = n({
                    className: "air-datepicker-overlay"
                }), P.appendChild(j);
            }
            _createComponents() {
                let { opts: e, treatAsInline: t, opts: { inline: i, buttons: s, timepicker: a, position: n, classes: r, onlyTimepicker: o, isMobile: h } } = this;
                this._buildBaseHtml(), this.elIsInput && (i || this._setPositionClasses(n)), !i && this.elIsInput || this.$datepicker.classList.add("-inline-"), r && this.$datepicker.classList.add(...r.split(" ")), o && this.$datepicker.classList.add("-only-timepicker-"), h && !t && this._addMobileAttributes(), this.views[this.currentView] = new T({
                    dp: this,
                    type: this.currentView,
                    opts: e
                }), this.nav = new V({
                    dp: this,
                    opts: e
                }), a && this._addTimepicker(), s && this._addButtons(), this.$content.appendChild(this.views[this.currentView].$el), this.$nav.appendChild(this.nav.$el);
            }
            _destroyComponents() {
                for(let e in this.views)this.views[e].destroy();
                this.views = {}, this.nav.destroy(), this.timepicker && this.timepicker.destroy();
            }
            _addMobileAttributes() {
                j.addEventListener("click", this._onClickOverlay), this.$datepicker.classList.add("-is-mobile-"), this.$el.setAttribute("readonly", !0);
            }
            _removeMobileAttributes() {
                j.removeEventListener("click", this._onClickOverlay), this.$datepicker.classList.remove("-is-mobile-"), this.initialReadonly || "" === this.initialReadonly || this.$el.removeAttribute("readonly");
            }
            _createMinMaxDates() {
                let { minDate: e, maxDate: t } = this.opts;
                this.minDate = !!e && b(e), this.maxDate = !!t && b(t);
            }
            _addTimepicker() {
                this.$timepicker = n({
                    className: "air-datepicker--time"
                }), this.$datepicker.appendChild(this.$timepicker), this.timepicker = new L({
                    dp: this,
                    opts: this.opts
                }), this.$timepicker.appendChild(this.timepicker.$el);
            }
            _addButtons() {
                this.$buttons = n({
                    className: "air-datepicker--buttons"
                }), this.$datepicker.appendChild(this.$buttons), this.buttons = new H({
                    dp: this,
                    opts: this.opts
                }), this.$buttons.appendChild(this.buttons.$el);
            }
            _bindSubEvents() {
                this.on(i.eventChangeSelectedDate, this._onChangeSelectedDate), this.on(i.eventChangeFocusDate, this._onChangeFocusedDate), this.on(i.eventChangeTime, this._onChangeTime);
            }
            _buildBaseHtml() {
                let { inline: e } = this.opts;
                var t, i;
                this.elIsInput ? e ? (t = this.$datepicker, (i = this.$el).parentNode.insertBefore(t, i.nextSibling)) : this.$container.appendChild(this.$datepicker) : this.$el.appendChild(this.$datepicker), this.$datepicker.innerHTML = '<i class="air-datepicker--pointer"></i><div class="air-datepicker--navigation"></div><div class="air-datepicker--content"></div>', this.$content = a(".air-datepicker--content", this.$datepicker), this.$pointer = a(".air-datepicker--pointer", this.$datepicker), this.$nav = a(".air-datepicker--navigation", this.$datepicker);
            }
            _handleLocale() {
                let { locale: e, dateFormat: t, firstDay: i, timepicker: s, onlyTimepicker: a, timeFormat: n, dateTimeSeparator: r } = this.opts;
                var o;
                this.locale = (o = e, JSON.parse(JSON.stringify(o))), t && (this.locale.dateFormat = t), void 0 !== n && "" !== n && (this.locale.timeFormat = n);
                let { timeFormat: h } = this.locale;
                if ("" !== i && (this.locale.firstDay = i), s && "function" != typeof t) {
                    let e = h ? r : "";
                    this.locale.dateFormat = [
                        this.locale.dateFormat,
                        h || ""
                    ].join(e);
                }
                a && "function" != typeof t && (this.locale.dateFormat = this.locale.timeFormat);
            }
            _setPositionClasses(e) {
                if ("function" == typeof e) return void this.$datepicker.classList.add("-custom-position-");
                let t = (e = e.split(" "))[0], i = `air-datepicker -${t}-${e[1]}- -from-${t}-`;
                this.$datepicker.classList.add(...i.split(" "));
            }
            _bindEvents() {
                this.$el.addEventListener(this.opts.showEvent, this._onFocus), this.$el.addEventListener("blur", this._onBlur), this.$datepicker.addEventListener("mousedown", this._onMouseDown), this.$datepicker.addEventListener("mouseup", this._onMouseUp), window.addEventListener("resize", this._onResize);
            }
            _limitViewDateByMaxMinDates() {
                let { viewDate: e, minDate: t, maxDate: i } = this;
                i && m(e, i) && this.setViewDate(i), t && v(e, t) && this.setViewDate(t);
            }
            formatDate() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : this.viewDate, t = arguments.length > 1 ? arguments[1] : void 0;
                if (e = b(e), !(e instanceof Date)) return;
                let i = t, s = this.locale, a = h(e), n = a.dayPeriod, r = c(e), o = R.replacer, l = {
                    T: e.getTime(),
                    m: a.minutes,
                    mm: a.fullMinutes,
                    h: a.hours12,
                    hh: a.fullHours12,
                    H: a.hours,
                    HH: a.fullHours,
                    aa: n,
                    AA: n.toUpperCase(),
                    E: s.daysShort[a.day],
                    EEEE: s.days[a.day],
                    d: a.date,
                    dd: a.fullDate,
                    M: a.month + 1,
                    MM: a.fullMonth,
                    MMM: s.monthsShort[a.month],
                    MMMM: s.months[a.month],
                    yy: a.year.toString().slice(-2),
                    yyyy: a.year,
                    yyyy1: r[0],
                    yyyy2: r[1]
                };
                for (let [e, t] of Object.entries(l))i = o(i, k(e), t);
                return i;
            }
            down(e) {
                this._handleUpDownActions(e, "down");
            }
            up(e) {
                this._handleUpDownActions(e, "up");
            }
            selectDate(e) {
                let t, s = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, { currentView: a, parsedViewDate: n, selectedDates: r } = this, { updateTime: o } = s, { moveToOtherMonthsOnSelect: h, moveToOtherYearsOnSelect: l, multipleDates: d, range: c, autoClose: u, onBeforeSelect: p } = this.opts, v = r.length;
                if (Array.isArray(e)) return e.forEach((e)=>{
                    this.selectDate(e, s);
                }), new Promise((e)=>{
                    setTimeout(e);
                });
                if ((e = b(e)) instanceof Date) {
                    if (p && !p({
                        date: e,
                        datepicker: this
                    })) return Promise.resolve();
                    if (a === i.days && e.getMonth() !== n.month && h && (t = new Date(e.getFullYear(), e.getMonth(), 1)), a === i.years && e.getFullYear() !== n.year && l && (t = new Date(e.getFullYear(), 0, 1)), t && this.setViewDate(t), d && !c) {
                        if (v === d) return;
                        this._checkIfDateIsSelected(e) || r.push(e);
                    } else if (c) switch(v){
                        case 1:
                            r.push(e), this.rangeDateTo || (this.rangeDateTo = e), m(this.rangeDateFrom, this.rangeDateTo) && (this.rangeDateTo = this.rangeDateFrom, this.rangeDateFrom = e), this.selectedDates = [
                                this.rangeDateFrom,
                                this.rangeDateTo
                            ];
                            break;
                        case 2:
                            this.selectedDates = [
                                e
                            ], this.rangeDateFrom = e, this.rangeDateTo = "";
                            break;
                        default:
                            this.selectedDates = [
                                e
                            ], this.rangeDateFrom = e;
                    }
                    else this.selectedDates = [
                        e
                    ];
                    return this.trigger(i.eventChangeSelectedDate, {
                        action: i.actionSelectDate,
                        silent: null == s ? void 0 : s.silent,
                        date: e,
                        updateTime: o
                    }), this._updateLastSelectedDate(e), u && !this.timepickerIsActive && this.visible && (d || c ? c && 1 === v && this.hide() : this.hide()), new Promise((e)=>{
                        setTimeout(e);
                    });
                }
            }
            unselectDate(e) {
                let t = this.selectedDates, s = this;
                if ((e = b(e)) instanceof Date) return t.some((a, n)=>{
                    if (p(a, e)) return t.splice(n, 1), s.selectedDates.length ? (s.rangeDateTo = "", s.rangeDateFrom = t[0], s._updateLastSelectedDate(s.selectedDates[s.selectedDates.length - 1])) : (s.rangeDateFrom = "", s.rangeDateTo = "", s._updateLastSelectedDate(!1)), this.trigger(i.eventChangeSelectedDate, {
                        action: i.actionUnselectDate,
                        date: e
                    }), !0;
                });
            }
            replaceDate(e, t) {
                let s = this.selectedDates.find((t)=>p(t, e, this.currentView)), a = this.selectedDates.indexOf(s);
                a < 0 || p(this.selectedDates[a], t, this.currentView) || (this.selectedDates[a] = t, this.trigger(i.eventChangeSelectedDate, {
                    action: i.actionSelectDate,
                    date: t,
                    updateTime: !0
                }), this._updateLastSelectedDate(t));
            }
            clear() {
                let e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                return this.selectedDates = [], this.rangeDateFrom = !1, this.rangeDateTo = !1, this.lastSelectedDate = !1, this.trigger(i.eventChangeSelectedDate, {
                    action: i.actionUnselectDate,
                    silent: e.silent
                }), new Promise((e)=>{
                    setTimeout(e);
                });
            }
            show() {
                let { onShow: e, isMobile: t } = this.opts;
                this._cancelScheduledCall(), this.visible || this.hideAnimation || this._createComponents(), this.setPosition(this.opts.position), this.$datepicker.classList.add("-active-"), this.visible = !0, e && this._scheduleCallAfterTransition(e), t && this._showMobileOverlay();
            }
            hide() {
                let { onHide: e, isMobile: t } = this.opts, i = this._hasTransition();
                this.visible = !1, this.hideAnimation = !0, this.$datepicker.classList.remove("-active-"), this.customHide && this.customHide(), this.elIsInput && this.$el.blur(), this._scheduleCallAfterTransition((t)=>{
                    !this.customHide && (t && i || !t && !i) && this._finishHide(), e && e(t);
                }), t && j.classList.remove("-active-");
            }
            _triggerOnSelect() {
                let e = [], t = [], { selectedDates: i, locale: s, opts: { onSelect: a, multipleDates: n, range: r } } = this, o = n || r, h = "function" == typeof s.dateFormat;
                i.length && (e = i.map(g), t = h ? n ? s.dateFormat(e) : e.map((e)=>s.dateFormat(e)) : e.map((e)=>this.formatDate(e, s.dateFormat))), a({
                    date: o ? e : e[0],
                    formattedDate: o ? t : t[0],
                    datepicker: this
                });
            }
            _handleAlreadySelectedDates(e, t) {
                let { selectedDates: i, rangeDateFrom: s, rangeDateTo: a } = this, { range: n, toggleSelected: r } = this.opts, o = i.length, h = "function" == typeof r ? r({
                    datepicker: this,
                    date: t
                }) : r, l = Boolean(n && 1 === o && e), d = l ? g(t) : t;
                n && !h && (2 !== o && this.selectDate(d), 2 === o && p(s, a)) || (h ? this.unselectDate(d) : this._updateLastSelectedDate(l ? d : e));
            }
            _handleUpDownActions(e, t) {
                if (!((e = b(e || this.focusDate || this.viewDate)) instanceof Date)) return;
                let i = "up" === t ? this.viewIndex + 1 : this.viewIndex - 1;
                i > 2 && (i = 2), i < 0 && (i = 0), this.setViewDate(new Date(e.getFullYear(), e.getMonth(), 1)), this.setCurrentView(this.viewIndexes[i]);
            }
            getCell(e) {
                let t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : i.day;
                if (!((e = b(e)) instanceof Date)) return;
                let { year: s, month: a, date: n } = h(e), r = `[data-year="${s}"]`, o = `[data-month="${a}"]`, l = {
                    [i.day]: `${r}${o}[data-date="${n}"]`,
                    [i.month]: `${r}${o}`,
                    [i.year]: `${r}`
                };
                return this.views[this.currentView] ? this.views[this.currentView].$el.querySelector(l[t]) : void 0;
            }
            _showMobileOverlay() {
                j.classList.add("-active-");
            }
            _hasTransition() {
                return window.getComputedStyle(this.$datepicker).getPropertyValue("transition-duration").split(", ").reduce((e, t)=>parseFloat(t) + e, 0) > 0;
            }
            get shouldUpdateDOM() {
                return this.visible || this.treatAsInline;
            }
            get parsedViewDate() {
                return h(this.viewDate);
            }
            get currentViewSingular() {
                return this.currentView.slice(0, -1);
            }
            get curDecade() {
                return c(this.viewDate);
            }
            get viewIndex() {
                return this.viewIndexes.indexOf(this.currentView);
            }
            get isFinalView() {
                return this.currentView === i.years;
            }
            get hasSelectedDates() {
                return this.selectedDates.length > 0;
            }
            get isMinViewReached() {
                return this.currentView === this.opts.minView || this.currentView === i.days;
            }
            get $container() {
                return this.$customContainer || P;
            }
            static replacer(e, t, i) {
                return e.replace(t, function(e, t, s, a) {
                    return t + i + a;
                });
            }
        }
        var K;
        return I(R, "defaults", s), I(R, "version", "3.5.3"), I(R, "defaultGlobalContainerId", "air-datepicker-global-container"), K = R.prototype, Object.assign(K, N), t.default;
    }();
});


var $83ac11529f3e97df$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($7c91cf96f56c9b55$exports)));


const $53c84e46671fcc30$var$localeEn = {
    days: [
        "\u041D\u0435\u0434\u0456\u043B\u044F",
        "\u041F\u043E\u043D\u0435\u0434\u0456\u043B\u043E\u043A",
        "\u0412\u0456\u0432\u0442\u043E\u0440\u043E\u043A",
        "\u0421\u0435\u0440\u0435\u0434\u0430",
        "\u0427\u0435\u0442\u0432\u0435\u0440",
        "\u041F'\u044F\u0442\u043D\u0438\u0446\u044F",
        "\u0421\u0443\u0431\u043E\u0442\u0430"
    ],
    daysShort: [
        'Mon',
        'Tue',
        'Wed',
        'Thu',
        'Fri',
        'Sat',
        'Sun'
    ],
    daysMin: [
        "\u041D\u0434",
        "\u041F\u043D",
        "\u0412\u0442",
        "\u0421\u0440",
        "\u0427\u0442",
        "\u041F\u0442",
        "\u0421\u0431"
    ],
    months: [
        "\u0421\u0456\u0447\u0435\u043D\u044C",
        "\u041B\u044E\u0442\u0438\u0439",
        "\u0411\u0435\u0440\u0435\u0437\u0435\u043D\u044C",
        "\u041A\u0432\u0456\u0442\u0435\u043D\u044C",
        "\u0422\u0440\u0430\u0432\u0435\u043D\u044C",
        "\u0427\u0435\u0440\u0432\u0435\u043D\u044C",
        "\u041B\u0438\u043F\u0435\u043D\u044C",
        "\u0421\u0435\u0440\u043F\u0435\u043D\u044C",
        "\u0412\u0435\u0440\u0435\u0441\u0435\u043D\u044C",
        "\u0416\u043E\u0432\u0442\u0435\u043D\u044C",
        "\u041B\u0438\u0441\u0442\u043E\u043F\u0430\u0434",
        "\u0413\u0440\u0443\u0434\u0435\u043D\u044C"
    ],
    monthsShort: [
        "\u0421\u0456\u0447.",
        "\u041B\u044E\u0442.",
        "\u0411\u0435\u0440\u0435\u0437.",
        "\u041A\u0432\u0456\u0442.",
        "\u0422\u0440\u0430\u0432.",
        "\u0427\u0435\u0440\u0432.",
        "\u041B\u0438\u043F.",
        "\u0421\u0435\u0440\u043F.",
        "\u0412\u0435\u0440\u0435\u0441.",
        "\u0416\u043E\u0432\u0442.",
        "\u041B\u0438\u0441\u0442\u043E\u043F.",
        "\u0413\u0440\u0443\u0434."
    ],
    today: "\u0421\u044C\u043E\u0433\u043E\u0434\u043D\u0456",
    clear: 'Clear',
    dateFormat: 'dd/MM/yyyy',
    timeFormat: 'hh:mm aa',
    firstDay: 1
};
window.dateInput = function dateInput1() {
    if (document.getElementsByClassName('date-input')[0]) {
        const dateInputsArr = document.querySelectorAll('.date-input');
        dateInputsArr.forEach((dateInput1, i)=>{
            if (!dateInput1.classList.contains('is-init')) {
                dateInput1.classList.add('is-init');
                dateInput1.setAttribute('readonly', true);
                const now = new Date();
                const today = new Date();
                today.setHours(0, 0, 0, 0);
                const currentHour = now.getHours();
                const isTodayAllowed = currentHour < 21;
                const allowedDaysString = dateInput1.getAttribute('data-days');
                const allowedDaysMap = {
                    \u041F\u043D: 1,
                    \u0412\u0442: 2,
                    \u0421\u0440: 3,
                    \u0427\u0442: 4,
                    \u041F\u0442: 5,
                    \u0421\u0431: 6,
                    \u041D\u0434: 0
                };
                const allowedDays = allowedDaysString.split(',').map((day)=>allowedDaysMap[day.trim()]);
                const choiceTimeSelect = document.querySelector('#choice-time');
                const timePicker = document.querySelector('#time-picker');
                let choiceTimeInitOptions = choiceTimeSelect ? Array.from(choiceTimeSelect.options).map((option)=>option.cloneNode(true)) : null;
                let timePickerInitialValue = timePicker ? timePicker.value : null;
                const airDatepicker = new (0, $83ac11529f3e97df$export$2e2bcd8739ae039)(dateInput1, {
                    dateFormat: 'dd/MM/yyyy',
                    locale: $53c84e46671fcc30$var$localeEn,
                    minDate: today,
                    onSelect ({ date: date, formattedDate: formattedDate }) {
                        dateInput1.value = formattedDate;
                        if (!dateInput1.value || dateInput1.value === 'undefined') dateInput1.value = '';
                        const now = new Date();
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);
                        const selectedDate = new Date(date);
                        selectedDate.setHours(0, 0, 0, 0);
                        if (choiceTimeSelect && choiceTimeInitOptions !== null) {
                            const currentOptions = choiceTimeSelect.querySelectorAll('option');
                            for(let j = 0; j < currentOptions.length; j++){
                                currentOptions[j].disabled = false;
                                updateProjectMetaSelect('choice-time');
                                setProjectMetaSelectValue('choice-time', '');
                            }
                        }
                        if (timePicker) {
                            const timePickerParent = timePicker.closest('.meta-time-picker');
                            if (timePickerParent) timePickerParent.classList.remove('is-disabled');
                            timePicker.value = timePickerInitialValue;
                        }
                        if (selectedDate.getTime() === today.getTime()) {
                            const currentHour = now.getHours();
                            const currentHourMathFloor = Math.floor(now.getHours());
                            /*console.log(`Сьогодні, зараз ${currentHour}:00`);*/ if (choiceTimeSelect && choiceTimeInitOptions !== null) {
                                const currentOptions = choiceTimeSelect.querySelectorAll('option');
                                if (Number(currentHourMathFloor) >= 14) currentOptions.forEach((option)=>{
                                    option.disabled = true;
                                    updateProjectMetaSelect('choice-time');
                                });
                                else {
                                    const currentOptions = choiceTimeSelect.querySelectorAll('option');
                                    currentOptions.forEach((option)=>{
                                        const value = option.value;
                                        const [start, end] = value.split('-').map((part)=>part.trim());
                                        const startHour = parseInt(start);
                                        const endHour = parseInt(end);
                                        if (Number(currentHourMathFloor) >= startHour) {
                                            option.disabled = true;
                                            updateProjectMetaSelect('choice-time');
                                            setProjectMetaSelectValue('choice-time', '');
                                        }
                                        console.log(Number(currentHourMathFloor), startHour, endHour);
                                    });
                                }
                            } else if (timePicker) {
                                if (Number(currentHourMathFloor) >= 14) {
                                    const timePickerParent = timePicker.closest('.meta-time-picker');
                                    if (timePickerParent) timePickerParent.classList.add('is-disabled');
                                    timePicker.value = '';
                                }
                            }
                        }
                        if (window.innerWidth <= 768) setTimeout(()=>{
                            airDatepicker.hide();
                        }, 100);
                    },
                    onRenderCell ({ date: date, cellType: cellType }) {
                        if (cellType === 'day') {
                            const day = date.getDay();
                            const isToday = date.getTime() === today.getTime();
                            if (!allowedDays.includes(day) || date < today || isToday && !isTodayAllowed) return {
                                disabled: true,
                                classes: 'disabled-day'
                            };
                        }
                    }
                });
                dateInput1.addEventListener('input', (event)=>{
                    event.preventDefault();
                    event.stopPropagation();
                    dateInput1.value = '';
                });
            /*document.addEventListener('scroll', () => {});

        document.addEventListener('wheel', (event) => {
          console.log('Wheel event triggered');
          const datepickerElement = document.querySelector('.air-datepicker');

          if (
            datepickerElement &&
            document.querySelector('#popup').classList.contains('active')
          ) {
            airDatepicker.hide();
          }
        });*/ }
        });
    }
};
dateInput();


if (document.querySelector('.order__form-tabs')) {
    const orderFormTabsArr = document.querySelectorAll('.order__form-tab');
    orderFormTabsArr.forEach((tab)=>{
        tab.addEventListener('click', ()=>{
            for(let i = 0; i < orderFormTabsArr.length; i++)orderFormTabsArr[i].classList.remove('active');
            tab.classList.add('active');
        });
    });
}
window.checkoutValidationsFunc = function checkoutValidationsFunc1() {
    const requiredInputsContainersArr = document.querySelectorAll('.required-input');
    const orderButtons = document.querySelector('.order__cart-buttons');
    if (document.querySelector('.order__cart-buttons')) {
        function validateForm() {
            let allInputsValid = true;
            // console.log(requiredInputsContainersArr);
            requiredInputsContainersArr.forEach((requiredInputsContainer)=>{
                const input = requiredInputsContainer.querySelector('input:not(.choices__input)');
                const select = requiredInputsContainer.querySelector('select');
                if (input) {
                    const inputValue = input.value.trim();
                    // console.log(input, `Input value: "${inputValue}"`);
                    if (inputValue === '') allInputsValid = false;
                }
                if (select) {
                    const selectValue = select.value.trim();
                    // console.log(`Select value: "${selectValue}"`);
                    if (selectValue === '') allInputsValid = false;
                }
            });
            if (allInputsValid) {
                orderButtons.classList.add('is-next-active');
                const btn = document.getElementById('checkout-btn');
                btn.disabled = false;
                btn.classList.remove('disabled-type');
            } else orderButtons.classList.remove('is-next-active');
        /*console.log('All inputs valid:', allInputsValid);*/ }
        requiredInputsContainersArr.forEach((requiredInputsContainer)=>{
            if (!requiredInputsContainer.classList.contains('is-valid-start')) {
                requiredInputsContainer.classList.add('is-valid-start');
                const input = requiredInputsContainer.querySelector('input');
                const select = requiredInputsContainer.querySelector('select');
                if (input) input.addEventListener('input', ()=>{
                    validateForm();
                    if (!orderButtons.classList.contains('is-next-active')) enableCheckoutBtn();
                });
                if (select) select.addEventListener('change', ()=>{
                    validateForm();
                    if (!orderButtons.classList.contains('is-next-active')) enableCheckoutBtn();
                });
            }
        });
        validateForm();
    }
};
checkoutValidationsFunc();
const $0aa4a858c0d719d9$var$otherNovaInput = document.querySelector('#other_address');
if ($0aa4a858c0d719d9$var$otherNovaInput) {
    const profileNameInput = document.querySelector('[name="full_name"]');
    const emailInput = document.querySelector('[name="email"]');
    const telInput = document.querySelector('[name="tel"]');
    const orderButtons = document.querySelector('.order__cart-buttons');
    $0aa4a858c0d719d9$var$otherNovaInput.addEventListener('input', ()=>{
        if ($0aa4a858c0d719d9$var$otherNovaInput.value !== '' && profileNameInput.value !== '' && emailInput.value !== '' && telInput.value !== '') {
            enableCheckoutBtn();
            orderButtons.classList.add('is-next-active');
        } else {
            disableCheckoutBtn();
            orderButtons.classList.remove('is-next-active');
        }
    });
}


const $6b3169d24286edc1$var$cartComponent = document.getElementsByClassName('cart-container')[0];
if ($6b3169d24286edc1$var$cartComponent) {
    // console.log(cartComponent);
    const cartOpenBtn = $6b3169d24286edc1$var$cartComponent.querySelector('.cart-open');
    const cartMobileOpenBtn = document.querySelector('.cart-open-mob');
    const cartMoreOpenBtn = document.querySelector('.cart__list-more');
    const cartCloseBg = $6b3169d24286edc1$var$cartComponent.querySelector('.cart-close-wrapper');
    const cartCloseMobBtn = $6b3169d24286edc1$var$cartComponent.querySelector('.cart__close');
    const cart = $6b3169d24286edc1$var$cartComponent.querySelector('.cart');
    const cartTitle = $6b3169d24286edc1$var$cartComponent.querySelector('.cart__title');
    const cartList = $6b3169d24286edc1$var$cartComponent.querySelector('.cart__list');
    const cartVisibleBottom = $6b3169d24286edc1$var$cartComponent.querySelector('.cart__visible-bottom');
    const cartResult = $6b3169d24286edc1$var$cartComponent.querySelector('.cart__result');
    let scrollList = null;
    let openDelay = 500;
    function openCartFunc() {
        if (!$6b3169d24286edc1$var$cartComponent.classList.contains('is-open')) {
            const productsArr = cartList.querySelectorAll('.cart__item');
            for(let i = 0; i < productsArr.length; i++)productsArr[i].classList.remove('hidden');
            $6b3169d24286edc1$var$cartComponent.classList.add('is-open');
            $6b3169d24286edc1$var$cartComponent.style.zIndex = 1000;
            scrollListCalc();
        } else {
            $6b3169d24286edc1$var$cartComponent.classList.remove('is-open');
            setTimeout(function() {
                $6b3169d24286edc1$var$cartComponent.style.zIndex = 800;
            }, openDelay);
            /*disableScrollListFunc();*/ scrollListCalc();
            moreCounterFunc();
        }
        // LockScroll when burger open and enable when closed and enable scroll on menu
        if (!document.getElementsByClassName('header')[0].classList.contains('open-menu')) {
            if (scrollLock.getScrollState()) {
                scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
                scrollLock.addScrollableSelector('.simplebar-content-wrapper');
            } else scrollLock.enablePageScroll();
        }
    }
    cartOpenBtn.addEventListener('click', ()=>{
        openCartFunc();
    });
    cartMobileOpenBtn.addEventListener('click', ()=>{
        openCartFunc();
    });
    cartCloseBg.addEventListener('click', ()=>{
        openCartFunc();
    });
    cartCloseMobBtn.addEventListener('click', ()=>{
        openCartFunc();
    });
    cartMoreOpenBtn.addEventListener('click', ()=>{
        openCartFunc();
    });
    function scrollListCalc() {
        if (cartList && $6b3169d24286edc1$var$cartComponent.classList.contains('is-open')) cartList.style.maxHeight = `calc(100% - ${cartTitle.clientHeight + cartResult.clientHeight}px)`;
        else if (cartList && !$6b3169d24286edc1$var$cartComponent.classList.contains('is-open')) cartList.style.maxHeight = `calc(100% - ${cartTitle.clientHeight + cartVisibleBottom.clientHeight}px)`;
    }
    scrollListCalc();
    function enableScrollListFunc() {
        if (cartList) scrollList = new SimpleBar(cartList);
    }
    enableScrollListFunc();
    function disableScrollListFunc() {
        if (cartList) scrollList.unMount();
    }
    window.moreCounterFunc = function moreCounterFunc1() {
        const cartListMoreShowEl = cartMoreOpenBtn.querySelector('.cart__list-more-text.with-show');
        const cartListMoreNotShowEl = cartMoreOpenBtn.querySelector('.cart__list-more-text.with-not-show');
        const cartListMoreCounter = cartListMoreShowEl.querySelector('span');
        const productsArr = cartList.querySelectorAll('.cart__item');
        const productCount = productsArr.length;
        const productMenuCounter = document.querySelector('header .small-btn-icon__count');
        if (productMenuCounter) {
            let previousCheckoutValue = 0;
            const checkAndUpdate = ()=>{
                let totalCheckoutValue = 0;
                productsArr.forEach((productEl)=>{
                    const checkoutInput = productEl.querySelector('.checkout-input');
                    if (checkoutInput) {
                        const value = parseFloat(checkoutInput.value) || 0;
                        totalCheckoutValue += value;
                    }
                });
                if (totalCheckoutValue !== previousCheckoutValue) {
                    /*console.log('checkoutInput:', totalCheckoutValue);*/ previousCheckoutValue = totalCheckoutValue;
                    productMenuCounter.textContent = `${totalCheckoutValue}`;
                }
            };
            checkAndUpdate();
            setInterval(checkAndUpdate, 1000);
            if (productCount >= 1) productMenuCounter.classList.remove('is-hidden');
            else productMenuCounter.classList.add('is-hidden');
        }
        if (!$6b3169d24286edc1$var$cartComponent.classList.contains('is-open') && productCount > 0) {
            /*console.log(productCount);*/ productsArr.forEach((item)=>item.classList.remove('hidden'));
            let threshold = window.innerHeight > 800 ? 3 : 2;
            if (productCount > threshold) {
                cartListMoreCounter.textContent = `${productCount - threshold}`;
                for(let i = threshold; i < productsArr.length; i++)productsArr[i].classList.add('hidden');
                cartListMoreShowEl.classList.remove('hidden');
                cartListMoreNotShowEl.classList.add('hidden');
            } else {
                cartListMoreCounter.textContent = '0';
                cartListMoreShowEl.classList.add('hidden');
                cartListMoreNotShowEl.classList.remove('hidden');
            }
        }
        scrollListCalc();
    };
    moreCounterFunc();
    window.addEventListener('resize', scrollListCalc);
}
window.closeCartGlobal = function closeCartGlobal() {
    if ($6b3169d24286edc1$var$cartComponent) {
        $6b3169d24286edc1$var$cartComponent.classList.remove('is-open');
        moreCounterFunc();
        setTimeout(function() {
            $6b3169d24286edc1$var$cartComponent.style.zIndex = 800;
        }, 500);
    }
};
window.checkoutCartItems = function checkoutCartItems() {
    const checkoutBtn = document.querySelector('.cart-container .cart-checkout-btn');
    const checkoutListItemArr = document.querySelectorAll('.cart-container .cart__item');
    const notProductsContent = document.querySelector('.cart-container .cart__not-products-container');
    if (document.querySelector('.cart-container')) {
        if (checkoutListItemArr.length >= 1) {
            notProductsContent.classList.remove('is-visible');
            moreCounterFunc();
        } else notProductsContent.classList.add('is-visible');
    }
    updateCardsFunc();
};
window.updateCardsFunc = function updateCardsFunc1() {
    if (document.querySelector('.cart__list')) {
        const cards = document.querySelectorAll('.product-card');
        cards.forEach((card)=>{
            if (card.classList.contains('is-open-counter')) {
                const input = card.querySelector('.checkout-input');
                const btnCounter = card.querySelector('.product-card__btn-counter');
                if (input && input.value < 1 || input && input.value === '') {
                    card.classList.remove('is-open-counter');
                    if (btnCounter) btnCounter.classList.remove('active');
                }
            }
        });
    }
}; /*setTimeout(function () {
  checkoutCartItems();
}, 1000);*/ 


window.productCardsFunc = function productCardsFunc1() {
    if (document.querySelector('.product-card')) {
        const productCardsArr = document.querySelectorAll('.product-card');
        productCardsArr.forEach((card)=>{
            if (!card.classList.contains('is-init')) {
                card.classList.add('is-init');
                const counterBlock = card.querySelector('.product-card__btn-counter');
                const btn = card.querySelector('.btn-second');
                const btnIcon = counterBlock.querySelector('.btn-icon');
                const input = counterBlock.querySelector('input');
                const favoriteBtn = card.querySelector('.product-card__favorite');
                const favoriteBtnIcon = card.querySelector('.product-card__favorite i');
                if (input && input.value !== '') {
                    if (counterBlock) {
                        counterBlock.classList.add('active');
                        card.classList.add('is-open-counter');
                    }
                }
                if (btn) btn.addEventListener('click', ()=>{
                    // console.log(input.value);
                    if (counterBlock) {
                        counterBlock.classList.add('active');
                        card.classList.add('is-open-counter');
                    }
                    if (input && input.value < 1 || input && input.value === '') {
                        input.value = '0';
                        // console.log(input.value);
                        input.stepUp();
                    }
                });
                if (btnIcon) btnIcon.addEventListener('click', ()=>{
                    // console.log(input.value);
                    if (counterBlock) {
                        counterBlock.classList.add('active');
                        card.classList.add('is-open-counter');
                    }
                    if (input && input.value < 1 || input && input.value === '') {
                        input.value = '0';
                        // console.log(input.value);
                        input.stepUp();
                    }
                });
                if (favoriteBtn) favoriteBtn.addEventListener('click', (e)=>{
                    e.preventDefault();
                    if (!document.querySelector('#site').classList.contains('not-authorized')) {
                        if (favoriteBtn.classList.contains('active')) {
                            favoriteBtn.classList.remove('active');
                            favoriteBtnIcon.classList.remove('icon-heart-fill');
                            favoriteBtnIcon.classList.add('icon-heart');
                        } else {
                            favoriteBtn.classList.add('active');
                            favoriteBtnIcon.classList.remove('icon-heart');
                            favoriteBtnIcon.classList.add('icon-heart-fill');
                        }
                    }
                });
            }
        });
        setTimeout(function() {
            const productCardsTitlesArr = document.querySelectorAll('.product-card__title');
            if (productCardsTitlesArr.length > 0) {
                let maxHeight = 0;
                productCardsTitlesArr.forEach((title)=>{
                    const height = title.offsetHeight;
                    if (height > maxHeight) maxHeight = height;
                });
                productCardsTitlesArr.forEach((title)=>{
                    title.style.minHeight = `${maxHeight}px`;
                });
            }
        }, 50);
    }
};
productCardsFunc();
const $5f26265bff9b74ae$var$productRecipeContainer = document.querySelector('.product-section__container');
if ($5f26265bff9b74ae$var$productRecipeContainer) {
    const productInstructionsEl = document.querySelector('.product-section__instruction');
    if (productInstructionsEl) {
        const productInstructionsCountsArr = $5f26265bff9b74ae$var$productRecipeContainer.querySelectorAll('.product-section__instruction-count');
        productInstructionsCountsArr.forEach((count, i)=>{
            count.textContent = `${i + 1}`;
        });
    }
}
window.relatedCardsFunc = function relatedCardsFunc() {
    if (document.querySelector('.product-card')) {
        const cards = document.querySelectorAll('.product-card');
        cards.forEach((card)=>{
            const relatedContent = card.querySelector('.product-card__related');
            if (relatedContent) card.classList.add('is-related-products');
            else card.classList.remove('is-related-products');
        });
    }
};
window.relatedBtnAdd = function relatedBtnAdd(id) {
    const btn = document.getElementById(id);
    btn.classList.add('is-added');
};
window.relatedBtnRemove = function relatedBtnRemove(id) {
    const btn = document.getElementById(id);
    btn.classList.remove('is-added');
};


window.choicesArray = [];
window.initChoices = function initChoices(elementsArr) {
    const choicesDOM = document.querySelector(elementsArr);
    if (choicesDOM) {
        const choicesArr = document.querySelectorAll(`${elementsArr}`);
        for(let i = 0; i < choicesArr.length; i++){
            // console.log('init');
            const parentContainer = choicesArr[i].parentNode;
            /*const list = parentContainer.querySelector(".default-select__list");*/ const choices = new Choices(choicesArr[i], {
                searchEnabled: false,
                itemSelectText: '',
                placeholder: true,
                searchPlaceholderValue: 'Search',
                shouldSort: false
            });
            choicesArray.push(choices);
            /* if(choicesArr[i].classList.contains('personal-city-select')) {
        choices.passedElement.element.addEventListener('change', function (event) {
          console.log('Выбранное значение:', event.target.value);
        });
      }*/ const choicesMultipleElement = parentContainer.querySelector(".choices[data-type='select-multiple']");
            if (choicesMultipleElement) choicesMultipleElement.addEventListener('click', ()=>{
                if (parentContainer.querySelector('.is-open')) choices.hideDropdown();
            });
            /* New multiselect logic */ if (choicesArr[i].multiple && choicesArr[i].hasAttribute('data-multiple-list-logic')) {
                let optionName = null;
                let optionValue = null;
                const multiplePlaceholder = parentContainer.querySelector('.choices__list--multiple');
                const list = document.createElement('ul');
                list.className = 'meta-select__list';
                parentContainer.appendChild(list);
                function createListItem(optionName, optionValue) {
                    const listItem = document.createElement('li');
                    listItem.setAttribute('data-val', optionValue);
                    listItem.innerHTML = `${optionName}`;
                    listItem.classList.add('meta-select__list-item');
                    list.appendChild(listItem);
                    listItem.addEventListener('click', ()=>{
                        handleListItemClick(listItem);
                    });
                }
                function handleSelectedOptions() {
                    list.innerHTML = '';
                    const selectedOptions = Array.from(choicesArr[i].selectedOptions);
                    if (selectedOptions.length >= 1) list.classList.add('is-visible');
                    else list.classList.remove('is-visible');
                    if (selectedOptions.length === 0 && !choicesArr[i].multiple) choices.setChoiceByValue('');
                    selectedOptions.forEach(function(option) {
                        optionName = option.textContent;
                        optionValue = option.value;
                        if (optionName !== 'Select') createListItem(optionName, optionValue);
                    });
                    const listArr = list.querySelectorAll('.meta-select__list-item');
                    if (listArr.length === 1) multiplePlaceholder.textContent = optionName;
                    else if (listArr.length >= 2) multiplePlaceholder.textContent = `Selected ${listArr.length} items`;
                    else multiplePlaceholder.textContent = 'Select';
                }
                function handleListItemClick(listItem) {
                    const optionValue = listItem.getAttribute('data-val');
                    choices.removeActiveItemsByValue(optionValue);
                    handleSelectedOptions();
                }
                handleSelectedOptions();
                choicesArr[i].addEventListener('change', function() {
                    handleSelectedOptions();
                });
                list.addEventListener('click', function(event) {
                    const liElement = event.target.closest('.meta-select__list-item');
                    if (liElement) handleListItemClick(liElement);
                });
            }
        }
    }
};
window.initChoices('[data-choices]');
window.getChoice = function getChoice1(select) {
    let selectEl = typeof select === 'object' ? select : document.querySelector(select);
    let choicesArr = window.choicesArray;
    let targetChoice;
    if (choicesArr) window.choicesArray.forEach((choices)=>{
        let choicesSelect = choices.passedElement.element;
        if (choicesSelect == selectEl) targetChoice = choices;
    });
    return targetChoice;
};
window.resetChoice = function resetChoice(select) {
    let choice = getChoice(select);
    if (choice) {
        let startValue = choice.config.choices[0].value;
        choice.setChoiceByValue(startValue);
    }
};


/**
 * Swiper 8.4.7
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: January 30, 2023
 */ /* eslint no-param-reassign: "off" */ 
var $4acFp = parcelRequire("4acFp");

var $5apVM = parcelRequire("5apVM");
const $90a9de1e3d9f56dd$var$Methods = {
    addClass: $5apVM.addClass,
    removeClass: $5apVM.removeClass,
    hasClass: $5apVM.hasClass,
    toggleClass: $5apVM.toggleClass,
    attr: $5apVM.attr,
    removeAttr: $5apVM.removeAttr,
    transform: $5apVM.transform,
    transition: $5apVM.transition,
    on: $5apVM.on,
    off: $5apVM.off,
    trigger: $5apVM.trigger,
    transitionEnd: $5apVM.transitionEnd,
    outerWidth: $5apVM.outerWidth,
    outerHeight: $5apVM.outerHeight,
    styles: $5apVM.styles,
    offset: $5apVM.offset,
    css: $5apVM.css,
    each: $5apVM.each,
    html: $5apVM.html,
    text: $5apVM.text,
    is: $5apVM.is,
    index: $5apVM.index,
    eq: $5apVM.eq,
    append: $5apVM.append,
    prepend: $5apVM.prepend,
    next: $5apVM.next,
    nextAll: $5apVM.nextAll,
    prev: $5apVM.prev,
    prevAll: $5apVM.prevAll,
    parent: $5apVM.parent,
    parents: $5apVM.parents,
    closest: $5apVM.closest,
    find: $5apVM.find,
    children: $5apVM.children,
    filter: $5apVM.filter,
    remove: $5apVM.remove
};
Object.keys($90a9de1e3d9f56dd$var$Methods).forEach((methodName)=>{
    Object.defineProperty((0, $5apVM.$).fn, methodName, {
        value: $90a9de1e3d9f56dd$var$Methods[methodName],
        writable: true
    });
});
var $90a9de1e3d9f56dd$export$2e2bcd8739ae039 = (0, $5apVM.$);



var $4acFp = parcelRequire("4acFp");
function $b254fe4b7c9c1178$export$8694e5c03a4df8e6(obj) {
    const object = obj;
    Object.keys(object).forEach((key)=>{
        try {
            object[key] = null;
        } catch (e) {}
        try {
            delete object[key];
        } catch (e) {}
    });
}
function $b254fe4b7c9c1178$export$bdd553fddd433dcb(callback, delay = 0) {
    return setTimeout(callback, delay);
}
function $b254fe4b7c9c1178$export$461939dd4422153() {
    return Date.now();
}
function $b254fe4b7c9c1178$export$3735103072e4a80(el) {
    const window1 = (0, $4acFp.getWindow)();
    let style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $b254fe4b7c9c1178$export$5ec402b7fcf74398(el, axis = 'x') {
    const window1 = (0, $4acFp.getWindow)();
    let matrix;
    let curTransform;
    let transformMatrix;
    const curStyle = $b254fe4b7c9c1178$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(',').length > 6) curTransform = curTransform.split(', ').map((a)=>a.replace(',', '.')).join(', ');
         // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === 'none' ? '' : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue('transform').replace('translate(', 'matrix(1, 0, 0, 1,');
        matrix = transformMatrix.toString().split(',');
    }
    if (axis === 'x') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]); // Normal Browsers
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === 'y') {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42; // Crazy IE10 Matrix
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]); // Normal Browsers
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $b254fe4b7c9c1178$export$a6cdc56e425d0d0a(o) {
    return typeof o === 'object' && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === 'Object';
}
function $b254fe4b7c9c1178$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== 'undefined' && typeof window.HTMLElement !== 'undefined') return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $b254fe4b7c9c1178$export$8b58be045bf06082(...args) {
    const to = Object(args[0]);
    const noExtend = [
        '__proto__',
        'constructor',
        'prototype'
    ];
    for(let i = 1; i < args.length; i += 1){
        const nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$b254fe4b7c9c1178$var$isNode(nextSource)) {
            const keysArray = Object.keys(Object(nextSource)).filter((key)=>noExtend.indexOf(key) < 0);
            for(let nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                const nextKey = keysArray[nextIndex];
                const desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($b254fe4b7c9c1178$export$a6cdc56e425d0d0a(to[nextKey]) && $b254fe4b7c9c1178$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b254fe4b7c9c1178$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$b254fe4b7c9c1178$export$a6cdc56e425d0d0a(to[nextKey]) && $b254fe4b7c9c1178$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $b254fe4b7c9c1178$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    }
    return to;
}
function $b254fe4b7c9c1178$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $b254fe4b7c9c1178$export$a5dd2b4b1a116d6d({ swiper: swiper, targetPosition: targetPosition, side: side }) {
    const window1 = (0, $4acFp.getWindow)();
    const startPosition = -swiper.translate;
    let startTime = null;
    let time;
    const duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = 'none';
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    const dir = targetPosition > startPosition ? 'next' : 'prev';
    const isOutOfBound = (current, target)=>{
        return dir === 'next' && current >= target || dir === 'prev' && current <= target;
    };
    const animate = ()=>{
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        const progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        const easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        let currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo({
            [side]: currentPosition
        });
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.scrollSnapType = '';
            setTimeout(()=>{
                swiper.wrapperEl.style.overflow = '';
                swiper.wrapperEl.scrollTo({
                    [side]: currentPosition
                });
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}



var $4acFp = parcelRequire("4acFp");
let $23cabd961154dd1d$var$support;
function $23cabd961154dd1d$var$calcSupport() {
    const window = (0, $4acFp.getWindow)();
    const document = (0, $4acFp.getDocument)();
    return {
        smoothScroll: document.documentElement && 'scrollBehavior' in document.documentElement.style,
        touch: !!('ontouchstart' in window || window.DocumentTouch && document instanceof window.DocumentTouch),
        passiveListener: function checkPassiveListener() {
            let supportsPassive = false;
            try {
                const opts = Object.defineProperty({}, 'passive', {
                    // eslint-disable-next-line
                    get () {
                        supportsPassive = true;
                    }
                });
                window.addEventListener('testPassiveListener', null, opts);
            } catch (e) {}
            return supportsPassive;
        }(),
        gestures: function checkGestures() {
            return 'ongesturestart' in window;
        }()
    };
}
function $23cabd961154dd1d$export$d61c7b85ff180578() {
    if (!$23cabd961154dd1d$var$support) $23cabd961154dd1d$var$support = $23cabd961154dd1d$var$calcSupport();
    return $23cabd961154dd1d$var$support;
}



var $4acFp = parcelRequire("4acFp");

let $1d5a11620700da71$var$deviceCached;
function $1d5a11620700da71$var$calcDevice({ userAgent: userAgent } = {}) {
    const support = (0, $23cabd961154dd1d$export$d61c7b85ff180578)();
    const window = (0, $4acFp.getWindow)();
    const platform = window.navigator.platform;
    const ua = userAgent || window.navigator.userAgent;
    const device = {
        ios: false,
        android: false
    };
    const screenWidth = window.screen.width;
    const screenHeight = window.screen.height;
    const android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    let ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    const ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    const iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    const windows = platform === 'Win32';
    let macos = platform === 'MacIntel'; // iPadOs 13 fix
    const iPadScreens = [
        '1024x1366',
        '1366x1024',
        '834x1194',
        '1194x834',
        '834x1112',
        '1112x834',
        '768x1024',
        '1024x768',
        '820x1180',
        '1180x820',
        '810x1080',
        '1080x810'
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf(`${screenWidth}x${screenHeight}`) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            '13_0_0'
        ];
        macos = false;
    } // Android
    if (android && !windows) {
        device.os = 'android';
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = 'ios';
        device.ios = true;
    } // Export object
    return device;
}
function $1d5a11620700da71$export$30c823bc834d6ab4(overrides = {}) {
    if (!$1d5a11620700da71$var$deviceCached) $1d5a11620700da71$var$deviceCached = $1d5a11620700da71$var$calcDevice(overrides);
    return $1d5a11620700da71$var$deviceCached;
}



var $4acFp = parcelRequire("4acFp");
let $251e4c8fce621376$var$browser;
function $251e4c8fce621376$var$calcBrowser() {
    const window = (0, $4acFp.getWindow)();
    function isSafari() {
        const ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf('safari') >= 0 && ua.indexOf('chrome') < 0 && ua.indexOf('android') < 0;
    }
    return {
        isSafari: isSafari(),
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $251e4c8fce621376$export$89e15fc796a4a429() {
    if (!$251e4c8fce621376$var$browser) $251e4c8fce621376$var$browser = $251e4c8fce621376$var$calcBrowser();
    return $251e4c8fce621376$var$browser;
}



var $4acFp = parcelRequire("4acFp");
function $4d70267c217bac06$export$2e2bcd8739ae039({ swiper: swiper, on: on, emit: emit }) {
    const window = (0, $4acFp.getWindow)();
    let observer = null;
    let animationFrame = null;
    const resizeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('beforeResize');
        emit('resize');
    };
    const createObserver = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver((entries)=>{
            animationFrame = window.requestAnimationFrame(()=>{
                const { width: width, height: height } = swiper;
                let newWidth = width;
                let newHeight = height;
                entries.forEach(({ contentBoxSize: contentBoxSize, contentRect: contentRect, target: target })=>{
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    const removeObserver = ()=>{
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    const orientationChangeHandler = ()=>{
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit('orientationchange');
    };
    on('init', ()=>{
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== 'undefined') {
            createObserver();
            return;
        }
        window.addEventListener('resize', resizeHandler);
        window.addEventListener('orientationchange', orientationChangeHandler);
    });
    on('destroy', ()=>{
        removeObserver();
        window.removeEventListener('resize', resizeHandler);
        window.removeEventListener('orientationchange', orientationChangeHandler);
    });
}



var $4acFp = parcelRequire("4acFp");
function $d0e6f8dae4d7097b$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const observers = [];
    const window = (0, $4acFp.getWindow)();
    const attach = (target, options = {})=>{
        const ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        const observer = new ObserverFunc((mutations)=>{
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (mutations.length === 1) {
                emit('observerUpdate', mutations[0]);
                return;
            }
            const observerUpdate = function observerUpdate() {
                emit('observerUpdate', mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === 'undefined' ? true : options.attributes,
            childList: typeof options.childList === 'undefined' ? true : options.childList,
            characterData: typeof options.characterData === 'undefined' ? true : options.characterData
        });
        observers.push(observer);
    };
    const init = ()=>{
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            const containerParents = swiper.$el.parents();
            for(let i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        } // Observe container
        attach(swiper.$el[0], {
            childList: swiper.params.observeSlideChildren
        }); // Observe wrapper
        attach(swiper.$wrapperEl[0], {
            attributes: false
        });
    };
    const destroy = ()=>{
        observers.forEach((observer)=>{
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on('init', init);
    on('destroy', destroy);
}


/* eslint-disable no-underscore-dangle */ var $74b464c34803e653$export$2e2bcd8739ae039 = {
    on (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        events.split(' ').forEach((event)=>{
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once (events, handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        function onceHandler(...args) {
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny (handler, priority) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== 'function') return self;
        const method = priority ? 'unshift' : 'push';
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny (handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        const index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off (events, handler) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(' ').forEach((event)=>{
            if (typeof handler === 'undefined') self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler, index)=>{
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit (...args) {
        const self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        let events;
        let data;
        let context;
        if (typeof args[0] === 'string' || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        const eventsArray = Array.isArray(events) ? events : events.split(' ');
        eventsArray.forEach((event)=>{
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach((eventHandler)=>{
                eventHandler.apply(context, [
                    event,
                    ...data
                ]);
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach((eventHandler)=>{
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};


function $b96a7e23bdc0c3e1$export$2e2bcd8739ae039() {
    const swiper = this;
    let width;
    let height;
    const $el = swiper.$el;
    if (typeof swiper.params.width !== 'undefined' && swiper.params.width !== null) width = swiper.params.width;
    else width = $el[0].clientWidth;
    if (typeof swiper.params.height !== 'undefined' && swiper.params.height !== null) height = swiper.params.height;
    else height = $el[0].clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
     // Subtract paddings
    width = width - parseInt($el.css('padding-left') || 0, 10) - parseInt($el.css('padding-right') || 0, 10);
    height = height - parseInt($el.css('padding-top') || 0, 10) - parseInt($el.css('padding-bottom') || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $0d8e0e75b56b918a$export$2e2bcd8739ae039() {
    const swiper = this;
    function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
         // prettier-ignore
        return ({
            'width': 'height',
            'margin-top': 'margin-left',
            'margin-bottom ': 'margin-right',
            'margin-left': 'margin-top',
            'margin-right': 'margin-bottom',
            'padding-left': 'padding-top',
            'padding-right': 'padding-bottom',
            'marginRight': 'marginBottom'
        })[property];
    }
    function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    }
    const params = swiper.params;
    const { $wrapperEl: $wrapperEl, size: swiperSize, rtlTranslate: rtl, wrongRTL: wrongRTL } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    const previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    const slides = $wrapperEl.children(`.${swiper.params.slideClass}`);
    const slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    let snapGrid = [];
    const slidesGrid = [];
    const slidesSizesGrid = [];
    let offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === 'function') offsetBefore = params.slidesOffsetBefore.call(swiper);
    let offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === 'function') offsetAfter = params.slidesOffsetAfter.call(swiper);
    const previousSnapGridLength = swiper.snapGrid.length;
    const previousSlidesGridLength = swiper.slidesGrid.length;
    let spaceBetween = params.spaceBetween;
    let slidePosition = -offsetBefore;
    let prevSlideSize = 0;
    let index = 0;
    if (typeof swiperSize === 'undefined') return;
    if (typeof spaceBetween === 'string' && spaceBetween.indexOf('%') >= 0) spaceBetween = parseFloat(spaceBetween.replace('%', '')) / 100 * swiperSize;
    swiper.virtualSize = -spaceBetween; // reset margins
    if (rtl) slides.css({
        marginLeft: '',
        marginBottom: '',
        marginTop: ''
    });
    else slides.css({
        marginRight: '',
        marginBottom: '',
        marginTop: ''
    }); // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', '');
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', '');
    }
    const gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
     // Calc slides
    let slideSize;
    const shouldResetSlideSize = params.slidesPerView === 'auto' && params.breakpoints && Object.keys(params.breakpoints).filter((key)=>{
        return typeof params.breakpoints[key].slidesPerView !== 'undefined';
    }).length > 0;
    for(let i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        const slide = slides.eq(i);
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slide.css('display') === 'none') continue; // eslint-disable-line
        if (params.slidesPerView === 'auto') {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel('width')] = ``;
            const slideStyles = getComputedStyle(slide[0]);
            const currentTransform = slide[0].style.transform;
            const currentWebKitTransform = slide[0].style.webkitTransform;
            if (currentTransform) slide[0].style.transform = 'none';
            if (currentWebKitTransform) slide[0].style.webkitTransform = 'none';
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? slide.outerWidth(true) : slide.outerHeight(true);
            else {
                // eslint-disable-next-line
                const width = getDirectionPropertyValue(slideStyles, 'width');
                const paddingLeft = getDirectionPropertyValue(slideStyles, 'padding-left');
                const paddingRight = getDirectionPropertyValue(slideStyles, 'padding-right');
                const marginLeft = getDirectionPropertyValue(slideStyles, 'margin-left');
                const marginRight = getDirectionPropertyValue(slideStyles, 'margin-right');
                const boxSizing = slideStyles.getPropertyValue('box-sizing');
                if (boxSizing && boxSizing === 'border-box') slideSize = width + marginLeft + marginRight;
                else {
                    const { clientWidth: clientWidth, offsetWidth: offsetWidth } = slide[0];
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide[0].style.transform = currentTransform;
            if (currentWebKitTransform) slide[0].style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel('width')] = `${slideSize}px`;
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === 'slide' || params.effect === 'coverflow')) $wrapperEl.css({
        width: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (params.setWrapperSize) $wrapperEl.css({
        [getDirectionLabel('width')]: `${swiper.virtualSize + params.spaceBetween}px`
    });
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
     // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        const newSlidesGrid = [];
        for(let i = 0; i < snapGrid.length; i += 1){
            let slidesGridItem = snapGrid[i];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (params.spaceBetween !== 0) {
        const key = swiper.isHorizontal() && rtl ? 'marginLeft' : getDirectionLabel('marginRight');
        slides.filter((_, slideIndex)=>{
            if (!params.cssMode) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).css({
            [key]: `${spaceBetween}px`
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        const maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map((snap)=>{
            if (snap < 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        let allSlidesSize = 0;
        slidesSizesGrid.forEach((slideSizeValue)=>{
            allSlidesSize += slideSizeValue + (params.spaceBetween ? params.spaceBetween : 0);
        });
        allSlidesSize -= params.spaceBetween;
        if (allSlidesSize < swiperSize) {
            const allSlidesOffset = (swiperSize - allSlidesSize) / 2;
            snapGrid.forEach((snap, snapIndex)=>{
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach((snap, snapIndex)=>{
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-before', `${-snapGrid[0]}px`);
        (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-centered-offset-after', `${swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2}px`);
        const addToSnapGrid = -swiper.snapGrid[0];
        const addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map((v)=>v + addToSnapGrid);
        swiper.slidesGrid = swiper.slidesGrid.map((v)=>v + addToSlidesGrid);
    }
    if (slidesLength !== previousSlidesLength) swiper.emit('slidesLengthChange');
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit('snapGridLengthChange');
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit('slidesGridLengthChange');
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === 'slide' || params.effect === 'fade')) {
        const backFaceHiddenClass = `${params.containerModifierClass}backface-hidden`;
        const hasClassBackfaceClassAdded = swiper.$el.hasClass(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.$el.addClass(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.$el.removeClass(backFaceHiddenClass);
    }
}



function $fc0231be1e9178c0$export$2e2bcd8739ae039(speed) {
    const swiper = this;
    const activeSlides = [];
    const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    let newHeight = 0;
    let i;
    if (typeof speed === 'number') swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    const getSlideByIndex = (index)=>{
        if (isVirtual) return swiper.slides.filter((el)=>parseInt(el.getAttribute('data-swiper-slide-index'), 10) === index)[0];
        return swiper.slides.eq(index)[0];
    }; // Find slides currently in view
    if (swiper.params.slidesPerView !== 'auto' && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)([])).each((slide)=>{
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            const index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
     // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== 'undefined') {
        const height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
     // Update Height
    if (newHeight || newHeight === 0) swiper.$wrapperEl.css('height', `${newHeight}px`);
}


function $11d42bb20eb9d9eb$export$2e2bcd8739ae039() {
    const swiper = this;
    const slides = swiper.slides;
    for(let i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop;
}



function $6c97f7622d9f4ced$export$2e2bcd8739ae039(translate = this && this.translate || 0) {
    const swiper = this;
    const params = swiper.params;
    const { slides: slides, rtlTranslate: rtl, snapGrid: snapGrid } = swiper;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === 'undefined') swiper.updateSlidesOffset();
    let offsetCenter = -translate;
    if (rtl) offsetCenter = translate; // Visible Slides
    slides.removeClass(params.slideVisibleClass);
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    for(let i = 0; i < slides.length; i += 1){
        const slide = slides[i];
        let slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        const slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + params.spaceBetween);
        const slideBefore = -(offsetCenter - slideOffset);
        const slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        const isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides.eq(i).addClass(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
    swiper.visibleSlides = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.visibleSlides);
}


function $8d57fff72a19789d$export$2e2bcd8739ae039(translate) {
    const swiper = this;
    if (typeof translate === 'undefined') {
        const multiplier = swiper.rtlTranslate ? -1 : 1; // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    const params = swiper.params;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    let { progress: progress, isBeginning: isBeginning, isEnd: isEnd } = swiper;
    const wasBeginning = isBeginning;
    const wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        isBeginning = progress <= 0;
        isEnd = progress >= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit('reachBeginning toEdge');
    if (isEnd && !wasEnd) swiper.emit('reachEnd toEdge');
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit('fromEdge');
    swiper.emit('progress', progress);
}


function $d271fe0693747d09$export$2e2bcd8739ae039() {
    const swiper = this;
    const { slides: slides, params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex, realIndex: realIndex } = swiper;
    const isVirtual = swiper.virtual && params.virtual.enabled;
    slides.removeClass(`${params.slideActiveClass} ${params.slideNextClass} ${params.slidePrevClass} ${params.slideDuplicateActiveClass} ${params.slideDuplicateNextClass} ${params.slideDuplicatePrevClass}`);
    let activeSlide;
    if (isVirtual) activeSlide = swiper.$wrapperEl.find(`.${params.slideClass}[data-swiper-slide-index="${activeIndex}"]`);
    else activeSlide = slides.eq(activeIndex);
     // Active classes
    activeSlide.addClass(params.slideActiveClass);
    if (params.loop) {
        // Duplicate to all looped slides
        if (activeSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${realIndex}"]`).addClass(params.slideDuplicateActiveClass);
    } // Next Slide
    let nextSlide = activeSlide.nextAll(`.${params.slideClass}`).eq(0).addClass(params.slideNextClass);
    if (params.loop && nextSlide.length === 0) {
        nextSlide = slides.eq(0);
        nextSlide.addClass(params.slideNextClass);
    } // Prev Slide
    let prevSlide = activeSlide.prevAll(`.${params.slideClass}`).eq(0).addClass(params.slidePrevClass);
    if (params.loop && prevSlide.length === 0) {
        prevSlide = slides.eq(-1);
        prevSlide.addClass(params.slidePrevClass);
    }
    if (params.loop) {
        // Duplicate to all looped slides
        if (nextSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${nextSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicateNextClass);
        if (prevSlide.hasClass(params.slideDuplicateClass)) $wrapperEl.children(`.${params.slideClass}:not(.${params.slideDuplicateClass})[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
        else $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass}[data-swiper-slide-index="${prevSlide.attr('data-swiper-slide-index')}"]`).addClass(params.slideDuplicatePrevClass);
    }
    swiper.emitSlidesClasses();
}


function $2859f72c9b0c677a$export$2e2bcd8739ae039(newActiveIndex) {
    const swiper = this;
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    const { slidesGrid: slidesGrid, snapGrid: snapGrid, params: params, activeIndex: previousIndex, realIndex: previousRealIndex, snapIndex: previousSnapIndex } = swiper;
    let activeIndex = newActiveIndex;
    let snapIndex;
    if (typeof activeIndex === 'undefined') {
        for(let i = 0; i < slidesGrid.length; i += 1){
            if (typeof slidesGrid[i + 1] !== 'undefined') {
                if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
                else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
            } else if (translate >= slidesGrid[i]) activeIndex = i;
        } // Normalize slideIndex
        if (params.normalizeSlideIndex) {
            if (activeIndex < 0 || typeof activeIndex === 'undefined') activeIndex = 0;
        }
    }
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        const skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit('snapIndexChange');
        }
        return;
    } // Get real index
    const realIndex = parseInt(swiper.slides.eq(activeIndex).attr('data-swiper-slide-index') || activeIndex, 10);
    Object.assign(swiper, {
        snapIndex: snapIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    swiper.emit('activeIndexChange');
    swiper.emit('snapIndexChange');
    if (previousRealIndex !== realIndex) swiper.emit('realIndexChange');
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit('slideChange');
}



function $fb52046cc124fe07$export$2e2bcd8739ae039(e) {
    const swiper = this;
    const params = swiper.params;
    const slide = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e).closest(`.${params.slideClass}`)[0];
    let slideFound = false;
    let slideIndex;
    if (slide) {
        for(let i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slide).attr('data-swiper-slide-index'), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $8f4a1bd5616070ce$export$2e2bcd8739ae039 = {
    updateSize: $b96a7e23bdc0c3e1$export$2e2bcd8739ae039,
    updateSlides: $0d8e0e75b56b918a$export$2e2bcd8739ae039,
    updateAutoHeight: $fc0231be1e9178c0$export$2e2bcd8739ae039,
    updateSlidesOffset: $11d42bb20eb9d9eb$export$2e2bcd8739ae039,
    updateSlidesProgress: $6c97f7622d9f4ced$export$2e2bcd8739ae039,
    updateProgress: $8d57fff72a19789d$export$2e2bcd8739ae039,
    updateSlidesClasses: $d271fe0693747d09$export$2e2bcd8739ae039,
    updateActiveIndex: $2859f72c9b0c677a$export$2e2bcd8739ae039,
    updateClickedSlide: $fb52046cc124fe07$export$2e2bcd8739ae039
};



function $60df7d7ac2ffbb4e$export$2e2bcd8739ae039(axis = this.isHorizontal() ? 'x' : 'y') {
    const swiper = this;
    const { params: params, rtlTranslate: rtl, translate: translate, $wrapperEl: $wrapperEl } = swiper;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    let currentTranslate = (0, $b254fe4b7c9c1178$export$5ec402b7fcf74398)($wrapperEl[0], axis);
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $e7445ee6d3074e4c$export$2e2bcd8739ae039(translate, byController) {
    const swiper = this;
    const { rtlTranslate: rtl, params: params, $wrapperEl: $wrapperEl, wrapperEl: wrapperEl, progress: progress } = swiper;
    let x = 0;
    let y = 0;
    const z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? 'scrollLeft' : 'scrollTop'] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) $wrapperEl.transform(`translate3d(${x}px, ${y}px, ${z}px)`);
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y; // Check if we need to update progress
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit('setTranslate', swiper.translate, byController);
}


function $d56e9d558de83ab3$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $d54ad53b6e1f47e6$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



function $ab9b0648313b094c$export$2e2bcd8739ae039(translate = 0, speed = this.params.speed, runCallbacks = true, translateBounds = true, internal) {
    const swiper = this;
    const { params: params, wrapperEl: wrapperEl } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    const minTranslate = swiper.minTranslate();
    const maxTranslate = swiper.maxTranslate();
    let newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate; // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $b254fe4b7c9c1178$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: -newTranslate,
                behavior: 'smooth'
            });
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionEnd');
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit('beforeTransitionStart', speed, internal);
            swiper.emit('transitionStart');
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
                swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit('transitionEnd');
            };
            swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onTranslateToWrapperTransitionEnd);
            swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $9f58678d892afa12$export$2e2bcd8739ae039 = {
    getTranslate: $60df7d7ac2ffbb4e$export$2e2bcd8739ae039,
    setTranslate: $e7445ee6d3074e4c$export$2e2bcd8739ae039,
    minTranslate: $d56e9d558de83ab3$export$2e2bcd8739ae039,
    maxTranslate: $d54ad53b6e1f47e6$export$2e2bcd8739ae039,
    translateTo: $ab9b0648313b094c$export$2e2bcd8739ae039
};


function $e221a96f24e2daec$export$2e2bcd8739ae039(duration, byController) {
    const swiper = this;
    if (!swiper.params.cssMode) swiper.$wrapperEl.transition(duration);
    swiper.emit('setTransition', duration, byController);
}


function $6cbaeefea937afb9$export$2e2bcd8739ae039({ swiper: swiper, runCallbacks: runCallbacks, direction: direction, step: step }) {
    const { activeIndex: activeIndex, previousIndex: previousIndex } = swiper;
    let dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = 'next';
        else if (activeIndex < previousIndex) dir = 'prev';
        else dir = 'reset';
    }
    swiper.emit(`transition${step}`);
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === 'reset') {
            swiper.emit(`slideResetTransition${step}`);
            return;
        }
        swiper.emit(`slideChangeTransition${step}`);
        if (dir === 'next') swiper.emit(`slideNextTransition${step}`);
        else swiper.emit(`slidePrevTransition${step}`);
    }
}


function $109986cb6d9bdc87$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $6cbaeefea937afb9$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'Start'
    });
}



function $b103cd34ed644041$export$2e2bcd8739ae039(runCallbacks = true, direction) {
    const swiper = this;
    const { params: params } = swiper;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $6cbaeefea937afb9$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: 'End'
    });
}


var $3f2b868738e95e42$export$2e2bcd8739ae039 = {
    setTransition: $e221a96f24e2daec$export$2e2bcd8739ae039,
    transitionStart: $109986cb6d9bdc87$export$2e2bcd8739ae039,
    transitionEnd: $b103cd34ed644041$export$2e2bcd8739ae039
};



function $4d9dea3156e195f0$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal, initial) {
    if (typeof index !== 'number' && typeof index !== 'string') throw new Error(`The 'index' argument cannot have type other than 'number' or 'string'. [${typeof index}] given.`);
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    const { params: params, snapGrid: snapGrid, slidesGrid: slidesGrid, previousIndex: previousIndex, activeIndex: activeIndex, rtlTranslate: rtl, wrapperEl: wrapperEl, enabled: enabled } = swiper;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    let snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    const translate = -snapGrid[snapIndex]; // Normalize slideIndex
    if (params.normalizeSlideIndex) for(let i = 0; i < slidesGrid.length; i += 1){
        const normalizedTranslate = -Math.floor(translate * 100);
        const normalizedGrid = Math.floor(slidesGrid[i] * 100);
        const normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== 'undefined') {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
     // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && translate < swiper.translate && translate < swiper.minTranslate()) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit('beforeSlideChangeStart');
     // Update progress
    swiper.updateProgress(translate);
    let direction;
    if (slideIndex > activeIndex) direction = 'next';
    else if (slideIndex < activeIndex) direction = 'prev';
    else direction = 'reset'; // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex); // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== 'slide') swiper.setTranslate(translate);
        if (direction !== 'reset') {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        const isH = swiper.isHorizontal();
        const t = rtl ? translate : -translate;
        if (speed === 0) {
            const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = 'none';
                swiper._immediateVirtual = true;
            }
            wrapperEl[isH ? 'scrollLeft' : 'scrollTop'] = t;
            if (isVirtual) requestAnimationFrame(()=>{
                swiper.wrapperEl.style.scrollSnapType = '';
                swiper._swiperImmediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $b254fe4b7c9c1178$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? 'left' : 'top'
                });
                return true;
            }
            wrapperEl.scrollTo({
                [isH ? 'left' : 'top']: t,
                behavior: 'smooth'
            });
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit('beforeTransitionStart', speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.$wrapperEl[0].removeEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
            swiper.$wrapperEl[0].removeEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.$wrapperEl[0].addEventListener('transitionend', swiper.onSlideToWrapperTransitionEnd);
        swiper.$wrapperEl[0].addEventListener('webkitTransitionEnd', swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $9635d3c5e8c369f6$export$2e2bcd8739ae039(index = 0, speed = this.params.speed, runCallbacks = true, internal) {
    if (typeof index === 'string') {
        /**
     * The `index` argument converted from `string` to `number`.
     * @type {number}
     */ const indexAsNumber = parseInt(index, 10);
        /**
     * Determines whether the `index` argument is a valid `number`
     * after being converted from the `string` type.
     * @type {boolean}
     */ const isValidNumber = isFinite(indexAsNumber);
        if (!isValidNumber) throw new Error(`The passed-in 'index' (string) couldn't be converted to 'number'. [${index}] given.`);
         // Knowing that the converted `index` is a valid number,
        // we can update the original argument's value.
        index = indexAsNumber;
    }
    const swiper = this;
    let newIndex = index;
    if (swiper.params.loop) newIndex += swiper.loopedSlides;
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $af0b2a703a605a3e$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { animating: animating, enabled: enabled, params: params } = swiper;
    if (!enabled) return swiper;
    let perGroup = params.slidesPerGroup;
    if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic('current', true), 1);
    const increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $8e1a3d4ea0cb9e06$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    const { params: params, animating: animating, snapGrid: snapGrid, slidesGrid: slidesGrid, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return swiper;
    if (params.loop) {
        if (animating && params.loopPreventsSlide) return false;
        swiper.loopFix(); // eslint-disable-next-line
        swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
    }
    const translate = rtlTranslate ? swiper.translate : -swiper.translate;
    function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    }
    const normalizedTranslate = normalize(translate);
    const normalizedSnapGrid = snapGrid.map((val)=>normalize(val));
    let prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === 'undefined' && params.cssMode) {
        let prevSnapIndex;
        snapGrid.forEach((snap, snapIndex)=>{
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== 'undefined') prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    let prevIndex = 0;
    if (typeof prevSnap !== 'undefined') {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === 'auto' && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic('previous', true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        const lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $68e0ccc72a9aa9ef$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal) {
    const swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $ac7624697f897e03$export$2e2bcd8739ae039(speed = this.params.speed, runCallbacks = true, internal, threshold = 0.5) {
    const swiper = this;
    let index = swiper.activeIndex;
    const skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    const snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    const translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        const currentSnap = swiper.snapGrid[snapIndex];
        const nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        const prevSnap = swiper.snapGrid[snapIndex - 1];
        const currentSnap = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}




function $495e32765e97ad9d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl } = swiper;
    const slidesPerView = params.slidesPerView === 'auto' ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    let slideToIndex = swiper.clickedIndex;
    let realIndex;
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
                (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = $wrapperEl.children(`.${params.slideClass}[data-swiper-slide-index="${realIndex}"]:not(.${params.slideDuplicateClass})`).eq(0).index();
            (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $bc69c4bbb0402867$export$2e2bcd8739ae039 = {
    slideTo: $4d9dea3156e195f0$export$2e2bcd8739ae039,
    slideToLoop: $9635d3c5e8c369f6$export$2e2bcd8739ae039,
    slideNext: $af0b2a703a605a3e$export$2e2bcd8739ae039,
    slidePrev: $8e1a3d4ea0cb9e06$export$2e2bcd8739ae039,
    slideReset: $68e0ccc72a9aa9ef$export$2e2bcd8739ae039,
    slideToClosest: $ac7624697f897e03$export$2e2bcd8739ae039,
    slideToClickedSlide: $495e32765e97ad9d$export$2e2bcd8739ae039
};



var $4acFp = parcelRequire("4acFp");

function $66ecee90d80ea70f$export$2e2bcd8739ae039() {
    const swiper = this;
    const document = (0, $4acFp.getDocument)();
    const { params: params, $wrapperEl: $wrapperEl } = swiper; // Remove duplicated slides
    const $selector = $wrapperEl.children().length > 0 ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)($wrapperEl.children()[0].parentNode) : $wrapperEl;
    $selector.children(`.${params.slideClass}.${params.slideDuplicateClass}`).remove();
    let slides = $selector.children(`.${params.slideClass}`);
    if (params.loopFillGroupWithBlank) {
        const blankSlidesNum = params.slidesPerGroup - slides.length % params.slidesPerGroup;
        if (blankSlidesNum !== params.slidesPerGroup) {
            for(let i = 0; i < blankSlidesNum; i += 1){
                const blankNode = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document.createElement('div')).addClass(`${params.slideClass} ${params.slideBlankClass}`);
                $selector.append(blankNode);
            }
            slides = $selector.children(`.${params.slideClass}`);
        }
    }
    if (params.slidesPerView === 'auto' && !params.loopedSlides) params.loopedSlides = slides.length;
    swiper.loopedSlides = Math.ceil(parseFloat(params.loopedSlides || params.slidesPerView, 10));
    swiper.loopedSlides += params.loopAdditionalSlides;
    if (swiper.loopedSlides > slides.length && swiper.params.loopedSlidesLimit) swiper.loopedSlides = slides.length;
    const prependSlides = [];
    const appendSlides = [];
    slides.each((el, index)=>{
        const slide = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el);
        slide.attr('data-swiper-slide-index', index);
    });
    for(let i = 0; i < swiper.loopedSlides; i += 1){
        const index = i - Math.floor(i / slides.length) * slides.length;
        appendSlides.push(slides.eq(index)[0]);
        prependSlides.unshift(slides.eq(slides.length - index - 1)[0]);
    }
    for(let i = 0; i < appendSlides.length; i += 1)$selector.append((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(appendSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
    for(let i = prependSlides.length - 1; i >= 0; i -= 1)$selector.prepend((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(prependSlides[i].cloneNode(true)).addClass(params.slideDuplicateClass));
}


function $16d125a6f5791ce5$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.emit('beforeLoopFix');
    const { activeIndex: activeIndex, slides: slides, loopedSlides: loopedSlides, allowSlidePrev: allowSlidePrev, allowSlideNext: allowSlideNext, snapGrid: snapGrid, rtlTranslate: rtl } = swiper;
    let newIndex;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    const snapTranslate = -snapGrid[activeIndex];
    const diff = snapTranslate - swiper.getTranslate(); // Fix For Negative Oversliding
    if (activeIndex < loopedSlides) {
        newIndex = slides.length - loopedSlides * 3 + activeIndex;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    } else if (activeIndex >= slides.length - loopedSlides) {
        // Fix For Positive Oversliding
        newIndex = -slides.length + activeIndex + loopedSlides;
        newIndex += loopedSlides;
        const slideChanged = swiper.slideTo(newIndex, 0, false, true);
        if (slideChanged && diff !== 0) swiper.setTranslate((rtl ? -swiper.translate : swiper.translate) - diff);
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    swiper.emit('loopFix');
}


function $b75eb75dc08558ea$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, slides: slides } = swiper;
    $wrapperEl.children(`.${params.slideClass}.${params.slideDuplicateClass},.${params.slideClass}.${params.slideBlankClass}`).remove();
    slides.removeAttr('data-swiper-slide-index');
}


var $f929d5d48e6fbbb6$export$2e2bcd8739ae039 = {
    loopCreate: $66ecee90d80ea70f$export$2e2bcd8739ae039,
    loopFix: $16d125a6f5791ce5$export$2e2bcd8739ae039,
    loopDestroy: $b75eb75dc08558ea$export$2e2bcd8739ae039
};


function $e005bc3bd89ee5bb$export$2e2bcd8739ae039(moving) {
    const swiper = this;
    if (swiper.support.touch || !swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    const el = swiper.params.touchEventsTarget === 'container' ? swiper.el : swiper.wrapperEl;
    el.style.cursor = 'move';
    el.style.cursor = moving ? 'grabbing' : 'grab';
}


function $f01ee6c3f655d819$export$2e2bcd8739ae039() {
    const swiper = this;
    if (swiper.support.touch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    swiper[swiper.params.touchEventsTarget === 'container' ? 'el' : 'wrapperEl'].style.cursor = '';
}


var $90248c4085b54b52$export$2e2bcd8739ae039 = {
    setGrabCursor: $e005bc3bd89ee5bb$export$2e2bcd8739ae039,
    unsetGrabCursor: $f01ee6c3f655d819$export$2e2bcd8739ae039
};



var $4acFp = parcelRequire("4acFp");

var $4acFp = parcelRequire("4acFp");


function $b15d160745c3babc$var$closestElement(selector, base = this) {
    function __closestFrom(el) {
        if (!el || el === (0, $4acFp.getDocument)() || el === (0, $4acFp.getWindow)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        const found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $b15d160745c3babc$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const document = (0, $4acFp.getDocument)();
    const window = (0, $4acFp.getWindow)();
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, enabled: enabled } = swiper;
    if (!enabled) return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    let $targetEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target);
    if (params.touchEventsTarget === 'wrapper') {
        if (!$targetEl.closest(swiper.wrapperEl).length) return;
    }
    data.isTouchEvent = e.type === 'touchstart';
    if (!data.isTouchEvent && 'which' in e && e.which === 3) return;
    if (!data.isTouchEvent && 'button' in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return; // change target el for shadow root component
    const swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== ''; // eslint-disable-next-line
    const eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) $targetEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(eventPath[0]);
    const noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : `.${params.noSwipingClass}`;
    const isTargetShadow = !!(e.target && e.target.shadowRoot); // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $b15d160745c3babc$var$closestElement(noSwipingSelector, $targetEl[0]) : $targetEl.closest(noSwipingSelector)[0])) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!$targetEl.closest(params.swipeHandler)[0]) return;
    }
    touches.currentX = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
    touches.currentY = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    const startX = touches.currentX;
    const startY = touches.currentY; // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    const edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    const edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === 'prevent') event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    if (e.type !== 'touchstart') {
        let preventDefault = true;
        if ($targetEl.is(data.focusableElements)) {
            preventDefault = false;
            if ($targetEl[0].nodeName === 'SELECT') data.isTouched = false;
        }
        if (document.activeElement && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document.activeElement).is(data.focusableElements) && document.activeElement !== $targetEl[0]) document.activeElement.blur();
        const shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
        if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !$targetEl[0].isContentEditable) e.preventDefault();
    }
    if (swiper.params.freeMode && swiper.params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit('touchStart', e);
}



var $4acFp = parcelRequire("4acFp");


function $2a78afa7725f20a7$export$2e2bcd8739ae039(event) {
    const document = (0, $4acFp.getDocument)();
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit('touchMoveOpposite', e);
        return;
    }
    if (data.isTouchEvent && e.type !== 'touchmove') return;
    const targetTouch = e.type === 'touchmove' && e.targetTouches && (e.targetTouches[0] || e.changedTouches[0]);
    const pageX = e.type === 'touchmove' ? targetTouch.pageX : e.pageX;
    const pageY = e.type === 'touchmove' ? targetTouch.pageY : e.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
        }
        return;
    }
    if (data.isTouchEvent && params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (data.isTouchEvent && document.activeElement) {
        if (e.target === document.activeElement && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).is(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit('touchMove', e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    const diffX = touches.currentX - touches.startX;
    const diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(diffX ** 2 + diffY ** 2) < swiper.params.threshold) return;
    if (typeof data.isScrolling === 'undefined') {
        let touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit('touchMoveOpposite', e);
    if (typeof data.startMoving === 'undefined') {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    if (!data.isMoved) {
        if (params.loop && !params.cssMode) swiper.loopFix();
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) swiper.$wrapperEl.trigger('webkitTransitionEnd transitionend');
        data.allowMomentumBounce = false; // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit('sliderFirstMove', e);
    }
    swiper.emit('sliderMove', e);
    data.isMoved = true;
    let diff = swiper.isHorizontal() ? diffX : diffY;
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) diff = -diff;
    swiper.swipeDirection = diff > 0 ? 'prev' : 'next';
    data.currentTranslate = diff + data.startTranslate;
    let disableParentSwiper = true;
    let resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0 && data.currentTranslate > swiper.minTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + (-swiper.minTranslate() + data.startTranslate + diff) ** resistanceRatio;
    } else if (diff < 0 && data.currentTranslate < swiper.maxTranslate()) {
        disableParentSwiper = false;
        if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - (swiper.maxTranslate() - data.startTranslate - diff) ** resistanceRatio;
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
     // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === 'next' && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === 'prev' && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
     // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return; // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (swiper.params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
     // Update progress
    swiper.updateProgress(data.currentTranslate); // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $d08783fc78d02175$export$2e2bcd8739ae039(event) {
    const swiper = this;
    const data = swiper.touchEventsData;
    const { params: params, touches: touches, rtlTranslate: rtl, slidesGrid: slidesGrid, enabled: enabled } = swiper;
    if (!enabled) return;
    let e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit('touchEnd', e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    } // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
     // Time diff
    const touchEndTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    const timeDiff = touchEndTime - data.touchStartTime; // Tap, doubleTap, Click
    if (swiper.allowClick) {
        const pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit('tap click', e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit('doubleTap doubleClick', e);
    }
    data.lastClickTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    let currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (swiper.params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    } // Find current slide
    let stopIndex = 0;
    let groupSize = swiper.slidesSizesGrid[0];
    for(let i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        const increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== 'undefined') {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    let rewindFirstIndex = null;
    let rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    } // Find current slide size
    const ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    const increment = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === 'next') {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === 'prev') {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        const isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === 'next') swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment);
            if (swiper.swipeDirection === 'prev') swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment);
        else swiper.slideTo(stopIndex);
    }
}


function $1b1643a6bb74221f$export$2e2bcd8739ae039() {
    const swiper = this;
    const { params: params, el: el } = swiper;
    if (el && el.offsetWidth === 0) return; // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
     // Save locks
    const { allowSlideNext: allowSlideNext, allowSlidePrev: allowSlidePrev, snapGrid: snapGrid } = swiper; // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    if ((params.slidesPerView === 'auto' || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.run();
     // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $47b5e8b66ebb5a6e$export$2e2bcd8739ae039(e) {
    const swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $a94b8f37e4c27a3c$export$2e2bcd8739ae039() {
    const swiper = this;
    const { wrapperEl: wrapperEl, rtlTranslate: rtlTranslate, enabled: enabled } = swiper;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
     // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    let newProgress;
    const translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit('setTranslate', swiper.translate, false);
}


let $dc24c96bad3f572c$var$dummyEventAttached = false;
function $dc24c96bad3f572c$var$dummyEventListener() {}
const $dc24c96bad3f572c$var$events = (swiper, method)=>{
    const document = (0, $4acFp.getDocument)();
    const { params: params, touchEvents: touchEvents, el: el, wrapperEl: wrapperEl, device: device, support: support } = swiper;
    const capture = !!params.nested;
    const domMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
    const swiperMethod = method; // Touch Events
    if (!support.touch) {
        el[domMethod](touchEvents.start, swiper.onTouchStart, false);
        document[domMethod](touchEvents.move, swiper.onTouchMove, capture);
        document[domMethod](touchEvents.end, swiper.onTouchEnd, false);
    } else {
        const passiveListener = touchEvents.start === 'touchstart' && support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        el[domMethod](touchEvents.start, swiper.onTouchStart, passiveListener);
        el[domMethod](touchEvents.move, swiper.onTouchMove, support.passiveListener ? {
            passive: false,
            capture: capture
        } : capture);
        el[domMethod](touchEvents.end, swiper.onTouchEnd, passiveListener);
        if (touchEvents.cancel) el[domMethod](touchEvents.cancel, swiper.onTouchEnd, passiveListener);
    } // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]('click', swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]('scroll', swiper.onScroll);
     // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? 'resize orientationchange observerUpdate' : 'resize observerUpdate', (0, $1b1643a6bb74221f$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]('observerUpdate', (0, $1b1643a6bb74221f$export$2e2bcd8739ae039), true);
};
function $dc24c96bad3f572c$var$attachEvents() {
    const swiper = this;
    const document = (0, $4acFp.getDocument)();
    const { params: params, support: support } = swiper;
    swiper.onTouchStart = (0, $b15d160745c3babc$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $2a78afa7725f20a7$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $d08783fc78d02175$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $a94b8f37e4c27a3c$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $47b5e8b66ebb5a6e$export$2e2bcd8739ae039).bind(swiper);
    if (support.touch && !$dc24c96bad3f572c$var$dummyEventAttached) {
        document.addEventListener('touchstart', $dc24c96bad3f572c$var$dummyEventListener);
        $dc24c96bad3f572c$var$dummyEventAttached = true;
    }
    $dc24c96bad3f572c$var$events(swiper, 'on');
}
function $dc24c96bad3f572c$var$detachEvents() {
    const swiper = this;
    $dc24c96bad3f572c$var$events(swiper, 'off');
}
var $dc24c96bad3f572c$export$2e2bcd8739ae039 = {
    attachEvents: $dc24c96bad3f572c$var$attachEvents,
    detachEvents: $dc24c96bad3f572c$var$detachEvents
};



const $9d748ea43e402950$var$isGridEnabled = (swiper, params)=>{
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $9d748ea43e402950$export$2e2bcd8739ae039() {
    const swiper = this;
    const { activeIndex: activeIndex, initialized: initialized, loopedSlides: loopedSlides = 0, params: params, $el: $el } = swiper;
    const breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return; // Get breakpoint for window width and update parameters
    const breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    const breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    const breakpointParams = breakpointOnlyParams || swiper.originalParams;
    const wasMultiRow = $9d748ea43e402950$var$isGridEnabled(swiper, params);
    const isMultiRow = $9d748ea43e402950$var$isGridEnabled(swiper, breakpointParams);
    const wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        $el.removeClass(`${params.containerModifierClass}grid ${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        $el.addClass(`${params.containerModifierClass}grid`);
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === 'column' || !breakpointParams.grid.fill && params.grid.fill === 'column') $el.addClass(`${params.containerModifierClass}grid-column`);
        swiper.emitContainerClasses();
    } // Toggle navigation, pagination, scrollbar
    [
        'navigation',
        'pagination',
        'scrollbar'
    ].forEach((prop)=>{
        const wasModuleEnabled = params[prop] && params[prop].enabled;
        const isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    const directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    const needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(swiper.params, breakpointParams);
    const isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit('_beforeBreakpoint', breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate();
        swiper.updateSlides();
        swiper.slideTo(activeIndex - loopedSlides + swiper.loopedSlides, 0, false);
    }
    swiper.emit('breakpoint', breakpointParams);
}



var $4acFp = parcelRequire("4acFp");
function $7a29e4db01987bc4$export$2e2bcd8739ae039(breakpoints, base = 'window', containerEl) {
    if (!breakpoints || base === 'container' && !containerEl) return undefined;
    let breakpoint = false;
    const window = (0, $4acFp.getWindow)();
    const currentHeight = base === 'window' ? window.innerHeight : containerEl.clientHeight;
    const points = Object.keys(breakpoints).map((point)=>{
        if (typeof point === 'string' && point.indexOf('@') === 0) {
            const minRatio = parseFloat(point.substr(1));
            const value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort((a, b)=>parseInt(a.value, 10) - parseInt(b.value, 10));
    for(let i = 0; i < points.length; i += 1){
        const { point: point, value: value } = points[i];
        if (base === 'window') {
            if (window.matchMedia(`(min-width: ${value}px)`).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || 'max';
}


var $ee7f6089a376b64d$export$2e2bcd8739ae039 = {
    setBreakpoint: $9d748ea43e402950$export$2e2bcd8739ae039,
    getBreakpoint: $7a29e4db01987bc4$export$2e2bcd8739ae039
};


function $2190804c4655748f$var$prepareClasses(entries, prefix) {
    const resultClasses = [];
    entries.forEach((item)=>{
        if (typeof item === 'object') Object.keys(item).forEach((classNames)=>{
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === 'string') resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $2190804c4655748f$export$2e2bcd8739ae039() {
    const swiper = this;
    const { classNames: classNames, params: params, rtl: rtl, $el: $el, device: device, support: support } = swiper; // prettier-ignore
    const suffixes = $2190804c4655748f$var$prepareClasses([
        'initialized',
        params.direction,
        {
            'pointer-events': !support.touch
        },
        {
            'free-mode': swiper.params.freeMode && params.freeMode.enabled
        },
        {
            'autoheight': params.autoHeight
        },
        {
            'rtl': rtl
        },
        {
            'grid': params.grid && params.grid.rows > 1
        },
        {
            'grid-column': params.grid && params.grid.rows > 1 && params.grid.fill === 'column'
        },
        {
            'android': device.android
        },
        {
            'ios': device.ios
        },
        {
            'css-mode': params.cssMode
        },
        {
            'centered': params.cssMode && params.centeredSlides
        },
        {
            'watch-progress': params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    classNames.push(...suffixes);
    $el.addClass([
        ...classNames
    ].join(' '));
    swiper.emitContainerClasses();
}


function $fa3eea195c5fe69d$export$2e2bcd8739ae039() {
    const swiper = this;
    const { $el: $el, classNames: classNames } = swiper;
    $el.removeClass(classNames.join(' '));
    swiper.emitContainerClasses();
}


var $d63baffdaeae902c$export$2e2bcd8739ae039 = {
    addClasses: $2190804c4655748f$export$2e2bcd8739ae039,
    removeClasses: $fa3eea195c5fe69d$export$2e2bcd8739ae039
};



var $4acFp = parcelRequire("4acFp");

function $017c5524d7ef69d4$export$2e2bcd8739ae039(imageEl, src, srcset, sizes, checkForComplete, callback) {
    const window = (0, $4acFp.getWindow)();
    let image;
    function onReady() {
        if (callback) callback();
    }
    const isPicture = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(imageEl).parent('picture')[0];
    if (!isPicture && (!imageEl.complete || !checkForComplete)) {
        if (src) {
            image = new window.Image();
            image.onload = onReady;
            image.onerror = onReady;
            if (sizes) image.sizes = sizes;
            if (srcset) image.srcset = srcset;
            if (src) image.src = src;
        } else onReady();
    } else // image already loaded...
    onReady();
}


function $b6f2f49d7141bb2e$export$2e2bcd8739ae039() {
    const swiper = this;
    swiper.imagesToLoad = swiper.$el.find('img');
    function onReady() {
        if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper.destroyed) return;
        if (swiper.imagesLoaded !== undefined) swiper.imagesLoaded += 1;
        if (swiper.imagesLoaded === swiper.imagesToLoad.length) {
            if (swiper.params.updateOnImagesReady) swiper.update();
            swiper.emit('imagesReady');
        }
    }
    for(let i = 0; i < swiper.imagesToLoad.length; i += 1){
        const imageEl = swiper.imagesToLoad[i];
        swiper.loadImage(imageEl, imageEl.currentSrc || imageEl.getAttribute('src'), imageEl.srcset || imageEl.getAttribute('srcset'), imageEl.sizes || imageEl.getAttribute('sizes'), true, onReady);
    }
}


var $73157fd5be78b253$export$2e2bcd8739ae039 = {
    loadImage: $017c5524d7ef69d4$export$2e2bcd8739ae039,
    preloadImages: $b6f2f49d7141bb2e$export$2e2bcd8739ae039
};


function $8d9c247da82d0131$var$checkOverflow() {
    const swiper = this;
    const { isLocked: wasLocked, params: params } = swiper;
    const { slidesOffsetBefore: slidesOffsetBefore } = params;
    if (slidesOffsetBefore) {
        const lastSlideIndex = swiper.slides.length - 1;
        const lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? 'lock' : 'unlock');
}
var $8d9c247da82d0131$export$2e2bcd8739ae039 = {
    checkOverflow: $8d9c247da82d0131$var$checkOverflow
};


var $64df97bf2a11c9d8$export$2e2bcd8739ae039 = {
    init: true,
    direction: 'horizontal',
    touchEventsTarget: 'wrapper',
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: 'input, select, option, textarea, button, video, label',
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: 'slide',
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: 'window',
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 0,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // Images
    preloadImages: true,
    updateOnImagesReady: true,
    // loop
    loop: false,
    loopAdditionalSlides: 0,
    loopedSlides: null,
    loopedSlidesLimit: true,
    loopFillGroupWithBlank: false,
    loopPreventsSlide: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: 'swiper-no-swiping',
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: 'swiper-',
    // NEW
    slideClass: 'swiper-slide',
    slideBlankClass: 'swiper-slide-invisible-blank',
    slideActiveClass: 'swiper-slide-active',
    slideDuplicateActiveClass: 'swiper-slide-duplicate-active',
    slideVisibleClass: 'swiper-slide-visible',
    slideDuplicateClass: 'swiper-slide-duplicate',
    slideNextClass: 'swiper-slide-next',
    slideDuplicateNextClass: 'swiper-slide-duplicate-next',
    slidePrevClass: 'swiper-slide-prev',
    slideDuplicatePrevClass: 'swiper-slide-duplicate-prev',
    wrapperClass: 'swiper-wrapper',
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $ce955312af607476$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams(obj = {}) {
        const moduleParamName = Object.keys(obj)[0];
        const moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== 'object' || moduleParams === null) {
            (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            'navigation',
            'pagination',
            'scrollbar'
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && 'enabled' in moduleParams)) {
            (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === 'object' && !('enabled' in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $b254fe4b7c9c1178$export$8b58be045bf06082)(allModulesParams, obj);
    };
}


const $85f4b8a35c4e1acd$var$prototypes = {
    eventsEmitter: $74b464c34803e653$export$2e2bcd8739ae039,
    update: $8f4a1bd5616070ce$export$2e2bcd8739ae039,
    translate: $9f58678d892afa12$export$2e2bcd8739ae039,
    transition: $3f2b868738e95e42$export$2e2bcd8739ae039,
    slide: $bc69c4bbb0402867$export$2e2bcd8739ae039,
    loop: $f929d5d48e6fbbb6$export$2e2bcd8739ae039,
    grabCursor: $90248c4085b54b52$export$2e2bcd8739ae039,
    events: $dc24c96bad3f572c$export$2e2bcd8739ae039,
    breakpoints: $ee7f6089a376b64d$export$2e2bcd8739ae039,
    checkOverflow: $8d9c247da82d0131$export$2e2bcd8739ae039,
    classes: $d63baffdaeae902c$export$2e2bcd8739ae039,
    images: $73157fd5be78b253$export$2e2bcd8739ae039
};
const $85f4b8a35c4e1acd$var$extendedDefaults = {};
class $85f4b8a35c4e1acd$var$Swiper {
    constructor(...args){
        let el;
        let params;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === 'Object') params = args[0];
        else [el, params] = args;
        if (!params) params = {};
        params = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        if (params.el && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el).length > 1) {
            const swipers = [];
            (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el).each((containerEl)=>{
                const newParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new $85f4b8a35c4e1acd$var$Swiper(newParams));
            }); // eslint-disable-next-line no-constructor-return
            return swipers;
        } // Swiper Instance
        const swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $23cabd961154dd1d$export$d61c7b85ff180578)();
        swiper.device = (0, $1d5a11620700da71$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $251e4c8fce621376$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = [
            ...swiper.__modules__
        ];
        if (params.modules && Array.isArray(params.modules)) swiper.modules.push(...params.modules);
        const allModulesParams = {};
        swiper.modules.forEach((mod)=>{
            mod({
                swiper: swiper,
                extendParams: (0, $ce955312af607476$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        }); // Extend defaults with modules params
        const swiperParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, (0, $64df97bf2a11c9d8$export$2e2bcd8739ae039), allModulesParams); // Extend defaults with passed params
        swiper.params = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, swiperParams, $85f4b8a35c4e1acd$var$extendedDefaults, params);
        swiper.originalParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $b254fe4b7c9c1178$export$8b58be045bf06082)({}, params); // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach((eventName)=>{
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
         // Save Dom lib
        swiper.$ = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039); // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(),
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal () {
                return swiper.params.direction === 'horizontal';
            },
            isVertical () {
                return swiper.params.direction === 'vertical';
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEvents: function touchEvents() {
                const touch = [
                    'touchstart',
                    'touchmove',
                    'touchend',
                    'touchcancel'
                ];
                const desktop = [
                    'pointerdown',
                    'pointermove',
                    'pointerup'
                ];
                swiper.touchEventsTouch = {
                    start: touch[0],
                    move: touch[1],
                    end: touch[2],
                    cancel: touch[3]
                };
                swiper.touchEventsDesktop = {
                    start: desktop[0],
                    move: desktop[1],
                    end: desktop[2]
                };
                return swiper.support.touch || !swiper.params.simulateTouch ? swiper.touchEventsTouch : swiper.touchEventsDesktop;
            }(),
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: (0, $b254fe4b7c9c1178$export$461939dd4422153)(),
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                isTouchEvent: undefined,
                startMoving: undefined
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit('_swiper'); // Init
        if (swiper.params.init) swiper.init();
         // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    enable() {
        const swiper = this;
        if (swiper.enabled) return;
        swiper.enabled = true;
        if (swiper.params.grabCursor) swiper.setGrabCursor();
        swiper.emit('enable');
    }
    disable() {
        const swiper = this;
        if (!swiper.enabled) return;
        swiper.enabled = false;
        if (swiper.params.grabCursor) swiper.unsetGrabCursor();
        swiper.emit('disable');
    }
    setProgress(progress, speed) {
        const swiper = this;
        progress = Math.min(Math.max(progress, 0), 1);
        const min = swiper.minTranslate();
        const max = swiper.maxTranslate();
        const current = (max - min) * progress + min;
        swiper.translateTo(current, typeof speed === 'undefined' ? 0 : speed);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    emitContainerClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const cls = swiper.el.className.split(' ').filter((className)=>{
            return className.indexOf('swiper') === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
        });
        swiper.emit('_containerClasses', cls.join(' '));
    }
    getSlideClasses(slideEl) {
        const swiper = this;
        if (swiper.destroyed) return '';
        return slideEl.className.split(' ').filter((className)=>{
            return className.indexOf('swiper-slide') === 0 || className.indexOf(swiper.params.slideClass) === 0;
        }).join(' ');
    }
    emitSlidesClasses() {
        const swiper = this;
        if (!swiper.params._emitClasses || !swiper.el) return;
        const updates = [];
        swiper.slides.each((slideEl)=>{
            const classNames = swiper.getSlideClasses(slideEl);
            updates.push({
                slideEl: slideEl,
                classNames: classNames
            });
            swiper.emit('_slideClass', slideEl, classNames);
        });
        swiper.emit('_slideClasses', updates);
    }
    slidesPerViewDynamic(view = 'current', exact = false) {
        const swiper = this;
        const { params: params, slides: slides, slidesGrid: slidesGrid, slidesSizesGrid: slidesSizesGrid, size: swiperSize, activeIndex: activeIndex } = swiper;
        let spv = 1;
        if (params.centeredSlides) {
            let slideSize = slides[activeIndex].swiperSlideSize;
            let breakLoop;
            for(let i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
            for(let i = activeIndex - 1; i >= 0; i -= 1)if (slides[i] && !breakLoop) {
                slideSize += slides[i].swiperSlideSize;
                spv += 1;
                if (slideSize > swiperSize) breakLoop = true;
            }
        } else {
            // eslint-disable-next-line
            if (view === 'current') for(let i = activeIndex + 1; i < slides.length; i += 1){
                const slideInView = exact ? slidesGrid[i] + slidesSizesGrid[i] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i] - slidesGrid[activeIndex] < swiperSize;
                if (slideInView) spv += 1;
            }
            else // previous
            for(let i = activeIndex - 1; i >= 0; i -= 1){
                const slideInView = slidesGrid[activeIndex] - slidesGrid[i] < swiperSize;
                if (slideInView) spv += 1;
            }
        }
        return spv;
    }
    update() {
        const swiper = this;
        if (!swiper || swiper.destroyed) return;
        const { snapGrid: snapGrid, params: params } = swiper; // Breakpoints
        if (params.breakpoints) swiper.setBreakpoint();
        swiper.updateSize();
        swiper.updateSlides();
        swiper.updateProgress();
        swiper.updateSlidesClasses();
        function setTranslate() {
            const translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
            const newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
            swiper.setTranslate(newTranslate);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
        let translated;
        if (swiper.params.freeMode && swiper.params.freeMode.enabled) {
            setTranslate();
            if (swiper.params.autoHeight) swiper.updateAutoHeight();
        } else {
            if ((swiper.params.slidesPerView === 'auto' || swiper.params.slidesPerView > 1) && swiper.isEnd && !swiper.params.centeredSlides) translated = swiper.slideTo(swiper.slides.length - 1, 0, false, true);
            else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
            if (!translated) setTranslate();
        }
        if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
        swiper.emit('update');
    }
    changeDirection(newDirection, needUpdate = true) {
        const swiper = this;
        const currentDirection = swiper.params.direction;
        if (!newDirection) // eslint-disable-next-line
        newDirection = currentDirection === 'horizontal' ? 'vertical' : 'horizontal';
        if (newDirection === currentDirection || newDirection !== 'horizontal' && newDirection !== 'vertical') return swiper;
        swiper.$el.removeClass(`${swiper.params.containerModifierClass}${currentDirection}`).addClass(`${swiper.params.containerModifierClass}${newDirection}`);
        swiper.emitContainerClasses();
        swiper.params.direction = newDirection;
        swiper.slides.each((slideEl)=>{
            if (newDirection === 'vertical') slideEl.style.width = '';
            else slideEl.style.height = '';
        });
        swiper.emit('changeDirection');
        if (needUpdate) swiper.update();
        return swiper;
    }
    changeLanguageDirection(direction) {
        const swiper = this;
        if (swiper.rtl && direction === 'rtl' || !swiper.rtl && direction === 'ltr') return;
        swiper.rtl = direction === 'rtl';
        swiper.rtlTranslate = swiper.params.direction === 'horizontal' && swiper.rtl;
        if (swiper.rtl) {
            swiper.$el.addClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'rtl';
        } else {
            swiper.$el.removeClass(`${swiper.params.containerModifierClass}rtl`);
            swiper.el.dir = 'ltr';
        }
        swiper.update();
    }
    mount(el) {
        const swiper = this;
        if (swiper.mounted) return true; // Find el
        const $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el || swiper.params.el);
        el = $el[0];
        if (!el) return false;
        el.swiper = swiper;
        const getWrapperSelector = ()=>{
            return `.${(swiper.params.wrapperClass || '').trim().split(' ').join('.')}`;
        };
        const getWrapper = ()=>{
            if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                const res = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el.shadowRoot.querySelector(getWrapperSelector())); // Children needs to return slot items
                res.children = (options)=>$el.children(options);
                return res;
            }
            if (!$el.children) return (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)($el).children(getWrapperSelector());
            return $el.children(getWrapperSelector());
        }; // Find Wrapper
        let $wrapperEl = getWrapper();
        if ($wrapperEl.length === 0 && swiper.params.createElements) {
            const document = (0, $4acFp.getDocument)();
            const wrapper = document.createElement('div');
            $wrapperEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(wrapper);
            wrapper.className = swiper.params.wrapperClass;
            $el.append(wrapper);
            $el.children(`.${swiper.params.slideClass}`).each((slideEl)=>{
                $wrapperEl.append(slideEl);
            });
        }
        Object.assign(swiper, {
            $el: $el,
            el: el,
            $wrapperEl: $wrapperEl,
            wrapperEl: $wrapperEl[0],
            mounted: true,
            // RTL
            rtl: el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl',
            rtlTranslate: swiper.params.direction === 'horizontal' && (el.dir.toLowerCase() === 'rtl' || $el.css('direction') === 'rtl'),
            wrongRTL: $wrapperEl.css('display') === '-webkit-box'
        });
        return true;
    }
    init(el) {
        const swiper = this;
        if (swiper.initialized) return swiper;
        const mounted = swiper.mount(el);
        if (mounted === false) return swiper;
        swiper.emit('beforeInit'); // Set breakpoint
        if (swiper.params.breakpoints) swiper.setBreakpoint();
         // Add Classes
        swiper.addClasses(); // Create loop
        if (swiper.params.loop) swiper.loopCreate();
         // Update size
        swiper.updateSize(); // Update slides
        swiper.updateSlides();
        if (swiper.params.watchOverflow) swiper.checkOverflow();
         // Set Grab Cursor
        if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
        if (swiper.params.preloadImages) swiper.preloadImages();
         // Slide To Initial Slide
        if (swiper.params.loop) swiper.slideTo(swiper.params.initialSlide + swiper.loopedSlides, 0, swiper.params.runCallbacksOnInit, false, true);
        else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
         // Attach events
        swiper.attachEvents(); // Init Flag
        swiper.initialized = true; // Emit
        swiper.emit('init');
        swiper.emit('afterInit');
        return swiper;
    }
    destroy(deleteInstance = true, cleanStyles = true) {
        const swiper = this;
        const { params: params, $el: $el, $wrapperEl: $wrapperEl, slides: slides } = swiper;
        if (typeof swiper.params === 'undefined' || swiper.destroyed) return null;
        swiper.emit('beforeDestroy'); // Init Flag
        swiper.initialized = false; // Detach events
        swiper.detachEvents(); // Destroy loop
        if (params.loop) swiper.loopDestroy();
         // Cleanup styles
        if (cleanStyles) {
            swiper.removeClasses();
            $el.removeAttr('style');
            $wrapperEl.removeAttr('style');
            if (slides && slides.length) slides.removeClass([
                params.slideVisibleClass,
                params.slideActiveClass,
                params.slideNextClass,
                params.slidePrevClass
            ].join(' ')).removeAttr('style').removeAttr('data-swiper-slide-index');
        }
        swiper.emit('destroy'); // Detach emitter events
        Object.keys(swiper.eventsListeners).forEach((eventName)=>{
            swiper.off(eventName);
        });
        if (deleteInstance !== false) {
            swiper.$el[0].swiper = null;
            (0, $b254fe4b7c9c1178$export$8694e5c03a4df8e6)(swiper);
        }
        swiper.destroyed = true;
        return null;
    }
    static extendDefaults(newDefaults) {
        (0, $b254fe4b7c9c1178$export$8b58be045bf06082)($85f4b8a35c4e1acd$var$extendedDefaults, newDefaults);
    }
    static get extendedDefaults() {
        return $85f4b8a35c4e1acd$var$extendedDefaults;
    }
    static get defaults() {
        return 0, $64df97bf2a11c9d8$export$2e2bcd8739ae039;
    }
    static installModule(mod) {
        if (!$85f4b8a35c4e1acd$var$Swiper.prototype.__modules__) $85f4b8a35c4e1acd$var$Swiper.prototype.__modules__ = [];
        const modules = $85f4b8a35c4e1acd$var$Swiper.prototype.__modules__;
        if (typeof mod === 'function' && modules.indexOf(mod) < 0) modules.push(mod);
    }
    static use(module) {
        if (Array.isArray(module)) {
            module.forEach((m)=>$85f4b8a35c4e1acd$var$Swiper.installModule(m));
            return $85f4b8a35c4e1acd$var$Swiper;
        }
        $85f4b8a35c4e1acd$var$Swiper.installModule(module);
        return $85f4b8a35c4e1acd$var$Swiper;
    }
}
Object.keys($85f4b8a35c4e1acd$var$prototypes).forEach((prototypeGroup)=>{
    Object.keys($85f4b8a35c4e1acd$var$prototypes[prototypeGroup]).forEach((protoMethod)=>{
        $85f4b8a35c4e1acd$var$Swiper.prototype[protoMethod] = $85f4b8a35c4e1acd$var$prototypes[prototypeGroup][protoMethod];
    });
});
$85f4b8a35c4e1acd$var$Swiper.use([
    (0, $4d70267c217bac06$export$2e2bcd8739ae039),
    (0, $d0e6f8dae4d7097b$export$2e2bcd8739ae039)
]);
var $85f4b8a35c4e1acd$export$2e2bcd8739ae039 = $85f4b8a35c4e1acd$var$Swiper;




function $0ed6abb29af34172$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    let cssModeTimeout;
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    function renderSlide(slide, index) {
        const params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        const $slideEl = params.renderSlide ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.renderSlide.call(swiper, slide, index)) : (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="${swiper.params.slideClass}" data-swiper-slide-index="${index}">${slide}</div>`);
        if (!$slideEl.attr('data-swiper-slide-index')) $slideEl.attr('data-swiper-slide-index', index);
        if (params.cache) swiper.virtual.cache[index] = $slideEl;
        return $slideEl;
    }
    function update(force) {
        const { slidesPerView: slidesPerView, slidesPerGroup: slidesPerGroup, centeredSlides: centeredSlides } = swiper.params;
        const { addSlidesBefore: addSlidesBefore, addSlidesAfter: addSlidesAfter } = swiper.params.virtual;
        const { from: previousFrom, to: previousTo, slides: slides, slidesGrid: previousSlidesGrid, offset: previousOffset } = swiper.virtual;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        const activeIndex = swiper.activeIndex || 0;
        let offsetProp;
        if (swiper.rtlTranslate) offsetProp = 'right';
        else offsetProp = swiper.isHorizontal() ? 'left' : 'top';
        let slidesAfter;
        let slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = slidesPerGroup + addSlidesBefore;
        }
        const from = Math.max((activeIndex || 0) - slidesBefore, 0);
        const to = Math.min((activeIndex || 0) + slidesAfter, slides.length - 1);
        const offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            if (swiper.lazy && swiper.params.lazy.enabled) swiper.lazy.load();
            emit('virtualUpdate');
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.css(offsetProp, `${offset}px`);
            swiper.updateProgress();
            emit('virtualUpdate');
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    const slidesToRender = [];
                    for(let i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit('virtualUpdate');
            return;
        }
        const prependIndexes = [];
        const appendIndexes = [];
        if (force) swiper.$wrapperEl.find(`.${swiper.params.slideClass}`).remove();
        else {
            for(let i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) swiper.$wrapperEl.find(`.${swiper.params.slideClass}[data-swiper-slide-index="${i}"]`).remove();
        }
        for(let i = 0; i < slides.length; i += 1)if (i >= from && i <= to) {
            if (typeof previousTo === 'undefined' || force) appendIndexes.push(i);
            else {
                if (i > previousTo) appendIndexes.push(i);
                if (i < previousFrom) prependIndexes.push(i);
            }
        }
        appendIndexes.forEach((index)=>{
            swiper.$wrapperEl.append(renderSlide(slides[index], index));
        });
        prependIndexes.sort((a, b)=>b - a).forEach((index)=>{
            swiper.$wrapperEl.prepend(renderSlide(slides[index], index));
        });
        swiper.$wrapperEl.children('.swiper-slide').css(offsetProp, `${offset}px`);
        onRendered();
    }
    function appendSlide(slides) {
        if (typeof slides === 'object' && 'length' in slides) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    }
    function prependSlide(slides) {
        const activeIndex = swiper.activeIndex;
        let newActiveIndex = activeIndex + 1;
        let numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(let i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            const cache = swiper.virtual.cache;
            const newCache = {};
            Object.keys(cache).forEach((cachedIndex)=>{
                const $cachedEl = cache[cachedIndex];
                const cachedElIndex = $cachedEl.attr('data-swiper-slide-index');
                if (cachedElIndex) $cachedEl.attr('data-swiper-slide-index', parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = $cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    }
    function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === 'undefined' || slidesIndexes === null) return;
        let activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(let i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    }
    function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    }
    on('beforeInit', ()=>{
        if (!swiper.params.virtual.enabled) return;
        swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push(`${swiper.params.containerModifierClass}virtual`);
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(()=>{
                update();
            }, 100);
        } else update();
    });
    on('init update resize', ()=>{
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $b254fe4b7c9c1178$export$a607267f322101fd)(swiper.wrapperEl, '--swiper-virtual-size', `${swiper.virtualSize}px`);
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 
var $4acFp = parcelRequire("4acFp");

function $38f924aa78a8f5bb$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $4acFp.getDocument)();
    const window = (0, $4acFp.getWindow)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    function handle(event) {
        if (!swiper.enabled) return;
        const { rtlTranslate: rtl } = swiper;
        let e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        const kc = e.keyCode || e.charCode;
        const pageUpDown = swiper.params.keyboard.pageUpDown;
        const isPageUp = pageUpDown && kc === 33;
        const isPageDown = pageUpDown && kc === 34;
        const isArrowLeft = kc === 37;
        const isArrowRight = kc === 39;
        const isArrowUp = kc === 38;
        const isArrowDown = kc === 40; // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === 'input' || document.activeElement.nodeName.toLowerCase() === 'textarea')) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            let inView = false; // Check that swiper should be inside of visible area of window
            if (swiper.$el.parents(`.${swiper.params.slideClass}`).length > 0 && swiper.$el.parents(`.${swiper.params.slideActiveClass}`).length === 0) return undefined;
            const $el = swiper.$el;
            const swiperWidth = $el[0].clientWidth;
            const swiperHeight = $el[0].clientHeight;
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const swiperOffset = swiper.$el.offset();
            if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
            const swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(let i = 0; i < swiperCoord.length; i += 1){
                const point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit('keyPress', kc);
        return undefined;
    }
    function enable() {
        if (swiper.keyboard.enabled) return;
        (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document).on('keydown', handle);
        swiper.keyboard.enabled = true;
    }
    function disable() {
        if (!swiper.keyboard.enabled) return;
        (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(document).off('keydown', handle);
        swiper.keyboard.enabled = false;
    }
    on('init', ()=>{
        if (swiper.params.keyboard.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 
var $4acFp = parcelRequire("4acFp");


function $d4f01ea054a44f20$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $4acFp.getWindow)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: 'container',
            thresholdDelta: null,
            thresholdTime: null
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    let timeout;
    let lastScrollTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
    let lastEventBeforeSnap;
    const recentWheelEvents = [];
    function normalize(e) {
        // Reasonable defaults
        const PIXEL_STEP = 10;
        const LINE_HEIGHT = 40;
        const PAGE_HEIGHT = 800;
        let sX = 0;
        let sY = 0; // spinX, spinY
        let pX = 0;
        let pY = 0; // pixelX, pixelY
        // Legacy
        if ('detail' in e) sY = e.detail;
        if ('wheelDelta' in e) sY = -e.wheelDelta / 120;
        if ('wheelDeltaY' in e) sY = -e.wheelDeltaY / 120;
        if ('wheelDeltaX' in e) sX = -e.wheelDeltaX / 120;
         // side scrolling on FF with DOMMouseScroll
        if ('axis' in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ('deltaY' in e) pY = e.deltaY;
        if ('deltaX' in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        } // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    }
    function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    }
    function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    }
    function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $b254fe4b7c9c1178$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
         // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $b254fe4b7c9c1178$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
         // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit('scroll', newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit('scroll', newEvent.raw);
        } // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime(); // Return false as a default
        return false;
    }
    function releaseScroll(newEvent) {
        const params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    }
    function handle(event1) {
        let e = event1;
        let disableParentSwiper = true;
        if (!swiper.enabled) return;
        const params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        if (!swiper.mouseEntered && !target[0].contains(e.target) && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        let delta = 0;
        const rtlFactor = swiper.rtlTranslate ? -1 : 1;
        const data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta; // Get the scroll positions
        let positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate(); // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            const newEvent = {
                time: (0, $b254fe4b7c9c1178$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            }; // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent); // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
             // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            const newEvent = {
                time: (0, $b254fe4b7c9c1178$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            const ignoreWheelEvents = lastEventBeforeSnap && newEvent.time < lastEventBeforeSnap.time + 500 && newEvent.delta <= lastEventBeforeSnap.delta && newEvent.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                if (swiper.params.loop) swiper.loopFix();
                let position = swiper.getTranslate() + delta * params.sensitivity;
                const wasBeginning = swiper.isBeginning;
                const wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    const prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    const firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent);
                    if (prevEvent && (newEvent.delta > prevEvent.delta || newEvent.direction !== prevEvent.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent.time - firstEvent.time < 500 && firstEvent.delta - newEvent.delta >= 1 && newEvent.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        const snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        timeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                        const snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                } // Emit event
                if (!ignoreWheelEvents) emit('scroll', e); // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop(); // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    }
    function events(method) {
        let target = swiper.$el;
        if (swiper.params.mousewheel.eventsTarget !== 'container') target = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.params.mousewheel.eventsTarget);
        target[method]('mouseenter', handleMouseEnter);
        target[method]('mouseleave', handleMouseLeave);
        target[method]('wheel', handle);
    }
    function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener('wheel', handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events('on');
        swiper.mousewheel.enabled = true;
        return true;
    }
    function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events('off');
        swiper.mousewheel.enabled = false;
        return true;
    }
    on('init', ()=>{
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on('destroy', ()=>{
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $4acFp = parcelRequire("4acFp");
function $ebb110cd73bf06ce$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    const document = (0, $4acFp.getDocument)();
    if (swiper.params.createElements) Object.keys(checkProps).forEach((key)=>{
        if (!params[key] && params.auto === true) {
            let element = swiper.$el.children(`.${checkProps[key]}`)[0];
            if (!element) {
                element = document.createElement('div');
                element.className = checkProps[key];
                swiper.$el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}



function $482b46abf0b619ea$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: 'swiper-button-disabled',
            hiddenClass: 'swiper-button-hidden',
            lockClass: 'swiper-button-lock',
            navigationDisabledClass: 'swiper-navigation-disabled'
        }
    });
    swiper.navigation = {
        nextEl: null,
        $nextEl: null,
        prevEl: null,
        $prevEl: null
    };
    function getEl(el) {
        let $el;
        if (el) {
            $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el);
            if (swiper.params.uniqueNavElements && typeof el === 'string' && $el.length > 1 && swiper.$el.find(el).length === 1) $el = swiper.$el.find(el);
        }
        return $el;
    }
    function toggleEl($el, disabled) {
        const params = swiper.params.navigation;
        if ($el && $el.length > 0) {
            $el[disabled ? 'addClass' : 'removeClass'](params.disabledClass);
            if ($el[0] && $el[0].tagName === 'BUTTON') $el[0].disabled = disabled;
            if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
        }
    }
    function update() {
        // Update Navigation Buttons
        if (swiper.params.loop) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        toggleEl($prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl($nextEl, swiper.isEnd && !swiper.params.rewind);
    }
    function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit('navigationPrev');
    }
    function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit('navigationNext');
    }
    function init() {
        const params = swiper.params.navigation;
        swiper.params.navigation = (0, $ebb110cd73bf06ce$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: 'swiper-button-next',
            prevEl: 'swiper-button-prev'
        });
        if (!(params.nextEl || params.prevEl)) return;
        const $nextEl = getEl(params.nextEl);
        const $prevEl = getEl(params.prevEl);
        if ($nextEl && $nextEl.length > 0) $nextEl.on('click', onNextClick);
        if ($prevEl && $prevEl.length > 0) $prevEl.on('click', onPrevClick);
        Object.assign(swiper.navigation, {
            $nextEl: $nextEl,
            nextEl: $nextEl && $nextEl[0],
            $prevEl: $prevEl,
            prevEl: $prevEl && $prevEl[0]
        });
        if (!swiper.enabled) {
            if ($nextEl) $nextEl.addClass(params.lockClass);
            if ($prevEl) $prevEl.addClass(params.lockClass);
        }
    }
    function destroy() {
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl && $nextEl.length) {
            $nextEl.off('click', onNextClick);
            $nextEl.removeClass(swiper.params.navigation.disabledClass);
        }
        if ($prevEl && $prevEl.length) {
            $prevEl.off('click', onPrevClick);
            $prevEl.removeClass(swiper.params.navigation.disabledClass);
        }
    }
    on('init', ()=>{
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on('toEdge fromEdge lock unlock', ()=>{
        update();
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($nextEl) $nextEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
        if ($prevEl) $prevEl[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.navigation.lockClass);
    });
    on('click', (_s, e)=>{
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        const targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(targetEl).is($prevEl) && !(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(targetEl).is($nextEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            let isHidden;
            if ($nextEl) isHidden = $nextEl.hasClass(swiper.params.navigation.hiddenClass);
            else if ($prevEl) isHidden = $prevEl.hasClass(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit('navigationShow');
            else emit('navigationHide');
            if ($nextEl) $nextEl.toggleClass(swiper.params.navigation.hiddenClass);
            if ($prevEl) $prevEl.toggleClass(swiper.params.navigation.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.navigation.navigationDisabledClass);
        init();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.navigation.navigationDisabledClass);
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



function $636b3690d5e49284$export$2e2bcd8739ae039(classes = '') {
    return `.${classes.trim().replace(/([\.:!\/])/g, '\\$1') // eslint-disable-line
    .replace(/ /g, '.')}`;
}



function $66a0766673700297$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const pfx = 'swiper-pagination';
    extendParams({
        pagination: {
            el: null,
            bulletElement: 'span',
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: 'bullets',
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: (number)=>number,
            formatFractionTotal: (number)=>number,
            bulletClass: `${pfx}-bullet`,
            bulletActiveClass: `${pfx}-bullet-active`,
            modifierClass: `${pfx}-`,
            currentClass: `${pfx}-current`,
            totalClass: `${pfx}-total`,
            hiddenClass: `${pfx}-hidden`,
            progressbarFillClass: `${pfx}-progressbar-fill`,
            progressbarOppositeClass: `${pfx}-progressbar-opposite`,
            clickableClass: `${pfx}-clickable`,
            lockClass: `${pfx}-lock`,
            horizontalClass: `${pfx}-horizontal`,
            verticalClass: `${pfx}-vertical`,
            paginationDisabledClass: `${pfx}-disabled`
        }
    });
    swiper.pagination = {
        el: null,
        $el: null,
        bullets: []
    };
    let bulletSize;
    let dynamicBulletIndex = 0;
    function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || !swiper.pagination.$el || swiper.pagination.$el.length === 0;
    }
    function setSideBullets($bulletEl, position) {
        const { bulletActiveClass: bulletActiveClass } = swiper.params.pagination;
        $bulletEl[position]().addClass(`${bulletActiveClass}-${position}`)[position]().addClass(`${bulletActiveClass}-${position}-${position}`);
    }
    function update() {
        // Render || Update Pagination bullets/items
        const rtl = swiper.rtl;
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el; // Current/Total
        let current;
        const total = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            current = Math.ceil((swiper.activeIndex - swiper.loopedSlides) / swiper.params.slidesPerGroup);
            if (current > slidesLength - 1 - swiper.loopedSlides * 2) current -= slidesLength - swiper.loopedSlides * 2;
            if (current > total - 1) current -= total;
            if (current < 0 && swiper.params.paginationType !== 'bullets') current = total + current;
        } else if (typeof swiper.snapIndex !== 'undefined') current = swiper.snapIndex;
        else current = swiper.activeIndex || 0;
         // Types
        if (params.type === 'bullets' && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            const bullets = swiper.pagination.bullets;
            let firstIndex;
            let lastIndex;
            let midIndex;
            if (params.dynamicBullets) {
                bulletSize = bullets.eq(0)[swiper.isHorizontal() ? 'outerWidth' : 'outerHeight'](true);
                $el.css(swiper.isHorizontal() ? 'width' : 'height', `${bulletSize * (params.dynamicMainBullets + 4)}px`);
                if (params.dynamicMainBullets > 1 && swiper.previousIndex !== undefined) {
                    dynamicBulletIndex += current - (swiper.previousIndex - swiper.loopedSlides || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.removeClass([
                '',
                '-next',
                '-next-next',
                '-prev',
                '-prev-prev',
                '-main'
            ].map((suffix)=>`${params.bulletActiveClass}${suffix}`).join(' '));
            if ($el.length > 1) bullets.each((bullet)=>{
                const $bullet = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(bullet);
                const bulletIndex = $bullet.index();
                if (bulletIndex === current) $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) $bullet.addClass(`${params.bulletActiveClass}-main`);
                    if (bulletIndex === firstIndex) setSideBullets($bullet, 'prev');
                    if (bulletIndex === lastIndex) setSideBullets($bullet, 'next');
                }
            });
            else {
                const $bullet = bullets.eq(current);
                const bulletIndex = $bullet.index();
                $bullet.addClass(params.bulletActiveClass);
                if (params.dynamicBullets) {
                    const $firstDisplayedBullet = bullets.eq(firstIndex);
                    const $lastDisplayedBullet = bullets.eq(lastIndex);
                    for(let i = firstIndex; i <= lastIndex; i += 1)bullets.eq(i).addClass(`${params.bulletActiveClass}-main`);
                    if (swiper.params.loop) {
                        if (bulletIndex >= bullets.length) {
                            for(let i = params.dynamicMainBullets; i >= 0; i -= 1)bullets.eq(bullets.length - i).addClass(`${params.bulletActiveClass}-main`);
                            bullets.eq(bullets.length - params.dynamicMainBullets - 1).addClass(`${params.bulletActiveClass}-prev`);
                        } else {
                            setSideBullets($firstDisplayedBullet, 'prev');
                            setSideBullets($lastDisplayedBullet, 'next');
                        }
                    } else {
                        setSideBullets($firstDisplayedBullet, 'prev');
                        setSideBullets($lastDisplayedBullet, 'next');
                    }
                }
            }
            if (params.dynamicBullets) {
                const dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                const bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                const offsetProp = rtl ? 'right' : 'left';
                bullets.css(swiper.isHorizontal() ? offsetProp : 'top', `${bulletsOffset}px`);
            }
        }
        if (params.type === 'fraction') {
            $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.currentClass)).text(params.formatFractionCurrent(current + 1));
            $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.totalClass)).text(params.formatFractionTotal(total));
        }
        if (params.type === 'progressbar') {
            let progressbarDirection;
            if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? 'vertical' : 'horizontal';
            else progressbarDirection = swiper.isHorizontal() ? 'horizontal' : 'vertical';
            const scale = (current + 1) / total;
            let scaleX = 1;
            let scaleY = 1;
            if (progressbarDirection === 'horizontal') scaleX = scale;
            else scaleY = scale;
            $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.progressbarFillClass)).transform(`translate3d(0,0,0) scaleX(${scaleX}) scaleY(${scaleY})`).transition(swiper.params.speed);
        }
        if (params.type === 'custom' && params.renderCustom) {
            $el.html(params.renderCustom(swiper, current + 1, total));
            emit('paginationRender', $el[0]);
        } else emit('paginationUpdate', $el[0]);
        if (swiper.params.watchOverflow && swiper.enabled) $el[swiper.isLocked ? 'addClass' : 'removeClass'](params.lockClass);
    }
    function render() {
        // Render Container
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        const $el = swiper.pagination.$el;
        let paginationHTML = '';
        if (params.type === 'bullets') {
            let numberOfBullets = swiper.params.loop ? Math.ceil((slidesLength - swiper.loopedSlides * 2) / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.loop && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(let i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else paginationHTML += `<${params.bulletElement} class="${params.bulletClass}"></${params.bulletElement}>`;
            $el.html(paginationHTML);
            swiper.pagination.bullets = $el.find((0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.bulletClass));
        }
        if (params.type === 'fraction') {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = `<span class="${params.currentClass}"></span>` + ' / ' + `<span class="${params.totalClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type === 'progressbar') {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = `<span class="${params.progressbarFillClass}"></span>`;
            $el.html(paginationHTML);
        }
        if (params.type !== 'custom') emit('paginationRender', swiper.pagination.$el[0]);
    }
    function init() {
        swiper.params.pagination = (0, $ebb110cd73bf06ce$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: 'swiper-pagination'
        });
        const params = swiper.params.pagination;
        if (!params.el) return;
        let $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el);
        if ($el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1) {
            $el = swiper.$el.find(params.el); // check if it belongs to another nested Swiper
            if ($el.length > 1) $el = $el.filter((el)=>{
                if ((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el).parents('.swiper')[0] !== swiper.el) return false;
                return true;
            });
        }
        if (params.type === 'bullets' && params.clickable) $el.addClass(params.clickableClass);
        $el.addClass(params.modifierClass + params.type);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (params.type === 'bullets' && params.dynamicBullets) {
            $el.addClass(`${params.modifierClass}${params.type}-dynamic`);
            dynamicBulletIndex = 0;
            if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
        }
        if (params.type === 'progressbar' && params.progressbarOpposite) $el.addClass(params.progressbarOppositeClass);
        if (params.clickable) $el.on('click', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.bulletClass), function onClick(e) {
            e.preventDefault();
            let index = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(this).index() * swiper.params.slidesPerGroup;
            if (swiper.params.loop) index += swiper.loopedSlides;
            swiper.slideTo(index);
        });
        Object.assign(swiper.pagination, {
            $el: $el,
            el: $el[0]
        });
        if (!swiper.enabled) $el.addClass(params.lockClass);
    }
    function destroy() {
        const params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        const $el = swiper.pagination.$el;
        $el.removeClass(params.hiddenClass);
        $el.removeClass(params.modifierClass + params.type);
        $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        if (swiper.pagination.bullets && swiper.pagination.bullets.removeClass) swiper.pagination.bullets.removeClass(params.bulletActiveClass);
        if (params.clickable) $el.off('click', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(params.bulletClass));
    }
    on('init', ()=>{
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on('activeIndexChange', ()=>{
        if (swiper.params.loop) update();
        else if (typeof swiper.snapIndex === 'undefined') update();
    });
    on('snapIndexChange', ()=>{
        if (!swiper.params.loop) update();
    });
    on('slidesLengthChange', ()=>{
        if (swiper.params.loop) {
            render();
            update();
        }
    });
    on('snapGridLengthChange', ()=>{
        if (!swiper.params.loop) {
            render();
            update();
        }
    });
    on('destroy', ()=>{
        destroy();
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.pagination;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.pagination.lockClass);
    });
    on('lock unlock', ()=>{
        update();
    });
    on('click', (_s, e)=>{
        const targetEl = e.target;
        const { $el: $el } = swiper.pagination;
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && $el && $el.length > 0 && !(0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(targetEl).hasClass(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            const isHidden = $el.hasClass(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit('paginationShow');
            else emit('paginationHide');
            $el.toggleClass(swiper.params.pagination.hiddenClass);
        }
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.removeClass(swiper.params.pagination.paginationDisabledClass);
        init();
        render();
        update();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        if (swiper.pagination.$el) swiper.pagination.$el.addClass(swiper.params.pagination.paginationDisabledClass);
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $4acFp = parcelRequire("4acFp");



function $558f0a9ee089358a$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const document = (0, $4acFp.getDocument)();
    let isTouched = false;
    let timeout = null;
    let dragTimeout = null;
    let dragStartPos;
    let dragSize;
    let trackSize;
    let divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: 'auto',
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: 'swiper-scrollbar-lock',
            dragClass: 'swiper-scrollbar-drag',
            scrollbarDisabledClass: 'swiper-scrollbar-disabled',
            horizontalClass: `swiper-scrollbar-horizontal`,
            verticalClass: `swiper-scrollbar-vertical`
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null,
        $el: null,
        $dragEl: null
    };
    function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar, rtlTranslate: rtl, progress: progress } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        const params = swiper.params.scrollbar;
        let newSize = dragSize;
        let newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            $dragEl.transform(`translate3d(${newPos}px, 0, 0)`);
            $dragEl[0].style.width = `${newSize}px`;
        } else {
            $dragEl.transform(`translate3d(0px, ${newPos}px, 0)`);
            $dragEl[0].style.height = `${newSize}px`;
        }
        if (params.hide) {
            clearTimeout(timeout);
            $el[0].style.opacity = 1;
            timeout = setTimeout(()=>{
                $el[0].style.opacity = 0;
                $el.transition(400);
            }, 1000);
        }
    }
    function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.$dragEl.transition(duration);
    }
    function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        const { scrollbar: scrollbar } = swiper;
        const { $dragEl: $dragEl, $el: $el } = scrollbar;
        $dragEl[0].style.width = '';
        $dragEl[0].style.height = '';
        trackSize = swiper.isHorizontal() ? $el[0].offsetWidth : $el[0].offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === 'auto') dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) $dragEl[0].style.width = `${dragSize}px`;
        else $dragEl[0].style.height = `${dragSize}px`;
        if (divider >= 1) $el[0].style.display = 'none';
        else $el[0].style.display = '';
        if (swiper.params.scrollbar.hide) $el[0].style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.$el[swiper.isLocked ? 'addClass' : 'removeClass'](swiper.params.scrollbar.lockClass);
    }
    function getPointerPosition(e) {
        if (swiper.isHorizontal()) return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientX : e.clientX;
        return e.type === 'touchstart' || e.type === 'touchmove' ? e.targetTouches[0].clientY : e.clientY;
    }
    function setDragPosition(e) {
        const { scrollbar: scrollbar, rtlTranslate: rtl } = swiper;
        const { $el: $el } = scrollbar;
        let positionRatio;
        positionRatio = (getPointerPosition(e) - $el.offset()[swiper.isHorizontal() ? 'left' : 'top'] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        const position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    function onDragStart(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        isTouched = true;
        dragStartPos = e.target === $dragEl[0] || e.target === $dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? 'left' : 'top'] : null;
        e.preventDefault();
        e.stopPropagation();
        $wrapperEl.transition(100);
        $dragEl.transition(100);
        setDragPosition(e);
        clearTimeout(dragTimeout);
        $el.transition(0);
        if (params.hide) $el.css('opacity', 1);
        if (swiper.params.cssMode) swiper.$wrapperEl.css('scroll-snap-type', 'none');
        emit('scrollbarDragStart', e);
    }
    function onDragMove(e) {
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el, $dragEl: $dragEl } = scrollbar;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        $wrapperEl.transition(0);
        $el.transition(0);
        $dragEl.transition(0);
        emit('scrollbarDragMove', e);
    }
    function onDragEnd(e) {
        const params = swiper.params.scrollbar;
        const { scrollbar: scrollbar, $wrapperEl: $wrapperEl } = swiper;
        const { $el: $el } = scrollbar;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.$wrapperEl.css('scroll-snap-type', '');
            $wrapperEl.transition('');
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                $el.css('opacity', 0);
                $el.transition(400);
            }, 1000);
        }
        emit('scrollbarDragEnd', e);
        if (params.snapOnRelease) swiper.slideToClosest();
    }
    function events(method) {
        const { scrollbar: scrollbar, touchEventsTouch: touchEventsTouch, touchEventsDesktop: touchEventsDesktop, params: params, support: support } = swiper;
        const $el = scrollbar.$el;
        if (!$el) return;
        const target = $el[0];
        const activeListener = support.passiveListener && params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        const passiveListener = support.passiveListener && params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        const eventMethod = method === 'on' ? 'addEventListener' : 'removeEventListener';
        if (!support.touch) {
            target[eventMethod](touchEventsDesktop.start, onDragStart, activeListener);
            document[eventMethod](touchEventsDesktop.move, onDragMove, activeListener);
            document[eventMethod](touchEventsDesktop.end, onDragEnd, passiveListener);
        } else {
            target[eventMethod](touchEventsTouch.start, onDragStart, activeListener);
            target[eventMethod](touchEventsTouch.move, onDragMove, activeListener);
            target[eventMethod](touchEventsTouch.end, onDragEnd, passiveListener);
        }
    }
    function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('on');
    }
    function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events('off');
    }
    function init() {
        const { scrollbar: scrollbar, $el: $swiperEl } = swiper;
        swiper.params.scrollbar = (0, $ebb110cd73bf06ce$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: 'swiper-scrollbar'
        });
        const params = swiper.params.scrollbar;
        if (!params.el) return;
        let $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(params.el);
        if (swiper.params.uniqueNavElements && typeof params.el === 'string' && $el.length > 1 && $swiperEl.find(params.el).length === 1) $el = $swiperEl.find(params.el);
        $el.addClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        let $dragEl = $el.find(`.${swiper.params.scrollbar.dragClass}`);
        if ($dragEl.length === 0) {
            $dragEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="${swiper.params.scrollbar.dragClass}"></div>`);
            $el.append($dragEl);
        }
        Object.assign(scrollbar, {
            $el: $el,
            el: $el[0],
            $dragEl: $dragEl,
            dragEl: $dragEl[0]
        });
        if (params.draggable) enableDraggable();
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    }
    function destroy() {
        const params = swiper.params.scrollbar;
        const $el = swiper.scrollbar.$el;
        if ($el) $el.removeClass(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    }
    on('init', ()=>{
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on('update resize observerUpdate lock unlock', ()=>{
        updateSize();
    });
    on('setTranslate', ()=>{
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        setTransition(duration);
    });
    on('enable disable', ()=>{
        const { $el: $el } = swiper.scrollbar;
        if ($el) $el[swiper.enabled ? 'removeClass' : 'addClass'](swiper.params.scrollbar.lockClass);
    });
    on('destroy', ()=>{
        destroy();
    });
    const enable = ()=>{
        swiper.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.removeClass(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    const disable = ()=>{
        swiper.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.$el) swiper.scrollbar.$el.addClass(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $6b0ad44af32694c9$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        parallax: {
            enabled: false
        }
    });
    const setTransform = (el, progress)=>{
        const { rtl: rtl } = swiper;
        const $el = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(el);
        const rtlFactor = rtl ? -1 : 1;
        const p = $el.attr('data-swiper-parallax') || '0';
        let x = $el.attr('data-swiper-parallax-x');
        let y = $el.attr('data-swiper-parallax-y');
        const scale = $el.attr('data-swiper-parallax-scale');
        const opacity = $el.attr('data-swiper-parallax-opacity');
        if (x || y) {
            x = x || '0';
            y = y || '0';
        } else if (swiper.isHorizontal()) {
            x = p;
            y = '0';
        } else {
            y = p;
            x = '0';
        }
        if (x.indexOf('%') >= 0) x = `${parseInt(x, 10) * progress * rtlFactor}%`;
        else x = `${x * progress * rtlFactor}px`;
        if (y.indexOf('%') >= 0) y = `${parseInt(y, 10) * progress}%`;
        else y = `${y * progress}px`;
        if (typeof opacity !== 'undefined' && opacity !== null) {
            const currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            $el[0].style.opacity = currentOpacity;
        }
        if (typeof scale === 'undefined' || scale === null) $el.transform(`translate3d(${x}, ${y}, 0px)`);
        else {
            const currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            $el.transform(`translate3d(${x}, ${y}, 0px) scale(${currentScale})`);
        }
    };
    const setTranslate = ()=>{
        const { $el: $el, slides: slides, progress: progress, snapGrid: snapGrid } = swiper;
        $el.children('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
            setTransform(el, progress);
        });
        slides.each((slideEl, slideIndex)=>{
            let slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== 'auto') slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((el)=>{
                setTransform(el, slideProgress);
            });
        });
    };
    const setTransition = (duration = swiper.params.speed)=>{
        const { $el: $el } = swiper;
        $el.find('[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]').each((parallaxEl)=>{
            const $parallaxEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(parallaxEl);
            let parallaxDuration = parseInt($parallaxEl.attr('data-swiper-parallax-duration'), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            $parallaxEl.transition(parallaxDuration);
        });
    };
    on('beforeInit', ()=>{
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on('init', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTranslate', ()=>{
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on('setTransition', (_swiper, duration)=>{
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $4acFp = parcelRequire("4acFp");


function $e236535974c64ffc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    const window = (0, $4acFp.getWindow)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: 'swiper-zoom-container',
            zoomedSlideClass: 'swiper-slide-zoomed'
        }
    });
    swiper.zoom = {
        enabled: false
    };
    let currentScale = 1;
    let isScaling = false;
    let gesturesEnabled;
    let fakeGestureTouched;
    let fakeGestureMoved;
    const gesture = {
        $slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        $imageEl: undefined,
        $imageWrapEl: undefined,
        maxRatio: 3
    };
    const image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    const velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    let scale = 1;
    Object.defineProperty(swiper.zoom, 'scale', {
        get () {
            return scale;
        },
        set (value) {
            if (scale !== value) {
                const imageEl = gesture.$imageEl ? gesture.$imageEl[0] : undefined;
                const slideEl = gesture.$slideEl ? gesture.$slideEl[0] : undefined;
                emit('zoomChange', value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    function getDistanceBetweenTouches(e) {
        if (e.targetTouches.length < 2) return 1;
        const x1 = e.targetTouches[0].pageX;
        const y1 = e.targetTouches[0].pageY;
        const x2 = e.targetTouches[1].pageX;
        const y2 = e.targetTouches[1].pageY;
        const distance = Math.sqrt((x2 - x1) ** 2 + (y2 - y1) ** 2);
        return distance;
    } // Events
    function onGestureStart(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!support.gestures) {
            if (e.type !== 'touchstart' || e.type === 'touchstart' && e.targetTouches.length < 2) return;
            fakeGestureTouched = true;
            gesture.scaleStart = getDistanceBetweenTouches(e);
        }
        if (!gesture.$slideEl || !gesture.$slideEl.length) {
            gesture.$slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (gesture.$slideEl.length === 0) gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
            gesture.maxRatio = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
            if (gesture.$imageWrapEl.length === 0) {
                gesture.$imageEl = undefined;
                return;
            }
        }
        if (gesture.$imageEl) gesture.$imageEl.transition(0);
        isScaling = true;
    }
    function onGestureChange(e) {
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (e.type !== 'touchmove' || e.type === 'touchmove' && e.targetTouches.length < 2) return;
            fakeGestureMoved = true;
            gesture.scaleMove = getDistanceBetweenTouches(e);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) {
            if (e.type === 'gesturechange') onGestureStart(e);
            return;
        }
        if (support.gestures) zoom.scale = e.scale * currentScale;
        else zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + (zoom.scale - gesture.maxRatio + 1) ** 0.5;
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - (params.minRatio - zoom.scale + 1) ** 0.5;
        gesture.$imageEl.transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function onGestureEnd(e) {
        const device = swiper.device;
        const support = swiper.support;
        const params = swiper.params.zoom;
        const zoom = swiper.zoom;
        if (!support.gestures) {
            if (!fakeGestureTouched || !fakeGestureMoved) return;
            if (e.type !== 'touchend' || e.type === 'touchend' && e.changedTouches.length < 2 && !device.android) return;
            fakeGestureTouched = false;
            fakeGestureMoved = false;
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.$imageEl.transition(swiper.params.speed).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale === 1) gesture.$slideEl = undefined;
    }
    function onTouchStart(e) {
        const device = swiper.device;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        image.touchesStart.x = e.type === 'touchstart' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesStart.y = e.type === 'touchstart' ? e.targetTouches[0].pageY : e.pageY;
    }
    function onTouchMove(e) {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        swiper.allowClick = false;
        if (!image.isTouched || !gesture.$slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.$imageEl[0].offsetWidth;
            image.height = gesture.$imageEl[0].offsetHeight;
            image.startX = (0, $b254fe4b7c9c1178$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'x') || 0;
            image.startY = (0, $b254fe4b7c9c1178$export$5ec402b7fcf74398)(gesture.$imageWrapEl[0], 'y') || 0;
            gesture.slideWidth = gesture.$slideEl[0].offsetWidth;
            gesture.slideHeight = gesture.$slideEl[0].offsetHeight;
            gesture.$imageWrapEl.transition(0);
        } // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = e.type === 'touchmove' ? e.targetTouches[0].pageX : e.pageX;
        image.touchesCurrent.y = e.type === 'touchmove' ? e.targetTouches[0].pageY : e.pageY;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX;
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY;
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - (image.minX - image.currentX + 1) ** 0.8;
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + (image.currentX - image.maxX + 1) ** 0.8;
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - (image.minY - image.currentY + 1) ** 0.8;
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + (image.currentY - image.maxY + 1) ** 0.8;
         // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.$imageWrapEl.transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTouchEnd() {
        const zoom = swiper.zoom;
        if (!gesture.$imageEl || gesture.$imageEl.length === 0) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        let momentumDurationX = 300;
        let momentumDurationY = 300;
        const momentumDistanceX = velocity.x * momentumDurationX;
        const newPositionX = image.currentX + momentumDistanceX;
        const momentumDistanceY = velocity.y * momentumDurationY;
        const newPositionY = image.currentY + momentumDistanceY; // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        const momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY; // Define if we need image drag
        const scaledWidth = image.width * zoom.scale;
        const scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.$imageWrapEl.transition(momentumDuration).transform(`translate3d(${image.currentX}px, ${image.currentY}px,0)`);
    }
    function onTransitionEnd() {
        const zoom = swiper.zoom;
        if (gesture.$slideEl && swiper.previousIndex !== swiper.activeIndex) {
            if (gesture.$imageEl) gesture.$imageEl.transform('translate3d(0,0,0) scale(1)');
            if (gesture.$imageWrapEl) gesture.$imageWrapEl.transform('translate3d(0,0,0)');
            zoom.scale = 1;
            currentScale = 1;
            gesture.$slideEl = undefined;
            gesture.$imageEl = undefined;
            gesture.$imageWrapEl = undefined;
        }
    }
    function zoomIn(e) {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (e && e.target) gesture.$slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target).closest(`.${swiper.params.slideClass}`);
            if (!gesture.$slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
                else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            }
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = 'hidden';
            swiper.wrapperEl.style.touchAction = 'none';
        }
        gesture.$slideEl.addClass(`${params.zoomedSlideClass}`);
        let touchX;
        let touchY;
        let offsetX;
        let offsetY;
        let diffX;
        let diffY;
        let translateX;
        let translateY;
        let imageWidth;
        let imageHeight;
        let scaledWidth;
        let scaledHeight;
        let translateMinX;
        let translateMinY;
        let translateMaxX;
        let translateMaxY;
        let slideWidth;
        let slideHeight;
        if (typeof image.touchesStart.x === 'undefined' && e) {
            touchX = e.type === 'touchend' ? e.changedTouches[0].pageX : e.pageX;
            touchY = e.type === 'touchend' ? e.changedTouches[0].pageY : e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        zoom.scale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        currentScale = gesture.$imageWrapEl.attr('data-swiper-zoom') || params.maxRatio;
        if (e) {
            slideWidth = gesture.$slideEl[0].offsetWidth;
            slideHeight = gesture.$slideEl[0].offsetHeight;
            offsetX = gesture.$slideEl.offset().left + window.scrollX;
            offsetY = gesture.$slideEl.offset().top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.$imageEl[0].offsetWidth;
            imageHeight = gesture.$imageEl[0].offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        gesture.$imageWrapEl.transition(300).transform(`translate3d(${translateX}px, ${translateY}px,0)`);
        gesture.$imageEl.transition(300).transform(`translate3d(0,0,0) scale(${zoom.scale})`);
    }
    function zoomOut() {
        const zoom = swiper.zoom;
        const params = swiper.params.zoom;
        if (!gesture.$slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.$slideEl = swiper.$wrapperEl.children(`.${swiper.params.slideActiveClass}`);
            else gesture.$slideEl = swiper.slides.eq(swiper.activeIndex);
            gesture.$imageEl = gesture.$slideEl.find(`.${params.containerClass}`).eq(0).find('picture, img, svg, canvas, .swiper-zoom-target').eq(0);
            gesture.$imageWrapEl = gesture.$imageEl.parent(`.${params.containerClass}`);
        }
        if (!gesture.$imageEl || gesture.$imageEl.length === 0 || !gesture.$imageWrapEl || gesture.$imageWrapEl.length === 0) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = '';
            swiper.wrapperEl.style.touchAction = '';
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.$imageWrapEl.transition(300).transform('translate3d(0,0,0)');
        gesture.$imageEl.transition(300).transform('translate3d(0,0,0) scale(1)');
        gesture.$slideEl.removeClass(`${params.zoomedSlideClass}`);
        gesture.$slideEl = undefined;
    } // Toggle Zoom
    function zoomToggle(e) {
        const zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    }
    function getListeners() {
        const support = swiper.support;
        const passiveListener = swiper.touchEvents.start === 'touchstart' && support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        const activeListenerWithCapture = support.passiveListener ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    }
    function getSlideSelector() {
        return `.${swiper.params.slideClass}`;
    }
    function toggleGestures(method) {
        const { passiveListener: passiveListener } = getListeners();
        const slideSelector = getSlideSelector();
        swiper.$wrapperEl[method]('gesturestart', slideSelector, onGestureStart, passiveListener);
        swiper.$wrapperEl[method]('gesturechange', slideSelector, onGestureChange, passiveListener);
        swiper.$wrapperEl[method]('gestureend', slideSelector, onGestureEnd, passiveListener);
    }
    function enableGestures() {
        if (gesturesEnabled) return;
        gesturesEnabled = true;
        toggleGestures('on');
    }
    function disableGestures() {
        if (!gesturesEnabled) return;
        gesturesEnabled = false;
        toggleGestures('off');
    } // Attach/Detach Events
    function enable() {
        const zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        const support = swiper.support;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.on(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.on(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.on(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.on(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.on(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.on(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    function disable() {
        const zoom = swiper.zoom;
        if (!zoom.enabled) return;
        const support = swiper.support;
        zoom.enabled = false;
        const { passiveListener: passiveListener, activeListenerWithCapture: activeListenerWithCapture } = getListeners();
        const slideSelector = getSlideSelector(); // Scale image
        if (support.gestures) {
            swiper.$wrapperEl.off(swiper.touchEvents.start, enableGestures, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.end, disableGestures, passiveListener);
        } else if (swiper.touchEvents.start === 'touchstart') {
            swiper.$wrapperEl.off(swiper.touchEvents.start, slideSelector, onGestureStart, passiveListener);
            swiper.$wrapperEl.off(swiper.touchEvents.move, slideSelector, onGestureChange, activeListenerWithCapture);
            swiper.$wrapperEl.off(swiper.touchEvents.end, slideSelector, onGestureEnd, passiveListener);
            if (swiper.touchEvents.cancel) swiper.$wrapperEl.off(swiper.touchEvents.cancel, slideSelector, onGestureEnd, passiveListener);
        } // Move image
        swiper.$wrapperEl.off(swiper.touchEvents.move, `.${swiper.params.zoom.containerClass}`, onTouchMove, activeListenerWithCapture);
    }
    on('init', ()=>{
        if (swiper.params.zoom.enabled) enable();
    });
    on('destroy', ()=>{
        disable();
    });
    on('touchStart', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on('touchEnd', (_s, e)=>{
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on('doubleTap', (_s, e)=>{
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on('transitionEnd', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on('slideChange', ()=>{
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}



var $4acFp = parcelRequire("4acFp");

function $470215bb19934ee4$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    extendParams({
        lazy: {
            checkInView: false,
            enabled: false,
            loadPrevNext: false,
            loadPrevNextAmount: 1,
            loadOnTransitionStart: false,
            scrollingElement: '',
            elementClass: 'swiper-lazy',
            loadingClass: 'swiper-lazy-loading',
            loadedClass: 'swiper-lazy-loaded',
            preloaderClass: 'swiper-lazy-preloader'
        }
    });
    swiper.lazy = {};
    let scrollHandlerAttached = false;
    let initialImageLoaded = false;
    function loadInSlide(index, loadInDuplicate = true) {
        const params = swiper.params.lazy;
        if (typeof index === 'undefined') return;
        if (swiper.slides.length === 0) return;
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        const $slideEl = isVirtual ? swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-swiper-slide-index="${index}"]`) : swiper.slides.eq(index);
        const $images = $slideEl.find(`.${params.elementClass}:not(.${params.loadedClass}):not(.${params.loadingClass})`);
        if ($slideEl.hasClass(params.elementClass) && !$slideEl.hasClass(params.loadedClass) && !$slideEl.hasClass(params.loadingClass)) $images.push($slideEl[0]);
        if ($images.length === 0) return;
        $images.each((imageEl)=>{
            const $imageEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(imageEl);
            $imageEl.addClass(params.loadingClass);
            const background = $imageEl.attr('data-background');
            const src = $imageEl.attr('data-src');
            const srcset = $imageEl.attr('data-srcset');
            const sizes = $imageEl.attr('data-sizes');
            const $pictureEl = $imageEl.parent('picture');
            swiper.loadImage($imageEl[0], src || background, srcset, sizes, false, ()=>{
                if (typeof swiper === 'undefined' || swiper === null || !swiper || swiper && !swiper.params || swiper.destroyed) return;
                if (background) {
                    $imageEl.css('background-image', `url("${background}")`);
                    $imageEl.removeAttr('data-background');
                } else {
                    if (srcset) {
                        $imageEl.attr('srcset', srcset);
                        $imageEl.removeAttr('data-srcset');
                    }
                    if (sizes) {
                        $imageEl.attr('sizes', sizes);
                        $imageEl.removeAttr('data-sizes');
                    }
                    if ($pictureEl.length) $pictureEl.children('source').each((sourceEl)=>{
                        const $source = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(sourceEl);
                        if ($source.attr('data-srcset')) {
                            $source.attr('srcset', $source.attr('data-srcset'));
                            $source.removeAttr('data-srcset');
                        }
                    });
                    if (src) {
                        $imageEl.attr('src', src);
                        $imageEl.removeAttr('data-src');
                    }
                }
                $imageEl.addClass(params.loadedClass).removeClass(params.loadingClass);
                $slideEl.find(`.${params.preloaderClass}`).remove();
                if (swiper.params.loop && loadInDuplicate) {
                    const slideOriginalIndex = $slideEl.attr('data-swiper-slide-index');
                    if ($slideEl.hasClass(swiper.params.slideDuplicateClass)) {
                        const originalSlide = swiper.$wrapperEl.children(`[data-swiper-slide-index="${slideOriginalIndex}"]:not(.${swiper.params.slideDuplicateClass})`);
                        loadInSlide(originalSlide.index(), false);
                    } else {
                        const duplicatedSlide = swiper.$wrapperEl.children(`.${swiper.params.slideDuplicateClass}[data-swiper-slide-index="${slideOriginalIndex}"]`);
                        loadInSlide(duplicatedSlide.index(), false);
                    }
                }
                emit('lazyImageReady', $slideEl[0], $imageEl[0]);
                if (swiper.params.autoHeight) swiper.updateAutoHeight();
            });
            emit('lazyImageLoad', $slideEl[0], $imageEl[0]);
        });
    }
    function load() {
        const { $wrapperEl: $wrapperEl, params: swiperParams, slides: slides, activeIndex: activeIndex } = swiper;
        const isVirtual = swiper.virtual && swiperParams.virtual.enabled;
        const params = swiperParams.lazy;
        let slidesPerView = swiperParams.slidesPerView;
        if (slidesPerView === 'auto') slidesPerView = 0;
        function slideExist(index) {
            if (isVirtual) {
                if ($wrapperEl.children(`.${swiperParams.slideClass}[data-swiper-slide-index="${index}"]`).length) return true;
            } else if (slides[index]) return true;
            return false;
        }
        function slideIndex(slideEl) {
            if (isVirtual) return (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index');
            return (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).index();
        }
        if (!initialImageLoaded) initialImageLoaded = true;
        if (swiper.params.watchSlidesProgress) $wrapperEl.children(`.${swiperParams.slideVisibleClass}`).each((slideEl)=>{
            const index = isVirtual ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).attr('data-swiper-slide-index') : (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl).index();
            loadInSlide(index);
        });
        else if (slidesPerView > 1) {
            for(let i = activeIndex; i < activeIndex + slidesPerView; i += 1)if (slideExist(i)) loadInSlide(i);
        } else loadInSlide(activeIndex);
        if (params.loadPrevNext) {
            if (slidesPerView > 1 || params.loadPrevNextAmount && params.loadPrevNextAmount > 1) {
                const amount = params.loadPrevNextAmount;
                const spv = Math.ceil(slidesPerView);
                const maxIndex = Math.min(activeIndex + spv + Math.max(amount, spv), slides.length);
                const minIndex = Math.max(activeIndex - Math.max(spv, amount), 0); // Next Slides
                for(let i = activeIndex + spv; i < maxIndex; i += 1)if (slideExist(i)) loadInSlide(i);
                 // Prev Slides
                for(let i = minIndex; i < activeIndex; i += 1)if (slideExist(i)) loadInSlide(i);
            } else {
                const nextSlide = $wrapperEl.children(`.${swiperParams.slideNextClass}`);
                if (nextSlide.length > 0) loadInSlide(slideIndex(nextSlide));
                const prevSlide = $wrapperEl.children(`.${swiperParams.slidePrevClass}`);
                if (prevSlide.length > 0) loadInSlide(slideIndex(prevSlide));
            }
        }
    }
    function checkInViewOnLoad() {
        const window = (0, $4acFp.getWindow)();
        if (!swiper || swiper.destroyed) return;
        const $scrollElement = swiper.params.lazy.scrollingElement ? (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.params.lazy.scrollingElement) : (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(window);
        const isWindow = $scrollElement[0] === window;
        const scrollElementWidth = isWindow ? window.innerWidth : $scrollElement[0].offsetWidth;
        const scrollElementHeight = isWindow ? window.innerHeight : $scrollElement[0].offsetHeight;
        const swiperOffset = swiper.$el.offset();
        const { rtlTranslate: rtl } = swiper;
        let inView = false;
        if (rtl) swiperOffset.left -= swiper.$el[0].scrollLeft;
        const swiperCoord = [
            [
                swiperOffset.left,
                swiperOffset.top
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top
            ],
            [
                swiperOffset.left,
                swiperOffset.top + swiper.height
            ],
            [
                swiperOffset.left + swiper.width,
                swiperOffset.top + swiper.height
            ]
        ];
        for(let i = 0; i < swiperCoord.length; i += 1){
            const point = swiperCoord[i];
            if (point[0] >= 0 && point[0] <= scrollElementWidth && point[1] >= 0 && point[1] <= scrollElementHeight) {
                if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                inView = true;
            }
        }
        const passiveListener = swiper.touchEvents.start === 'touchstart' && swiper.support.passiveListener && swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (inView) {
            load();
            $scrollElement.off('scroll', checkInViewOnLoad, passiveListener);
        } else if (!scrollHandlerAttached) {
            scrollHandlerAttached = true;
            $scrollElement.on('scroll', checkInViewOnLoad, passiveListener);
        }
    }
    on('beforeInit', ()=>{
        if (swiper.params.lazy.enabled && swiper.params.preloadImages) swiper.params.preloadImages = false;
    });
    on('init', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('scroll', ()=>{
        if (swiper.params.freeMode && swiper.params.freeMode.enabled && !swiper.params.freeMode.sticky) load();
    });
    on('scrollbarDragMove resize _freeModeNoMomentumRelease', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('transitionStart', ()=>{
        if (swiper.params.lazy.enabled) {
            if (swiper.params.lazy.loadOnTransitionStart || !swiper.params.lazy.loadOnTransitionStart && !initialImageLoaded) {
                if (swiper.params.lazy.checkInView) checkInViewOnLoad();
                else load();
            }
        }
    });
    on('transitionEnd', ()=>{
        if (swiper.params.lazy.enabled && !swiper.params.lazy.loadOnTransitionStart) {
            if (swiper.params.lazy.checkInView) checkInViewOnLoad();
            else load();
        }
    });
    on('slideChange', ()=>{
        const { lazy: lazy, cssMode: cssMode, watchSlidesProgress: watchSlidesProgress, touchReleaseOnEdges: touchReleaseOnEdges, resistanceRatio: resistanceRatio } = swiper.params;
        if (lazy.enabled && (cssMode || watchSlidesProgress && (touchReleaseOnEdges || resistanceRatio === 0))) load();
    });
    on('destroy', ()=>{
        if (!swiper.$el) return;
        swiper.$el.find(`.${swiper.params.lazy.loadingClass}`).removeClass(swiper.params.lazy.loadingClass);
    });
    Object.assign(swiper.lazy, {
        load: load,
        loadInSlide: loadInSlide
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $94e9e4e6f84e5251$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: 'slide' // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    function LinearSpline(x, y) {
        const binarySearch = function search() {
            let maxIndex;
            let minIndex;
            let guess;
            return (array, val)=>{
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1; // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        let i1;
        let i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0; // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1; // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    } // xxx: for now i will just save one spline function to to
    function getInterpolateFunction(c) {
        if (!swiper.controller.spline) swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    }
    function setTranslate(_t, byController) {
        const controlled = swiper.controller.control;
        let multiplier;
        let controlledTranslate;
        const Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            const translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === 'slide') {
                getInterpolateFunction(c); // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === 'container') {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(let i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    }
    function setTransition(duration, byController) {
        const Swiper = swiper.constructor;
        const controlled = swiper.controller.control;
        let i;
        function setControlledTransition(c) {
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
                    c.updateAutoHeight();
                });
                c.$wrapperEl.transitionEnd(()=>{
                    if (!controlled) return;
                    if (c.params.loop && swiper.params.controller.by === 'slide') c.loopFix();
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    }
    function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    }
    on('beforeInit', ()=>{
        swiper.controller.control = swiper.params.controller.control;
    });
    on('update', ()=>{
        removeSpline();
    });
    on('resize', ()=>{
        removeSpline();
    });
    on('observerUpdate', ()=>{
        removeSpline();
    });
    on('setTranslate', (_s, translate, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on('setTransition', (_s, duration, byController)=>{
        if (!swiper.controller.control) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $f01ccbf3aeabc885$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: 'swiper-notification',
            prevSlideMessage: 'Previous slide',
            nextSlideMessage: 'Next slide',
            firstSlideMessage: 'This is the first slide',
            lastSlideMessage: 'This is the last slide',
            paginationBulletMessage: 'Go to slide {{index}}',
            slideLabelMessage: '{{index}} / {{slidesLength}}',
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: 'group',
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    let liveRegion = null;
    function notify(message) {
        const notification = liveRegion;
        if (notification.length === 0) return;
        notification.html('');
        notification.html(message);
    }
    function getRandomNumber(size = 16) {
        const randomChar = ()=>Math.round(16 * Math.random()).toString(16);
        return 'x'.repeat(size).replace(/x/g, randomChar);
    }
    function makeElFocusable($el) {
        $el.attr('tabIndex', '0');
    }
    function makeElNotFocusable($el) {
        $el.attr('tabIndex', '-1');
    }
    function addElRole($el, role) {
        $el.attr('role', role);
    }
    function addElRoleDescription($el, description) {
        $el.attr('aria-roledescription', description);
    }
    function addElControls($el, controls) {
        $el.attr('aria-controls', controls);
    }
    function addElLabel($el, label) {
        $el.attr('aria-label', label);
    }
    function addElId($el, id) {
        $el.attr('id', id);
    }
    function addElLive($el, live) {
        $el.attr('aria-live', live);
    }
    function disableEl($el) {
        $el.attr('aria-disabled', true);
    }
    function enableEl($el) {
        $el.attr('aria-disabled', false);
    }
    function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        const params = swiper.params.a11y;
        const $targetEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(e.target);
        if (swiper.navigation && swiper.navigation.$nextEl && $targetEl.is(swiper.navigation.$nextEl)) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.$prevEl && $targetEl.is(swiper.navigation.$prevEl)) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && $targetEl.is((0, $636b3690d5e49284$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) $targetEl[0].click();
    }
    function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        const { $nextEl: $nextEl, $prevEl: $prevEl } = swiper.navigation;
        if ($prevEl && $prevEl.length > 0) {
            if (swiper.isBeginning) {
                disableEl($prevEl);
                makeElNotFocusable($prevEl);
            } else {
                enableEl($prevEl);
                makeElFocusable($prevEl);
            }
        }
        if ($nextEl && $nextEl.length > 0) {
            if (swiper.isEnd) {
                disableEl($nextEl);
                makeElNotFocusable($nextEl);
            } else {
                enableEl($nextEl);
                makeElFocusable($nextEl);
            }
        }
    }
    function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    }
    function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    }
    function updatePagination() {
        const params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.each((bulletEl)=>{
            const $bulletEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(bulletEl);
            if (swiper.params.pagination.clickable) {
                makeElFocusable($bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole($bulletEl, 'button');
                    addElLabel($bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, $bulletEl.index() + 1));
                }
            }
            if ($bulletEl.is(`.${swiper.params.pagination.bulletActiveClass}`)) $bulletEl.attr('aria-current', 'true');
            else $bulletEl.removeAttr('aria-current');
        });
    }
    const initNavEl = ($el, wrapperId, message)=>{
        makeElFocusable($el);
        if ($el[0].tagName !== 'BUTTON') {
            addElRole($el, 'button');
            $el.on('keydown', onEnterOrSpaceKey);
        }
        addElLabel($el, message);
        addElControls($el, wrapperId);
    };
    const handlePointerDown = ()=>{
        swiper.a11y.clicked = true;
    };
    const handlePointerUp = ()=>{
        requestAnimationFrame(()=>{
            requestAnimationFrame(()=>{
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    const handleFocus = (e)=>{
        if (swiper.a11y.clicked) return;
        const slideEl = e.target.closest(`.${swiper.params.slideClass}`);
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        const isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        const isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    const initSlides = ()=>{
        const params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.slides), params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(swiper.slides), params.slideRole);
        const slidesLength = swiper.params.loop ? swiper.slides.filter((el)=>!el.classList.contains(swiper.params.slideDuplicateClass)).length : swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.each((slideEl, index)=>{
            const $slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl);
            const slideIndex = swiper.params.loop ? parseInt($slideEl.attr('data-swiper-slide-index'), 10) : index;
            const ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel($slideEl, ariaLabelMessage);
        });
    };
    const init = ()=>{
        const params = swiper.params.a11y;
        swiper.$el.append(liveRegion); // Container
        const $containerEl = swiper.$el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription($containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel($containerEl, params.containerMessage);
         // Wrapper
        const $wrapperEl = swiper.$wrapperEl;
        const wrapperId = params.id || $wrapperEl.attr('id') || `swiper-wrapper-${getRandomNumber(16)}`;
        const live = swiper.params.autoplay && swiper.params.autoplay.enabled ? 'off' : 'polite';
        addElId($wrapperEl, wrapperId);
        addElLive($wrapperEl, live); // Slide
        initSlides(); // Navigation
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl && $nextEl.length) initNavEl($nextEl, wrapperId, params.nextSlideMessage);
        if ($prevEl && $prevEl.length) initNavEl($prevEl, wrapperId, params.prevSlideMessage);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.on('keydown', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.on('focus', handleFocus, true);
        swiper.$el.on('pointerdown', handlePointerDown, true);
        swiper.$el.on('pointerup', handlePointerUp, true);
    };
    function destroy() {
        if (liveRegion && liveRegion.length > 0) liveRegion.remove();
        let $nextEl;
        let $prevEl;
        if (swiper.navigation && swiper.navigation.$nextEl) $nextEl = swiper.navigation.$nextEl;
        if (swiper.navigation && swiper.navigation.$prevEl) $prevEl = swiper.navigation.$prevEl;
        if ($nextEl) $nextEl.off('keydown', onEnterOrSpaceKey);
        if ($prevEl) $prevEl.off('keydown', onEnterOrSpaceKey);
         // Pagination
        if (hasClickablePagination()) swiper.pagination.$el.off('keydown', (0, $636b3690d5e49284$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass), onEnterOrSpaceKey);
         // Tab focus
        swiper.$el.off('focus', handleFocus, true);
        swiper.$el.off('pointerdown', handlePointerDown, true);
        swiper.$el.off('pointerup', handlePointerUp, true);
    }
    on('beforeInit', ()=>{
        liveRegion = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<span class="${swiper.params.a11y.notificationClass}" aria-live="assertive" aria-atomic="true"></span>`);
    });
    on('afterInit', ()=>{
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on('slidesLengthChange snapGridLengthChange slidesGridLengthChange', ()=>{
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on('fromEdge toEdge afterInit lock unlock', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on('paginationUpdate', ()=>{
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on('destroy', ()=>{
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



var $4acFp = parcelRequire("4acFp");
function $a8d75c807afc5954$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        history: {
            enabled: false,
            root: '',
            replaceState: false,
            key: 'slides',
            keepQuery: false
        }
    });
    let initialized = false;
    let paths = {};
    const slugify = (text)=>{
        return text.toString().replace(/\s+/g, '-').replace(/[^\w-]+/g, '').replace(/--+/g, '-').replace(/^-+/, '').replace(/-+$/, '');
    };
    const getPathValues = (urlOverride)=>{
        const window = (0, $4acFp.getWindow)();
        let location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        const pathArray = location.pathname.slice(1).split('/').filter((part)=>part !== '');
        const total = pathArray.length;
        const key = pathArray[total - 2];
        const value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    const setHistory = (key, index)=>{
        const window = (0, $4acFp.getWindow)();
        if (!initialized || !swiper.params.history.enabled) return;
        let location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        const slide = swiper.slides.eq(index);
        let value = slugify(slide.attr('data-history'));
        if (swiper.params.history.root.length > 0) {
            let root = swiper.params.history.root;
            if (root[root.length - 1] === '/') root = root.slice(0, root.length - 1);
            value = `${root}/${key}/${value}`;
        } else if (!location.pathname.includes(key)) value = `${key}/${value}`;
        if (swiper.params.history.keepQuery) value += location.search;
        const currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    const scrollToSlide = (speed, value, runCallbacks)=>{
        if (value) for(let i = 0, length = swiper.slides.length; i < length; i += 1){
            const slide = swiper.slides.eq(i);
            const slideHistory = slugify(slide.attr('data-history'));
            if (slideHistory === value && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                const index = slide.index();
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    const setHistoryPopState = ()=>{
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    const init = ()=>{
        const window = (0, $4acFp.getWindow)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) return;
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener('popstate', setHistoryPopState);
    };
    const destroy = ()=>{
        const window = (0, $4acFp.getWindow)();
        if (!swiper.params.history.replaceState) window.removeEventListener('popstate', setHistoryPopState);
    };
    on('init', ()=>{
        if (swiper.params.history.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.history.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}



var $4acFp = parcelRequire("4acFp");

function $d38d7f1432d0d671$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, on: on }) {
    let initialized = false;
    const document = (0, $4acFp.getDocument)();
    const window = (0, $4acFp.getWindow)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false
        }
    });
    const onHashChange = ()=>{
        emit('hashChange');
        const newHash = document.location.hash.replace('#', '');
        const activeSlideHash = swiper.slides.eq(swiper.activeIndex).attr('data-hash');
        if (newHash !== activeSlideHash) {
            const newIndex = swiper.$wrapperEl.children(`.${swiper.params.slideClass}[data-hash="${newHash}"]`).index();
            if (typeof newIndex === 'undefined') return;
            swiper.slideTo(newIndex);
        }
    };
    const setHash = ()=>{
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, `#${swiper.slides.eq(swiper.activeIndex).attr('data-hash')}` || '');
            emit('hashSet');
        } else {
            const slide = swiper.slides.eq(swiper.activeIndex);
            const hash = slide.attr('data-hash') || slide.attr('data-history');
            document.location.hash = hash || '';
            emit('hashSet');
        }
    };
    const init = ()=>{
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        const hash = document.location.hash.replace('#', '');
        if (hash) {
            const speed = 0;
            for(let i = 0, length = swiper.slides.length; i < length; i += 1){
                const slide = swiper.slides.eq(i);
                const slideHash = slide.attr('data-hash') || slide.attr('data-history');
                if (slideHash === hash && !slide.hasClass(swiper.params.slideDuplicateClass)) {
                    const index = slide.index();
                    swiper.slideTo(index, speed, swiper.params.runCallbacksOnInit, true);
                }
            }
        }
        if (swiper.params.hashNavigation.watchState) (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(window).on('hashchange', onHashChange);
    };
    const destroy = ()=>{
        if (swiper.params.hashNavigation.watchState) (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(window).off('hashchange', onHashChange);
    };
    on('init', ()=>{
        if (swiper.params.hashNavigation.enabled) init();
    });
    on('destroy', ()=>{
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on('transitionEnd _freeModeNoMomentumRelease', ()=>{
        if (initialized) setHash();
    });
    on('slideChange', ()=>{
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
var $4acFp = parcelRequire("4acFp");

function $11e8d961c11b7050$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on, emit: emit }) {
    let timeout;
    swiper.autoplay = {
        running: false,
        paused: false
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    function run() {
        if (!swiper.size) {
            swiper.autoplay.running = false;
            swiper.autoplay.paused = false;
            return;
        }
        const $activeSlideEl = swiper.slides.eq(swiper.activeIndex);
        let delay = swiper.params.autoplay.delay;
        if ($activeSlideEl.attr('data-swiper-autoplay')) delay = $activeSlideEl.attr('data-swiper-autoplay') || swiper.params.autoplay.delay;
        clearTimeout(timeout);
        timeout = (0, $b254fe4b7c9c1178$export$bdd553fddd433dcb)(()=>{
            let autoplayResult;
            if (swiper.params.autoplay.reverseDirection) {
                if (swiper.params.loop) {
                    swiper.loopFix();
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.isBeginning) {
                    autoplayResult = swiper.slidePrev(swiper.params.speed, true, true);
                    emit('autoplay');
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    autoplayResult = swiper.slideTo(swiper.slides.length - 1, swiper.params.speed, true, true);
                    emit('autoplay');
                } else stop();
            } else if (swiper.params.loop) {
                swiper.loopFix();
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.isEnd) {
                autoplayResult = swiper.slideNext(swiper.params.speed, true, true);
                emit('autoplay');
            } else if (!swiper.params.autoplay.stopOnLastSlide) {
                autoplayResult = swiper.slideTo(0, swiper.params.speed, true, true);
                emit('autoplay');
            } else stop();
            if (swiper.params.cssMode && swiper.autoplay.running) run();
            else if (autoplayResult === false) run();
        }, delay);
    }
    function start() {
        if (typeof timeout !== 'undefined') return false;
        if (swiper.autoplay.running) return false;
        swiper.autoplay.running = true;
        emit('autoplayStart');
        run();
        return true;
    }
    function stop() {
        if (!swiper.autoplay.running) return false;
        if (typeof timeout === 'undefined') return false;
        if (timeout) {
            clearTimeout(timeout);
            timeout = undefined;
        }
        swiper.autoplay.running = false;
        emit('autoplayStop');
        return true;
    }
    function pause(speed) {
        if (!swiper.autoplay.running) return;
        if (swiper.autoplay.paused) return;
        if (timeout) clearTimeout(timeout);
        swiper.autoplay.paused = true;
        if (speed === 0 || !swiper.params.autoplay.waitForTransition) {
            swiper.autoplay.paused = false;
            run();
        } else [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].addEventListener(event, onTransitionEnd);
        });
    }
    function onVisibilityChange() {
        const document = (0, $4acFp.getDocument)();
        if (document.visibilityState === 'hidden' && swiper.autoplay.running) pause();
        if (document.visibilityState === 'visible' && swiper.autoplay.paused) {
            run();
            swiper.autoplay.paused = false;
        }
    }
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.$wrapperEl) return;
        if (e.target !== swiper.$wrapperEl[0]) return;
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
        swiper.autoplay.paused = false;
        if (!swiper.autoplay.running) stop();
        else run();
    }
    function onMouseEnter() {
        if (swiper.params.autoplay.disableOnInteraction) stop();
        else {
            emit('autoplayPause');
            pause();
        }
        [
            'transitionend',
            'webkitTransitionEnd'
        ].forEach((event)=>{
            swiper.$wrapperEl[0].removeEventListener(event, onTransitionEnd);
        });
    }
    function onMouseLeave() {
        if (swiper.params.autoplay.disableOnInteraction) return;
        swiper.autoplay.paused = false;
        emit('autoplayResume');
        run();
    }
    function attachMouseEvents() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.$el.on('mouseenter', onMouseEnter);
            swiper.$el.on('mouseleave', onMouseLeave);
        }
    }
    function detachMouseEvents() {
        swiper.$el.off('mouseenter', onMouseEnter);
        swiper.$el.off('mouseleave', onMouseLeave);
    }
    on('init', ()=>{
        if (swiper.params.autoplay.enabled) {
            start();
            const document = (0, $4acFp.getDocument)();
            document.addEventListener('visibilitychange', onVisibilityChange);
            attachMouseEvents();
        }
    });
    on('beforeTransitionStart', (_s, speed, internal)=>{
        if (swiper.autoplay.running) {
            if (internal || !swiper.params.autoplay.disableOnInteraction) swiper.autoplay.pause(speed);
            else stop();
        }
    });
    on('sliderFirstMove', ()=>{
        if (swiper.autoplay.running) {
            if (swiper.params.autoplay.disableOnInteraction) stop();
            else pause();
        }
    });
    on('touchEnd', ()=>{
        if (swiper.params.cssMode && swiper.autoplay.paused && !swiper.params.autoplay.disableOnInteraction) run();
    });
    on('destroy', ()=>{
        detachMouseEvents();
        if (swiper.autoplay.running) stop();
        const document = (0, $4acFp.getDocument)();
        document.removeEventListener('visibilitychange', onVisibilityChange);
    });
    Object.assign(swiper.autoplay, {
        pause: pause,
        run: run,
        start: start,
        stop: stop
    });
}




function $063a77c64406fb38$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: 'swiper-slide-thumb-active',
            thumbsContainerClass: 'swiper-thumbs'
        }
    });
    let initialized = false;
    let swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    function onThumbClick() {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const clickedIndex = thumbsSwiper.clickedIndex;
        const clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(clickedSlide).hasClass(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === 'undefined' || clickedIndex === null) return;
        let slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(thumbsSwiper.clickedSlide).attr('data-swiper-slide-index'), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) {
            let currentIndex = swiper.activeIndex;
            if (swiper.slides.eq(currentIndex).hasClass(swiper.params.slideDuplicateClass)) {
                swiper.loopFix(); // eslint-disable-next-line
                swiper._clientLeft = swiper.$wrapperEl[0].clientLeft;
                currentIndex = swiper.activeIndex;
            }
            const prevIndex = swiper.slides.eq(currentIndex).prevAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            const nextIndex = swiper.slides.eq(currentIndex).nextAll(`[data-swiper-slide-index="${slideToIndex}"]`).eq(0).index();
            if (typeof prevIndex === 'undefined') slideToIndex = nextIndex;
            else if (typeof nextIndex === 'undefined') slideToIndex = prevIndex;
            else if (nextIndex - currentIndex < currentIndex - prevIndex) slideToIndex = nextIndex;
            else slideToIndex = prevIndex;
        }
        swiper.slideTo(slideToIndex);
    }
    function init() {
        const { thumbs: thumbsParams } = swiper.params;
        if (initialized) return false;
        initialized = true;
        const SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
        } else if ((0, $b254fe4b7c9c1178$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            const thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.$el.addClass(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on('tap', onThumbClick);
        return true;
    }
    function update(initial) {
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        const slidesPerView = thumbsSwiper.params.slidesPerView === 'auto' ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView; // Activate thumbs
        let thumbsToActivate = 1;
        const thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.removeClass(thumbActiveClass);
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.$wrapperEl.children(`[data-swiper-slide-index="${swiper.realIndex + i}"]`).addClass(thumbActiveClass);
        else for(let i = 0; i < thumbsToActivate; i += 1)thumbsSwiper.slides.eq(swiper.realIndex + i).addClass(thumbActiveClass);
        const autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        const useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            let currentThumbsIndex = thumbsSwiper.activeIndex;
            let newThumbsIndex;
            let direction;
            if (thumbsSwiper.params.loop) {
                if (thumbsSwiper.slides.eq(currentThumbsIndex).hasClass(thumbsSwiper.params.slideDuplicateClass)) {
                    thumbsSwiper.loopFix(); // eslint-disable-next-line
                    thumbsSwiper._clientLeft = thumbsSwiper.$wrapperEl[0].clientLeft;
                    currentThumbsIndex = thumbsSwiper.activeIndex;
                } // Find actual thumbs index to slide to
                const prevThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).prevAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                const nextThumbsIndex = thumbsSwiper.slides.eq(currentThumbsIndex).nextAll(`[data-swiper-slide-index="${swiper.realIndex}"]`).eq(0).index();
                if (typeof prevThumbsIndex === 'undefined') newThumbsIndex = nextThumbsIndex;
                else if (typeof nextThumbsIndex === 'undefined') newThumbsIndex = prevThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex === currentThumbsIndex - prevThumbsIndex) newThumbsIndex = thumbsSwiper.params.slidesPerGroup > 1 ? nextThumbsIndex : currentThumbsIndex;
                else if (nextThumbsIndex - currentThumbsIndex < currentThumbsIndex - prevThumbsIndex) newThumbsIndex = nextThumbsIndex;
                else newThumbsIndex = prevThumbsIndex;
                direction = swiper.activeIndex > swiper.previousIndex ? 'next' : 'prev';
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? 'next' : 'prev';
            }
            if (useOffset) newThumbsIndex += direction === 'next' ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    }
    on('beforeInit', ()=>{
        const { thumbs: thumbs } = swiper.params;
        if (!thumbs || !thumbs.swiper) return;
        init();
        update(true);
    });
    on('slideChange update resize observerUpdate', ()=>{
        update();
    });
    on('setTransition', (_s, duration)=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on('beforeDestroy', ()=>{
        const thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $093847604d5cafbc$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, emit: emit, once: once }) {
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    function onTouchStart() {
        const translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    }
    function onTouchMove() {
        const { touchEventsData: data, touches: touches } = swiper; // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'startX' : 'startY'],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? 'currentX' : 'currentY'],
            time: (0, $b254fe4b7c9c1178$export$461939dd4422153)()
        });
    }
    function onTouchEnd({ currentPos: currentPos }) {
        const { params: params, $wrapperEl: $wrapperEl, rtlTranslate: rtl, snapGrid: snapGrid, touchEventsData: data } = swiper; // Time diff
        const touchEndTime = (0, $b254fe4b7c9c1178$export$461939dd4422153)();
        const timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                const lastMoveEvent = data.velocities.pop();
                const velocityEvent = data.velocities.pop();
                const distance = lastMoveEvent.position - velocityEvent.position;
                const time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                 // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $b254fe4b7c9c1178$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            let momentumDuration = 1000 * params.freeMode.momentumRatio;
            const momentumDistance = swiper.velocity * momentumDuration;
            let newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            let doBounce = false;
            let afterBouncePosition;
            const bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            let needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                let nextSlide;
                for(let j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === 'next') newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once('transitionEnd', ()=>{
                swiper.loopFix();
            });
             // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    const moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    const currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                $wrapperEl.transitionEnd(()=>{
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit('momentumBounce');
                    swiper.setTransition(params.speed);
                    setTimeout(()=>{
                        swiper.setTranslate(afterBouncePosition);
                        $wrapperEl.transitionEnd(()=>{
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit('_freeModeNoMomentumRelease');
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    $wrapperEl.transitionEnd(()=>{
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit('_freeModeNoMomentumRelease');
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    }
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}


function $8d4e16c568ab01e7$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams }) {
    extendParams({
        grid: {
            rows: 1,
            fill: 'column'
        }
    });
    let slidesNumberEvenToRows;
    let slidesPerRow;
    let numFullColumns;
    const initSlides = (slidesLength)=>{
        const { slidesPerView: slidesPerView } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid;
        slidesPerRow = slidesNumberEvenToRows / rows;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== 'auto' && fill === 'row') slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
    };
    const updateSlide = (i, slide, slidesLength, getDirectionLabel)=>{
        const { slidesPerGroup: slidesPerGroup, spaceBetween: spaceBetween } = swiper.params;
        const { rows: rows, fill: fill } = swiper.params.grid; // Set slides order
        let newSlideOrderIndex;
        let column;
        let row;
        if (fill === 'row' && slidesPerGroup > 1) {
            const groupIndex = Math.floor(i / (slidesPerGroup * rows));
            const slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            const columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.css({
                '-webkit-order': newSlideOrderIndex,
                order: newSlideOrderIndex
            });
        } else if (fill === 'column') {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.css(getDirectionLabel('margin-top'), row !== 0 ? spaceBetween && `${spaceBetween}px` : '');
    };
    const updateWrapperSize = (slideSize, snapGrid, getDirectionLabel)=>{
        const { spaceBetween: spaceBetween, centeredSlides: centeredSlides, roundLengths: roundLengths } = swiper.params;
        const { rows: rows } = swiper.params.grid;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.$wrapperEl.css({
            [getDirectionLabel('width')]: `${swiper.virtualSize + spaceBetween}px`
        });
        if (centeredSlides) {
            snapGrid.splice(0, snapGrid.length);
            const newSlidesGrid = [];
            for(let i = 0; i < snapGrid.length; i += 1){
                let slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.push(...newSlidesGrid);
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $d59b6e2443b78190$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params } = swiper;
    if (params.loop) swiper.loopDestroy();
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
    } else $wrapperEl.append(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
}


function $4581dd3fc0dc14e7$export$2e2bcd8739ae039(slides) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    if (params.loop) swiper.loopDestroy();
    let newActiveIndex = activeIndex + 1;
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.prepend(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else $wrapperEl.prepend(slides);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $f4d9a81beb7efc43$export$2e2bcd8739ae039(index, slides) {
    const swiper = this;
    const { $wrapperEl: $wrapperEl, params: params, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    const baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    let newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    const slidesBuffer = [];
    for(let i = baseLength - 1; i >= index; i -= 1){
        const currentSlide = swiper.slides.eq(i);
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === 'object' && 'length' in slides) {
        for(let i = 0; i < slides.length; i += 1)if (slides[i]) $wrapperEl.append(slides[i]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else $wrapperEl.append(slides);
    for(let i = 0; i < slidesBuffer.length; i += 1)$wrapperEl.append(slidesBuffer[i]);
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $05fa667223b0de98$export$2e2bcd8739ae039(slidesIndexes) {
    const swiper = this;
    const { params: params, $wrapperEl: $wrapperEl, activeIndex: activeIndex } = swiper;
    let activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.slides = $wrapperEl.children(`.${params.slideClass}`);
    }
    let newActiveIndex = activeIndexBuffer;
    let indexToRemove;
    if (typeof slidesIndexes === 'object' && 'length' in slidesIndexes) {
        for(let i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides.eq(indexToRemove).remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    if (params.loop) swiper.loopCreate();
    if (!params.observer) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $39eda8f4166c8156$export$2e2bcd8739ae039() {
    const swiper = this;
    const slidesIndexes = [];
    for(let i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $3bee8b7b8f78b39b$export$2e2bcd8739ae039({ swiper: swiper }) {
    Object.assign(swiper, {
        appendSlide: (0, $d59b6e2443b78190$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $4581dd3fc0dc14e7$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $f4d9a81beb7efc43$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $05fa667223b0de98$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $39eda8f4166c8156$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $c4cb41250e7e6a0a$export$2e2bcd8739ae039(params) {
    const { effect: effect, swiper: swiper, on: on, setTranslate: setTranslate, setTransition: setTransition, overwriteParams: overwriteParams, perspective: perspective, recreateShadows: recreateShadows, getEffectParams: getEffectParams } = params;
    on('beforeInit', ()=>{
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push(`${swiper.params.containerModifierClass}${effect}`);
        if (perspective && perspective()) swiper.classNames.push(`${swiper.params.containerModifierClass}3d`);
        const overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on('setTranslate', ()=>{
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on('setTransition', (_s, duration)=>{
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on('transitionEnd', ()=>{
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return; // remove shadows
            swiper.slides.each((slideEl)=>{
                const $slideEl = swiper.$(slideEl);
                $slideEl.find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').remove();
            }); // create new one
            recreateShadows();
        }
    });
    let requireUpdateOnVirtual;
    on('virtualUpdate', ()=>{
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(()=>{
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}


function $869bdd50588521f3$export$2e2bcd8739ae039(effectParams, $slideEl) {
    if (effectParams.transformEl) return $slideEl.find(effectParams.transformEl).css({
        'backface-visibility': 'hidden',
        '-webkit-backface-visibility': 'hidden'
    });
    return $slideEl;
}


function $7ee679e4e1fc3cdd$export$2e2bcd8739ae039({ swiper: swiper, duration: duration, transformEl: transformEl, allSlides: allSlides }) {
    const { slides: slides, activeIndex: activeIndex, $wrapperEl: $wrapperEl } = swiper;
    if (swiper.params.virtualTranslate && duration !== 0) {
        let eventTriggered = false;
        let $transitionEndTarget;
        if (allSlides) $transitionEndTarget = transformEl ? slides.find(transformEl) : slides;
        else $transitionEndTarget = transformEl ? slides.eq(activeIndex).find(transformEl) : slides.eq(activeIndex);
        $transitionEndTarget.transitionEnd(()=>{
            if (eventTriggered) return;
            if (!swiper || swiper.destroyed) return;
            eventTriggered = true;
            swiper.animating = false;
            const triggerEvents = [
                'webkitTransitionEnd',
                'transitionend'
            ];
            for(let i = 0; i < triggerEvents.length; i += 1)$wrapperEl.trigger(triggerEvents[i]);
        });
    }
}


function $9d892de9fba7bf61$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        fadeEffect: {
            crossFade: false,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { slides: slides } = swiper;
        const params = swiper.params.fadeEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = swiper.slides.eq(i);
            const offset = $slideEl[0].swiperSlideOffset;
            let tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            const slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs($slideEl[0].progress), 0) : 1 + Math.min(Math.max($slideEl[0].progress, -1), 0);
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.css({
                opacity: slideOpacity
            }).transform(`translate3d(${tx}px, ${ty}px, 0px)`);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.fadeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'fade',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




function $22dd7d617eacaa4c$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    const createSlideShadows = ($slideEl, progress, isHorizontal)=>{
        let shadowBefore = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) {
            shadowBefore = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'left' : 'top'}"></div>`);
            $slideEl.append(shadowBefore);
        }
        if (shadowAfter.length === 0) {
            shadowAfter = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow-${isHorizontal ? 'right' : 'bottom'}"></div>`);
            $slideEl.append(shadowAfter);
        }
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // create new ones
        const isHorizontal = swiper.isHorizontal();
        swiper.slides.each((slideEl)=>{
            const progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows((0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl), progress, isHorizontal);
        });
    };
    const setTranslate = ()=>{
        const { $el: $el, $wrapperEl: $wrapperEl, slides: slides, width: swiperWidth, height: swiperHeight, rtlTranslate: rtl, size: swiperSize, browser: browser } = swiper;
        const params = swiper.params.cubeEffect;
        const isHorizontal = swiper.isHorizontal();
        const isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        let wrapperRotate = 0;
        let $cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                $cubeShadowEl = $wrapperEl.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $wrapperEl.append($cubeShadowEl);
                }
                $cubeShadowEl.css({
                    height: `${swiperWidth}px`
                });
            } else {
                $cubeShadowEl = $el.find('.swiper-cube-shadow');
                if ($cubeShadowEl.length === 0) {
                    $cubeShadowEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)('<div class="swiper-cube-shadow"></div>');
                    $el.append($cubeShadowEl);
                }
            }
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let slideIndex = i;
            if (isVirtual) slideIndex = parseInt($slideEl.attr('data-swiper-slide-index'), 10);
            let slideAngle = slideIndex * 90;
            let round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            const progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            let tx = 0;
            let ty = 0;
            let tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            const transform = `rotateX(${isHorizontal ? 0 : -slideAngle}deg) rotateY(${isHorizontal ? slideAngle : 0}deg) translate3d(${tx}px, ${ty}px, ${tz}px)`;
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            $slideEl.transform(transform);
            if (params.slideShadows) createSlideShadows($slideEl, progress, isHorizontal);
        }
        $wrapperEl.css({
            '-webkit-transform-origin': `50% 50% -${swiperSize / 2}px`,
            'transform-origin': `50% 50% -${swiperSize / 2}px`
        });
        if (params.shadow) {
            if (isHorizontal) $cubeShadowEl.transform(`translate3d(0px, ${swiperWidth / 2 + params.shadowOffset}px, ${-swiperWidth / 2}px) rotateX(90deg) rotateZ(0deg) scale(${params.shadowScale})`);
            else {
                const shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                const multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                const scale1 = params.shadowScale;
                const scale2 = params.shadowScale / multiplier;
                const offset = params.shadowOffset;
                $cubeShadowEl.transform(`scale3d(${scale1}, 1, ${scale2}) translate3d(0px, ${swiperHeight / 2 + offset}px, ${-swiperHeight / 2 / scale2}px) rotateX(-90deg)`);
            }
        }
        const zFactor = browser.isSafari || browser.isWebView ? -swiperSize / 2 : 0;
        $wrapperEl.transform(`translate3d(0px,0,${zFactor}px) rotateX(${swiper.isHorizontal() ? 0 : wrapperRotate}deg) rotateY(${swiper.isHorizontal() ? -wrapperRotate : 0}deg)`);
        $wrapperEl[0].style.setProperty('--swiper-cube-translate-z', `${zFactor}px`);
    };
    const setTransition = (duration)=>{
        const { $el: $el, slides: slides } = swiper;
        slides.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) $el.find('.swiper-cube-shadow').transition(duration);
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'cube',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.cubeEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            })
    });
}




function $50e091fb9de20d2d$export$2e2bcd8739ae039(params, $slideEl, side) {
    const shadowClass = `swiper-slide-shadow${side ? `-${side}` : ''}`;
    const $shadowContainer = params.transformEl ? $slideEl.find(params.transformEl) : $slideEl;
    let $shadowEl = $shadowContainer.children(`.${shadowClass}`);
    if (!$shadowEl.length) {
        $shadowEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(`<div class="swiper-slide-shadow${side ? `-${side}` : ''}"></div>`);
        $shadowContainer.append($shadowEl);
    }
    return $shadowEl;
}





function $e3f7a5551d142941$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true,
            transformEl: null
        }
    });
    const createSlideShadows = ($slideEl, progress, params)=>{
        let shadowBefore = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
        let shadowAfter = swiper.isHorizontal() ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
        if (shadowBefore.length === 0) shadowBefore = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'left' : 'top');
        if (shadowAfter.length === 0) shadowAfter = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, swiper.isHorizontal() ? 'right' : 'bottom');
        if (shadowBefore.length) shadowBefore[0].style.opacity = Math.max(-progress, 0);
        if (shadowAfter.length) shadowAfter[0].style.opacity = Math.max(progress, 0);
    };
    const recreateShadows = ()=>{
        // Set shadows
        const params = swiper.params.flipEffect;
        swiper.slides.each((slideEl)=>{
            const $slideEl = (0, $90a9de1e3d9f56dd$export$2e2bcd8739ae039)(slideEl);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows($slideEl, progress, params);
        });
    };
    const setTranslate = ()=>{
        const { slides: slides, rtlTranslate: rtl } = swiper;
        const params = swiper.params.flipEffect;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            let progress = $slideEl[0].progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min($slideEl[0].progress, 1), -1);
            const offset = $slideEl[0].swiperSlideOffset;
            const rotate = -180 * progress;
            let rotateY = rotate;
            let rotateX = 0;
            let tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            $slideEl[0].style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows($slideEl, progress, params);
            const transform = `translate3d(${tx}px, ${ty}px, 0px) rotateX(${rotateX}deg) rotateY(${rotateY}deg)`;
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.flipEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'flip',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: ()=>swiper.params.flipEffect,
        perspective: ()=>true,
        overwriteParams: ()=>({
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}





function $af05481a6c3d5a31$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true,
            transformEl: null
        }
    });
    const setTranslate = ()=>{
        const { width: swiperWidth, height: swiperHeight, slides: slides, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.coverflowEffect;
        const isHorizontal = swiper.isHorizontal();
        const transform = swiper.translate;
        const center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        const rotate = isHorizontal ? params.rotate : -params.rotate;
        const translate = params.depth; // Each slide offset from center
        for(let i = 0, length = slides.length; i < length; i += 1){
            const $slideEl = slides.eq(i);
            const slideSize = slidesSizesGrid[i];
            const slideOffset = $slideEl[0].swiperSlideOffset;
            const centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            const offsetMultiplier = typeof params.modifier === 'function' ? params.modifier(centerOffset) : centerOffset * params.modifier;
            let rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            let rotateX = isHorizontal ? 0 : rotate * offsetMultiplier; // var rotateZ = 0
            let translateZ = -translate * Math.abs(offsetMultiplier);
            let stretch = params.stretch; // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === 'string' && stretch.indexOf('%') !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            let translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            let translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            let scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier); // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            const slideTransform = `translate3d(${translateX}px,${translateY}px,${translateZ}px)  rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(${scale})`;
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(slideTransform);
            $slideEl[0].style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                let $shadowBeforeEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-left') : $slideEl.find('.swiper-slide-shadow-top');
                let $shadowAfterEl = isHorizontal ? $slideEl.find('.swiper-slide-shadow-right') : $slideEl.find('.swiper-slide-shadow-bottom');
                if ($shadowBeforeEl.length === 0) $shadowBeforeEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'left' : 'top');
                if ($shadowAfterEl.length === 0) $shadowAfterEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl, isHorizontal ? 'right' : 'bottom');
                if ($shadowBeforeEl.length) $shadowBeforeEl[0].style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if ($shadowAfterEl.length) $shadowAfterEl[0].style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.coverflowEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left').transition(duration);
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'coverflow',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true
            })
    });
}






function $8abffc196ff25a15$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        creativeEffect: {
            transformEl: null,
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    const getTranslateValue = (value)=>{
        if (typeof value === 'string') return value;
        return `${value}px`;
    };
    const setTranslate = ()=>{
        const { slides: slides, $wrapperEl: $wrapperEl, slidesSizesGrid: slidesSizesGrid } = swiper;
        const params = swiper.params.creativeEffect;
        const { progressMultiplier: multiplier } = params;
        const isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            const margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            $wrapperEl.transform(`translateX(calc(50% - ${margin}px))`);
        }
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max($slideEl[0].progress, -params.limitProgress), params.limitProgress);
            let originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max($slideEl[0].originalProgress, -params.limitProgress), params.limitProgress);
            const offset = $slideEl[0].swiperSlideOffset;
            const t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            const r = [
                0,
                0,
                0
            ];
            let custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            let data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            } // set translate
            t.forEach((value, index)=>{
                t[index] = `calc(${value}px + (${getTranslateValue(data.translate[index])} * ${Math.abs(progress * multiplier)}))`;
            }); // set rotates
            r.forEach((value, index)=>{
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const translateString = t.join(', ');
            const rotateString = `rotateX(${r[0]}deg) rotateY(${r[1]}deg) rotateZ(${r[2]}deg)`;
            const scaleString = originalProgress < 0 ? `scale(${1 + (1 - data.scale) * originalProgress * multiplier})` : `scale(${1 - (1 - data.scale) * originalProgress * multiplier})`;
            const opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            const transform = `translate3d(${translateString}) ${rotateString} ${scaleString}`; // Set shadows
            if (custom && data.shadow || !custom) {
                let $shadowEl = $slideEl.children('.swiper-slide-shadow');
                if ($shadowEl.length === 0 && data.shadow) $shadowEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) {
                    const shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    $shadowEl[0].style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform).css({
                opacity: opacityString
            });
            if (data.origin) $targetEl.css('transform-origin', data.origin);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.creativeEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl,
            allSlides: true
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'creative',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>swiper.params.creativeEffect.perspective,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}






function $403997b391f9cdb3$export$2e2bcd8739ae039({ swiper: swiper, extendParams: extendParams, on: on }) {
    extendParams({
        cardsEffect: {
            slideShadows: true,
            transformEl: null,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    const setTranslate = ()=>{
        const { slides: slides, activeIndex: activeIndex } = swiper;
        const params = swiper.params.cardsEffect;
        const { startTranslate: startTranslate, isTouched: isTouched } = swiper.touchEventsData;
        const currentTranslate = swiper.translate;
        for(let i = 0; i < slides.length; i += 1){
            const $slideEl = slides.eq(i);
            const slideProgress = $slideEl[0].progress;
            const progress = Math.min(Math.max(slideProgress, -4), 4);
            let offset = $slideEl[0].swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.$wrapperEl.transform(`translateX(${swiper.minTranslate()}px)`);
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            let tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            let tY = 0;
            const tZ = -100 * Math.abs(progress);
            let scale = 1;
            let rotate = -params.perSlideRotate * progress;
            let tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            const slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            const isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            const isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                const subProgress = (1 - Math.abs((Math.abs(progress) - 0.5) / 0.5)) ** 0.5;
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = `${-25 * subProgress * Math.abs(progress)}%`;
            }
            if (progress < 0) // next
            tX = `calc(${tX}px + (${tXAdd * Math.abs(progress)}%))`;
            else if (progress > 0) // prev
            tX = `calc(${tX}px + (-${tXAdd * Math.abs(progress)}%))`;
            else tX = `${tX}px`;
            if (!swiper.isHorizontal()) {
                const prevY = tY;
                tY = tX;
                tX = prevY;
            }
            const scaleString = progress < 0 ? `${1 + (1 - scale) * progress}` : `${1 - (1 - scale) * progress}`;
            const transform = `
        translate3d(${tX}, ${tY}, ${tZ}px)
        rotateZ(${params.rotate ? rotate : 0}deg)
        scale(${scaleString})
      `;
            if (params.slideShadows) {
                // Set shadows
                let $shadowEl = $slideEl.find('.swiper-slide-shadow');
                if ($shadowEl.length === 0) $shadowEl = (0, $50e091fb9de20d2d$export$2e2bcd8739ae039)(params, $slideEl);
                if ($shadowEl.length) $shadowEl[0].style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            $slideEl[0].style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            const $targetEl = (0, $869bdd50588521f3$export$2e2bcd8739ae039)(params, $slideEl);
            $targetEl.transform(transform);
        }
    };
    const setTransition = (duration)=>{
        const { transformEl: transformEl } = swiper.params.cardsEffect;
        const $transitionElements = transformEl ? swiper.slides.find(transformEl) : swiper.slides;
        $transitionElements.transition(duration).find('.swiper-slide-shadow').transition(duration);
        (0, $7ee679e4e1fc3cdd$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformEl: transformEl
        });
    };
    (0, $c4cb41250e7e6a0a$export$2e2bcd8739ae039)({
        effect: 'cards',
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: ()=>true,
        overwriteParams: ()=>({
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            })
    });
}




/**
 * Function for disabling Swiper autoscroll when Swiper is not in viewport
 */ const $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a = (swiperInstance)=>{
    const observerOptions = {
        root: null,
        rootMargin: '0px',
        threshold: 0.85
    };
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (entry.isIntersecting) swiperInstance.autoplay.start();
            else swiperInstance.autoplay.stop();
        });
    }, observerOptions);
    observer.observe(swiperInstance.el);
};


if (document.getElementsByClassName('testimonials-section__slider')[0]) {
    const testimonialsSlidersArr = document.querySelectorAll('.testimonials-section__slider');
    testimonialsSlidersArr.forEach((sliderEl, sliderIdx)=>{
        /*const slides = sliderEl.querySelectorAll('.swiper-slide');
    let loop = false;
    let loopedSlides = false;

    if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/ let pauseOnMouseEnter = window.innerWidth > 1024;
        const testimonialsSwiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(sliderEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            slidesPerView: 'auto',
            spaceBetween: 12,
            threshold: 10,
            /*loop: loop,
      loopedSlides: loopedSlides,*/ autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: pauseOnMouseEnter
            },
            navigation: {
                prevEl: sliderEl.querySelector('.slider-buttons .slider-btn.prev'),
                nextEl: sliderEl.querySelector('.slider-buttons .slider-btn.next')
            },
            breakpoints: {
                651: {
                    spaceBetween: 16
                }
            }
        });
    /*swiperObserver(testimonialsSwiper);*/ });
}




if (document.getElementsByClassName('recipes-section__slider')[0]) {
    const recipesSlidersArr = document.querySelectorAll('.recipes-section__slider');
    recipesSlidersArr.forEach((sliderEl, sliderIdx)=>{
        /*const slides = sliderEl.querySelectorAll('.swiper-slide');
    let loop = false;
    let loopedSlides = false;

    if (slides.length >= 4) {
      loop = true;
      loopedSlides = slides.length * 4;
    }*/ let pauseOnMouseEnter = window.innerWidth > 1024;
        const mainPrevEl = sliderEl.querySelector('.slider-buttons .slider-btn.prev');
        const mainNextEl = sliderEl.querySelector('.slider-buttons .slider-btn.next');
        const deskPrevEl = document.querySelector('.slider-buttons.with-desk .slider-btn.prev');
        const deskNextEl = document.querySelector('.slider-buttons.with-desk .slider-btn.next');
        const navigationConfig = {
            prevEl: [],
            nextEl: []
        };
        if (mainPrevEl) navigationConfig.prevEl.push(mainPrevEl);
        if (mainNextEl) navigationConfig.nextEl.push(mainNextEl);
        if (deskPrevEl) navigationConfig.prevEl.push(deskPrevEl);
        if (deskNextEl) navigationConfig.nextEl.push(deskNextEl);
        const recipesSwiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(sliderEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            slidesPerView: 1,
            spaceBetween: 20,
            threshold: 10,
            /*loop: loop,
      loopedSlides: loopedSlides,*/ autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: pauseOnMouseEnter
            },
            navigation: navigationConfig,
            breakpoints: {
                360: {
                    spaceBetween: 12,
                    slidesPerView: 1.025
                },
                451: {
                    spaceBetween: 20,
                    slidesPerView: 1.5
                },
                1200: {
                    spaceBetween: 16,
                    slidesPerView: 2
                }
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(recipesSwiper);
    });
}




let $d66d12db91ff6d84$var$valuesSwiperWr = document.querySelectorAll('.values-swiper-wr');
$d66d12db91ff6d84$var$valuesSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.slider-btn.next');
        let prevEl = el.querySelector('.slider-btn.prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 8,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 8,
                    slidesPerView: 2
                },
                640: {
                    spaceBetween: 16,
                    slidesPerView: 2
                },
                1024: {
                    spaceBetween: 16,
                    slidesPerView: 3
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            },
            on: {
                afterInit: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') : wrapper.classList.add('justify-center');
                },
                resize: function() {
                    wrapper.scrollWidth >= wrapper.clientWidth ? wrapper.classList.remove('justify-center') : wrapper.classList.add('justify-center');
                }
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $883c182a124e6a2e$var$productsSwiperWr = document.querySelectorAll('.products-swiper-wr');
$883c182a124e6a2e$var$productsSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.slider-btn.next');
        let prevEl = el.querySelector('.slider-btn.prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 12,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 12,
                    slidesPerView: 2
                },
                768: {
                    spaceBetween: 12,
                    slidesPerView: 3
                },
                1023: {
                    spaceBetween: 16,
                    slidesPerView: 3
                },
                1200: {
                    spaceBetween: 16,
                    slidesPerView: 4
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $8142a2ec81ada476$var$videosSwiperWr = document.querySelectorAll('.videos-swiper-wr');
$8142a2ec81ada476$var$videosSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.slider-btn.next');
        let prevEl = el.querySelector('.slider-btn.prev');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 20,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            breakpoints: {
                551: {
                    spaceBetween: 12,
                    slidesPerView: 1.5
                },
                768: {
                    spaceBetween: 12,
                    slidesPerView: 2
                },
                1023: {
                    spaceBetween: 14,
                    slidesPerView: 2
                },
                1200: {
                    spaceBetween: 16,
                    slidesPerView: 2
                }
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $24c8a9ccc7f4876b$var$productSwiperWr = document.querySelectorAll('.product-swiper-wr');
$24c8a9ccc7f4876b$var$productSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        let nextEl = el.querySelector('.slider-btn.next');
        let prevEl = el.querySelector('.slider-btn.prev');
        let paginationEl = el.querySelector('.swiper-pagination');
        let slidesCount = el.querySelectorAll('.swiper-slide').length;
        let wrapper = swiperEl.querySelector('.swiper-wrapper');
        if (slidesCount === 1) el.classList.add('one-slide');
        let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
            modules: [
                (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                (0, $482b46abf0b619ea$export$2e2bcd8739ae039),
                (0, $66a0766673700297$export$2e2bcd8739ae039)
            ],
            observer: true,
            observeParents: true,
            spaceBetween: 0,
            slidesPerView: 1,
            threshold: 10,
            navigation: {
                nextEl: nextEl,
                prevEl: prevEl
            },
            pagination: {
                el: paginationEl,
                clickable: true
            },
            autoplay: {
                delay: 4000,
                disableOnInteraction: false,
                pauseOnMouseEnter: window.innerWidth >= 640
            }
        });
        (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
    }
});




let $644debfdc2b42d3c$var$feedbackSwiperWr = document.querySelectorAll('.feedback-swiper-wr');
$644debfdc2b42d3c$var$feedbackSwiperWr.forEach((el)=>{
    if (el) {
        let swiperEl = el.querySelector('.swiper');
        if (swiperEl) {
            let nextEl = el.querySelector('.slider-btn.next');
            let prevEl = el.querySelector('.slider-btn.prev');
            let slidesCount = el.querySelectorAll('.swiper-slide').length;
            let wrapper = swiperEl.querySelector('.swiper-wrapper');
            let swiper = new (0, $85f4b8a35c4e1acd$export$2e2bcd8739ae039)(swiperEl, {
                modules: [
                    (0, $11e8d961c11b7050$export$2e2bcd8739ae039),
                    (0, $482b46abf0b619ea$export$2e2bcd8739ae039)
                ],
                observer: true,
                observeParents: true,
                spaceBetween: 12,
                slidesPerView: 1,
                threshold: 10,
                navigation: {
                    nextEl: nextEl,
                    prevEl: prevEl
                },
                breakpoints: {
                    551: {
                        spaceBetween: 12,
                        slidesPerView: 1.5
                    },
                    768: {
                        spaceBetween: 12,
                        slidesPerView: 2
                    },
                    1023: {
                        spaceBetween: 16,
                        slidesPerView: 2
                    },
                    1200: {
                        spaceBetween: 32,
                        slidesPerView: 2
                    }
                },
                autoplay: {
                    delay: 4000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: window.innerWidth >= 640
                }
            });
            (0, $8cfce3d5cca9b8e8$export$1ef7ff889bcb5d7a)(swiper);
        } else // console.log(121);
        document.querySelectorAll('.feedback-section__buttons + .slider-buttons .slider-btn').forEach((btn)=>{
            // console.log(btn);
            btn.style.display = 'none';
        });
    }
});


const $5ed3e9da97e00e56$var$searchSection = document.querySelector('.search-section');
const $5ed3e9da97e00e56$var$categoriesPopup = document.querySelector('.categories-popup');
if ($5ed3e9da97e00e56$var$searchSection) {
    const stickyBtn = $5ed3e9da97e00e56$var$searchSection.querySelector('.sticky-button');
    const categoriesPopupClose = $5ed3e9da97e00e56$var$searchSection.querySelector('.categories-popup-close');
    const categoriesPopupCloseBg = $5ed3e9da97e00e56$var$searchSection.querySelector('.categories-popup-close-bg');
    let nextSection = $5ed3e9da97e00e56$var$searchSection.nextElementSibling;
    while(nextSection && nextSection.tagName !== 'SECTION')nextSection = nextSection.nextElementSibling;
    window.addEventListener('scroll', ()=>{
        const scrollPosition = window.innerHeight + window.scrollY;
        const documentHeight = document.documentElement.offsetHeight;
        const threshold = documentHeight * 0.1;
        if (scrollPosition >= documentHeight - threshold) stickyBtn.classList.add('is-hidden');
        else stickyBtn.classList.remove('is-hidden');
    });
    if (nextSection) {
        const observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                if (entry.isIntersecting) stickyBtn.classList.add('is-hidden');
                else stickyBtn.classList.remove('is-hidden');
            });
        }, {
            threshold: 0,
            rootMargin: '0% 0% 10% 0%'
        });
        observer.observe(nextSection);
    }
    stickyBtn.addEventListener('click', ()=>{
        $5ed3e9da97e00e56$var$categoriesPopup.classList.add('is-open');
        categoriesPopupCloseBg.classList.add('is-open');
        scrollLock.disablePageScroll(document.querySelector('.navbar-nav .menu'));
        scrollLock.addScrollableSelector('.simplebar-content-wrapper');
    });
    categoriesPopupClose.addEventListener('click', ()=>{
        $5ed3e9da97e00e56$var$categoriesPopup.classList.remove('is-open');
        categoriesPopupCloseBg.classList.remove('is-open');
        scrollLock.enablePageScroll();
    });
    categoriesPopupCloseBg.addEventListener('click', ()=>{
        $5ed3e9da97e00e56$var$categoriesPopup.classList.remove('is-open');
        categoriesPopupCloseBg.classList.remove('is-open');
        scrollLock.enablePageScroll();
    });
/*const categoriesCheckboxes = document.querySelectorAll(
    '.search-section__category input'
  );
  const categoriesMobileCheckboxes = document.querySelectorAll(
    '.categories-popup__category input'
  );

  function syncCheckboxes(sourceCheckboxes, targetCheckboxes) {
    sourceCheckboxes.forEach((sourceCheckbox, index) => {
      sourceCheckbox.addEventListener('change', () => {
        targetCheckboxes[index].checked = sourceCheckbox.checked;
        console.log(targetCheckboxes[index].checked, sourceCheckbox.checked);
      });
    });
  }

  syncCheckboxes(categoriesCheckboxes, categoriesMobileCheckboxes);

  syncCheckboxes(categoriesMobileCheckboxes, categoriesCheckboxes);*/ }


const $26f1fd5a76811548$var$faqAccordion = document.getElementsByClassName('faq-section__accordion')[0];
if ($26f1fd5a76811548$var$faqAccordion) {
    const faqItemsArr = $26f1fd5a76811548$var$faqAccordion.querySelectorAll('.faq-section__item');
    faqItemsArr.forEach((item, i)=>{
        const btn = item.querySelector('.faq-section__item-btn');
        const content = item.querySelector('.faq-section__item-content');
        const itemID = item.getAttribute('id');
        item.addEventListener('click', (event)=>{
            if (event.target !== btn) openAccordion(item);
            else if (event.target === btn && item.classList.contains('active')) item.classList.remove('active');
            else openAccordion(item);
        });
        function openAccordion(item) {
            for(let j = 0; j < faqItemsArr.length; j++)faqItemsArr[j].classList.remove('active');
            item.classList.add('active');
            content.style.maxHeight = `${itemCalcMaxHeight(item, content)}px`;
            setTimeout(function() {
                scrollToEl(`#${itemID}|300|150`);
            }, 310);
        }
        function itemCalcMaxHeight(item, content) {
            const children = Array.from(content.children);
            const totalHeight = children.reduce((acc, child)=>{
                const childHeight = child.offsetHeight;
                return acc + childHeight;
            }, 0);
            return totalHeight + 100;
        }
    });
}


// tabs?
const $0a25492647135480$var$tabs = document?.querySelectorAll('.locations-item');
if ($0a25492647135480$var$tabs[0]) {
    $0a25492647135480$var$tabs[0]?.classList.add('active');
    $0a25492647135480$var$tabs.forEach((item)=>{
        const tabNav = item.querySelector('.locations-item__nav');
        const tabBody = item.querySelector('.locations-item__body');
        const tabBodyItemFirst = item.querySelector('.locations-item__body .locations-item__info');
        // console.log(tabBody);
        tabBody.style.maxHeight = `${tabBodyItemFirst.clientHeight}px`;
        item.addEventListener('click', ()=>{
            if (item.classList.contains('active')) return;
            $0a25492647135480$var$tabs.forEach((t)=>t.classList.remove('active'));
            item.classList.add('active');
        });
    });
}


const $aac4a0a3dc1c0ce2$var$tabItems = document.querySelectorAll('.delivery-zones__nav-item'), $aac4a0a3dc1c0ce2$var$tabContents = document.querySelectorAll('.delivery-zones__content');
if ($aac4a0a3dc1c0ce2$var$tabItems && $aac4a0a3dc1c0ce2$var$tabContents) {
    $aac4a0a3dc1c0ce2$var$tabItems[0]?.classList.add('active');
    $aac4a0a3dc1c0ce2$var$tabContents[0]?.classList.add('active');
    $aac4a0a3dc1c0ce2$var$tabItems?.forEach((item, i)=>{
        item?.addEventListener('click', ()=>{
            if (item?.classList.contains('active')) return;
            $aac4a0a3dc1c0ce2$var$tabItems?.forEach((t)=>t.classList.remove('active'));
            $aac4a0a3dc1c0ce2$var$tabContents?.forEach((t)=>t.classList.remove('active'));
            item?.classList.add('active');
            $aac4a0a3dc1c0ce2$var$tabContents[i]?.classList.add('active');
        });
    });
}


const $5640a85516837bd7$var$authTabs = document.querySelectorAll('.authorization-tab'), $5640a85516837bd7$var$authForms = document.querySelectorAll('.authorization-form');
if ($5640a85516837bd7$var$authTabs && $5640a85516837bd7$var$authForms) {
    $5640a85516837bd7$var$authTabs[0]?.classList.add('active');
    $5640a85516837bd7$var$authForms[0]?.classList.add('active');
    $5640a85516837bd7$var$authTabs?.forEach((item, i)=>{
        item?.addEventListener('click', ()=>{
            if (item?.classList.contains('active')) return;
            $5640a85516837bd7$var$authTabs?.forEach((t)=>t.classList.remove('active'));
            $5640a85516837bd7$var$authForms?.forEach((t)=>t.classList.remove('active'));
            item?.classList.add('active');
            $5640a85516837bd7$var$authForms[i]?.classList.add('active');
        });
    });
}


if (document.getElementsByClassName('title-decor')[0]) {
    function afterFontsLoaded() {
        const titlesDecorArr = document.querySelectorAll('.title-decor');
        const sharedSVG = document.getElementById('title-decor-svg').cloneNode(true);
        titlesDecorArr.forEach((titleDecorEl)=>{
            titleWidthCalc(titleDecorEl);
            generateTitleDecor(titleDecorEl);
            const titleDecorPath = titleDecorEl.querySelector('path');
            getPathLength(titleDecorPath);
        });
        function generateTitleDecor(element) {
            const svg = sharedSVG.cloneNode(true);
            element.appendChild(svg);
        }
        function getPathLength(figure) {
            figure.style.strokeDasharray = `${figure.getTotalLength()}`;
            figure.style.strokeDashoffset = `${figure.getTotalLength()}`;
        }
        function titleWidthCalc(element) {
            const parentContainer = element.parentElement;
            const heading = element.previousElementSibling;
            parentContainer.style.setProperty('--title-width', `${Math.ceil(heading.clientWidth + 2)}px`);
        }
        window.addEventListener('resize', ()=>{
            if (window.innerWidth >= 640) for(let i = 0; i < titlesDecorArr.length; i++)titleWidthCalc(titlesDecorArr[i]);
        });
    }
    document.fonts.ready.then(afterFontsLoaded);
}


const $63e98197a6d20fc0$var$items = document.querySelectorAll('.profile__orders-item');
if ($63e98197a6d20fc0$var$items.length) {
    $63e98197a6d20fc0$var$items[0].classList.add('active');
    $63e98197a6d20fc0$var$items[0].style.maxHeight = `5000px`;
    $63e98197a6d20fc0$var$items.forEach((item)=>{
        const itemToggle = item.querySelector('.profile__orders-item__nav');
        const itemBody = item.querySelector('.profile__orders-item__body');
        const itemBottom = item.querySelector('.profile__orders-item__bottom');
        itemToggle.addEventListener('click', ()=>{
            const itemH = itemToggle.clientHeight + itemBody.scrollHeight + itemBottom.scrollHeight + 60;
            if (item.classList.contains('active')) {
                item.classList.remove('active');
                item.style.maxHeight = `${itemToggle.clientHeight}px`;
                return;
            }
            $63e98197a6d20fc0$var$items.forEach((i)=>{
                i.classList.remove('active');
                i.style.maxHeight = `${itemToggle.clientHeight}px`;
            });
            item.classList.add('active');
            item.style.maxHeight = `${itemH}px`;
        });
    });
}


var $aaf9df1af6f2db2f$var$t = function() {
    return $aaf9df1af6f2db2f$var$t = Object.assign || function(t) {
        for(var i, n = 1, s = arguments.length; n < s; n++)for(var a in i = arguments[n])Object.prototype.hasOwnProperty.call(i, a) && (t[a] = i[a]);
        return t;
    }, $aaf9df1af6f2db2f$var$t.apply(this, arguments);
}, $aaf9df1af6f2db2f$export$1567cc001e3d0c1d = function() {
    function i(i, n, s) {
        var a = this;
        this.endVal = n, this.options = s, this.version = "2.8.1", this.defaults = {
            startVal: 0,
            decimalPlaces: 0,
            duration: 2,
            useEasing: !0,
            useGrouping: !0,
            useIndianSeparators: !1,
            smartEasingThreshold: 999,
            smartEasingAmount: 333,
            separator: ",",
            decimal: ".",
            prefix: "",
            suffix: "",
            enableScrollSpy: !1,
            scrollSpyDelay: 200,
            scrollSpyOnce: !1
        }, this.finalEndVal = null, this.useEasing = !0, this.countDown = !1, this.error = "", this.startVal = 0, this.paused = !0, this.once = !1, this.count = function(t) {
            a.startTime || (a.startTime = t);
            var i = t - a.startTime;
            a.remaining = a.duration - i, a.useEasing ? a.countDown ? a.frameVal = a.startVal - a.easingFn(i, 0, a.startVal - a.endVal, a.duration) : a.frameVal = a.easingFn(i, a.startVal, a.endVal - a.startVal, a.duration) : a.frameVal = a.startVal + (a.endVal - a.startVal) * (i / a.duration);
            var n = a.countDown ? a.frameVal < a.endVal : a.frameVal > a.endVal;
            a.frameVal = n ? a.endVal : a.frameVal, a.frameVal = Number(a.frameVal.toFixed(a.options.decimalPlaces)), a.printValue(a.frameVal), i < a.duration ? a.rAF = requestAnimationFrame(a.count) : null !== a.finalEndVal ? a.update(a.finalEndVal) : a.options.onCompleteCallback && a.options.onCompleteCallback();
        }, this.formatNumber = function(t) {
            var i, n, s, e, o = t < 0 ? "-" : "";
            i = Math.abs(t).toFixed(a.options.decimalPlaces);
            var r = (i += "").split(".");
            if (n = r[0], s = r.length > 1 ? a.options.decimal + r[1] : "", a.options.useGrouping) {
                e = "";
                for(var l = 3, h = 0, u = 0, p = n.length; u < p; ++u)a.options.useIndianSeparators && 4 === u && (l = 2, h = 1), 0 !== u && h % l == 0 && (e = a.options.separator + e), h++, e = n[p - u - 1] + e;
                n = e;
            }
            return a.options.numerals && a.options.numerals.length && (n = n.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            }), s = s.replace(/[0-9]/g, function(t) {
                return a.options.numerals[+t];
            })), o + a.options.prefix + n + s + a.options.suffix;
        }, this.easeOutExpo = function(t, i, n, s) {
            return n * (1 - Math.pow(2, -10 * t / s)) * 1024 / 1023 + i;
        }, this.options = $aaf9df1af6f2db2f$var$t($aaf9df1af6f2db2f$var$t({}, this.defaults), s), this.formattingFn = this.options.formattingFn ? this.options.formattingFn : this.formatNumber, this.easingFn = this.options.easingFn ? this.options.easingFn : this.easeOutExpo, this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.endVal = this.validateValue(n), this.options.decimalPlaces = Math.max(this.options.decimalPlaces), this.resetDuration(), this.options.separator = String(this.options.separator), this.useEasing = this.options.useEasing, "" === this.options.separator && (this.options.useGrouping = !1), this.el = "string" == typeof i ? document.getElementById(i) : i, this.el ? this.printValue(this.startVal) : this.error = "[CountUp] target is null or undefined", "undefined" != typeof window && this.options.enableScrollSpy && (this.error ? console.error(this.error, i) : (window.onScrollFns = window.onScrollFns || [], window.onScrollFns.push(function() {
            return a.handleScroll(a);
        }), window.onscroll = function() {
            window.onScrollFns.forEach(function(t) {
                return t();
            });
        }, this.handleScroll(this)));
    }
    return i.prototype.handleScroll = function(t) {
        if (t && window && !t.once) {
            var i = window.innerHeight + window.scrollY, n = t.el.getBoundingClientRect(), s = n.top + window.pageYOffset, a = n.top + n.height + window.pageYOffset;
            a < i && a > window.scrollY && t.paused ? (t.paused = !1, setTimeout(function() {
                return t.start();
            }, t.options.scrollSpyDelay), t.options.scrollSpyOnce && (t.once = !0)) : (window.scrollY > a || s > i) && !t.paused && t.reset();
        }
    }, i.prototype.determineDirectionAndSmartEasing = function() {
        var t = this.finalEndVal ? this.finalEndVal : this.endVal;
        this.countDown = this.startVal > t;
        var i = t - this.startVal;
        if (Math.abs(i) > this.options.smartEasingThreshold && this.options.useEasing) {
            this.finalEndVal = t;
            var n = this.countDown ? 1 : -1;
            this.endVal = t + n * this.options.smartEasingAmount, this.duration = this.duration / 2;
        } else this.endVal = t, this.finalEndVal = null;
        null !== this.finalEndVal ? this.useEasing = !1 : this.useEasing = this.options.useEasing;
    }, i.prototype.start = function(t) {
        this.error || (this.options.onStartCallback && this.options.onStartCallback(), t && (this.options.onCompleteCallback = t), this.duration > 0 ? (this.determineDirectionAndSmartEasing(), this.paused = !1, this.rAF = requestAnimationFrame(this.count)) : this.printValue(this.endVal));
    }, i.prototype.pauseResume = function() {
        this.paused ? (this.startTime = null, this.duration = this.remaining, this.startVal = this.frameVal, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count)) : cancelAnimationFrame(this.rAF), this.paused = !this.paused;
    }, i.prototype.reset = function() {
        cancelAnimationFrame(this.rAF), this.paused = !0, this.resetDuration(), this.startVal = this.validateValue(this.options.startVal), this.frameVal = this.startVal, this.printValue(this.startVal);
    }, i.prototype.update = function(t) {
        cancelAnimationFrame(this.rAF), this.startTime = null, this.endVal = this.validateValue(t), this.endVal !== this.frameVal && (this.startVal = this.frameVal, null == this.finalEndVal && this.resetDuration(), this.finalEndVal = null, this.determineDirectionAndSmartEasing(), this.rAF = requestAnimationFrame(this.count));
    }, i.prototype.printValue = function(t) {
        var i;
        if (this.el) {
            var n = this.formattingFn(t);
            if (null === (i = this.options.plugin) || void 0 === i ? void 0 : i.render) this.options.plugin.render(this.el, n);
            else if ("INPUT" === this.el.tagName) this.el.value = n;
            else "text" === this.el.tagName || "tspan" === this.el.tagName ? this.el.textContent = n : this.el.innerHTML = n;
        }
    }, i.prototype.ensureNumber = function(t) {
        return "number" == typeof t && !isNaN(t);
    }, i.prototype.validateValue = function(t) {
        var i = Number(t);
        return this.ensureNumber(i) ? i : (this.error = "[CountUp] invalid start or end value: ".concat(t), null);
    }, i.prototype.resetDuration = function() {
        this.startTime = null, this.duration = 1e3 * Number(this.options.duration), this.remaining = this.duration;
    }, i;
}();


/**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 * **/ /**
 * CountUp Metamorfosi function
 * (just add .count-up class anywhere and setup unique option in data attributes)
 * **/ const $4f5e25340686dc37$var$counts = Array.from(document.getElementsByClassName('count-up'));
if ($4f5e25340686dc37$var$counts) {
    const defaultOptions = {
        separator: '',
        enableScrollSpy: true,
        scrollSpyRunOnce: true
    };
    let idNumber = 1;
    $4f5e25340686dc37$var$counts.forEach((count)=>{
        const id = `count-up-${idNumber}`, value = parseFloat(count.innerHTML);
        let optionsFromDataAttr = {
            ...count.dataset
        };
        for(const key in optionsFromDataAttr)if (optionsFromDataAttr[key] === '') optionsFromDataAttr[key] = true;
        count.id = id;
        new (0, $aaf9df1af6f2db2f$export$1567cc001e3d0c1d)(id, value, Object.assign(Object.assign({}, defaultOptions), optionsFromDataAttr));
        idNumber++;
    });
}


// Google Map Function
var $9744a98b8b2ebaa5$export$2e2bcd8739ae039 = {
    type: 'FeatureCollection',
    name: 'Green Zones',
    crs: {
        type: 'name',
        properties: {
            name: 'urn:ogc:def:crs:OGC:1.3:CRS84'
        }
    },
    features: [
        {
            type: 'Feature',
            properties: {
                Name: "\u041B\u044C\u0432\u0456\u0432"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.013943,
                            49.769242
                        ],
                        [
                            24.032011,
                            49.768106
                        ],
                        [
                            24.033421,
                            49.76798
                        ],
                        [
                            24.034418,
                            49.767873
                        ],
                        [
                            24.034212,
                            49.768569
                        ],
                        [
                            24.034746,
                            49.769407
                        ],
                        [
                            24.034832,
                            49.770904
                        ],
                        [
                            24.035433,
                            49.770848
                        ],
                        [
                            24.035433,
                            49.771901
                        ],
                        [
                            24.037407,
                            49.772012
                        ],
                        [
                            24.037836,
                            49.775116
                        ],
                        [
                            24.034661,
                            49.775726
                        ],
                        [
                            24.035572,
                            49.778554
                        ],
                        [
                            24.039553,
                            49.777333
                        ],
                        [
                            24.04127,
                            49.782211
                        ],
                        [
                            24.038094,
                            49.783208
                        ],
                        [
                            24.039295,
                            49.785591
                        ],
                        [
                            24.040894,
                            49.785648
                        ],
                        [
                            24.043469,
                            49.787089
                        ],
                        [
                            24.042096,
                            49.788197
                        ],
                        [
                            24.044156,
                            49.789084
                        ],
                        [
                            24.047589,
                            49.789195
                        ],
                        [
                            24.047761,
                            49.787532
                        ],
                        [
                            24.049477,
                            49.787311
                        ],
                        [
                            24.049477,
                            49.785537
                        ],
                        [
                            24.051537,
                            49.78587
                        ],
                        [
                            24.051881,
                            49.78066
                        ],
                        [
                            24.061322,
                            49.780771
                        ],
                        [
                            24.070935,
                            49.780993
                        ],
                        [
                            24.07969,
                            49.783542
                        ],
                        [
                            24.091019,
                            49.779441
                        ],
                        [
                            24.107541,
                            49.783874
                        ],
                        [
                            24.092736,
                            49.794514
                        ],
                        [
                            24.081406,
                            49.801938
                        ],
                        [
                            24.081235,
                            49.805151
                        ],
                        [
                            24.078488,
                            49.806148
                        ],
                        [
                            24.077973,
                            49.807588
                        ],
                        [
                            24.079518,
                            49.807366
                        ],
                        [
                            24.08072,
                            49.808918
                        ],
                        [
                            24.079175,
                            49.809914
                        ],
                        [
                            24.081235,
                            49.810801
                        ],
                        [
                            24.083466,
                            49.810025
                        ],
                        [
                            24.087414,
                            49.810468
                        ],
                        [
                            24.089303,
                            49.815675
                        ],
                        [
                            24.092393,
                            49.81944
                        ],
                        [
                            24.091363,
                            49.821102
                        ],
                        [
                            24.093766,
                            49.82232
                        ],
                        [
                            24.097952,
                            49.822587
                        ],
                        [
                            24.099754,
                            49.822809
                        ],
                        [
                            24.101299,
                            49.822864
                        ],
                        [
                            24.103617,
                            49.824193
                        ],
                        [
                            24.118466,
                            49.824969
                        ],
                        [
                            24.119988,
                            49.824954
                        ],
                        [
                            24.120782,
                            49.825051
                        ],
                        [
                            24.124216,
                            49.825855
                        ],
                        [
                            24.128486,
                            49.826463
                        ],
                        [
                            24.112476,
                            49.833172
                        ],
                        [
                            24.112992,
                            49.833283
                        ],
                        [
                            24.112649,
                            49.838376
                        ],
                        [
                            24.111619,
                            49.839704
                        ],
                        [
                            24.114194,
                            49.840922
                        ],
                        [
                            24.115224,
                            49.840147
                        ],
                        [
                            24.118142,
                            49.841365
                        ],
                        [
                            24.11797,
                            49.843136
                        ],
                        [
                            24.113507,
                            49.843911
                        ],
                        [
                            24.104581,
                            49.842361
                        ],
                        [
                            24.103722,
                            49.84369
                        ],
                        [
                            24.095483,
                            49.846014
                        ],
                        [
                            24.098401,
                            49.847786
                        ],
                        [
                            24.099602,
                            49.851549
                        ],
                        [
                            24.093766,
                            49.852213
                        ],
                        [
                            24.092564,
                            49.853541
                        ],
                        [
                            24.089303,
                            49.854094
                        ],
                        [
                            24.089818,
                            49.855312
                        ],
                        [
                            24.082093,
                            49.859407
                        ],
                        [
                            24.083981,
                            49.862616
                        ],
                        [
                            24.091363,
                            49.863833
                        ],
                        [
                            24.08793,
                            49.86494
                        ],
                        [
                            24.089174,
                            49.870555
                        ],
                        [
                            24.088093,
                            49.873266
                        ],
                        [
                            24.086385,
                            49.873542
                        ],
                        [
                            24.084496,
                            49.873625
                        ],
                        [
                            24.083295,
                            49.873708
                        ],
                        [
                            24.078394,
                            49.87429
                        ],
                        [
                            24.077973,
                            49.874012
                        ],
                        [
                            24.063554,
                            49.875893
                        ],
                        [
                            24.061322,
                            49.881092
                        ],
                        [
                            24.059463,
                            49.886132
                        ],
                        [
                            24.049706,
                            49.889624
                        ],
                        [
                            24.040464,
                            49.892672
                        ],
                        [
                            24.035341,
                            49.892403
                        ],
                        [
                            24.029954,
                            49.895749
                        ],
                        [
                            24.022269,
                            49.897795
                        ],
                        [
                            24.022322,
                            49.896332
                        ],
                        [
                            24.019627,
                            49.895753
                        ],
                        [
                            24.019046,
                            49.892163
                        ],
                        [
                            24.016853,
                            49.891398
                        ],
                        [
                            24.015213,
                            49.890696
                        ],
                        [
                            24.013395,
                            49.887136
                        ],
                        [
                            24.011904,
                            49.884439
                        ],
                        [
                            24.009093,
                            49.882918
                        ],
                        [
                            24.008021,
                            49.881479
                        ],
                        [
                            24.001841,
                            49.877829
                        ],
                        [
                            23.998922,
                            49.876612
                        ],
                        [
                            23.997936,
                            49.876032
                        ],
                        [
                            23.996906,
                            49.876086
                        ],
                        [
                            23.995404,
                            49.876197
                        ],
                        [
                            23.993858,
                            49.873818
                        ],
                        [
                            23.992872,
                            49.873874
                        ],
                        [
                            23.99328,
                            49.87516
                        ],
                        [
                            23.991778,
                            49.875423
                        ],
                        [
                            23.991392,
                            49.874551
                        ],
                        [
                            23.991134,
                            49.874317
                        ],
                        [
                            23.990297,
                            49.874579
                        ],
                        [
                            23.988924,
                            49.874662
                        ],
                        [
                            23.983988,
                            49.873127
                        ],
                        [
                            23.986821,
                            49.875395
                        ],
                        [
                            23.984246,
                            49.874455
                        ],
                        [
                            23.978066,
                            49.875893
                        ],
                        [
                            23.974976,
                            49.878105
                        ],
                        [
                            23.966565,
                            49.878105
                        ],
                        [
                            23.966565,
                            49.879101
                        ],
                        [
                            23.958668,
                            49.881203
                        ],
                        [
                            23.943906,
                            49.880981
                        ],
                        [
                            23.943391,
                            49.879543
                        ],
                        [
                            23.944764,
                            49.879212
                        ],
                        [
                            23.943047,
                            49.87722
                        ],
                        [
                            23.942125,
                            49.874261
                        ],
                        [
                            23.937597,
                            49.874579
                        ],
                        [
                            23.933456,
                            49.873155
                        ],
                        [
                            23.924079,
                            49.874261
                        ],
                        [
                            23.923714,
                            49.872975
                        ],
                        [
                            23.923306,
                            49.872989
                        ],
                        [
                            23.923027,
                            49.873044
                        ],
                        [
                            23.922019,
                            49.873127
                        ],
                        [
                            23.915581,
                            49.87357
                        ],
                        [
                            23.912319,
                            49.86837
                        ],
                        [
                            23.91068,
                            49.8658196
                        ],
                        [
                            23.91068,
                            49.865709
                        ],
                        [
                            23.9117185,
                            49.865991
                        ],
                        [
                            23.919263,
                            49.8652528
                        ],
                        [
                            23.9155811,
                            49.8539838
                        ],
                        [
                            23.9227055,
                            49.8522681
                        ],
                        [
                            23.9245943,
                            49.8520881
                        ],
                        [
                            23.9270268,
                            49.851952
                        ],
                        [
                            23.9344217,
                            49.8507189
                        ],
                        [
                            23.9384979,
                            49.8495568
                        ],
                        [
                            23.9446599,
                            49.8468953
                        ],
                        [
                            23.9490191,
                            49.845064
                        ],
                        [
                            23.9483864,
                            49.8440511
                        ],
                        [
                            23.9463697,
                            49.8438962
                        ],
                        [
                            23.9438745,
                            49.8437269
                        ],
                        [
                            23.9412352,
                            49.8426752
                        ],
                        [
                            23.9331457,
                            49.8438929
                        ],
                        [
                            23.9308283,
                            49.8424261
                        ],
                        [
                            23.9303133,
                            49.8406133
                        ],
                        [
                            23.9224383,
                            49.8395201
                        ],
                        [
                            23.9180539,
                            49.839246
                        ],
                        [
                            23.909745,
                            49.8380992
                        ],
                        [
                            23.902706,
                            49.83356
                        ],
                        [
                            23.903994,
                            49.831622
                        ],
                        [
                            23.905754,
                            49.829462
                        ],
                        [
                            23.907805,
                            49.826984
                        ],
                        [
                            23.909831,
                            49.823843
                        ],
                        [
                            23.910389,
                            49.823316
                        ],
                        [
                            23.910775,
                            49.823095
                        ],
                        [
                            23.912397,
                            49.82045
                        ],
                        [
                            23.914423,
                            49.819302
                        ],
                        [
                            23.919873,
                            49.814567
                        ],
                        [
                            23.92086,
                            49.81357
                        ],
                        [
                            23.922963,
                            49.811355
                        ],
                        [
                            23.924293,
                            49.811133
                        ],
                        [
                            23.925366,
                            49.811022
                        ],
                        [
                            23.92778,
                            49.810534
                        ],
                        [
                            23.931718,
                            49.80925
                        ],
                        [
                            23.938584,
                            49.809139
                        ],
                        [
                            23.951459,
                            49.807699
                        ],
                        [
                            23.952832,
                            49.807145
                        ],
                        [
                            23.95575,
                            49.807477
                        ],
                        [
                            23.962102,
                            49.804929
                        ],
                        [
                            23.962445,
                            49.802603
                        ],
                        [
                            23.959623,
                            49.798735
                        ],
                        [
                            23.964122,
                            49.797656
                        ],
                        [
                            23.96468,
                            49.790536
                        ],
                        [
                            23.96438,
                            49.786656
                        ],
                        [
                            23.968585,
                            49.78649
                        ],
                        [
                            23.968929,
                            49.785271
                        ],
                        [
                            23.977598,
                            49.785604
                        ],
                        [
                            23.987039,
                            49.783221
                        ],
                        [
                            23.987382,
                            49.786213
                        ],
                        [
                            23.99176,
                            49.785659
                        ],
                        [
                            23.99133,
                            49.783221
                        ],
                        [
                            23.992618,
                            49.783165
                        ],
                        [
                            23.99545,
                            49.78638
                        ],
                        [
                            23.998197,
                            49.786601
                        ],
                        [
                            23.999141,
                            49.787432
                        ],
                        [
                            24.008926,
                            49.787377
                        ],
                        [
                            24.008926,
                            49.786934
                        ],
                        [
                            24.00987,
                            49.786712
                        ],
                        [
                            24.010127,
                            49.787543
                        ],
                        [
                            24.01193,
                            49.787543
                        ],
                        [
                            24.012227,
                            49.783764
                        ],
                        [
                            24.012874,
                            49.779784
                        ],
                        [
                            24.011883,
                            49.777362
                        ],
                        [
                            24.011518,
                            49.774729
                        ],
                        [
                            24.008032,
                            49.774716
                        ],
                        [
                            24.007962,
                            49.771411
                        ],
                        [
                            24.007948,
                            49.769647
                        ],
                        [
                            24.013943,
                            49.769242
                        ]
                    ]
                ]
            }
        }
    ]
};


var $d93554ad9578c35d$export$2e2bcd8739ae039 = {
    type: 'FeatureCollection',
    name: 'Yellow Zones',
    crs: {
        type: 'name',
        properties: {
            name: 'urn:ogc:def:crs:OGC:1.3:CRS84'
        }
    },
    features: [
        {
            type: 'Feature',
            properties: {
                Name: "\u0421\u043E\u043B\u043E\u043D\u043A\u0430"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.953586,
                            49.740643
                        ],
                        [
                            23.952813,
                            49.740199
                        ],
                        [
                            23.951698,
                            49.740033
                        ],
                        [
                            23.951955,
                            49.739034
                        ],
                        [
                            23.950496,
                            49.737703
                        ],
                        [
                            23.951182,
                            49.737703
                        ],
                        [
                            23.951526,
                            49.736594
                        ],
                        [
                            23.953242,
                            49.736427
                        ],
                        [
                            23.954873,
                            49.735595
                        ],
                        [
                            23.956075,
                            49.735762
                        ],
                        [
                            23.966546,
                            49.735595
                        ],
                        [
                            23.980107,
                            49.739423
                        ],
                        [
                            24.007058,
                            49.743527
                        ],
                        [
                            24.011865,
                            49.741974
                        ],
                        [
                            24.01813,
                            49.734874
                        ],
                        [
                            24.031949,
                            49.734264
                        ],
                        [
                            24.032464,
                            49.73737
                        ],
                        [
                            24.038558,
                            49.738702
                        ],
                        [
                            24.050539,
                            49.752663
                        ],
                        [
                            24.049938,
                            49.753439
                        ],
                        [
                            24.049252,
                            49.753217
                        ],
                        [
                            24.048347,
                            49.754667
                        ],
                        [
                            24.047964,
                            49.755269
                        ],
                        [
                            24.045561,
                            49.754714
                        ],
                        [
                            24.045046,
                            49.755158
                        ],
                        [
                            24.043844,
                            49.755102
                        ],
                        [
                            24.042828,
                            49.75717
                        ],
                        [
                            24.041956,
                            49.758928
                        ],
                        [
                            24.042729,
                            49.759372
                        ],
                        [
                            24.042986,
                            49.760481
                        ],
                        [
                            24.042168,
                            49.760431
                        ],
                        [
                            24.041441,
                            49.76037
                        ],
                        [
                            24.039896,
                            49.7673
                        ],
                        [
                            24.034418,
                            49.767873
                        ],
                        [
                            24.026456,
                            49.768452
                        ],
                        [
                            24.022508,
                            49.76873
                        ],
                        [
                            24.020792,
                            49.768868
                        ],
                        [
                            24.018817,
                            49.768924
                        ],
                        [
                            24.01444,
                            49.769201
                        ],
                        [
                            24.011993,
                            49.769283
                        ],
                        [
                            24.009548,
                            49.769478
                        ],
                        [
                            24.006114,
                            49.769755
                        ],
                        [
                            23.996834,
                            49.77125
                        ],
                        [
                            23.988241,
                            49.773909
                        ],
                        [
                            23.983091,
                            49.773743
                        ],
                        [
                            23.98309,
                            49.770085
                        ],
                        [
                            23.981632,
                            49.769697
                        ],
                        [
                            23.98558,
                            49.766648
                        ],
                        [
                            23.983349,
                            49.761658
                        ],
                        [
                            23.981374,
                            49.760716
                        ],
                        [
                            23.974594,
                            49.759773
                        ],
                        [
                            23.974614,
                            49.754841
                        ],
                        [
                            23.993926,
                            49.758223
                        ],
                        [
                            23.994784,
                            49.755063
                        ],
                        [
                            23.986545,
                            49.753454
                        ],
                        [
                            23.98869,
                            49.748796
                        ],
                        [
                            23.969894,
                            49.740366
                        ],
                        [
                            23.960967,
                            49.739534
                        ],
                        [
                            23.953586,
                            49.740643
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041C\u0430\u043B\u0435\u0447\u043A\u043E\u0432\u0438\u0447\u0456"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.935522,
                            49.754178
                        ],
                        [
                            23.937668,
                            49.751212
                        ],
                        [
                            23.940408,
                            49.749983
                        ],
                        [
                            23.937297,
                            49.748056
                        ],
                        [
                            23.93859,
                            49.741561
                        ],
                        [
                            23.953586,
                            49.740643
                        ],
                        [
                            23.960967,
                            49.739534
                        ],
                        [
                            23.96876,
                            49.740202
                        ],
                        [
                            23.98869,
                            49.748796
                        ],
                        [
                            23.986545,
                            49.753454
                        ],
                        [
                            23.994784,
                            49.755063
                        ],
                        [
                            23.993926,
                            49.758223
                        ],
                        [
                            23.974614,
                            49.754841
                        ],
                        [
                            23.974594,
                            49.759773
                        ],
                        [
                            23.972963,
                            49.760105
                        ],
                        [
                            23.957194,
                            49.75892
                        ],
                        [
                            23.952517,
                            49.760832
                        ],
                        [
                            23.949684,
                            49.757852
                        ],
                        [
                            23.946187,
                            49.755565
                        ],
                        [
                            23.945114,
                            49.756396
                        ],
                        [
                            23.93947,
                            49.753472
                        ],
                        [
                            23.937389,
                            49.754941
                        ],
                        [
                            23.935522,
                            49.754178
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0411\u0430\u0441\u0456\u0432\u043A\u0430"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.881985,
                            49.783613
                        ],
                        [
                            23.877106,
                            49.778375
                        ],
                        [
                            23.901984,
                            49.77807
                        ],
                        [
                            23.904322,
                            49.775299
                        ],
                        [
                            23.90694,
                            49.748048
                        ],
                        [
                            23.9292,
                            49.756205
                        ],
                        [
                            23.932597,
                            49.753431
                        ],
                        [
                            23.935522,
                            49.754178
                        ],
                        [
                            23.937389,
                            49.754941
                        ],
                        [
                            23.938492,
                            49.754298
                        ],
                        [
                            23.93947,
                            49.753472
                        ],
                        [
                            23.942685,
                            49.755008
                        ],
                        [
                            23.943959,
                            49.75583
                        ],
                        [
                            23.945114,
                            49.756396
                        ],
                        [
                            23.946187,
                            49.755565
                        ],
                        [
                            23.949684,
                            49.757852
                        ],
                        [
                            23.955328,
                            49.764835
                        ],
                        [
                            23.962835,
                            49.773521
                        ],
                        [
                            23.944553,
                            49.777124
                        ],
                        [
                            23.947214,
                            49.781614
                        ],
                        [
                            23.944234,
                            49.783501
                        ],
                        [
                            23.942235,
                            49.789039
                        ],
                        [
                            23.938236,
                            49.78968
                        ],
                        [
                            23.929539,
                            49.792059
                        ],
                        [
                            23.930912,
                            49.794054
                        ],
                        [
                            23.927454,
                            49.796412
                        ],
                        [
                            23.922243,
                            49.796186
                        ],
                        [
                            23.915544,
                            49.792811
                        ],
                        [
                            23.905867,
                            49.791454
                        ],
                        [
                            23.890452,
                            49.793004
                        ],
                        [
                            23.886261,
                            49.78853
                        ],
                        [
                            23.881985,
                            49.783613
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041A\u043E\u043D\u043E\u043F\u043D\u0438\u0446\u044F"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.855213,
                            49.828991
                        ],
                        [
                            23.851823,
                            49.817418
                        ],
                        [
                            23.848862,
                            49.815203
                        ],
                        [
                            23.848862,
                            49.814843
                        ],
                        [
                            23.848518,
                            49.814483
                        ],
                        [
                            23.845858,
                            49.814178
                        ],
                        [
                            23.845557,
                            49.813818
                        ],
                        [
                            23.845342,
                            49.809636
                        ],
                        [
                            23.850879,
                            49.807088
                        ],
                        [
                            23.85178,
                            49.806064
                        ],
                        [
                            23.851565,
                            49.805261
                        ],
                        [
                            23.860062,
                            49.804762
                        ],
                        [
                            23.859376,
                            49.805731
                        ],
                        [
                            23.865985,
                            49.805704
                        ],
                        [
                            23.867144,
                            49.808418
                        ],
                        [
                            23.868045,
                            49.808501
                        ],
                        [
                            23.870319,
                            49.808279
                        ],
                        [
                            23.89343,
                            49.80825
                        ],
                        [
                            23.893171,
                            49.816685
                        ],
                        [
                            23.89081,
                            49.818706
                        ],
                        [
                            23.885532,
                            49.817294
                        ],
                        [
                            23.885489,
                            49.819786
                        ],
                        [
                            23.871756,
                            49.817709
                        ],
                        [
                            23.868002,
                            49.817141
                        ],
                        [
                            23.869289,
                            49.820575
                        ],
                        [
                            23.868924,
                            49.820616
                        ],
                        [
                            23.869653,
                            49.82117
                        ],
                        [
                            23.869332,
                            49.82362
                        ],
                        [
                            23.868752,
                            49.829338
                        ],
                        [
                            23.863173,
                            49.82978
                        ],
                        [
                            23.863066,
                            49.828742
                        ],
                        [
                            23.862915,
                            49.82704
                        ],
                        [
                            23.858753,
                            49.827234
                        ],
                        [
                            23.858818,
                            49.828853
                        ],
                        [
                            23.855213,
                            49.828991
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0421\u0443\u0445\u043E\u0432\u043E\u043B\u044F"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.845557,
                            49.813818
                        ],
                        [
                            23.845858,
                            49.814178
                        ],
                        [
                            23.848518,
                            49.814483
                        ],
                        [
                            23.8488572,
                            49.8147597
                        ],
                        [
                            23.848862,
                            49.815203
                        ],
                        [
                            23.851823,
                            49.817418
                        ],
                        [
                            23.855213,
                            49.828991
                        ],
                        [
                            23.858818,
                            49.828853
                        ],
                        [
                            23.858881,
                            49.829393
                        ],
                        [
                            23.860426,
                            49.831331
                        ],
                        [
                            23.858967,
                            49.834071
                        ],
                        [
                            23.860984,
                            49.835953
                        ],
                        [
                            23.857398,
                            49.835964
                        ],
                        [
                            23.857226,
                            49.841388
                        ],
                        [
                            23.8518538,
                            49.8403659
                        ],
                        [
                            23.8465323,
                            49.8411409
                        ],
                        [
                            23.8434424,
                            49.8434656
                        ],
                        [
                            23.8360609,
                            49.8451261
                        ],
                        [
                            23.8310827,
                            49.8440191
                        ],
                        [
                            23.8254179,
                            49.8443512
                        ],
                        [
                            23.8168349,
                            49.8426907
                        ],
                        [
                            23.8166632,
                            49.8395356
                        ],
                        [
                            23.826877,
                            49.8349963
                        ],
                        [
                            23.8322844,
                            49.8300136
                        ],
                        [
                            23.8308253,
                            49.8249197
                        ],
                        [
                            23.8372626,
                            49.8187177
                        ],
                        [
                            23.8338293,
                            49.8161148
                        ],
                        [
                            23.8229288,
                            49.8176101
                        ],
                        [
                            23.8220705,
                            49.8137888
                        ],
                        [
                            23.8455131,
                            49.8131795
                        ],
                        [
                            23.845557,
                            49.813818
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0411\u0456\u0440\u043A\u0438"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.930488,
                            49.917334
                        ],
                        [
                            23.92993,
                            49.919157
                        ],
                        [
                            23.930789,
                            49.921865
                        ],
                        [
                            23.929287,
                            49.923882
                        ],
                        [
                            23.926368,
                            49.925982
                        ],
                        [
                            23.923751,
                            49.925429
                        ],
                        [
                            23.922892,
                            49.926092
                        ],
                        [
                            23.91903,
                            49.92601
                        ],
                        [
                            23.915039,
                            49.924297
                        ],
                        [
                            23.913108,
                            49.921754
                        ],
                        [
                            23.91182,
                            49.92134
                        ],
                        [
                            23.911004,
                            49.920816
                        ],
                        [
                            23.91109,
                            49.919185
                        ],
                        [
                            23.910447,
                            49.915758
                        ],
                        [
                            23.904739,
                            49.908628
                        ],
                        [
                            23.910061,
                            49.906694
                        ],
                        [
                            23.91388,
                            49.90686
                        ],
                        [
                            23.917914,
                            49.905726
                        ],
                        [
                            23.916884,
                            49.90404
                        ],
                        [
                            23.924289,
                            49.900856
                        ],
                        [
                            23.926692,
                            49.905168
                        ],
                        [
                            23.92695,
                            49.906992
                        ],
                        [
                            23.92386,
                            49.9097
                        ],
                        [
                            23.924804,
                            49.910751
                        ],
                        [
                            23.924718,
                            49.911856
                        ],
                        [
                            23.92592,
                            49.91263
                        ],
                        [
                            23.926349,
                            49.913901
                        ],
                        [
                            23.930488,
                            49.917334
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0414\u0443\u0431\u043B\u044F\u043D\u0438"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.0682609,
                            49.9107449
                        ],
                        [
                            24.0675742,
                            49.9048855
                        ],
                        [
                            24.0680892,
                            49.9017898
                        ],
                        [
                            24.0740115,
                            49.9015133
                        ],
                        [
                            24.0738399,
                            49.8975327
                        ],
                        [
                            24.079333,
                            49.8971457
                        ],
                        [
                            24.0827662,
                            49.8993019
                        ],
                        [
                            24.0875728,
                            49.8999101
                        ],
                        [
                            24.0913493,
                            49.8962058
                        ],
                        [
                            24.0888602,
                            49.8895706
                        ],
                        [
                            24.093694,
                            49.890907
                        ],
                        [
                            24.0974433,
                            49.8927777
                        ],
                        [
                            24.0916926,
                            49.8933306
                        ],
                        [
                            24.0925509,
                            49.8962611
                        ],
                        [
                            24.0924651,
                            49.897588
                        ],
                        [
                            24.0971858,
                            49.8995784
                        ],
                        [
                            24.0970141,
                            49.9026743
                        ],
                        [
                            24.0988166,
                            49.9048303
                        ],
                        [
                            24.0973575,
                            49.9062675
                        ],
                        [
                            24.0981299,
                            49.9082022
                        ],
                        [
                            24.0930659,
                            49.9092525
                        ],
                        [
                            24.0743548,
                            49.9110765
                        ],
                        [
                            24.0682609,
                            49.9107449
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041F\u0456\u0434\u0431\u0456\u0440\u0446\u0456"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.1172261,
                            49.8494833
                        ],
                        [
                            24.118849,
                            49.843759
                        ],
                        [
                            24.125008,
                            49.844036
                        ],
                        [
                            24.1247505,
                            49.84296
                        ],
                        [
                            24.1381831,
                            49.841853
                        ],
                        [
                            24.1382689,
                            49.8402201
                        ],
                        [
                            24.1447491,
                            49.8397495
                        ],
                        [
                            24.1455645,
                            49.8412994
                        ],
                        [
                            24.166593,
                            49.8394866
                        ],
                        [
                            24.1674513,
                            49.840649
                        ],
                        [
                            24.1685671,
                            49.8433059
                        ],
                        [
                            24.1690392,
                            49.8453539
                        ],
                        [
                            24.1592545,
                            49.847125
                        ],
                        [
                            24.1576237,
                            49.8486746
                        ],
                        [
                            24.1385264,
                            49.8496155
                        ],
                        [
                            24.1346712,
                            49.8477814
                        ],
                        [
                            24.1172261,
                            49.8494833
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0412\u0438\u043D\u043D\u0438\u043A\u0438"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.077973,
                            49.807588
                        ],
                        [
                            24.078488,
                            49.806148
                        ],
                        [
                            24.081235,
                            49.805151
                        ],
                        [
                            24.081406,
                            49.801938
                        ],
                        [
                            24.094648,
                            49.793073
                        ],
                        [
                            24.107541,
                            49.783874
                        ],
                        [
                            24.123302,
                            49.779198
                        ],
                        [
                            24.1341,
                            49.782391
                        ],
                        [
                            24.140095,
                            49.789573
                        ],
                        [
                            24.142584,
                            49.793896
                        ],
                        [
                            24.144902,
                            49.796388
                        ],
                        [
                            24.146446,
                            49.797497
                        ],
                        [
                            24.148478,
                            49.798874
                        ],
                        [
                            24.150108,
                            49.801256
                        ],
                        [
                            24.155029,
                            49.809573
                        ],
                        [
                            24.155029,
                            49.810625
                        ],
                        [
                            24.155973,
                            49.811068
                        ],
                        [
                            24.157089,
                            49.812065
                        ],
                        [
                            24.158291,
                            49.814502
                        ],
                        [
                            24.159235,
                            49.817327
                        ],
                        [
                            24.156403,
                            49.825356
                        ],
                        [
                            24.157347,
                            49.830007
                        ],
                        [
                            24.154772,
                            49.830284
                        ],
                        [
                            24.150137,
                            49.827128
                        ],
                        [
                            24.128486,
                            49.826463
                        ],
                        [
                            24.124216,
                            49.825855
                        ],
                        [
                            24.120782,
                            49.825051
                        ],
                        [
                            24.119988,
                            49.824954
                        ],
                        [
                            24.118466,
                            49.824969
                        ],
                        [
                            24.103617,
                            49.824193
                        ],
                        [
                            24.101299,
                            49.822864
                        ],
                        [
                            24.099754,
                            49.822809
                        ],
                        [
                            24.097952,
                            49.822587
                        ],
                        [
                            24.093766,
                            49.82232
                        ],
                        [
                            24.091363,
                            49.821102
                        ],
                        [
                            24.092393,
                            49.81944
                        ],
                        [
                            24.089303,
                            49.815675
                        ],
                        [
                            24.087414,
                            49.810468
                        ],
                        [
                            24.083466,
                            49.810025
                        ],
                        [
                            24.081235,
                            49.810801
                        ],
                        [
                            24.079175,
                            49.809914
                        ],
                        [
                            24.08072,
                            49.808918
                        ],
                        [
                            24.079518,
                            49.807366
                        ],
                        [
                            24.077973,
                            49.807588
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0427\u0438\u0448\u043A\u0438"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.148478,
                            49.798874
                        ],
                        [
                            24.149121,
                            49.798347
                        ],
                        [
                            24.167661,
                            49.796574
                        ],
                        [
                            24.171008,
                            49.797433
                        ],
                        [
                            24.170665,
                            49.796187
                        ],
                        [
                            24.173025,
                            49.79458
                        ],
                        [
                            24.174785,
                            49.795189
                        ],
                        [
                            24.174441,
                            49.796187
                        ],
                        [
                            24.176244,
                            49.79627
                        ],
                        [
                            24.175858,
                            49.79433
                        ],
                        [
                            24.17972,
                            49.794441
                        ],
                        [
                            24.179977,
                            49.795937
                        ],
                        [
                            24.188646,
                            49.794718
                        ],
                        [
                            24.188518,
                            49.79361
                        ],
                        [
                            24.191221,
                            49.79361
                        ],
                        [
                            24.191135,
                            49.794469
                        ],
                        [
                            24.195126,
                            49.794497
                        ],
                        [
                            24.195169,
                            49.793416
                        ],
                        [
                            24.20607,
                            49.793222
                        ],
                        [
                            24.205984,
                            49.794247
                        ],
                        [
                            24.211778,
                            49.794137
                        ],
                        [
                            24.212164,
                            49.793278
                        ],
                        [
                            24.214825,
                            49.793195
                        ],
                        [
                            24.214825,
                            49.795937
                        ],
                        [
                            24.192981,
                            49.796048
                        ],
                        [
                            24.192938,
                            49.797572
                        ],
                        [
                            24.189333,
                            49.797212
                        ],
                        [
                            24.189076,
                            49.796159
                        ],
                        [
                            24.178132,
                            49.797599
                        ],
                        [
                            24.177574,
                            49.799012
                        ],
                        [
                            24.180321,
                            49.799317
                        ],
                        [
                            24.179977,
                            49.800231
                        ],
                        [
                            24.177488,
                            49.801588
                        ],
                        [
                            24.176158,
                            49.801644
                        ],
                        [
                            24.175772,
                            49.800259
                        ],
                        [
                            24.172338,
                            49.79843
                        ],
                        [
                            24.170794,
                            49.799151
                        ],
                        [
                            24.150108,
                            49.801256
                        ],
                        [
                            24.148478,
                            49.798874
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0414\u0430\u0432\u0438\u0434\u0456\u0432"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.122865,
                            49.758191
                        ],
                        [
                            24.120119,
                            49.757609
                        ],
                        [
                            24.117415,
                            49.756527
                        ],
                        [
                            24.117844,
                            49.756001
                        ],
                        [
                            24.119947,
                            49.75589
                        ],
                        [
                            24.122136,
                            49.753755
                        ],
                        [
                            24.119947,
                            49.75162
                        ],
                        [
                            24.128659,
                            49.747072
                        ],
                        [
                            24.122994,
                            49.745464
                        ],
                        [
                            24.129045,
                            49.743356
                        ],
                        [
                            24.134538,
                            49.741138
                        ],
                        [
                            24.137371,
                            49.738919
                        ],
                        [
                            24.138272,
                            49.736228
                        ],
                        [
                            24.141834,
                            49.737393
                        ],
                        [
                            24.142306,
                            49.739141
                        ],
                        [
                            24.147627,
                            49.738392
                        ],
                        [
                            24.147799,
                            49.737893
                        ],
                        [
                            24.151061,
                            49.736811
                        ],
                        [
                            24.155009,
                            49.734703
                        ],
                        [
                            24.156854,
                            49.735729
                        ],
                        [
                            24.158614,
                            49.734842
                        ],
                        [
                            24.15767,
                            49.734065
                        ],
                        [
                            24.159343,
                            49.733039
                        ],
                        [
                            24.157798,
                            49.732373
                        ],
                        [
                            24.159,
                            49.731347
                        ],
                        [
                            24.162948,
                            49.733233
                        ],
                        [
                            24.165223,
                            49.731402
                        ],
                        [
                            24.166854,
                            49.732012
                        ],
                        [
                            24.162862,
                            49.734592
                        ],
                        [
                            24.160244,
                            49.737782
                        ],
                        [
                            24.156683,
                            49.740084
                        ],
                        [
                            24.154151,
                            49.738808
                        ],
                        [
                            24.150546,
                            49.741138
                        ],
                        [
                            24.151662,
                            49.74111
                        ],
                        [
                            24.150202,
                            49.741609
                        ],
                        [
                            24.155867,
                            49.747239
                        ],
                        [
                            24.151232,
                            49.748403
                        ],
                        [
                            24.137156,
                            49.753367
                        ],
                        [
                            24.131362,
                            49.756805
                        ],
                        [
                            24.125226,
                            49.760048
                        ],
                        [
                            24.122865,
                            49.758191
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041A\u0440\u043E\u0442\u043E\u0448\u0438\u043D"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.060496,
                            49.754049
                        ],
                        [
                            24.05835,
                            49.754382
                        ],
                        [
                            24.050539,
                            49.752663
                        ],
                        [
                            24.041548,
                            49.742355
                        ],
                        [
                            24.079485,
                            49.742493
                        ],
                        [
                            24.072618,
                            49.739997
                        ],
                        [
                            24.07425,
                            49.737833
                        ],
                        [
                            24.082875,
                            49.738333
                        ],
                        [
                            24.085922,
                            49.737889
                        ],
                        [
                            24.087639,
                            49.738555
                        ],
                        [
                            24.089398,
                            49.739276
                        ],
                        [
                            24.088454,
                            49.740136
                        ],
                        [
                            24.092188,
                            49.741134
                        ],
                        [
                            24.093089,
                            49.74069
                        ],
                        [
                            24.107895,
                            49.740496
                        ],
                        [
                            24.114933,
                            49.742355
                        ],
                        [
                            24.109011,
                            49.742909
                        ],
                        [
                            24.113431,
                            49.747512
                        ],
                        [
                            24.122994,
                            49.745464
                        ],
                        [
                            24.128659,
                            49.747072
                        ],
                        [
                            24.119947,
                            49.75162
                        ],
                        [
                            24.122136,
                            49.753755
                        ],
                        [
                            24.119947,
                            49.75589
                        ],
                        [
                            24.117844,
                            49.756001
                        ],
                        [
                            24.117415,
                            49.756527
                        ],
                        [
                            24.120119,
                            49.757609
                        ],
                        [
                            24.122865,
                            49.758191
                        ],
                        [
                            24.125226,
                            49.760048
                        ],
                        [
                            24.119482,
                            49.762789
                        ],
                        [
                            24.114504,
                            49.764675
                        ],
                        [
                            24.113645,
                            49.767225
                        ],
                        [
                            24.123302,
                            49.779198
                        ],
                        [
                            24.104723,
                            49.769539
                        ],
                        [
                            24.100857,
                            49.76509
                        ],
                        [
                            24.096183,
                            49.763469
                        ],
                        [
                            24.091419,
                            49.763247
                        ],
                        [
                            24.084678,
                            49.761181
                        ],
                        [
                            24.074464,
                            49.75816
                        ],
                        [
                            24.060496,
                            49.754049
                        ]
                    ]
                ]
            }
        }
    ]
};


var $6c1b865c69e48d19$export$2e2bcd8739ae039 = {
    type: 'FeatureCollection',
    name: 'Blue Zones',
    crs: {
        type: 'name',
        properties: {
            name: 'urn:ogc:def:crs:OGC:1.3:CRS84'
        }
    },
    features: [
        {
            type: 'Feature',
            properties: {
                Name: "\u0421\u043E\u043A\u0456\u043B\u044C\u043D\u0438\u043A\u0438"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.008032,
                            49.774716
                        ],
                        [
                            24.011518,
                            49.774729
                        ],
                        [
                            24.012874,
                            49.779784
                        ],
                        [
                            24.01193,
                            49.787543
                        ],
                        [
                            24.010127,
                            49.787543
                        ],
                        [
                            24.00987,
                            49.786712
                        ],
                        [
                            24.008926,
                            49.786934
                        ],
                        [
                            24.008926,
                            49.787377
                        ],
                        [
                            23.999141,
                            49.787432
                        ],
                        [
                            23.998197,
                            49.786601
                        ],
                        [
                            23.99545,
                            49.78638
                        ],
                        [
                            23.992618,
                            49.783165
                        ],
                        [
                            23.99133,
                            49.783221
                        ],
                        [
                            23.99176,
                            49.785659
                        ],
                        [
                            23.987382,
                            49.786213
                        ],
                        [
                            23.987039,
                            49.783221
                        ],
                        [
                            23.977598,
                            49.785604
                        ],
                        [
                            23.968929,
                            49.785271
                        ],
                        [
                            23.968585,
                            49.78649
                        ],
                        [
                            23.96438,
                            49.786656
                        ],
                        [
                            23.96468,
                            49.790536
                        ],
                        [
                            23.964122,
                            49.797656
                        ],
                        [
                            23.959623,
                            49.798735
                        ],
                        [
                            23.94928,
                            49.798707
                        ],
                        [
                            23.946276,
                            49.798015
                        ],
                        [
                            23.945418,
                            49.797239
                        ],
                        [
                            23.936277,
                            49.791643
                        ],
                        [
                            23.933616,
                            49.790867
                        ],
                        [
                            23.942235,
                            49.789039
                        ],
                        [
                            23.945497,
                            49.782168
                        ],
                        [
                            23.947214,
                            49.781614
                        ],
                        [
                            23.944553,
                            49.777124
                        ],
                        [
                            23.962835,
                            49.773521
                        ],
                        [
                            23.951849,
                            49.760992
                        ],
                        [
                            23.957194,
                            49.75892
                        ],
                        [
                            23.969444,
                            49.759828
                        ],
                        [
                            23.972963,
                            49.760105
                        ],
                        [
                            23.974594,
                            49.759773
                        ],
                        [
                            23.977769,
                            49.760161
                        ],
                        [
                            23.981374,
                            49.760716
                        ],
                        [
                            23.983349,
                            49.761658
                        ],
                        [
                            23.984893,
                            49.763876
                        ],
                        [
                            23.98558,
                            49.766648
                        ],
                        [
                            23.981632,
                            49.769697
                        ],
                        [
                            23.98309,
                            49.770085
                        ],
                        [
                            23.984979,
                            49.77014
                        ],
                        [
                            23.983091,
                            49.773743
                        ],
                        [
                            23.988241,
                            49.773909
                        ],
                        [
                            23.993477,
                            49.772247
                        ],
                        [
                            23.995279,
                            49.771581
                        ],
                        [
                            23.99854,
                            49.77086
                        ],
                        [
                            24.002231,
                            49.77014
                        ],
                        [
                            24.00472,
                            49.769752
                        ],
                        [
                            24.007948,
                            49.769647
                        ],
                        [
                            24.008032,
                            49.774716
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0421\u043A\u043D\u0438\u043B\u0456\u0432"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.914522,
                            49.802669
                        ],
                        [
                            23.918468,
                            49.801409
                        ],
                        [
                            23.916235,
                            49.797322
                        ],
                        [
                            23.922243,
                            49.796186
                        ],
                        [
                            23.928938,
                            49.79674
                        ],
                        [
                            23.92954,
                            49.796076
                        ],
                        [
                            23.93014,
                            49.795743
                        ],
                        [
                            23.929883,
                            49.795217
                        ],
                        [
                            23.930656,
                            49.795023
                        ],
                        [
                            23.929539,
                            49.792059
                        ],
                        [
                            23.931857,
                            49.791117
                        ],
                        [
                            23.933616,
                            49.790867
                        ],
                        [
                            23.936277,
                            49.791643
                        ],
                        [
                            23.945418,
                            49.797239
                        ],
                        [
                            23.946276,
                            49.798015
                        ],
                        [
                            23.94928,
                            49.798707
                        ],
                        [
                            23.959623,
                            49.798735
                        ],
                        [
                            23.962445,
                            49.802603
                        ],
                        [
                            23.962102,
                            49.804929
                        ],
                        [
                            23.95575,
                            49.807477
                        ],
                        [
                            23.952832,
                            49.807145
                        ],
                        [
                            23.951459,
                            49.807699
                        ],
                        [
                            23.938852,
                            49.809122
                        ],
                        [
                            23.931718,
                            49.80925
                        ],
                        [
                            23.92778,
                            49.810534
                        ],
                        [
                            23.922963,
                            49.811355
                        ],
                        [
                            23.914522,
                            49.802669
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041B\u0430\u043F\u0430\u0457\u0432\u043A\u0430"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.893171,
                            49.816685
                        ],
                        [
                            23.89343,
                            49.80825
                        ],
                        [
                            23.902741,
                            49.807266
                        ],
                        [
                            23.903439,
                            49.803943
                        ],
                        [
                            23.905032,
                            49.802697
                        ],
                        [
                            23.914522,
                            49.802669
                        ],
                        [
                            23.922963,
                            49.811355
                        ],
                        [
                            23.918126,
                            49.810839
                        ],
                        [
                            23.915594,
                            49.811919
                        ],
                        [
                            23.912354,
                            49.812612
                        ],
                        [
                            23.909672,
                            49.81383
                        ],
                        [
                            23.906754,
                            49.815478
                        ],
                        [
                            23.905531,
                            49.816336
                        ],
                        [
                            23.903514,
                            49.818676
                        ],
                        [
                            23.893171,
                            49.816685
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0425\u043E\u043B\u043E\u0434\u043D\u043E\u0432\u0456\u0434\u043A\u0430"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.912902,
                            49.820604
                        ],
                        [
                            23.903192,
                            49.818818
                        ],
                        [
                            23.90603,
                            49.815907
                        ],
                        [
                            23.910499,
                            49.813411
                        ],
                        [
                            23.918126,
                            49.810839
                        ],
                        [
                            23.922963,
                            49.811355
                        ],
                        [
                            23.918878,
                            49.815446
                        ],
                        [
                            23.912902,
                            49.820604
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0417\u0438\u043C\u043D\u0430 \u0412\u043E\u0434\u0430"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.912397,
                            49.82045
                        ],
                        [
                            23.907805,
                            49.826984
                        ],
                        [
                            23.903213,
                            49.832521
                        ],
                        [
                            23.883257,
                            49.83205
                        ],
                        [
                            23.880554,
                            49.832493
                        ],
                        [
                            23.876648,
                            49.833656
                        ],
                        [
                            23.873687,
                            49.834763
                        ],
                        [
                            23.867894,
                            49.835649
                        ],
                        [
                            23.864031,
                            49.835981
                        ],
                        [
                            23.860984,
                            49.835953
                        ],
                        [
                            23.858967,
                            49.834071
                        ],
                        [
                            23.860426,
                            49.831331
                        ],
                        [
                            23.858881,
                            49.829393
                        ],
                        [
                            23.858753,
                            49.827234
                        ],
                        [
                            23.862915,
                            49.82704
                        ],
                        [
                            23.863173,
                            49.82978
                        ],
                        [
                            23.866392,
                            49.829559
                        ],
                        [
                            23.868752,
                            49.829338
                        ],
                        [
                            23.869653,
                            49.82117
                        ],
                        [
                            23.868924,
                            49.820616
                        ],
                        [
                            23.869739,
                            49.820616
                        ],
                        [
                            23.868002,
                            49.817141
                        ],
                        [
                            23.870855,
                            49.817792
                        ],
                        [
                            23.871756,
                            49.817709
                        ],
                        [
                            23.874975,
                            49.818152
                        ],
                        [
                            23.879996,
                            49.818955
                        ],
                        [
                            23.881584,
                            49.819066
                        ],
                        [
                            23.881755,
                            49.819371
                        ],
                        [
                            23.885489,
                            49.819786
                        ],
                        [
                            23.885532,
                            49.817294
                        ],
                        [
                            23.89081,
                            49.818706
                        ],
                        [
                            23.893171,
                            49.816685
                        ],
                        [
                            23.912397,
                            49.82045
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0420\u0443\u0434\u043D\u0435"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.896494,
                            49.843049
                        ],
                        [
                            23.886838,
                            49.842994
                        ],
                        [
                            23.887224,
                            49.839202
                        ],
                        [
                            23.879499,
                            49.842523
                        ],
                        [
                            23.873019,
                            49.844876
                        ],
                        [
                            23.875465,
                            49.845872
                        ],
                        [
                            23.872461,
                            49.847311
                        ],
                        [
                            23.865895,
                            49.848113
                        ],
                        [
                            23.857226,
                            49.841388
                        ],
                        [
                            23.857398,
                            49.835964
                        ],
                        [
                            23.864031,
                            49.835981
                        ],
                        [
                            23.868341,
                            49.835659
                        ],
                        [
                            23.873687,
                            49.834763
                        ],
                        [
                            23.876648,
                            49.833656
                        ],
                        [
                            23.880554,
                            49.832493
                        ],
                        [
                            23.883257,
                            49.83205
                        ],
                        [
                            23.903213,
                            49.832521
                        ],
                        [
                            23.898253,
                            49.839064
                        ],
                        [
                            23.896494,
                            49.843049
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041F\u0456\u0434\u0440\u044F\u0441\u043D\u0435"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.896834,
                            49.847942
                        ],
                        [
                            23.898894,
                            49.870296
                        ],
                        [
                            23.898122,
                            49.871071
                        ],
                        [
                            23.89692,
                            49.871956
                        ],
                        [
                            23.89529,
                            49.872122
                        ],
                        [
                            23.893401,
                            49.87273
                        ],
                        [
                            23.891599,
                            49.872509
                        ],
                        [
                            23.889968,
                            49.872509
                        ],
                        [
                            23.888938,
                            49.873118
                        ],
                        [
                            23.888766,
                            49.87439
                        ],
                        [
                            23.885762,
                            49.875109
                        ],
                        [
                            23.858468,
                            49.878041
                        ],
                        [
                            23.859412,
                            49.8771
                        ],
                        [
                            23.861129,
                            49.87616
                        ],
                        [
                            23.861129,
                            49.875662
                        ],
                        [
                            23.861987,
                            49.874501
                        ],
                        [
                            23.861386,
                            49.874058
                        ],
                        [
                            23.86379,
                            49.873394
                        ],
                        [
                            23.863189,
                            49.872565
                        ],
                        [
                            23.866794,
                            49.871182
                        ],
                        [
                            23.866622,
                            49.869301
                        ],
                        [
                            23.870313,
                            49.86919
                        ],
                        [
                            23.874862,
                            49.866535
                        ],
                        [
                            23.869712,
                            49.863602
                        ],
                        [
                            23.873231,
                            49.862219
                        ],
                        [
                            23.877523,
                            49.855801
                        ],
                        [
                            23.879754,
                            49.854915
                        ],
                        [
                            23.886838,
                            49.842994
                        ],
                        [
                            23.891857,
                            49.842961
                        ],
                        [
                            23.896494,
                            49.843049
                        ],
                        [
                            23.896834,
                            49.847942
                        ]
                    ],
                    [
                        [
                            23.893659,
                            49.849326
                        ],
                        [
                            23.895976,
                            49.848053
                        ],
                        [
                            23.896834,
                            49.847942
                        ],
                        [
                            23.893659,
                            49.849326
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0420\u044F\u0441\u043D\u0435-\u0420\u0443\u0441\u044C\u043A\u0435"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.9239107,
                            49.8787663
                        ],
                        [
                            23.932013,
                            49.89223
                        ],
                        [
                            23.931842,
                            49.8928386
                        ],
                        [
                            23.928924,
                            49.895106
                        ],
                        [
                            23.926863,
                            49.89682
                        ],
                        [
                            23.925061,
                            49.898258
                        ],
                        [
                            23.920598,
                            49.902349
                        ],
                        [
                            23.919772,
                            49.9029566
                        ],
                        [
                            23.916884,
                            49.9041506
                        ],
                        [
                            23.917914,
                            49.9058366
                        ],
                        [
                            23.91388,
                            49.9069706
                        ],
                        [
                            23.910061,
                            49.9068046
                        ],
                        [
                            23.904739,
                            49.9087386
                        ],
                        [
                            23.8590529,
                            49.8781826
                        ],
                        [
                            23.8857619,
                            49.8752196
                        ],
                        [
                            23.8890719,
                            49.8741596
                        ],
                        [
                            23.8889379,
                            49.8732286
                        ],
                        [
                            23.8899679,
                            49.8726196
                        ],
                        [
                            23.89692,
                            49.8720666
                        ],
                        [
                            23.898894,
                            49.8704066
                        ],
                        [
                            23.89905,
                            49.8692846
                        ],
                        [
                            23.898492,
                            49.8640356
                        ],
                        [
                            23.908449,
                            49.8661106
                        ],
                        [
                            23.91068,
                            49.8658196
                        ],
                        [
                            23.915581,
                            49.8736806
                        ],
                        [
                            23.923714,
                            49.8730856
                        ],
                        [
                            23.924326,
                            49.8761596
                        ],
                        [
                            23.929497,
                            49.8758686
                        ],
                        [
                            23.9239107,
                            49.8787663
                        ]
                    ],
                    [
                        [
                            23.92386,
                            49.8787926
                        ],
                        [
                            23.92386,
                            49.878682
                        ],
                        [
                            23.9239107,
                            49.8787663
                        ],
                        [
                            23.92386,
                            49.8787926
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0420\u044F\u0441\u043D\u0435 2"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.924079,
                            49.874261
                        ],
                        [
                            23.933456,
                            49.873155
                        ],
                        [
                            23.937597,
                            49.874579
                        ],
                        [
                            23.942125,
                            49.874261
                        ],
                        [
                            23.943047,
                            49.87722
                        ],
                        [
                            23.944764,
                            49.879212
                        ],
                        [
                            23.943391,
                            49.879543
                        ],
                        [
                            23.943906,
                            49.880981
                        ],
                        [
                            23.942742,
                            49.880783
                        ],
                        [
                            23.94065,
                            49.879774
                        ],
                        [
                            23.937565,
                            49.878234
                        ],
                        [
                            23.932566,
                            49.878787
                        ],
                        [
                            23.930291,
                            49.878773
                        ],
                        [
                            23.92386,
                            49.878682
                        ],
                        [
                            23.929497,
                            49.875758
                        ],
                        [
                            23.924326,
                            49.876049
                        ],
                        [
                            23.924079,
                            49.874261
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0411\u0456\u043B\u043E\u0433\u043E\u0440\u0449\u0430"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.9485488,
                            49.8452484
                        ],
                        [
                            23.9466713,
                            49.8460527
                        ],
                        [
                            23.9447026,
                            49.8468743
                        ],
                        [
                            23.9428063,
                            49.8476975
                        ],
                        [
                            23.9409099,
                            49.8485069
                        ],
                        [
                            23.9384979,
                            49.8495568
                        ],
                        [
                            23.9344217,
                            49.8507189
                        ],
                        [
                            23.9270268,
                            49.851952
                        ],
                        [
                            23.9247445,
                            49.8520673
                        ],
                        [
                            23.9227055,
                            49.8522681
                        ],
                        [
                            23.9155811,
                            49.8539838
                        ],
                        [
                            23.919263,
                            49.8652528
                        ],
                        [
                            23.9117185,
                            49.865991
                        ],
                        [
                            23.91068,
                            49.865709
                        ],
                        [
                            23.908449,
                            49.866
                        ],
                        [
                            23.898492,
                            49.863925
                        ],
                        [
                            23.896494,
                            49.843049
                        ],
                        [
                            23.902706,
                            49.83356
                        ],
                        [
                            23.909745,
                            49.8380992
                        ],
                        [
                            23.9224383,
                            49.8395201
                        ],
                        [
                            23.9303133,
                            49.8406133
                        ],
                        [
                            23.9308283,
                            49.8424261
                        ],
                        [
                            23.9331457,
                            49.8438929
                        ],
                        [
                            23.9412352,
                            49.8426752
                        ],
                        [
                            23.9438745,
                            49.8437269
                        ],
                        [
                            23.9483864,
                            49.8440511
                        ],
                        [
                            23.9490191,
                            49.845064
                        ],
                        [
                            23.9485488,
                            49.8452484
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0411\u0440\u044E\u0445\u043E\u0432\u0438\u0447\u0456"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            23.971582,
                            49.884046
                        ],
                        [
                            23.97244,
                            49.88554
                        ],
                        [
                            23.974844,
                            49.89129
                        ],
                        [
                            23.970895,
                            49.893668
                        ],
                        [
                            23.968148,
                            49.894387
                        ],
                        [
                            23.964973,
                            49.897206
                        ],
                        [
                            23.962741,
                            49.898146
                        ],
                        [
                            23.964028,
                            49.899474
                        ],
                        [
                            23.962998,
                            49.902072
                        ],
                        [
                            23.964973,
                            49.903509
                        ],
                        [
                            23.972182,
                            49.904173
                        ],
                        [
                            23.974457,
                            49.909341
                        ],
                        [
                            23.973642,
                            49.91064
                        ],
                        [
                            23.966088,
                            49.914343
                        ],
                        [
                            23.96832,
                            49.916444
                        ],
                        [
                            23.969522,
                            49.917825
                        ],
                        [
                            23.972011,
                            49.918488
                        ],
                        [
                            23.973126,
                            49.919041
                        ],
                        [
                            23.97862,
                            49.919152
                        ],
                        [
                            23.982654,
                            49.920809
                        ],
                        [
                            23.983512,
                            49.921638
                        ],
                        [
                            23.983254,
                            49.924512
                        ],
                        [
                            23.972096,
                            49.923572
                        ],
                        [
                            23.967118,
                            49.922522
                        ],
                        [
                            23.957505,
                            49.917825
                        ],
                        [
                            23.932443,
                            49.916665
                        ],
                        [
                            23.933044,
                            49.916941
                        ],
                        [
                            23.932786,
                            49.917493
                        ],
                        [
                            23.930488,
                            49.917334
                        ],
                        [
                            23.927002,
                            49.914761
                        ],
                        [
                            23.924718,
                            49.911856
                        ],
                        [
                            23.924804,
                            49.910751
                        ],
                        [
                            23.92386,
                            49.9097
                        ],
                        [
                            23.92695,
                            49.906992
                        ],
                        [
                            23.926692,
                            49.905168
                        ],
                        [
                            23.925448,
                            49.902432
                        ],
                        [
                            23.924289,
                            49.900856
                        ],
                        [
                            23.920598,
                            49.902349
                        ],
                        [
                            23.925061,
                            49.898258
                        ],
                        [
                            23.926863,
                            49.89682
                        ],
                        [
                            23.928924,
                            49.895106
                        ],
                        [
                            23.931155,
                            49.893336
                        ],
                        [
                            23.931842,
                            49.892728
                        ],
                        [
                            23.932013,
                            49.89223
                        ],
                        [
                            23.92386,
                            49.878682
                        ],
                        [
                            23.930291,
                            49.878773
                        ],
                        [
                            23.937565,
                            49.878234
                        ],
                        [
                            23.942742,
                            49.880783
                        ],
                        [
                            23.950553,
                            49.881115
                        ],
                        [
                            23.953214,
                            49.880894
                        ],
                        [
                            23.957848,
                            49.881226
                        ],
                        [
                            23.966565,
                            49.879101
                        ],
                        [
                            23.96686,
                            49.882221
                        ],
                        [
                            23.971582,
                            49.884046
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041C\u0430\u043B\u0435\u0445\u0456\u0432"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.077973,
                            49.874012
                        ],
                        [
                            24.08584,
                            49.879459
                        ],
                        [
                            24.090947,
                            49.881838
                        ],
                        [
                            24.095926,
                            49.883054
                        ],
                        [
                            24.094767,
                            49.884188
                        ],
                        [
                            24.095153,
                            49.885156
                        ],
                        [
                            24.095411,
                            49.886787
                        ],
                        [
                            24.095239,
                            49.887285
                        ],
                        [
                            24.09481,
                            49.888142
                        ],
                        [
                            24.094338,
                            49.88828
                        ],
                        [
                            24.093823,
                            49.888612
                        ],
                        [
                            24.093909,
                            49.888944
                        ],
                        [
                            24.094466,
                            49.888972
                        ],
                        [
                            24.093694,
                            49.890907
                        ],
                        [
                            24.080262,
                            49.886981
                        ],
                        [
                            24.079661,
                            49.888557
                        ],
                        [
                            24.074339,
                            49.88817
                        ],
                        [
                            24.068717,
                            49.89157
                        ],
                        [
                            24.040464,
                            49.892672
                        ],
                        [
                            24.059463,
                            49.886132
                        ],
                        [
                            24.063554,
                            49.875893
                        ],
                        [
                            24.077973,
                            49.874012
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041C\u0443\u0440\u043E\u0432\u0430\u043D\u0435"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.088951,
                            49.869892
                        ],
                        [
                            24.088779,
                            49.868952
                        ],
                        [
                            24.088565,
                            49.867955
                        ],
                        [
                            24.087857,
                            49.865024
                        ],
                        [
                            24.091363,
                            49.863833
                        ],
                        [
                            24.083981,
                            49.862616
                        ],
                        [
                            24.082093,
                            49.859407
                        ],
                        [
                            24.089818,
                            49.855312
                        ],
                        [
                            24.089303,
                            49.854094
                        ],
                        [
                            24.092564,
                            49.853541
                        ],
                        [
                            24.093766,
                            49.852213
                        ],
                        [
                            24.099602,
                            49.851549
                        ],
                        [
                            24.098401,
                            49.847786
                        ],
                        [
                            24.095483,
                            49.846014
                        ],
                        [
                            24.103722,
                            49.84369
                        ],
                        [
                            24.104581,
                            49.842361
                        ],
                        [
                            24.113507,
                            49.843911
                        ],
                        [
                            24.11797,
                            49.843136
                        ],
                        [
                            24.118849,
                            49.843759
                        ],
                        [
                            24.110581,
                            49.872879
                        ],
                        [
                            24.110109,
                            49.874622
                        ],
                        [
                            24.110323,
                            49.877221
                        ],
                        [
                            24.10762,
                            49.877553
                        ],
                        [
                            24.107705,
                            49.878798
                        ],
                        [
                            24.102427,
                            49.879157
                        ],
                        [
                            24.101955,
                            49.878327
                        ],
                        [
                            24.097749,
                            49.879793
                        ],
                        [
                            24.098221,
                            49.881093
                        ],
                        [
                            24.095926,
                            49.883054
                        ],
                        [
                            24.090947,
                            49.881838
                        ],
                        [
                            24.08584,
                            49.879459
                        ],
                        [
                            24.083372,
                            49.877885
                        ],
                        [
                            24.078394,
                            49.87429
                        ],
                        [
                            24.088093,
                            49.873266
                        ],
                        [
                            24.089209,
                            49.870279
                        ],
                        [
                            24.089037,
                            49.870099
                        ],
                        [
                            24.088951,
                            49.869892
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041B\u0438\u0441\u0438\u043D\u0438\u0447\u0456"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.11797,
                            49.843136
                        ],
                        [
                            24.118098,
                            49.841614
                        ],
                        [
                            24.118142,
                            49.841365
                        ],
                        [
                            24.115224,
                            49.840147
                        ],
                        [
                            24.114194,
                            49.840922
                        ],
                        [
                            24.111619,
                            49.839704
                        ],
                        [
                            24.112649,
                            49.838376
                        ],
                        [
                            24.112992,
                            49.833283
                        ],
                        [
                            24.112476,
                            49.833172
                        ],
                        [
                            24.112626,
                            49.832895
                        ],
                        [
                            24.128486,
                            49.826463
                        ],
                        [
                            24.142098,
                            49.826874
                        ],
                        [
                            24.150137,
                            49.827128
                        ],
                        [
                            24.154772,
                            49.830284
                        ],
                        [
                            24.13093,
                            49.838251
                        ],
                        [
                            24.129192,
                            49.838251
                        ],
                        [
                            24.129535,
                            49.839746
                        ],
                        [
                            24.126853,
                            49.839912
                        ],
                        [
                            24.126338,
                            49.841088
                        ],
                        [
                            24.124278,
                            49.841227
                        ],
                        [
                            24.125008,
                            49.844036
                        ],
                        [
                            24.118849,
                            49.843759
                        ],
                        [
                            24.11797,
                            49.843136
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u041F\u0430\u0441\u0456\u043A\u0438-\u0417\u0443\u0431\u0440\u0438\u0446\u044C\u043A\u0456"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.069103,
                            49.780985
                        ],
                        [
                            24.073566,
                            49.777854
                        ],
                        [
                            24.076313,
                            49.775249
                        ],
                        [
                            24.08054,
                            49.767052
                        ],
                        [
                            24.080905,
                            49.766241
                        ],
                        [
                            24.067706,
                            49.761652
                        ],
                        [
                            24.060496,
                            49.754056
                        ],
                        [
                            24.091419,
                            49.763247
                        ],
                        [
                            24.096183,
                            49.763469
                        ],
                        [
                            24.09923,
                            49.764301
                        ],
                        [
                            24.100646,
                            49.764605
                        ],
                        [
                            24.104165,
                            49.768348
                        ],
                        [
                            24.104723,
                            49.769539
                        ],
                        [
                            24.123302,
                            49.779198
                        ],
                        [
                            24.107541,
                            49.783874
                        ],
                        [
                            24.094681,
                            49.780431
                        ],
                        [
                            24.090518,
                            49.7796
                        ],
                        [
                            24.07969,
                            49.783549
                        ],
                        [
                            24.070935,
                            49.781
                        ],
                        [
                            24.069103,
                            49.780985
                        ]
                    ]
                ]
            }
        },
        {
            type: 'Feature',
            properties: {
                Name: "\u0417\u0443\u0431\u0440\u0430"
            },
            geometry: {
                type: 'Polygon',
                coordinates: [
                    [
                        [
                            24.060496,
                            49.754049
                        ],
                        [
                            24.061096,
                            49.754548
                        ],
                        [
                            24.061954,
                            49.755574
                        ],
                        [
                            24.062427,
                            49.756046
                        ],
                        [
                            24.063435,
                            49.757098
                        ],
                        [
                            24.0638,
                            49.757514
                        ],
                        [
                            24.064959,
                            49.758804
                        ],
                        [
                            24.065903,
                            49.759649
                        ],
                        [
                            24.067061,
                            49.761035
                        ],
                        [
                            24.067448,
                            49.761506
                        ],
                        [
                            24.070023,
                            49.762561
                        ],
                        [
                            24.080905,
                            49.766234
                        ],
                        [
                            24.079068,
                            49.769926
                        ],
                        [
                            24.077748,
                            49.772123
                        ],
                        [
                            24.076803,
                            49.774506
                        ],
                        [
                            24.073566,
                            49.777854
                        ],
                        [
                            24.069103,
                            49.780985
                        ],
                        [
                            24.065388,
                            49.780825
                        ],
                        [
                            24.064294,
                            49.780867
                        ],
                        [
                            24.063735,
                            49.780811
                        ],
                        [
                            24.062942,
                            49.780812
                        ],
                        [
                            24.062577,
                            49.780783
                        ],
                        [
                            24.062319,
                            49.780783
                        ],
                        [
                            24.061804,
                            49.780756
                        ],
                        [
                            24.060925,
                            49.780742
                        ],
                        [
                            24.060238,
                            49.78077
                        ],
                        [
                            24.059702,
                            49.780728
                        ],
                        [
                            24.054294,
                            49.780686
                        ],
                        [
                            24.051881,
                            49.78066
                        ],
                        [
                            24.051537,
                            49.78587
                        ],
                        [
                            24.049477,
                            49.785537
                        ],
                        [
                            24.049477,
                            49.787311
                        ],
                        [
                            24.047761,
                            49.787532
                        ],
                        [
                            24.047589,
                            49.789195
                        ],
                        [
                            24.044156,
                            49.789084
                        ],
                        [
                            24.042096,
                            49.788197
                        ],
                        [
                            24.043469,
                            49.787089
                        ],
                        [
                            24.040894,
                            49.785648
                        ],
                        [
                            24.039295,
                            49.785591
                        ],
                        [
                            24.038094,
                            49.783208
                        ],
                        [
                            24.04127,
                            49.782211
                        ],
                        [
                            24.039553,
                            49.777333
                        ],
                        [
                            24.036206,
                            49.778331
                        ],
                        [
                            24.035572,
                            49.778554
                        ],
                        [
                            24.03509,
                            49.777472
                        ],
                        [
                            24.034832,
                            49.776668
                        ],
                        [
                            24.034661,
                            49.775726
                        ],
                        [
                            24.037836,
                            49.775116
                        ],
                        [
                            24.037407,
                            49.772012
                        ],
                        [
                            24.035433,
                            49.771901
                        ],
                        [
                            24.035433,
                            49.770848
                        ],
                        [
                            24.034832,
                            49.770904
                        ],
                        [
                            24.034746,
                            49.769407
                        ],
                        [
                            24.034317,
                            49.768852
                        ],
                        [
                            24.034489,
                            49.767522
                        ],
                        [
                            24.039896,
                            49.7673
                        ],
                        [
                            24.040583,
                            49.76281
                        ],
                        [
                            24.041441,
                            49.76037
                        ],
                        [
                            24.042986,
                            49.760481
                        ],
                        [
                            24.042729,
                            49.759372
                        ],
                        [
                            24.041956,
                            49.758928
                        ],
                        [
                            24.043844,
                            49.755102
                        ],
                        [
                            24.045046,
                            49.755158
                        ],
                        [
                            24.045561,
                            49.754714
                        ],
                        [
                            24.047964,
                            49.755269
                        ],
                        [
                            24.049252,
                            49.753217
                        ],
                        [
                            24.049938,
                            49.753439
                        ],
                        [
                            24.050539,
                            49.752663
                        ],
                        [
                            24.05835,
                            49.754382
                        ],
                        [
                            24.060496,
                            49.754049
                        ]
                    ]
                ]
            }
        }
    ]
};


navigator.sayswho = function() {
    var ua = navigator.userAgent;
    var tem;
    var M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
        tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
        return 'IE ' + (tem[1] || '');
    }
    if (M[1] === 'Chrome') {
        tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
        if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera');
    }
    M = M[2] ? [
        M[1],
        M[2]
    ] : [
        navigator.appName,
        navigator.appVersion,
        '-?'
    ];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M.join(' ');
}();
/**
 * Function check for touchscreen device
 * **/ function $ce71ac302ea43ba0$var$is_touch_enabled() {
    return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}
/**
 * newShade function, convert hexColor to lighter or darker variant
 * @params hexColor, magnitude
 * @param hexColor - color in HEX format, type: string, default: ['#ffffff']
 * @param magnitude - amount of percentage to tint, lighter if > 0, darker if < 0, type: number
 * **/ window.disableCheckoutBtn = function disableCheckoutBtn1() {
    const btn = document.getElementById('checkout-btn');
    btn.disabled = true;
    btn.classList.add('disabled-type');
};
window.enableCheckoutBtn = function enableCheckoutBtn1() {
    const btn = document.getElementById('checkout-btn');
    btn.disabled = false;
    btn.classList.remove('disabled-type');
};
window.enableCheckoutRemoveZoneBtn = function enableCheckoutRemoveZoneBtn() {
    const btn = document.getElementById('checkout-btn');
    const orderZone = document.querySelector('.order__zone');
    btn.disabled = false;
    btn.classList.remove('disabled-type');
    if (orderZone) {
        orderZone.classList.add('!opacity-0', '!transition', '!duration-300', '!ease-in-out');
        setTimeout(function() {
            orderZone.classList.add('!hidden');
            orderZone.classList.remove('!opacity-0', '!transition', '!duration-300', '!ease-in-out');
        }, 400);
    }
};
// console.log(12345);
const $ce71ac302ea43ba0$var$newShade = (hexColor, magnitude)=>{
    hexColor = hexColor.replace(`#`, ``);
    if (hexColor.length === 6) {
        const decimalColor = parseInt(hexColor, 16);
        let r = (decimalColor >> 16) + magnitude;
        r > 255 && (r = 255);
        r < 0 && (r = 0);
        let g = (decimalColor & 0x0000ff) + magnitude;
        g > 255 && (g = 255);
        g < 0 && (g = 0);
        let b = (decimalColor >> 8 & 0x00ff) + magnitude;
        b > 255 && (b = 255);
        b < 0 && (b = 0);
        return `#${(g | b << 8 | r << 16).toString(16)}`;
    } else return hexColor;
};
// Custom Popup content
function $ce71ac302ea43ba0$var$popupContent(data1) {
    return `
        <div class="flex flex-col bg-white rounded-none">
            <h3 class="my-4 font-medium text-blue text-xl px-3">$${Number(data1.price).toLocaleString('en-GB')}</h3>
            <p class="mb-4 px-3 text-base text-blue">${data1.location}</p>
            <img class="w-full h-auto" src="${data1.image}" alt="">
        </div>
    `;
}
// Sort delivery zones points
function $ce71ac302ea43ba0$var$sortPointsForPolygon(points) {
    // Get the center (mean value) using reduce
    const center = points.reduce((acc, { lat: lat, lng: lng })=>{
        acc.lat += lat / points.length;
        acc.lng += lng / points.length;
        return acc;
    }, {
        lat: 0,
        lng: 0
    });
    // Add an angle property to each point using tan(angle) = y/x
    const angles = points.map(({ lat: lat, lng: lng })=>{
        return {
            lat: lat,
            lng: lng,
            angle: Math.atan2(lng - center.lng, lat - center.lat) * 180 / Math.PI
        };
    });
    // Sort your points by angle
    const sortByAngles = angles.sort((a, b)=>a.angle - b.angle);
    // delete Angle Property
    sortByAngles.forEach((elem)=>delete elem.angle);
    return sortByAngles;
}
// Parse GeoJSON to Normal appearance
function $ce71ac302ea43ba0$var$parseGeoJsonToLocations(geoJsonData) {
    const locations = geoJsonData.features.map((feature)=>{
        const name = feature.properties.Name;
        const coordinates = feature.geometry.coordinates[0].map((coord)=>({
                lat: coord[1],
                lng: coord[0]
            }));
        return {
            name: name,
            coordinates: coordinates
        };
    });
    return {
        name: geoJsonData.name,
        locations: locations
    };
}
function $ce71ac302ea43ba0$var$initMapFunc(google1, map1, marker, json1, defaultJson, zoom, defaultCenter) {
    const mapID = 'DEMO_MAP_ID';
    const myStyles = [
        {
            featureType: 'poi',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        }
    ];
    const mapStyles = [
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#d3d3d3'
                }
            ]
        },
        {
            featureType: 'transit',
            stylers: [
                {
                    color: '#808080'
                },
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#b3b3b3'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'road.local',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#ffffff'
                },
                {
                    weight: 1.8
                }
            ]
        },
        {
            featureType: 'road.local',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#d7d7d7'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#ebebeb'
                }
            ]
        },
        {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#a7a7a7'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#efefef'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#696969'
                }
            ]
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#737373'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#d6d6d6'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {},
        {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#dadada'
                }
            ]
        }
    ];
    if (json1?.length === 0) return;
    map1 = new google1.maps.Map(document.getElementById('map'), {
        center: defaultCenter || new google1.maps.LatLng(49.815691263639934, 24.01786260839841),
        zoom: +zoom,
        mapTypeControl: false,
        styles: mapStyles
    });
    // const card = document.getElementById("pac-card");
    // const input = document.getElementById("postcode");
    // Bind the map's bounds (viewport) property to the autocomplete object,
    // so that the autocomplete requests use the current map bounds for the
    // bounds option in the request.
    // autocomplete.bindTo("bounds", map);
    if (defaultJson) {
        var latLngDefault = new google1.maps.LatLng(defaultJson.lat, defaultJson.lng);
        // AdvancedMarker with colorPicker Logic
        /*const pinViewBackground = new google.maps.marker.PinView({
			borderColor: newShade(defaultJson.pinColor, -20),
			background: newShade(defaultJson.pinColor, 20),
			glyphColor: defaultJson.pinColor,
		});

		const marker = new google.maps.marker.AdvancedMarkerView({
			position: latLngDefault,
			map: map,
			title: defaultJson.title,
			content: pinViewBackground.element,
		});*/ const pinIconHref = data.points_type_id === 1 ? `${site_dir}/public/images/pins/pin-1.svg` : defaultJson.pinPath;
        const marker = new google1.maps.Marker({
            position: latLngDefault,
            map: map1,
            icon: `${pinIconHref}`,
            zIndex: data.points_type_id === 1 ? 9999 : 2
        });
    }
    let markersArr1 = [];
    for(const key in json1){
        const data1 = json1[key];
        var latLng = new google1.maps.LatLng(data1.lat, data1.lng);
        /*const pinViewBackground = new google.maps.marker.PinView({
			borderColor: newShade(data.pinColor, -20),
			background: newShade(data.pinColor, 20),
			glyphColor: data.pinColor,
		});

		const marker = new google.maps.marker.AdvancedMarkerView({
			position: latLng,
			map: map,
			title: data.title,
			content: pinViewBackground.element,
		});*/ const pinIconHref = data1.points_type_id === 1 ? `${site_dir}public/images/pins/pin-1.svg` : data1.pinPath;
        const marker = new google1.maps.Marker({
            position: latLng,
            map: map1,
            icon: `${pinIconHref}`,
            zIndex: data1.points_type_id === 1 ? 9999 : 2
        });
        markersArr1.push(marker);
    }
    return {
        map: map1,
        markersArr: markersArr1
    };
}
function $ce71ac302ea43ba0$var$initDeliveryZonesFunc(google1, map1, geocoder, json1, zoom, type) {
    const mapID = 'DEMO_MAP_ID';
    const mapStyles = [
        {
            featureType: 'water',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#d3d3d3'
                }
            ]
        },
        {
            featureType: 'transit',
            stylers: [
                {
                    color: '#808080'
                },
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#b3b3b3'
                }
            ]
        },
        {
            featureType: 'road.highway',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'road.local',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#ffffff'
                },
                {
                    weight: 1.8
                }
            ]
        },
        {
            featureType: 'road.local',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#d7d7d7'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#ebebeb'
                }
            ]
        },
        {
            featureType: 'administrative',
            elementType: 'geometry',
            stylers: [
                {
                    color: '#a7a7a7'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#ffffff'
                }
            ]
        },
        {
            featureType: 'landscape',
            elementType: 'geometry.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#efefef'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    color: '#696969'
                }
            ]
        },
        {
            featureType: 'administrative',
            elementType: 'labels.text.fill',
            stylers: [
                {
                    visibility: 'on'
                },
                {
                    color: '#737373'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {
            featureType: 'road.arterial',
            elementType: 'geometry.stroke',
            stylers: [
                {
                    color: '#d6d6d6'
                }
            ]
        },
        {
            featureType: 'road',
            elementType: 'labels.icon',
            stylers: [
                {
                    visibility: 'off'
                }
            ]
        },
        {},
        {
            featureType: 'poi',
            elementType: 'geometry.fill',
            stylers: [
                {
                    color: '#dadada'
                }
            ]
        }
    ];
    geocoder = new google1.maps.Geocoder();
    var myLatlng = new google1.maps.LatLng(json1[0]?.lat ? json1[0]?.lat : 49.815691263639934, json1[0]?.lng ? json1[0]?.lng : 24.01786260839841);
    map1 = new google1.maps.Map(document.getElementById('map'), {
        center: myLatlng,
        zoom: +zoom,
        mapTypeControl: false,
        styles: mapStyles
    });
    const marker = new google1.maps.Marker({
        map: map1,
        anchorPoint: new google1.maps.Point(0, -29)
    });
    const greenDeliveryArea = $ce71ac302ea43ba0$var$parseGeoJsonToLocations((0, $9744a98b8b2ebaa5$export$2e2bcd8739ae039));
    const yellowDeliveryArea = $ce71ac302ea43ba0$var$parseGeoJsonToLocations((0, $d93554ad9578c35d$export$2e2bcd8739ae039));
    const blueDeliveryArea = $ce71ac302ea43ba0$var$parseGeoJsonToLocations((0, $6c1b865c69e48d19$export$2e2bcd8739ae039));
    const greenDeliveryPoligon = new google1.maps.Polygon({
        paths: greenDeliveryArea.locations.map((loc)=>loc.coordinates),
        strokeColor: '#242426',
        strokeOpacity: 0.2,
        strokeWeight: 1,
        fillColor: '#229F5B',
        fillOpacity: 0.5
    });
    const blueDeliveryPoligon = new google1.maps.Polygon({
        paths: blueDeliveryArea.locations.map((loc)=>loc.coordinates),
        strokeColor: '#242426',
        strokeOpacity: 0.2,
        strokeWeight: 1,
        fillColor: '#1799BA',
        fillOpacity: 0.5
    });
    const yellowDeliveryPoligon = new google1.maps.Polygon({
        paths: yellowDeliveryArea.locations.map((loc)=>loc.coordinates),
        strokeColor: '#242426',
        strokeOpacity: 0.2,
        strokeWeight: 1,
        fillColor: '#F7AD40',
        fillOpacity: 0.5
    });
    greenDeliveryPoligon.setMap(map1);
    yellowDeliveryPoligon.setMap(map1);
    blueDeliveryPoligon.setMap(map1);
    /*const bounds = new google.maps.LatLngBounds();

  greenDeliveryArea.locations.forEach((loc) => {
    loc.coordinates.forEach((coord) => {
      bounds.extend(coord);
    });
  });

  yellowDeliveryArea.locations.forEach((loc) => {
    loc.coordinates.forEach((coord) => {
      bounds.extend(coord);
    });
  });

  blueDeliveryArea.locations.forEach((loc) => {
    loc.coordinates.forEach((coord) => {
      bounds.extend(coord);
    });
  });

  map.fitBounds(bounds);*/ /**
   * Comment out for now
   * Position google marker always in center of map when dragging
   * **/ // google.maps.event.addListener(map, "drag", function () {
    // 	console.log(this.getCenter().lat(), this.getCenter().lng());
    // 	// marker.setPosition(this.getCenter());
    // });
    if (type === 'checkout') $ce71ac302ea43ba0$var$checkoutLogicWithInputs(map1, marker, greenDeliveryPoligon, yellowDeliveryPoligon, blueDeliveryPoligon);
}
function $ce71ac302ea43ba0$var$hoverShowTrueMarker(data1) {
    const locationsSection = document.getElementById('our-locations-section');
    if (locationsSection) {
        const searchResultsBox = document.getElementById('search_results_box');
        const locationsArr = searchResultsBox.querySelectorAll('.location-card');
        const latLngArr = [];
        let previousMarker = null;
        let previousIcon = null;
        locationsArr.forEach((location, index)=>{
            const lat = Number(location.getAttribute('data-lat'));
            const lng = Number(location.getAttribute('data-lng'));
            latLngArr.push({
                lat: lat,
                lng: lng
            });
            let trueMarker = null;
            for(let i = 0; i < json.length; i++)if (Number(lat) === markersArr[i].getPosition().lat() && Number(lng) === markersArr[i].getPosition().lng()) {
                trueMarker = markersArr[i];
                break;
            }
            function bindInfoWindow(marker, map1, infoWindow, data1) {
                const mapBlock = document.getElementById('map');
                let originalIcon = trueMarker.getIcon();
                let iconPath = originalIcon.substring(0, originalIcon.lastIndexOf('/') + 1);
                google.maps.event.addListener(marker, 'click', function() {
                    if (previousMarker) {
                        previousMarker.setIcon(previousIcon);
                        previousMarker.zIndex = 2;
                        previousMarker.setAnimation(null);
                    }
                    previousMarker = trueMarker;
                    previousIcon = originalIcon;
                    markersArr.forEach((mrk)=>{
                        mrk.setAnimation(null);
                    });
                    locationsArr.forEach((loc)=>loc.classList.remove('active'));
                    trueMarker.setIcon(`${iconPath}point-1-active.svg`);
                    trueMarker.zIndex = 100;
                    trueMarker.setAnimation(google.maps.Animation.BOUNCE);
                    location.classList.add('active');
                    scrollIntoView(location);
                });
                location.addEventListener('click', ()=>{
                    if (previousMarker) {
                        previousMarker.setIcon(previousIcon);
                        previousMarker.zIndex = 2;
                        previousMarker.setAnimation(null);
                    }
                    previousMarker = trueMarker;
                    previousIcon = originalIcon;
                    // Hover on Location block
                    markersArr.forEach((mrk)=>{
                        mrk.setAnimation(null);
                    });
                    /*locationsArr.forEach((loc) => loc.classList.remove('hovered'));*/ /*location.classList.add('hovered');*/ map1.panTo(new google.maps.LatLng(lat, lng));
                    trueMarker.setIcon(`${iconPath}point-1-active.svg`);
                    trueMarker.zIndex = 100;
                    trueMarker.setAnimation(google.maps.Animation.BOUNCE);
                });
                /*location.addEventListener('mouseleave', () => {
          // Hover out Location block
          /!*locationsArr.forEach((loc) => loc.classList.remove('hovered'));*!/
          trueMarker.setIcon(originalIcon);
          trueMarker.setAnimation(null);
        });*/ location.addEventListener('click', function() {
                    if ($ce71ac302ea43ba0$var$is_touch_enabled()) scrollIntoView(document.getElementById('map'));
                });
                if (index === 0) location.click();
            }
            const infoWindow = new google.maps.InfoWindow();
            const infoWindowContent = document.getElementById('infowindow-content');
            infoWindow.setContent(infoWindowContent);
            bindInfoWindow(trueMarker, map, infoWindow, data1[index]);
        });
    }
}
/**
 * Checkout logic with form inputs on '/checkout'
 * @param map - Google Maps API: Map
 * @param marker - Google Maps API: Marker
 * @param greenDeliveryPoligon - Polygon of Green Delivery Zone
 * @param yellowDeliveryPoligon - Polygon of Yellow Delivery Zone
 * @param blueDeliveryPoligon - Polygon of Red Delivery Zone
 * **/ function $ce71ac302ea43ba0$var$checkoutLogicWithInputs(map1, marker, greenDeliveryPoligon, yellowDeliveryPoligon, blueDeliveryPoligon) {
    const selectCityEl = document.querySelector('#city-select');
    let citySelect = null;
    if (selectCityEl) {
        console.log(selectCityEl);
        selectCityEl.classList.add('is-init');
        citySelect = new Choices(selectCityEl, {
            searchEnabled: true,
            itemSelectText: '',
            placeholder: true,
            allowHTML: true,
            sorter: (a, b)=>0,
            fuseOptions: {
                threshold: 0.3
            },
            noResultsText: "\u041D\u0456\u0447\u043E\u0433\u043E \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E"
        });
        const observer = new MutationObserver((mutationsList)=>{
            for (const mutation of mutationsList)if (mutation.type === 'childList') {
                const selectedOption = selectCityEl.querySelector('option[selected]');
                if (selectedOption) {
                    if (selectedOption.value === 'other') {
                        ifOtherFunc();
                        setTimeout(function() {
                            if (document.querySelector('#delivery_area_banner')) document.querySelector('#delivery_area_banner').classList.add('hidden');
                        }, 100);
                    } else {
                        elseOtherFunc();
                        setTimeout(function() {
                            if (document.querySelector('#delivery_area_banner')) document.querySelector('#delivery_area_banner').classList.remove('hidden');
                        }, 100);
                    }
                }
            }
        });
        observer.observe(selectCityEl, {
            childList: true,
            subtree: true
        });
        const choiceEl = selectCityEl.parentElement?.parentElement;
        let hasListenerBeenCalled = false;
        document.addEventListener('pointerdown', (event)=>{
            const wasOpen = choiceEl.classList.contains('is-open');
            requestAnimationFrame(()=>{
                const isNowClosed = !choiceEl.classList.contains('is-open');
                if (wasOpen && isNowClosed) {
                    if (!hasListenerBeenCalled) {
                        formInputsListener(citySelect);
                        hasListenerBeenCalled = true;
                    }
                }
            });
        });
        document.addEventListener('pointerdown', (event)=>{
            if (choiceEl.classList.contains('is-open')) hasListenerBeenCalled = false;
        });
    }
    /**
   * Get place from Google Maps API / Geolocation by inputs values in form
   * @param city - value of select #choices-select
   * @param street - value of input #street
   * @param house - value of input #house
   * @return place
   * **/ async function getPlacePredictionsByInputs(city, street, house) {
        const fullInput = encodeURI(`\u{43C}\u{456}\u{441}\u{442}\u{43E} ${city}, \u{432}\u{443}\u{43B}\u{438}\u{446}\u{44F} ${street}, \u{431}\u{443}\u{434}\u{438}\u{43D}\u{43E}\u{43A} ${house}`);
        /*console.log('fullInput', fullInput);*/ try {
            const response = await axios.post(`https://maps.googleapis.com/maps/api/geocode/json?address=${fullInput}&key=${googleAPIKey}&region=UA&language=uk`);
            const place = response.data.results[0];
            validatePlacePrediction(place, city);
        } catch (e) {
            throw e;
        }
    }
    /**
   * Get place from Google Maps API / Geolocation by marker position
   * @param lat - latitude of a marker position
   * @param lng - longitude of a marker position
   * @return void
   * **/ async function getPlacePredictionsByMarkerMove(lat, lng) {
        // https://maps.googleapis.com/maps/api/geocode/json?latlng=40.714224,-73.961452&key=YOUR_API_KEY
        try {
            const response = await axios.post(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${googleAPIKey}`);
            const place = response.data.results[0];
            validatePlacePrediction(place);
        } catch (e) {
            // console.log(e);
            throw e;
        }
    }
    /**
   * Validate Place received from Google Maps API / Geolocation
   * @param place
   * @return void
   * **/ let cityNew = "\u041B\u044C\u0432\u0456\u0432";
    function validatePlacePrediction(place, city) {
        const locality = place?.address_components?.find((component)=>component.types.includes('locality'))?.long_name.toLowerCase();
        // console.log("place", place);
        // console.log("locality", locality);
        // console.log("same locality?", locality === city.toLowerCase());
        if (!place || !place.geometry || !place.geometry.location || locality !== city.toLowerCase()) {
            cityNew = city;
            console.log(cityNew);
            // User entered the name of a Place that was not suggested and
            // pressed the Enter key, or the Place Details request failed.
            // Swal.fire({
            //   icon: 'error',
            //   title:
            //     'Перевірте правильність написання адреси, ми не можемо знайти її',
            //   confirmButtonText: 'Зрозуміло',
            // }).then((result) => {});
            marker.setVisible(false);
            disableCheckoutBtn();
            load('change-delivery-area', 'area=outside', 'location=' + city);
            // If the place has a geometry, then present it on a map.
            map1.setCenter(new google.maps.LatLng(49.815691263639934, 24.01786260839841));
            map1.setZoom(11);
            return;
        }
        // If the place has a geometry, then present it on a map.
        map1.setCenter(place.geometry.location);
        map1.setZoom(13);
        // Set position of marker in center of place and make it visible.
        marker.setPosition(place.geometry.location);
        marker.setVisible(true);
        if (checkPointInsidePoly(place, greenDeliveryPoligon)) {
            enableCheckoutBtn();
            // console.log("area=green");
            load('change-delivery-area', 'area=green', 'location=' + city);
        } else if (checkPointInsidePoly(place, yellowDeliveryPoligon)) {
            enableCheckoutBtn();
            // console.log("area=yellow");
            load('change-delivery-area', 'area=yellow', 'location=' + city);
        } else if (checkPointInsidePoly(place, blueDeliveryPoligon)) {
            enableCheckoutBtn();
            // console.log("area=red");
            load('change-delivery-area', 'area=blue', 'location=' + city);
        }
    }
    /**
   * Search Place and Validate on Back logic
   * Fired every time one of inputs is changed
   * @param citySelect - select #choices-select [Choices.js]
   * @return void
   * **/ let isAutoCompleteFlagStart = false;
    function formInputsListener(citySelect) {
        const city = citySelect.getValue(true);
        const street = document.getElementById('street').value;
        const house = document.getElementById('house').value;
        /*const normalizedStreet = street.toLowerCase().replace(/[.,]/g, '');

    if (isAutoCompleteFlagStart !== false) {
      if (normalizedStreet.includes(city.trim().toLowerCase())) {
        /!*console.log(`✅ Название города "${city}" есть в улице: "${street}"`);*!/
      } else {
        /!*console.log(
          `❌ Название города "${city}" отсутствует в улице: "${street}"`
        );*!/
        disableCheckoutBtn();
        load('change-delivery-area', 'area=outside', 'location=' + city);
      }
    }

    setTimeout(function () {
      isAutoCompleteFlagStart = true;
    }, 150);*/ if (city && street && house) getPlacePredictionsByInputs(city, street, house);
    }
    /**
   * Check if place is inside Google Maps API:Polygon
   * @param place - place of Google Maps API:place
   * @param polygon - polygon of Google Maps APILPolygon
   * @return boolean
   * **/ function checkPointInsidePoly(place, polygon) {
        return google.maps.geometry.poly.containsLocation(place.geometry.location, polygon);
    }
    /**
   * Take all inputs id's from form, and addEventListener @change
   * @callback formInputsListener
   * **/ const inputIds = [
        'city-select',
        'street',
        'house'
    ];
    inputIds.forEach((id)=>{
        const input = document.getElementById(id);
        input.addEventListener('change', function(evt) {
            formInputsListener(citySelect);
        });
    });
    formInputsListener(citySelect);
/*const howToDeliver = document.querySelector('#deliver-delivery');
  howToDeliver.addEventListener('change', function (evt) {
    if (evt.target.checked) {
      formInputsListener(citySelect);
    }
  });*/ /*const allInputsIds = [
    ...inputIds,
    'first-name',
    'last-name',
    'phone-number',
    'name',
    'entrance',
    'floor',
    'apartment',
    'message',
  ];

  allInputsIds.forEach((id) => {
    const input = document.getElementById(id);

    input.addEventListener('change', function () {
      load('set-user-cookie', 'form:#pay-form');
    });
  });*/ /**
   * Comment out for now
   * Position google marker always in center of map when drag ended
   * @callback getPlacePredictionsByMarkerMove
   * **/ // google.maps.event.addListener(map, "dragend", function () {
// 	marker.setPosition(this.getCenter()); // set marker position to map center
// 	getPlacePredictionsByMarkerMove(
// 		this.getCenter().lat(),
// 		this.getCenter().lng()
// 	);
// });
}
window.hoverShowTrueMarker = $ce71ac302ea43ba0$var$hoverShowTrueMarker;
window.initMapFunc = $ce71ac302ea43ba0$var$initMapFunc;
window.initDeliveryZonesFunc = $ce71ac302ea43ba0$var$initDeliveryZonesFunc;


/*const scrollToTopElement = document.getElementById('scroll-to-top');
const followingCart = document.getElementsByClassName('following-cart')[0];

if (scrollToTopElement) {
  scrollToTopElement.addEventListener('click', function () {
    scrollIntoView(document.getElementById('map'));
  });

  if (!followingCart.classList.contains('sr-only')) {
    scrollToTopElement.classList.add('bottom-[90px]');
    followingCart.style.right = '4vw';
  }

  window.addEventListener('scroll', function () {
    if (window.scrollY > 400) {
      scrollToTopElement.classList.remove('opacity-0', 'pointer-events-none');
    } else {
      scrollToTopElement.classList.add('opacity-0', 'pointer-events-none');
    }
  });
}*/ if (document.querySelector('#site') && document.querySelector('#site').classList.contains('full-container-type')) document.querySelector('body').classList.add('site-full-container-type');


//# sourceMappingURL=scripts.d6411fe8.js.map
